//Angular References
import { Component, OnInit, ViewChild, HostListener, ElementRef, NgModule, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { forkJoin, Observable, Observer } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { CdkStepper } from '@angular/cdk/stepper';
import { SignaturePad } from 'angular2-signaturepad';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { isNullOrUndefined, isNumber } from 'util';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFileUploaderComponent } from 'angular-file-uploader';

//Service 
import { ContactService } from '../../../services/contact.service';
import { CountryService } from '../../../services/country.service';
import { DocumentService } from '../../../services/document.service';
import { InventionService } from '../../../services/invention.service';
import { ProductService } from '../../../services/product.service';
import { StateService } from '../../../services/state.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { WizardService } from '../../../services/wizard.service';
import { OfficeService } from '../../../services/office.service';
import { BillingService } from '../../../services/billing.service';
import { ContractSessionService } from '../../../services/contractsession.service';
import { InfoCollectService } from '../../../services/InfoCollect.service';
import { AddendumService } from '../../../services/addendum.service';
import { UserService } from '../../../services/user.service';
import { NavigationService } from '../../../services/navigation.service';
import { AppconfigService } from '../../../services/shared/appconfig.service';
import { ConfigMasterService } from '../../../services/configMaster.service';
import { MediaImagesService } from '../../../services/mediaimages.service';
import { SMSService } from '../../../services/sms.service';
import { EmailService } from '../../../services/email.service';
import { InventionCheckListService } from '../../../services/inventionCheckList.service';


//Models
import { User, UserResponse } from '../../../models/user.model';
import { ContactResponse, ContactDetails, CLPContactSOInvention, CLPContactSOInventionResponse } from '../../../models/contact.model';
import { InventionResponse, InventionDetails } from '../../../models/invention.model';
import { WizardResponse, WizardReadyResponse, WizardDetails } from '../../../models/wizard.model';
import { Country } from '../../../models/country.model';
import { State } from '../../../models/state.model';
import { DocumentContainer, DocumentList, DocumentResponse, ConfigDocuments, ConfigDocumentsResponse, DocumentBinaryPDF, DocumentResponseList, DocType, ContractsAzureDetailsResponse, GenerateContractsAzure, GenerateContractsAzureResponse, ContractsSingalFile, DocumentsMedia, AzureMedia } from '../../../models/document.model';
import { SMSDetails, SMSResponse } from '../../../models/sms.model';
import { EmailDetails, EmailResponse } from '../../../models/email.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { ProductListResponse, ProductDetails, ProductResponse } from '../../../models/product.model';
import { OfficeList, OfficeListResponse } from '../../../models/officelist.model';
import { RepaymentTerms, RepaymentTermsResponse } from '../../../models/billing.model';
import { PromotionOffers, PromotionOffersResponse } from '../../../models/promotionOffers.model';
import { ContractSession, ContractSessionResponse, ContractSessionListResponse, BIPConfirmation, CheckSendToCorpResponse } from '../../../models/contractsession.model';
import { Addendum, AddendumServicesResponse } from '../../../models/addendum.model';
import { ContractPayment, ContractPaymentResponse, ContractMultiPayment, ContractMultiPaymentResponse } from '../../../models/contractPayment.model';
import { BGInformInvention, BGInformInventionResponse } from '../../../models/bgInformInvention.model';
import { InventorInformation, InventorInformationResponse } from '../../../models/inventorInformation.model';
import { UniversalPayment, UniversalPaymentResponse } from '../../../models/universalPayment.model';
import { DocumentSignature, DocumentSignatureResponse } from '../../../models/documentSignature.model';
import { Navigation, NavigationResponse, NavigationSteps, NavigationStepsResponse } from '../../../models/navigation.model';
import { ConfigDetails } from '../../../models/appConfig.model';
import { BillingDetails, BillingResponse, ContractBillingTxn, ContractBillingTxnResponse } from '../../../models/billing.model';
import { ConfigMaster, ConfigMasterResponse } from '../../../models/configMaster.model';
import { mediaImages, MediaDocImagesResponse, MediaImagesResponse, ROIRefreshFlagResponse } from '../../../models/mediaImages.model';
import { checkList, configCheckList, CheckListImagesResponse, ConfigCheckListImagesResponse } from '../../../models/checkList.model';
import { mediaDoc } from '../../../models/mediaImages.model';
import { InventionCheckList, InventionCheckListResponse } from '../../../models/inventionCheckList.model';
import { ContractNum, ContractNumberResponse } from '../../../models/contractNum.model';



//Custom Validators
import { CustomValidators } from '../../../shared/custom.validators';
import { parse } from 'url';
import { ContractActionLog } from '../../../models/contractActionLog.model';
import { ContratActionLogService } from '../../../services/contratActionLog.service';
import { TransferDataService } from '../../../services/shared/transferData.service';
import { CheckListService } from '../../../services/checkList.service';
import { paymentDocList, PaymentDocMediaImagesResponse } from '../../../models/PaymentDocImage.model';
import { retry } from 'rxjs/operators';
import { CurrencyConversionService } from '../../../services/shared/currency-conversion.service';
import { config } from 'process';
import { MatSort } from '@angular/material/sort';
import { ASTWithName } from '@angular/compiler';
import { stringify } from 'querystring';
import { ClientsStateDataService } from '../../../services/clients-state-data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { promise } from 'protractor';
import { IpService } from '../../../services/ip.service';


//For jquery
declare var $: any;

@Component({
    selector: 'app-contract',
    templateUrl: './contract.component.html',
    styleUrls: ['./contract.component.css'],
})
/** contract component*/
export class ContractComponent implements OnInit {
    displayedColumns: string[] = ['id', 'payOption', 'downPaymentPart', 'paymentStatus', 'action'];
    displayedGenContractColumns = ['fileName', 'dtCreated', 'unZipDoc', 'zipDoc'];
    displayedSingleFileColumns = ['fileName', 'unZipDoc'];
    dataSource: MatTableDataSource<ContractMultiPayment>;
    dataSourceCollection: MatTableDataSource<ContractMultiPayment>;
    @ViewChild('sortDoc') sortDoc: MatSort;
    @ViewChild('sortDocPopUp') sortDocPopUp: MatSort;
    @ViewChild('paymentUploader') paymentUploader: AngularFileUploaderComponent;
    @ViewChild('roiDocMediaUploader') roiDocMediaUploader: AngularFileUploaderComponent;
    adjustAmount: number = 0;
    currentMultiPayId: number = 0;
    highlightedRows = [];
    lastAddedDOCImageId: number = 0;
    lastAddedImageId: number = 0;
    payMode: string = "Down Payment";
    mySubscription: any;
    contractActionlog: ContractActionLog;
    dtFirstWaitDate: Date;
    resetUpload: boolean;
    afuConfig: any;
    paymentDocConfig: any;
    waitDate: Date;
    waitAcceptDate: Date;
    sentPayAlert: boolean = false;
    showSSN: boolean = false;
    maxDate = new Date();
    expDate: string = "";
    cCardExpDTfield: string = "";
    currencySterling: string = "";
    convCurrencySterling: string = "";
    gbpRate: any;
    conversionRate: any;
    currencyRate: any;
    fileNumber: string = "";
    inputFileNumber: string = "";
    businessDays: string = "";
    clpUserCountryID: number;
    customerCountryID: number;
    customerStateID: string = "";
    isInCAN: boolean = false;
    isInUS: boolean = false;
    clientLocation: boolean = false;
    stateMessage: string = "";
    disableAgreement: boolean = false;
    todaysdate = new Date();
    expiry: boolean = false;
    isPaymentExceeds: boolean = false;
    isFileNoBlank: boolean = false;
    maxValue = 99999.00;
    socGroup: FormGroup;
    locationPOPUP: FormGroup;
    prodConfigGroup: FormGroup;
    signDocsGroup: FormGroup;
    collectPaymentGroup: FormGroup;
    addOkClass: string = "";
    _i1SSN: string = "";
    _unmaskI1SSN: string = "";
    _i2SSN: string = "";
    infoCollectAddress: string = "";
    infoCollectPhone: string = "";
    IsPromo: boolean = false;
    payFull: boolean = false;
    payInstall: boolean = false;
    autoPayYes: boolean = false;
    autoPayNo: boolean = false;
    payCheck: boolean = false;
    payMoneyOrder: boolean = false;
    payCreditCard: boolean = false;
    payCash: boolean = false;
    payMonterey: boolean = false;
    payOther: boolean = false;
    payCarryOver: boolean = false;
    contractSessionId: number = -1;
    flgInstallment: boolean = false;
    clpUserId: number;
    rdClpUserId: number;
    contact1Signature: string;
    socPanelTitle: string;
    prodConfigPanelTitle: string;
    infoCollectPanelTitle: string;
    paymentCollectPanelTitle: string;
    firstNameExistCoInvent: string;
    lastNameExistCoInvent: string;
    isSaving: boolean = false;
    isCalc: boolean = false;
    isCalcPayment: boolean = false;
    otherInventor: boolean = false;
    coInventor: boolean = false;
    socDocumentData: ContactResponse;
    chkInventor2: boolean = false;
    coInventorConfirm: boolean = false;
    currentUser: User;
    stateList: State[];
    socStateList: State[];
    popUPStateList: State[];
    paymentList: paymentDocList[];
    filteredStateList: State[];
    filteredSOCStateList: State[];
    filteredPOPUPStateList: State[];
    filterUserStateLst: State[];
    countryList: Country[];
    defaultCountryId: number = 1;
    checkState: string = "";
    paymentAuth: string = "";
    paymentAuthTitle: string = "";
    impOrWeb: string = "Web Services";
    contactId: number;
    inventionId: number;
    wizard: WizardDetails;
    selectedIndex: number;
    contactId2: number;
    c2Present: boolean;
    base64Str: string;
    base64StrCoInv: string;
    base64StrADS: string;
    base64StrADSCoInv: string;
    base64StrFinal: string;
    base64StrFinalCoInv: string;
    chkSignaturePad: boolean;
    isSecondInventor: boolean;
    documentTypeId: number;
    document: string = "The document is loading. Please wait...";
    mandatoryDocument: string = "The document is loading. Please wait...";
    documentTypeIds: string;
    finaldocument: string;
    auditActionFlag: string;
    productId: number = 1;
    selectedProductID: number = 1;
    bypassexport: number;
    c2_phone: string;
    c2_name: string;
    person: string;
    signature1: string = '';
    signature2: string = '';
    i1SignatureADS: string = '';
    i1SignatureFinal: string = '';
    payOption: number = 0;
    isCoInventor: boolean = false;
    i2person: string;
    divPaySaveAc: boolean = false;
    divPayCard: boolean = true;
    divNoAutoPay: boolean = false;
    hideOptionalDoc: boolean = false;
    dvId: string = "";
    dvSpinner: boolean = false;
    chkExpPDF: boolean = false;
    isStateExists: boolean = false;
    isWaitStateExists: boolean = false;
    isContractDone: boolean = false;
    showUploadFlg: boolean = false;
    paymentDocshowUploadFlg: boolean = false;
    isAddlDocExists: boolean = false;
    isBIPClient: boolean = false;
    isSubClient: boolean = false;
    isPPSOClient: boolean = false;
    isPlusClient: boolean = false;
    isExist: boolean = false;
    isCarryOver: boolean = false;
    exInventionName: string = '';

    IsSubmitCharge: boolean = false;
    currentActive: number = 0;
    IsMenu: boolean = true;
    isMarriageYes: boolean = true;
    isChildYes: boolean = true;
    doc_to_number: string = "";
    image_to_number: string = "";
    isNavBarClick: boolean = false;
    isROISubmitted: boolean = false;
    refreshROINav: any;
    refreshROIFlag: any;
    isROIDocMedia: boolean = false;
    isCheckListDocMedia: boolean = false;
    inventHelpSite: string = "";
    stateId: number = 0;
    isWaitStateDoc: boolean = false;
    waitStateDocTypeId: number = 0;
    sdaDocTypeId: number = 3;
    divOtherMandDocs: boolean = false;
    isSecondContract: boolean = false;
    isMandDocSigned: boolean = false;

    checkListDeleted: boolean = false;

    socDone: boolean = false;
    adsDone: boolean = false;
    ndaDone: boolean = false;
    waitDone: boolean = false;
    sdaDone: boolean = false;
    prodDone: boolean = false;
    roiDone: boolean = false;
    checkListDone: boolean = false;
    impDone: boolean = false;
    subDone: boolean = false;
    biiDone: boolean = false;
    bipDone: boolean = false;
    ppsoDone: boolean = false;
    informDone: boolean = false;
    retailDone: boolean = false;
    ppaDone: boolean = false;
    upcDone: boolean = false;
    paymentDone: boolean = false;
    WaitingPrdForPay: boolean = false;
    addlDone: boolean = false;
    finalSignDone: boolean = false;
    isSendToCorp: boolean = false;
    isExecuted: boolean = false;
    USFeeConfirm: number = null;
    isCancelled: boolean = false;
    sendToCorpMsg: string = "Send To Corp";
    countLoadDocument: number = 0;
    strMsg: string = "";

    public socFOffset: number = null;
    public socDOffset: number = null;
    public adsDOffset: number = null;
    public ndaDOffset: number = null;
    public sdaDOffset: number = null;
    public productFOffset: number = null;
    public biiFOffset: number = null;
    public biiDOffset: number = null;
    public bipFOffset: number = null;
    public bipDOffset: number = null;
    public infoFOffset: number = null;
    public infoDOffset: number = null;
    public upcFOffset: number = null;
    public upcDOffset: number = null;
    public ppsoDOffset: number = null;
    public retlDOffset: number = null;

    isSOCFormSaved: boolean = false;
    isServiceFormSaved: boolean = false;
    isBIISaved: boolean = false;
    isBIPSaved: boolean = false;
    isSUBSaved: boolean = false;
    isPPSOSaved: boolean = false;
    isIISaved: boolean = false;
    isRISaved: boolean = false;
    isUPSaved: boolean = false;
    isROISaved: boolean = false;
    isCheckListSaved: boolean = false;
    isIMPSaved: boolean = false;

    isBIIDocument: boolean = false;
    isBIPDocument: boolean = false;
    isPPSODocument: boolean = false;
    isInfoInventDocument: boolean = false;
    isRetailInsDocument: boolean = false;
    isUniPayDocument: boolean = false;
    isPPADocument: boolean = false;
    isROISignDoc: boolean = false;
    isCheckListSignDoc: boolean = false;
    isIMPSignDoc: boolean = false;
    isSUBSignDoc: boolean = false;
    isAddlSignDoc: boolean = false;

    isSOCMandDoc: boolean = false;
    isADSMandDoc: boolean = false;
    isNDAMandDoc: boolean = false;
    isSDAMandDoc: boolean = false;

    isSOCSignDoc: boolean = true;
    isADSSignDoc: boolean = true;
    isNDASignDoc: boolean = true;
    isSDASignDoc: boolean = true;
    isWaitSignDoc: boolean = true;

    isBIAccept: boolean = false;
    isBIPAccept: boolean = false;
    isPPSOAccept: boolean = false;
    isInfoInventAccept: boolean = false;
    isRetailAccept: boolean = false;
    isPPAAccept: boolean = false;
    isUniPayAccept: boolean = false;
    isROIAccept: boolean = false;
    isCheckListAccept: boolean = false;
    isIMPAccept: boolean = false;
    isSUBAccept: boolean = false;
    isAddmBAccept: boolean = false;
    isAddmGAccept: boolean = false;
    isAddmPAccept: boolean = false;
    isAddmTAccept: boolean = false;
    isAddmVAccept: boolean = false;
    isPatentAccept: boolean = false;
    isIntroMarkAccept: boolean = false;
    isAddlAccept: boolean = false;

    isSOCHeadAccept: boolean = false;
    isADSHeadAccept: boolean = false;
    isNDAHeadAccept: boolean = false;
    isWaitHeadAccept: boolean = false;
    isSDAHeadAccept: boolean = false;

    isBIHeadAccept: boolean = false;
    isBIPHeadAccept: boolean = false;
    isPPSOHeadAccept: boolean = false;
    isInfoInventHeadAccept: boolean = false;
    isRetailHeadAccept: boolean = false;
    isUniPayHeadAccept: boolean = false;
    isPPAHeadAccept: boolean = false;
    isROIHeadAccept: boolean = false;
    isCheckListHeadAccept: boolean = false;
    isWestern: boolean = false;
    isIMPHeadAccept: boolean = false;
    isSUBHeadAccept: boolean = false;
    isAddlHeadAccept: boolean = false;

    addmBDocumentId: number = 0;
    addmGDocumentId: number = 0;
    addmPDocumentId: number = 0;
    addmTDocumentId: number = 0;
    addmVDocumentId: number = 0;
    patentDocumentId: number = 0;
    introMarkDocumentId: number = 0;

    isShowBIP: boolean = false;
    isShowPPSO: boolean = false;
    isShowSub: boolean = false;
    isShowIMP: boolean = false;
    isShowCheckList: boolean = false;
    isShowROI: boolean = false;
    isShowPatent: boolean = false;

    docSignROI: string = "The document is loading. Please wait...";
    docSignCheckList: string = "The document is loading. Please wait...";
    documentBII: string = "The document is loading. Please wait...";
    documentBIP: string = "The document is loading. Please wait...";
    documentPPSO: string = "The document is loading. Please wait...";
    docSignIMP: string = "The document is loading. Please wait...";
    docSignSUB: string = "The document is loading. Please wait...";
    docSignAddmB: string = "The document is loading. Please wait...";
    docSignAddmG: string = "The document is loading. Please wait...";
    docSignAddmP: string = "The document is loading. Please wait...";
    docSignAddmT: string = "The document is loading. Please wait...";
    docSignAddmV: string = "The document is loading. Please wait...";
    docSignPatent: string = "The document is loading. Please wait...";
    docSignIntroMark: string = "The document is loading. Please wait...";
    documentInfoInvent: string = "The document is loading. Please wait...";
    documentRetailIns: string = "The document is loading. Please wait...";
    documentUniPay: string = "The document is loading. Please wait...";
    documentPPA: string = "Document is loading. Please wait...";
    documentSet: string = " ";

    docMandSOC: string = "The document is loading. Please wait...";
    docMandADS: string = "The document is loading. Please wait...";
    docMandNDA: string = "The document is loading. Please wait...";
    docMandSDA: string = "";
    docWaitState: string = "The document is loading. Please wait...";

    docSignSOC: string = "The document is loading. Please wait...";
    docSignADS: string = "The document is loading. Please wait...";
    docSignNDA: string = "The document is loading. Please wait...";
    docSignSDA: string = "The document is loading. Please wait...";
    docSignWaitState: string = "The document is loading. Please wait...";
    docSignAddlState: string = "The document is loading. Please wait...";

    lblAddendumP: string = "";
    mandateDocBtn: string = "Accept & Sign";

    divMmandDocs: boolean = false;
    divSOC: boolean = true;
    chkSOC: boolean = true;
    chkADS: boolean = true;
    ctrMandDocs: number = 0;
    ctrOtherMandDocs: number = 0;

    isWaitingPeriod: boolean = false;
    isWaitPrdForPayment: boolean = false;

    userStateName: string = "";
    waitDays: number;
    dtSOC: string = "";
    paymentDate: string = "";
    dtAddWait: string;
    msgConfirm: string = "";
    canConfirm: string = "";
    mode: string = "";
    ccId: string = "";
    saveByService: string = "";
    saveImpByService: string = "";
    isReceiptSent: boolean = false;

    /*Payment Collection*/
    isPaymentDone: boolean = false;
    isPaymentProcessing: boolean = false;
    productName: string;
    oneTimeFee: number = 0;
    oneTimeFeeInitial: number = 0;
    partialFee: string = "";
    originalPrice: string = "";
    checkListTabItem: string = "";
    email: string = "";
    inventionName: string = "";
    submitted: boolean = false;
    site: string = "";
    useType: number = 0;
    stripePublicKey: string = "";
    stripePublicKeyValue: string = "";
    stripePrivateKey: string = "";
    configKeyValue: string = "";
    imgSource: string = "";
    cardType: string = "";
    cardNumber: string = "";
    cardErrorMsg: string = "";
    imgVisible: boolean = false;
    cardToken: string = "";
    //elements: Elements;
    //card: StripeElement;
    cardName: string = "";
    cardTxnReference: string = "";
    cardTxnNotes: string = "";
    isPaymentError: boolean = false;
    isCardAuthorized: boolean = false;
    isSubmitCharge: boolean = false;
    isCardPaymentStarted: boolean = false;
    txnType: number = 0;
    chkAmount: boolean = false;
    chkFileNumber: boolean = false;
    show: boolean = false;
    showSSnDiv: boolean = true;
    disabledAgreement: boolean = true;
    emailTemplateType: string = "";
    response_code: string = "";
    isEditPay: boolean = false;
    editedRowId: number = -1;
    loading: boolean = false;
    popLoading: boolean = false;
    pop2Loading: boolean = false;
    popextLoading: boolean = false;
    popext2Loading: boolean = false;

    dataSourceGenContract: any;
    dataSourceGenContractPopUp: any;
    dataSourceSingleFile: any;
    refreshGenContact: any;
    refreshSendToCorp: any;
    phoneMask: string;
    maxLength: string;
    isImageUpload: boolean = false;
    isNoAutoPay: boolean = true;

    isExistSoc: boolean = false;
    isExistADS: boolean = false;
    isExistFinal: boolean = false;
    isExistSocinv: boolean = false;
    isExistADSinv: boolean = false;
    isExistFinalinv: boolean = false;
    titleMsg: string = '';
    titleMsgInv: string = '';
    isOtherCountry: boolean = false;
    zipLength: number = 10;
    navScrrol: string = '#divPS';
    isFinalSignWait: boolean = false;
    recursiveCallAPI: number = 0;
    checkSendToCorpCounter: number = 0;
    collectionError: string = '';
    downpaymentPre: string;
    salesRepComments: string;
    isAPRStatus: boolean = false;
    //elementsOptions: ElementsOptions = {
    //    locale: 'en'
    //};
    private mediaImagesResponse: MediaImagesResponse;
    private ROIFlagResponse: ROIRefreshFlagResponse;
    private mediaDocImagesResponse: MediaDocImagesResponse;
    private paymentDocMediaImagesResponse: PaymentDocMediaImagesResponse;
    private checkListImagesResponse: CheckListImagesResponse;
    private configCheckListImagesResponse: ConfigCheckListImagesResponse;
    private encryptedUser: string = '';
    private billingDetails: BillingDetails;
    private contractPaymentResponse: ContractPaymentResponse;
    public contractSession: ContractSession;
    public bipConfirmation: BIPConfirmation;
    private contractBillingTxns: ContractBillingTxn[];
    private contractBillingTxn: ContractBillingTxn;
    private contractBillingTxnResponse: ContractBillingTxnResponse;
    private addendum: Addendum;
    public addendumServicesResponse: AddendumServicesResponse;
    private contractSessionListResponse: ContractSessionListResponse;
    private contractSessionResponse: ContractSessionResponse;
    private configDocumentsResponse: ConfigDocumentsResponse;
    private configDocuments: ConfigDocuments;
    private documentResponse: DocumentResponse;
    private documentListResponse: DocumentResponseList;
    private documentList: DocumentList;
    private documentBinaryPDF: DocumentBinaryPDF;
    private documentContainer: DocumentContainer;
    private documentContainerADS: DocumentContainer;
    private documentSignature: DocumentSignature;
    private documentSignatureResponse: DocumentSignatureResponse;
    private emailDetails: EmailDetails;
    private emailResponse: EmailResponse;
    private inventionResponse: InventionResponse;
    private inventionDetails: InventionDetails;
    private inventorInformation: InventorInformation;
    private inventorInformationResponse: InventorInformationResponse;
    private billingResponse: BillingResponse;
    private configMaster: ConfigMaster[];
    private configMasterResponse: ConfigMasterResponse;
    private contactResponse: ContactResponse;
    private contactCoInventResponse: ContactResponse;
    private contactDetails: ContactDetails;
    private soContactDetails: CLPContactSOInvention;
    private contactCoInventDetails: ContactDetails;
    private contractPayment: ContractPayment;
    private initContractPayment: ContractPayment;
    private mediaImages: mediaImages;
    mediaImagesList: mediaImages[];
    private mediaDoc: mediaDoc;
    mediaDocList: mediaDoc[];
    paymentDoc: paymentDocList[];
    paymentDocCheque: paymentDocList[];
    paymentOther: paymentDocList[];
    paymentCash: paymentDocList[];
    paymentMonterey: paymentDocList[];
    checkList: checkList[];
    configCheckListArr: any[] = [];
    private navigation: Navigation;
    private navigationResponse: NavigationResponse;
    private navigationSteps: NavigationSteps[];
    private navigationStepsResponse: NavigationStepsResponse;
    officeList: OfficeList[];
    private officeListResponse: OfficeListResponse;
    private productListResponse: ProductListResponse;
    productDetails: ProductDetails[];
    private productDetail: ProductDetails;
    private productResponse: ProductResponse;
    private promotionOffersResponse: PromotionOffersResponse;
    promotionOffers: PromotionOffers[];
    private repaymentTermsResponse: RepaymentTermsResponse;
    repaymentTerms: RepaymentTerms[];
    private simpleResponse: SimpleResponse;
    private smsDetails: SMSDetails;
    private smsResponse: SMSResponse;
    private universalPayment: UniversalPayment;
    private universalPaymentResponse: UniversalPaymentResponse;
    private wizardResponse: WizardResponse;
    private wizardReadyResponse: WizardReadyResponse;
    private wizardDetails: WizardDetails;
    private globalResponse: any;
    private globalpaymentResponse: any;
    private globalCheckListResponse: any;
    private globalConfigCheckListResponse: any;
    private bgInformInvention: BGInformInvention;
    private bgInformInventionResponse: BGInformInventionResponse;
    private user: User;
    private configDetails: ConfigDetails;
    private userResponse: UserResponse;
    private inventionCheckListResponse: InventionCheckListResponse;
    private inventionCheckList: InventionCheckList;
    private clpContactSOInvention: CLPContactSOInvention;
    private clpContactSOInventionResponse: CLPContactSOInventionResponse;
    private contractNum: ContractNum;
    private contractNumberResponse: ContractNumberResponse;
    contractMultiPayments: ContractMultiPayment[];
    contractMultiPayment: ContractMultiPayment;
    contractMultiPaymentResponse: ContractMultiPaymentResponse;
    gencontractDetailsResponse: ContractsAzureDetailsResponse;
    generateContractsAzure: GenerateContractsAzure[];
    generateContractsMedia: GenerateContractsAzure[];
    checkSendToCorpResponse: CheckSendToCorpResponse;

    @ViewChild('sigpad1', { static: true }) signaturePad: SignaturePad;
    @ViewChild('sigpad2', { static: true }) signaturePadCoInv: SignaturePad;
    @ViewChild('sigpadADS', { static: true }) signaturePadADS: SignaturePad;
    @ViewChild('sigpadADSCoInv', { static: true }) signaturePadADSCoInv: SignaturePad;
    @ViewChild('sigpadFinal', { static: true }) signaturePadFinal: SignaturePad;
    @ViewChild('sigpadFinalCoInv', { static: true }) signaturePadFinalCoInv: SignaturePad;
    @ViewChild('groupAdjust') groupAdjust;
    @ViewChild('stepper') stepper: CdkStepper;
    @ViewChild('downloadPDFLink') private downloadPDFLink: ElementRef;

    noServiceDisabled: boolean = false;
    addendumBDisabled: boolean = false;
    addendumGDisabled: boolean = false;
    addendumPDisabled: boolean = false;
    patentDisabled: boolean = false;
    refreshFlag: boolean = true;
    refreshImageFlag: boolean = true;
    isRefreshDocConfig: boolean;
    isRefreshImageConfig: boolean;
    isRefreshCall: number = 0;
    isRemote: boolean = false;
    sel_brand: string = "unknown";
    sel_brandUPC: string = "unknown";

    initialDisabled: boolean = false;
    initialCoInvDisabled: boolean = false;
    initialAdsDisabled: boolean = false;
    initialAdsCoInvDisabled: boolean = false;
    initialFinalDisabled: boolean = false;
    initialFinalCoInvDisabled: boolean = false;
    checkListStatus: boolean = true;
    isDeleted: boolean = false;

    remainingDue: number = 0;
    generateDocumentData: GenerateContractsAzure;
    singalDownload: ContractsSingalFile[] = [];
    productYCutOffDate: any;
    productMCutOffDate: any;
    documentVCutOffDate: any;
    canadaNDACutOffDate: any;
    product123CutOffDate: any;
    checkList123StartDate: any;
    isBIPExist: boolean = false;
    isProductV: boolean = false;
    downpaymentExceed: boolean = false;
    serviceButtonText: string = "Save";
    IsContractNumExist: boolean;
    sendToCorpModalTitle: string;
    isContractActionLogDone: boolean = false;
    isGenerateContractsDone: boolean = false;
    isUpdateContractSessionDone: boolean = false;
    exportDocumentIds: string;
    isHandleSendToCorp: boolean = false;
    isBankAccountNameBlank: boolean = false;
    isRoutingNumberBlank: boolean = false;
    isAccountNumberBlank: boolean = false;
    docIds: string;
    isNewCanadianContract: boolean = false;
    ipAddress: string = '';

    constructor(private fb: FormBuilder,
        private fbProduct: FormBuilder,
        private _utilityService: UtilityService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _contactService: ContactService,
        private _configMasterService: ConfigMasterService,
        private _inventionService: InventionService,
        private _wizardService: WizardService,
        private _stateService: StateService,
        private _appconfigService: AppconfigService,
        //private stripeService: StripeService,
        private _countryService: CountryService,
        private _documentService: DocumentService,
        private _productService: ProductService,
        private _officeService: OfficeService,
        private _billingService: BillingService,
        private _contractSessionService: ContractSessionService,
        private _snackBar: MatSnackBar,
        private _infoCollectService: InfoCollectService,
        private _addendumService: AddendumService,
        private _userService: UserService,
        private _navigationService: NavigationService,
        private _mediaImagesService: MediaImagesService,
        private _checkListService: CheckListService,
        private _smsService: SMSService,
        private _emailService: EmailService,
        private _contractActionLogService: ContratActionLogService,
        private _transferDataService: TransferDataService,
        private _inventionCheckListService: InventionCheckListService,
        private _currencyConversion: CurrencyConversionService,
        private _ClientsStateDataService: ClientsStateDataService,
        private sanitizer: DomSanitizer,
        private datePipe: DatePipe,
        private ipService: IpService
    ) {
        this._router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
        this.mySubscription = this._router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // Trick the Router into believing it's last link wasn't previously loaded
                this._router.navigated = false;
            }
        });

        this._route.queryParamMap.subscribe(params => {
            if (params.has('r')) {
                this.encryptedUser = params.get('r');
                this._userService.getAuthenticateR(this.encryptedUser)
                    .then(res => {

                        if (res) {
                            if (res.isvalid) {
                                this.userResponse = UtilityService.clone(res);
                                this.clpUserId = this.userResponse.user.clpUserId;
                                console.log("Valid User");
                            } else {
                                this._router.navigate(['/unauthorized']);
                            }
                        } else {
                            this._router.navigate(['/unauthorized']);
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        console.log("Client side Error : " + err);
                        this._utilityService.handleErrorResponse(err);
                    });
            }
            else {
                console.log('no r');
                this._router.navigate(['/unauthorized']);
            }
        });
    }

    canDeactivate(): Observable<boolean> | boolean {
        return true;
    }


    get form() {
        return this.socGroup.controls;
    }

    get popupform() {
        return this.locationPOPUP.controls;
    }

    get prodForm() {
        return this.prodConfigGroup.controls;
    }

    get collectPaymentForm() {
        return this.collectPaymentGroup.controls;
    }

    highlight(row) {
        this.highlightedRows = [];
        this.highlightedRows.push(row);
    }

    get financeChargePackage() {
        if (this.contractPayment) {
            return (((this.contractPayment.cashPrice - this.contractPayment.PPSOPrice) - (this.contractPayment.downPayment)) * this.contractPayment.financeFactor * (this.contractPayment.months / 12.0) * (this.contractPayment.APR / 10000));
        } else {
            return 0;
        }
    }

    get BIPPrice() {
        if (this.contractPayment) {
            if (this.prodConfigGroup.controls.cashPrice.value) {
                if ($("#contract option:selected").val() === "1") {
                    return (parseFloat((this.prodConfigGroup.controls.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', "") - this.contractPayment.PPSOPrice).toString()).toFixed(2));
                }
                else if ($("#contract option:selected").val() === "2") {
                    return parseFloat(this.prodConfigGroup.controls.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', "").toString()).toFixed(2);
                }
                else
                    return 0;
            }
            else
                return 0;
        }
        else {
            return 0;
        }
    }

    get BIPFinancePrice() {
        if (this.contractPayment) {
            if ($("#contract option:selected").val() === "1" || $("#contract option:selected").val() === "2")
                return parseFloat(this.prodConfigGroup.controls.financeCharge.value.toString()).toFixed(2);
            else
                return 0;
        }
        else {
            return 0;
        }
    }

    get SUBPrice() {
        if (this.contractPayment) {
            if (this.prodConfigGroup.controls.cashPrice.value) {
                if (+$("#contract option:selected").val() >= 3 && +$("#contract option:selected").val() <= 14 && +$("#contract option:selected").val() != 6 && +$("#contract option:selected").val() != 11) {
                    return parseFloat(this.prodConfigGroup.controls.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', "").toString()).toFixed(2);
                }
                else
                    return 0;
            }
            else
                return 0;
        }
        else {
            return 0;
        }
    }

    get SUBFinancePrice() {
        if (this.contractPayment) {
            if (+$("#contract option:selected").val() >= 3 && +$("#contract option:selected").val() <= 14 && +$("#contract option:selected").val() != 6 && +$("#contract option:selected").val() != 11)
                return parseFloat(this.prodConfigGroup.controls.financeCharge.value.toString()).toFixed(2);
            else
                return 0;
        }
        else {
            return 0;
        }
    }
    get PPSOPrice() {
        if (this.contractPayment) {
            if (this.prodConfigGroup.controls.cashPrice.value) {
                if ($("#contract option:selected").val() === "1")
                    return parseFloat(this.contractPayment.PPSOPrice.toString()).toFixed(2);
                else if ($("#contract option:selected").val() === "6" || $("#contract option:selected").val() === "11") {
                    return parseFloat(this.prodConfigGroup.controls.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', "").toString()).toFixed(2);
                }
                else
                    return 0;
            }
            else
                return 0;
        }
        else {
            return 0;
        }
    }
    get PPSOFinancePrice() {
        if (this.contractPayment) {
            if ($("#contract option:selected").val() === "6" || $("#contract option:selected").val() === "11")
                return parseFloat(this.prodConfigGroup.controls.financeCharge.value.toString()).toFixed(2);
            else
                return 0;
        }
        else {
            return 0;
        }
    }

    get PRSPrice() {
        if (this.contractPayment) {
            if ((+$("#contract option:selected").val() >= 7 && +$("#contract option:selected").val() <= 9) || (+$("#contract option:selected").val() == 12 || +$("#contract option:selected").val() == 13 || +$("#contract option:selected").val() == 14))
                return parseFloat(this.contractPayment.PPSOPrice.toString()).toFixed(2);
            else
                return 0;
        }
        else {
            return 0;
        }
    }

    replaceCurrencyMask(value: string) {
        if (!isNullOrUndefined(this.contractSession))
            return value && value.toString().replace(this.currencySterling, "").replace(',', "");
        else
            return value && value.toString().replace(this.currencySterling, "").replace(',', "");
    }

    get paymentForm() { return this.collectPaymentGroup.controls; }

    validateDropdown(e) {
        const controlName = e.srcElement.id;
        this.socGroup.get(controlName).updateValueAndValidity();
    }

    navigateToContactList() {
        this._router.navigate(['/contract-list', this.clpUserId, this.contactId], {
            queryParams: { w: 1, 'clpuserid': this.clpUserId, 'contact': this.contactId, 'r': this.encryptedUser }
        });
    }

    ngOnInit() {

        this.socGroup = this.fb.group({
            firstname: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            lastname: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            address1: [{ value: '' }, [Validators.required]],
            address2: [{ value: '' }],
            address3: [{ value: '' }],
            country: [{ value: '-1' }, [CustomValidators.requiredDropdown(-1)]],
            state: [{ value: '-1' }, [CustomValidators.requiredDropdown(-1)]],
            city: [{ value: '' }, [Validators.required]],
            zipcode: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9-\s]{0,50})$/)]],
            homephone: [{ value: '' }, [Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)]],
            workphone: [{ value: '' }, [Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)]],
            //mobile: [{ value: '' }, [Validators.required, Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)]],
            mobile: [{ value: '' }, [Validators.required]],
            email: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/)]],
            inventname: ['', Validators.required],
            chkinvent: [{ value: false }],
            chkcoInventConfirm: [{ value: false }],
            firstnamei2: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            lastnamei2: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            //mobilei2: [{ value: '' }, [Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)]],
            //emaili2: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/)]],
            initialSignature: [{ value: '' }],
            initialCoInvSignature: [{ value: '' }],
            initialAdsSignature: [{ value: '' }],
            initialAdsCoInvSignature: [{ value: '' }],
            otherState: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            otherCountry: [{ value: '' }],
        });
        this.prodConfigGroup = this.fbProduct.group({
            paymentFull: [{ value: true }],
            paymentInstallment: [{ value: false }],
            autoPaymentYes: [{ value: true }],
            autoPaymentNo: [{ value: false }],
            payCheck: [{ value: false }],
            payMoneyOrder: [{ value: false }],
            payCreditCard: [{ value: false }],
            payCash: [{ value: false }],
            payMonterey: [{ value: false }],
            payOther: [{ value: false }],
            payCarryOver: [{ value: false }],
            contract: ['1', Validators.required],
            cashPrice: ['', [Validators.required, Validators.max(99999)]],
            downPayment: [{ value: 0, disabled: false }, [Validators.required, Validators.max(99999)]],
            contractNo: [{ value: '', disabled: true }, [Validators.required, Validators.pattern(/^[_A-z0-9]*((-|\s)*[_A-z0-9])*$/)]],
            officeCode: ['1', Validators.required],

            rolloverAmount: [{ value: 0 }, [Validators.max(99999)]],
            repaymentTerm: [{ value: 2 }],
            promotionOffer: ['-1'],
            APR: [{ value: 0 }],
            financeAmount: [{ value: 0 }],
            financeAmountA: [{ value: 0 }],
            financeAmountB: [{ value: 0 }],
            financeFactor: [{ value: 0 }],
            financeCharge: [{ value: 0 }],
            financeChargeA: [{ value: 0 }],
            financeChargeB: [{ value: 0 }],
            firstPayment: [{ value: 0 }],
            firstDueDate: [{ value: '' }],
            isAutoPayment: [{ value: false }],
            masterPPSOPrice: [{ value: 0 }],
            PPSOPrice: [{ value: 0 }],
            months: [{ value: 0 }],
            totalPayment: [{ value: 0 }],
            totalSalePrice: [{ value: 0 }],
            unpaidBalance: [{ value: 0 }],
            regularPayment: [{ value: 0 }],


            hasillustrations: [{ value: false }],
            isproductinproduction: [{ value: false }],
            isclientinventory: [{ value: false }],
            hasphotographs: [{ value: false }],
            hascopyrighttradmark: [{ value: false }],
            ispatentissued: [{ value: false }],
            hasprototype: [{ value: false }],
            haspatentpending: [{ value: false }],
            patentissuednumber: [{ value: '', disabled: true }],
            haspatentinterestuseevolve: [{ value: false }],
            haspatentinterestuseown: [{ value: false }],
            hasnopatentinterest: [{ value: false }],
            isPPSOConfirmed: [{ value: false }],

            isNoService: [{ value: false }],
            isAddendumB: [{ value: false }],
            isAddendumG: [{ value: false }],
            isAddendumP: [{ value: false }],
            isPatentServices: [{ value: false }],

            isIMPAgree: [{ value: false }],

            i1DOB: [{ value: '' }],
            i1SSN: [{ value: '' }, Validators.minLength(9)],
            i1SSNMask: [{ value: '' }, Validators.minLength(9)],
            i1AddressYear: [{ value: 0 }],
            i1AddressMonth: [{ value: 0 }, Validators.max(12)],
            i1HomeType: [{ value: '' }],
            i1HomeOwner: [{ value: false }],
            i1HomeRent: [{ value: false }],
            i1HomeOther: [{ value: false }],
            i1PreviousHomeAdd: [{ value: '' }],
            i1PreviousHomeApt: [{ value: '' }],
            i1PreviousHomeCity: [{ value: '' }],
            i1PreviousHomeZip: [{ value: '' }],
            i1PreviousHomeState: [{ value: '' }],
            i1PreviousAddYear: [{ value: 0 }],
            i1PreviousAddMonth: [{ value: 0 }, Validators.max(12)],
            i1PresentPosition: [{ value: '' }],
            i1PresentEmp: [{ value: '' }],
            i1PresentEmpYear: [{ value: 0 }],
            i1PresentEmpMonth: [{ value: 0 }, Validators.max(12)],
            i1PresentMonthlyInc: [{ value: '' }],
            i1BusinessAdd: [{ value: '' }],
            i1BusinessHomeCity: [{ value: '' }],
            i1BusinessHomeState: [{ value: '' }],
            i1BusinessHomeZip: [{ value: '' }],
            i1BusinessPhone: [{ value: '' }, [Validators.pattern(/^\d{10}$/)]],
            i1PreviousEmpName: [{ value: '' }],
            i1PreviousEmpPos: [{ value: '' }],
            i1PreviousEmpAdd: [{ value: '' }],
            i1PreviousEmpYear: [{ value: 0 }],
            i1PreviousEmpMonth: [{ value: 0 }, Validators.max(12)],
            i1PreviousMonthlyInc: [{ value: '' }],
            i1MonthlytOtherInc: [{ value: '' }],
            iI1MonthlyOtherIncSrc: [{ value: '' }],
            i1RelativeName: [{ value: '' }],
            i1RelativeAdd: [{ value: '' }],
            i1RelativeCity: [{ value: '' }],
            i1RelativeState: [{ value: '' }],
            i1RelativeRelation: [{ value: '' }],
            i1RelativePhone: [{ value: '' }],
            i2DOB: [{ value: '' }],
            i2SSN: [{ value: '' }],
            i2PresentHomeAdd1: [{ value: '' }],
            i2PresentHomeAdd2: [{ value: '' }],
            i2PresentHomeCity: [{ value: '' }],
            i2PresentHomeState: [{ value: '' }],
            i2PresentHomeZip: [{ value: '' }],
            i2PresentPhone: [{ value: '' }],
            i2RelationshipI1: [{ value: '' }],
            i2PresentPosition: [{ value: '' }],
            i2PresentEmp: [{ value: '' }],
            i2PresentEmpYear: [{ value: 0 }],
            i2PresentEmpMonth: [{ value: 0 }],
            i2PresentMonthlyInc: [{ value: '' }],
            i2BusinessAdd: [{ value: '' }],
            i2BusinessHomeCity: [{ value: '' }],
            i2BusinessHomeState: [{ value: '' }],
            i2BusinessHomeZip: [{ value: '' }],
            i2BusinessPhone: [{ value: '' }],
            i2PreviousEmpName: [{ value: '' }],
            i2PreviousEmpPos: [{ value: '' }],
            i2PreviousEmpAdd: [{ value: '' }],
            i2PreviousEmpYear: [{ value: 0 }],
            i2PreviousEmpMonth: [{ value: 0 }],
            i2PreviousMonthlyInc: [{ value: '' }],
            i2MonthlytOtherInc: [{ value: '' }],
            i2MonthlyOtherIncSrc: [{ value: '' }],

            chkNoAutoPay: [{ value: false }],
            chkSaveAc: [{ value: false }],
            bankName: ['', [Validators.pattern(/^[_A-z0-9 ]*((-|\s)*[_A-z0-9])*$/)]],
            ABANo: [{ value: '' }, Validators.minLength(9)],
            chkAcNo: [{ value: '' }],
            accountType: ['-1'],
            chkCCard: [{ value: true }],
            cCardNo: [{ value: '' }, Validators.minLength(14)],
            cCardExpDT: ['', [Validators.pattern(/^0[1-9]|^(10)|^(11)|^(12)[0-9][0-9]*$/)]],
            cCardCVV: [{ value: '' }],
            altDayMonth: [{ value: 0 }, Validators.max(31)],
            altAmount: [{ value: '' }, [Validators.max(99999)]],
            isSubmitYes: [{ value: false }],
            isSubmitNo: [{ value: false }],

            isAcceptYes: [{ value: false }],
            isAcceptNo: [{ value: false }],

            isDataBankYes: [{ value: false }],
            isDataBankNo: [{ value: false }],

            isSolicitsYes: [{ value: false }],
            isSolicitsNo: [{ value: false }],

            isIdeasYes: [{ value: false }],
            isIdeasNo: [{ value: false }],

            isPrepareYes: [{ value: false }],
            isPrepareNo: [{ value: false }],

            isStaffYes: [{ value: false }],
            isStaffNo: [{ value: false }],

            isBIPSYes: [{ value: false }],
            isBIPSNo: [{ value: false }],

            isPRSYes: [{ value: false }],
            isPRSNo: [{ value: false }],

            isSoldYes: [{ value: false }],
            isSoldNo: [{ value: false }],

            isSendYes: [{ value: false }],
            isSendNo: [{ value: false }],

            isShowsYes: [{ value: false }],
            isShowsNo: [{ value: false }],

            isWorkBrochureYes: [{ value: false }],
            isWorkBrochureNo: [{ value: false }],

            isBIPYes: [{ value: false }],
            isBIPNo: [{ value: false }],

            isBIPReportYes: [{ value: false }],
            isBIPReportNo: [{ value: false }],

            isNABIPReport: [{ value: false }],

            isServiceFeesYes: [{ value: false }],
            isServiceFeesNo: [{ value: false }],

            isADSYes: [{ value: false }],
            isADSNo: [{ value: false }],

            isNDAYes: [{ value: false }],
            isNDANo: [{ value: false }],

            isPRSBrochureYes: [{ value: false }],
            isPRSBrochureNo: [{ value: false }],

            isPPSOYes: [{ value: false }],
            isPPSONo: [{ value: false }],
            isNAPPSO: [{ value: false }],

            comments: [{ value: '' }],
            bestTimeToReach: [{ value: '' }],
            
            isSolicitYes: [{ value: false }],
            isSolicitNo: [{ value: false }],
            
            isRefineYes: [{ value: false }],
            isRefineNo: [{ value: false }],
            
            isIndependentYes: [{ value: false }],
            isIndependentNo: [{ value: false }],
            
            isAttorneyYes: [{ value: false }],
            isAttorneyNo: [{ value: false }],
            
            isPurchasedYes: [{ value: false }],
            isPurchasedNo: [{ value: false }],

            coInventor: [{ value: false }],
            i2firstname: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            i2lastname: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
        });
        this.signDocsGroup = this.fb.group({
            fourthCtrl: ['', Validators.required],
            initialFinalSignature: [{ value: '' }],
            initialFinalCoInvSignature: [{ value: '' }]
        });
        this.collectPaymentGroup = this.fb.group({
            firstName: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            lastName: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            creditCard: [{ value: '' }, [Validators.required, Validators.minLength(14)]],
            expirationDate: ['', [Validators.required, Validators.pattern(/^0[1-9]|^(10)|^(11)|^(12)[0-9][0-9]*$/)]],
            cvc: [{ value: '' }, [Validators.required, Validators.minLength(3), Validators.pattern(/^[0-9\s]{3,4}$/)]],
            zip: [{ value: '' }, [Validators.minLength(5), Validators.pattern(/^[a-zA-Z0-9\s]{5,10}$/)]],
            paymentType: [{ value: false }],
            fileNo: [{ value: false }],
            chkBankName: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,25})$/)]],
            chkCity: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,25})$/)]],
            chkState: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,25})$/)]],
            chkRoutingNo: [{ value: '' }],
            chkAccNo: [{ value: '' }],
            chkNumber: [{ value: '' }],
            bankAccountName: [{ value: '' }],
        });

        this.locationPOPUP = this.fb.group({
            clientstate: [{ value: '-1' }, [CustomValidators.requiredDropdown(-1)]],
            isClientRemote: [{ value: false }],
        });

        this._route.paramMap.subscribe(async params => {
            if (params.has('invention')) {
                this.inventionId = +params.get('invention');
            }

            if (params.has('contractSessionId')) {
                this.contractSessionId = +params.get('contractSessionId');
            }
            if (params.has('rdClpUserId')) {
                this.rdClpUserId = +params.get('rdClpUserId');
            }
        });

        this.checkUserState();
        resizeCanvas();
        this.setCCKeys("InventHelp_CS_Site");

        this.socPanelTitle = 'Statement of Confidentiality';
        this.prodConfigPanelTitle = 'Select Services';
        this.infoCollectPanelTitle = 'Information Collection';
        this.paymentCollectPanelTitle = 'Payment Collection';

        this.prodConfigGroup.patchValue({
            paymentFull: true,
            paymentInstallment: false,
            autoPaymentYes: true,
            autoPaymentNo: false,
            promotionOffer: -1,
            firstDueDate: '',
            payCash: false,
            payCheck: false,
            payOther: false,
            payCarryOver: false,
            payMoneyOrder: false,
            payCreditCard: false,
            payMonterey: false,
            downPayment: '0.00',
            rolloverAmount: '0.00',
            repaymentTerm: 3,

            hasillustrations: false,
            isproductinproduction: false,
            isclientinventory: false,
            hasphotographs: false,
            hascopyrighttradmark: false,
            ispatentissued: false,
            hasprototype: false,
            haspatentpending: false,
            patentissuednumber: '',
            haspatentinterestuseevolve: false,
            haspatentinterestuseown: false,
            hasnopatentinterest: false,
            isPPSOConfirmed: false,

            isNoService: false,
            isAddendumB: false,
            isAddendumG: false,
            isAddendumP: false,
            isPatentServices: false,

            isIMPAgree: false,

            i1DOB: '',
            i1SSN: '',
            i1SSNMask: '',
            i1AddressYear: 0,
            i1AddressMonth: 0,
            i1HomeType: '',
            i1HomeOwner: true,
            i1HomeRent: false,
            i1HomeOther: false,
            i1EmailAddress: '',
            i1PreviousHomeAdd: '',
            i1PreviousHomeCity: '',
            i1PreviousHomeZip: '',
            i1PreviousHomeState: '',
            i1PreviousAddYear: 0,
            i1PreviousAddMonth: 0,
            i1PresentPosition: '',
            i1PresentEmp: '',
            i1PresentEmpYear: 0,
            i1PresentEmpMonth: 0,
            i1PresentMonthlyInc: '',
            i1BusinessAdd: '',
            i1BusinessHomeCity: '',
            i1BusinessHomeState: '',
            i1BusinessHomeZip: '',
            i1BusinessPhone: '',
            i1PreviousEmpName: '',
            i1PreviousEmpPos: '',
            i1PreviousEmpAdd: '',
            i1PreviousEmpYear: 0,
            i1PreviousEmpMonth: 0,
            i1PreviousMonthlyInc: '',
            i1MonthlytOtherInc: '',
            iI1MonthlyOtherIncSrc: '',
            i1RelativeName: '',
            i1RelativeAdd: '',
            i1RelativeCity: '',
            i1RelativeState: '',
            i1RelativeRelation: '',
            i1RelativePhone: '',
            i2DOB: '',
            i2SSN: '',
            i2PresentHomeAdd1: '',
            i2PresentHomeAdd2: '',
            i2PresentHomeCity: '',
            i2PresentHomeState: '',
            i2PresentHomeZip: '',
            i2PresentPhone: '',
            i2RelationshipI1: '',
            i2PresentPosition: '',
            i2PresentEmp: '',
            i2PresentEmpYear: 0,
            i2PresentEmpMonth: 0,
            i2PresentMonthlyInc: '',
            i2BusinessAdd: '',
            i2BusinessHomeCity: '',
            i2BusinessHomeState: '',
            i2BusinessHomeZip: '',
            i2BusinessPhone: '',
            i2PreviousEmpName: '',
            i2PreviousEmpPos: '',
            i2PreviousEmpAdd: '',
            i2PreviousEmpYear: 0,
            i2PreviousEmpMonth: 0,
            i2PreviousMonthlyInc: '',
            i2MonthlytOtherInc: '',
            i2MonthlyOtherIncSrc: '',

            chkNoAutoPay: false,
            chkSaveAc: false,
            bankName: '',
            ABANo: '',
            chkAcNo: '',
            accountType: '-1',
            chkCCard: true,
            cCardNo: '',
            cCardExpDT: '',
            cCardCVV: '',
            altDayMonth: '',
            altAmount: '',
        });


        this.collectPaymentGroup.patchValue({
            firstName: '',
            lastName: '',
            creditCard: '',
            expirationDate: '',
            cvc: '',
            zip: '',
            paymentType: false,
            fileNo: false,
            chkBankName: '',
            chkCity: '',
            chkState: '',
            chkRoutingNo: '',
            chkAccNo: '',
            chkNumber: '',
            bankAccountName: ''
        })
        this.loadInvention();
        this.refresh();
        this.refreshSignedROINavigation();
        this.checkFileNumber();
        this.GetGenerateContractDetails();
        this._wizardService.getEvolveCSSiteURLAsync(this.encryptedUser)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (result.statusCode === 0) {
                        this.simpleResponse = UtilityService.clone(result);
                        if (this.simpleResponse) {
                            this.site = this.simpleResponse.messageString;
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });



        this.afuConfig = {
            theme: 'dragNDrop',
            hideResetBtn: false,
            hideSelectBtn: false,
            maxSize: 100,
            uploadAPI: {
                url: this.site + 'api/MediaImages/MediaDocumentPost/' + this.inventionId,

                headers: {
                },
            },
            formatsAllowed: '.jpg,.png,.pdf,.docx, .txt,.gif,.jpeg,.xlsx,.pptx,.bmp,.tiff,.mp4',
            multiple: true,
            replaceTexts: {
                selectFileBtn: 'Select Media',
                resetBtn: 'Reset',
                uploadBtn: 'Upload Media',
                dragNDropBox: 'Drag and Drop your image here',
                attachPinBtn: 'Attach Files...',
                afterUploadMsg_success: '',
                afterUploadMsg_error: 'Upload Failed!',
            }
        };

        this.paymentDocConfig = {
            theme: 'dragNDrop',
            hideResetBtn: false,
            hideSelectBtn: false,
            maxSize: 10,
            uploadAPI: {
                url: this.site + 'api/MediaImages/PaymentDocPost/' + this.inventionId + '/' + this.contractSessionId + '/' + this.currentMultiPayId + '/' + 0,

                headers: {
                },
            },
            formatsAllowed: '.jpg,.png,.pdf,.docx, .txt,.gif,.jpeg,.xlsx,.pptx,.bmp,.tiff',
            multiple: true,
            replaceTexts: {
                selectFileBtn: 'Select Image',
                resetBtn: 'Reset',
                uploadBtn: 'Upload Image',
                dragNDropBox: 'Drag and Drop your image here',
                attachPinBtn: 'Attach Files...',
                afterUploadMsg_success: 'Successfully Uploaded!',
                afterUploadMsg_error: 'Upload Failed!',
            }
        };



        this.signDocsGroup.patchValue({
            initialFinalSignature: '',
            initialFinalCoInvSignature: ''
        });

        this.loadContractActionlog(this.contractSessionId);
        this.refreshGetGenerateContractDetails();
        this.refreshCheckSendToCorpProcess();
        this.getIP();
    }

    getIP() {
        this.ipService.getIPAddress().subscribe((res: any) => {
            this.ipAddress = res.ip;
            console.log('this.ipAddress', this.ipAddress);
        });
    }


    updateContractLogObjectModel(Action: string, finalAction: boolean) {
        if (this.contractActionlog) {
            if (finalAction) {
                this.contractActionlog.audiFlag = this.contractActionlog.dtContractSign || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                this.contractActionlog.finalActionFlag = "contractSign";
            }
            switch (Action) {
                case "socSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtSOCForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "socSubmit";
                    break;
                case "socDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtSOCDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "socDocSign";
                    break;
                case "adsDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtADSDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "adsDocSign";
                    break;
                case "stateDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtStateDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "stateDocSign";
                    break;
                case "serviceSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtProdServicesForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.productId = this.productId;
                    this.contractActionlog.actionFlag = "serviceSubmit";
                    break;
                case "ndaDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtNDADoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "ndaDocSign";
                    break;
                case "waitStateDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtWaitDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "waitStateDocSign";
                    break;
                case "bipFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtBIPForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "bipFormSubmit";
                    break;
                case "bipDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtBIPDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "bipDocSign";
                    break;
                case "ppsoDocsign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtPPSODoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "ppsoDocsign";
                    break;
                case "retailInstallmentDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtRetailDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "retailInstallmentDocSign";
                    break;
                case "ppaDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtPPADoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "ppaDocSign";
                    break;
                case "inventFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtInformInventForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "inventFormSubmit";
                    break;
                case "inventDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtInformInventDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "inventDocSign";
                    break;
                case "uniPayFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtUniPayForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "uniPayFormSubmit";
                    break;
                case "uniPayDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtUniPayDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "uniPayDocSign";
                    break;

                case "roiFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtROIForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "roiFormSubmit";
                    break;
                case "roiDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtROIDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "roiDocSign";
                    break;
                case "payCollectionFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtPayCollectForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "payCollectionFormSubmit";
                    break;
                case "payReminder":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtPaymentReminder || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "payReminder";
                    break;
                case "sendToCorp":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtSendCrop || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "sendToCorp";
                    break;
                case "cancelled":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtCancel || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "cancelled";
                    break;
                case "addendumSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addendumSubmit";
                    break;
                case "subDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "subDocSign";
                    break;
                case "addmBDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumBDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addmBDocSign";
                    break;
                case "addmGDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumGDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addmGDocSign";
                    break;
                case "addmPDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumPDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addmPDocSign";
                    break;
                case "addmTDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumTDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addmTDocSign";
                    break;
                case "addmVDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumVDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addmVDocSign";
                    break;
                case "patentDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtPatentDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "patentDocSign";
                    break;
                case "introMarkDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtIntroMarkDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "introMarkDocSign";
                    break;
                case "impSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtIMPForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "impSubmit";
                    break;
                case "impDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtIMPDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "impDocSign";
                    break;
                case "additionalDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAdditionalDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "additionalDocSign";
                    break;
                case "checkListFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtCheckListForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "checkListFormSubmit";
                    break;
                case "checkListDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtCheckListDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "checkListDocSign";
                    break;
                case "contractSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtContractSign || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "contractSign";
                    break;
                default:
                    break;
            }
            this.contractActionlog.modifiedBy = this.clpUserId;
        }
    }

    async saveContrActionAcitonLog(source?: string, divId?) {
        if (isNullOrUndefined(this.contractActionlog)) {
            await this.loadContractActionlog(this.contractSessionId);
        }
        await this._contractActionLogService.updateContractActionLog(this.encryptedUser, this.contractActionlog)
            .then(res => {
                if (res) {
                    this.loadContractActionlog(this.contractSessionId);
                    if (source == "CustomerAccept")
                        this.updateUserSteps(divId);
                    if (source == "addendumSubmit")
                        this.loadDocument();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
        this.isContractActionLogDone = true;
    }

    async loadContractActionlog(contractSessionId: number) {
        await this._contractActionLogService.getContractActionLog(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    this.contractActionlog = UtilityService.clone(res);
                    if (!isNullOrUndefined(this.contractActionlog)) {
                        this.isFinalSignWait = this.contractActionlog.isFinalSign;
                        this.loadAddendumServices();
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    async loadWaitDate(contractSessionId: number) {
        await this._contractActionLogService.getContractActionLogWaitDT(this.encryptedUser, contractSessionId)
            .then(res => {
                if (res) {
                    this.dtFirstWaitDate = UtilityService.clone(res);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    deleteDocMedia(mediaID: number) {
        this._mediaImagesService.DeleteDocumentMediaByID(mediaID, this.inventionId, this.encryptedUser)
            .subscribe(
                (result: MediaDocImagesResponse) => {
                    this.globalResponse = result;
                    this.mediaDocImagesResponse = result;
                },
                error => {
                    console.error(error);
                    this.mediaDocList = null;
                },
                () => {

                    if (typeof this.globalResponse === 'object' && this.globalResponse.lastAdded > 0) {
                        let objMedia = this.mediaDocList.find(x => x.MediaId == mediaID);
                        if (objMedia) {
                            objMedia.MediaId = -1;
                            this.mediaDocList = this.mediaDocList.filter(x => x.MediaId != -1);
                        }
                        this.globalResponse = null;
                        this.isROIDocMedia = false;
                        if (this.mediaDocList.length > 0)
                            this.isROISignDoc = true

                    }
                    else {
                        this.mediaDocList = null;
                        if (!this.inventionResponse.inventionDetails.IsAgree) {
                            this.uncheckNavBar('tdIsROIForm');
                            this.navigationResponse.navigation.isROIForm = false;
                            this.uncheckNavBar('tdIsROIDoc');
                            this.navigationResponse.navigation.isROIDoc = false;
                            this.saveNavigationWizard();
                        }
                        this.isROIDocMedia = true;
                    }
                    this.openSnackBar("The document was deleted.", "");
                }
            );
    };

    deleteCheckList(mediaID: number) {
        this.checkListDeleted = true;
        this._checkListService.DeleteCheckListByID(mediaID, this.contractSessionId, this.encryptedUser)
            .subscribe(
                (result: CheckListImagesResponse) => {
                    this.globalCheckListResponse = result;
                    this.checkListImagesResponse = result;

                },
                error => {
                    console.error(error);
                    this.checkList = null;
                },
                () => {

                    if (typeof this.globalCheckListResponse === 'object' && this.globalCheckListResponse.lastAdded > 0) {
                        let objMedia = this.checkList.find(x => x.MediaId == mediaID);
                        if (objMedia) {
                            objMedia.MediaId = -1;
                            this.checkList = this.checkList.filter(x => x.MediaId != -1);
                        }
                        this.globalResponse = null;
                        this.isCheckListDocMedia = false;
                        if (this.checkList.length > 0)
                            this.isCheckListSignDoc = true
                    }
                    else {
                        this.checkList = null;
                        this.uncheckNavBar('tdIsCheckListForm');
                        this.navigationResponse.navigation.isCheckListForm = false;
                        this.uncheckNavBar('tdIsCheckListDoc');
                        this.navigationResponse.navigation.isCheckListDoc = false;
                        this.saveNavigationWizard();
                        this.isCheckListDocMedia = true;
                    }

                    this._documentService.getProductDocumentList(this.encryptedUser, "-3", this.inventionId, this.contactId, this.contractSessionId)
                        .subscribe((result: DocumentResponseList) => {
                            if (result) {
                                if (result.statusCode == 0) {
                                    this.documentListResponse = UtilityService.clone(result);
                                    if (this.documentListResponse && this.documentListResponse.docList.length > 0) {

                                        let doc: DocType = this.documentListResponse.docList[0];

                                        if (doc) {
                                            this.docSignCheckList = UtilityService.clone(doc.document); this.isCheckListSignDoc = true; if (this.docSignCheckList == "") this.docSignCheckList = "Please upload the checklist images.";
                                            this.checkListDeleted = false;
                                        }
                                    }
                                } else {
                                    console.log("loadDocument_DocTypeId.statusCode: " + result.statusCode);
                                }
                            }
                        },
                            error => {
                                console.error(error);
                            }
                        );
                    this.openSnackBar("The Checklist was deleted.", "");

                }
            );
    };

    ngAfterViewInit() {
        $("#dvSOCMandDoc img:last-child").remove();
        $("#dvADSMandDoc img:last-child").remove();
        $("#dvNDAMandDoc img:last-child").remove();
        $("#dvSDAMandDoc img:last-child").remove();
    }

    @HostListener('window:scroll', ['$event'])
    checkOffsetTop() {
        if (!isNullOrUndefined(this.stepper)) {
            if (this.stepper.selectedIndex == 0) {
                if (this.divSOC || this.isSOCMandDoc)
                    this.currentActive = 1;
                else {
                    if (this.isADSMandDoc == true)
                        this.currentActive = 2;
                    else if (this.isSDAMandDoc == true)
                        this.currentActive = 4;
                }
            }
            if (this.stepper.selectedIndex == 1) {

                if (this.divOtherMandDocs && this.isNDAMandDoc)
                    this.currentActive = 3;
                else if (this.divOtherMandDocs && this.isWaitStateDoc)
                    this.currentActive = 14;
                else {
                    var elPS = document.getElementById('divPS');
                    var elBIP = document.getElementById('divBIP');
                    var elIFI = document.getElementById('divIFI');
                    var elUPC = document.getElementById('divUPC');
                    var elROI = document.getElementById('divROI');
                    var elCheckList = document.getElementById('divCheckList');
                    var elNDA = document.getElementById('dvNDASignDoc');
                    var elWaitState = document.getElementById('dvWaitSignDoc');
                    var elRetailInsDocument = document.getElementById('dvRetailInsDocument');
                    var elPPSODocument = document.getElementById('dvPPSODocument');
                    var elSUB = document.getElementById('divSUB');
                    var elIMP = document.getElementById('divIMP');

                    var elPSTop = elPS.getBoundingClientRect().top + window.scrollY - 120;
                    var elBIPTop = elBIP.getBoundingClientRect().top + window.scrollY - 120;
                    var elIFITop = elIFI.getBoundingClientRect().top + window.scrollY - 120;
                    var elUPCTop = elUPC.getBoundingClientRect().top + window.scrollY - 120;
                    var elCheckListTop = elCheckList.getBoundingClientRect().top + window.scrollY - 120;
                    var elNDATop = elNDA.getBoundingClientRect().top + window.scrollY - 120;
                    var elWaitStateTop = elWaitState.getBoundingClientRect().top + window.scrollY - 120;
                    var elRetailInsDocumentTop = elRetailInsDocument.getBoundingClientRect().top + window.scrollY - 120;
                    var elPPSODocumentTop = elPPSODocument.getBoundingClientRect().top + window.scrollY - 120;
                    var elSUBTop = elSUB.getBoundingClientRect().top + window.scrollY - 120;
                    var elIMPTop = elIMP.getBoundingClientRect().top + window.scrollY - 120;
                    var elROITop = elROI.getBoundingClientRect().top + window.scrollY - 120;

                    if (this.isNavBarClick == false) {
                        switch (!isNullOrUndefined(this.contractSession) && this.contractSession.productId) {
                            case 3: //Sub Only            
                            case 7: // Sub With Patent
                            case 8:
                            case 9:
                            case 10:
                            case 12:
                            case 13:
                            case 14:
                                if (this.contractSession && (this.contractSession.CountryID == 3 || this.contractSession.CountryID == 4 || this.contractSession.CountryID == 6)) {
                                    if (window.scrollY >= elPSTop && window.scrollY < elSUBTop) this.currentActive = 5;
                                    if (this.flgInstallment) {
                                        if (window.scrollY >= elSUBTop && window.scrollY < elUPCTop) this.currentActive = 15;
                                        else if (window.scrollY >= elUPCTop && window.scrollY < elCheckListTop) this.currentActive = 11;
                                    }
                                    else {
                                        if (window.scrollY >= elSUBTop && window.scrollY < elCheckListTop) this.currentActive = 15;
                                    }
                                    if (window.scrollY >= elCheckListTop) this.currentActive = 18;
                                }
                                else {
                                    if (this.isWaitStateExists) {
                                        if (window.scrollY >= elPSTop && window.scrollY < elSUBTop) this.currentActive = 5;
                                        else if (window.scrollY >= elNDATop && window.scrollY < elWaitStateTop) this.currentActive = 3;
                                        else if (window.scrollY >= elWaitStateTop && window.scrollY < elSUBTop) this.currentActive = 14;
                                    } else {
                                        if (window.scrollY >= elPSTop && window.scrollY < elSUBTop) this.currentActive = 5;
                                        else if (window.scrollY >= elNDATop && window.scrollY < elSUBTop) this.currentActive = 3;
                                    }

                                    if (this.flgInstallment) {
                                        if (window.scrollY >= elSUBTop && window.scrollY < elIFITop) this.currentActive = 15;
                                        else if (window.scrollY >= elIFITop && window.scrollY < elUPCTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUPCTop && window.scrollY < elCheckListTop) this.currentActive = 11;
                                        else if (window.scrollY >= elCheckListTop) this.currentActive = 18;
                                    } else {
                                        if (window.scrollY >= elSUBTop && window.scrollY < elCheckListTop) this.currentActive = 15;
                                        else if (window.scrollY >= elCheckListTop) this.currentActive = 18;
                                    }
                                }
                                break;
                            case 4: case 5: // IMP
                                if (window.scrollY >= elPSTop && window.scrollY < elIMPTop) this.currentActive = 5;
                                else if (window.scrollY >= elIMPTop && window.scrollY < elSUBTop) this.currentActive = 16;
                                if (this.contractSession && (this.contractSession.CountryID == 3 || this.contractSession.CountryID == 4 || this.contractSession.CountryID == 6)) {
                                    if (this.flgInstallment) {
                                        if (window.scrollY >= elSUBTop && window.scrollY < elUPCTop) this.currentActive = 15;
                                        else if (window.scrollY >= elUPCTop) this.currentActive = 11;
                                    }
                                }
                                else {
                                    if (this.flgInstallment) {
                                        if (window.scrollY >= elSUBTop && window.scrollY < elIFITop) this.currentActive = 15;
                                        else if (window.scrollY >= elIFITop && window.scrollY < elUPCTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUPCTop) this.currentActive = 11;
                                    }
                                }
                                if (!this.flgInstallment && window.scrollY >= elSUBTop) this.currentActive = 15;
                                break;
                            case 1: // BWP
                                if (this.isWaitStateExists) {
                                    if (window.scrollY >= elPSTop && window.scrollY < elBIPTop) this.currentActive = 5;
                                    else if (window.scrollY >= elNDATop && window.scrollY < elWaitStateTop) this.currentActive = 3;
                                    else if (window.scrollY >= elWaitStateTop && window.scrollY < elBIPTop) this.currentActive = 14;
                                } else {
                                    if (window.scrollY >= elPSTop && window.scrollY < elBIPTop) this.currentActive = 5;
                                    else if (window.scrollY >= elNDATop && window.scrollY < elBIPTop) this.currentActive = 3;
                                }

                                if (this.flgInstallment) {
                                    if (window.scrollY >= elBIPTop && window.scrollY < elIFITop) this.currentActive = 7;
                                    else if (window.scrollY >= elIFITop && window.scrollY < elUPCTop) this.currentActive = 9;
                                    else if (window.scrollY >= elUPCTop && window.scrollY < elROITop) this.currentActive = 11;
                                } else {
                                    if (window.scrollY >= elBIPTop && window.scrollY < elROITop) this.currentActive = 7;
                                }
                                if (window.scrollY >= elROITop) this.currentActive = 12;
                                break;
                            case 2: // BIP Only
                                if (this.isWaitStateExists) {
                                    if (window.scrollY >= elPSTop && window.scrollY < elBIPTop) this.currentActive = 5;
                                    else if (window.scrollY >= elNDATop && window.scrollY < elWaitStateTop) this.currentActive = 3;
                                    else if (window.scrollY >= elWaitStateTop && window.scrollY < elBIPTop) this.currentActive = 14;
                                } else {
                                    if (window.scrollY >= elPSTop && window.scrollY < elBIPTop) this.currentActive = 5;
                                    else if (window.scrollY >= elNDATop && window.scrollY < elBIPTop) this.currentActive = 3;
                                }

                                if (this.flgInstallment) {
                                    if (window.scrollY >= elBIPTop && window.scrollY < elIFITop) this.currentActive = 7;
                                    else if (window.scrollY >= elIFITop && window.scrollY < elUPCTop) this.currentActive = 9;
                                    else if (window.scrollY >= elUPCTop && window.scrollY < elROITop) this.currentActive = 11;
                                } else {
                                    if (window.scrollY >= elBIPTop && window.scrollY < elROITop) this.currentActive = 7;
                                }
                                if (window.scrollY >= elROITop) this.currentActive = 12;
                                break;
                            case 6: // PPSO
                            case 11: // PPSO
                                if (window.scrollY >= elPSTop) this.currentActive = 5;
                                if (this.flgInstallment) {
                                    if (window.scrollY >= elIFITop && window.scrollY < elUPCTop) this.currentActive = 9;
                                    else if (window.scrollY >= elUPCTop) this.currentActive = 11;
                                } else {
                                    if (window.scrollY >= elPSTop) this.currentActive = 5;
                                }
                                if (window.scrollY >= elROITop) this.currentActive = 12;
                                break;
                            default:
                                if (this.isWaitStateExists) {
                                    if (window.scrollY >= elPSTop && window.scrollY < elBIPTop) this.currentActive = 5;
                                    else if (window.scrollY >= elNDATop && window.scrollY < elWaitStateTop) this.currentActive = 3;
                                    else if (window.scrollY >= elWaitStateTop && window.scrollY < elBIPTop) this.currentActive = 14;
                                } else {
                                    if (window.scrollY >= elPSTop && window.scrollY < elBIPTop) this.currentActive = 5;
                                    else if (window.scrollY >= elNDATop && window.scrollY < elBIPTop) this.currentActive = 3;
                                }

                                if (this.flgInstallment) {
                                    if (window.scrollY >= elBIPTop && window.scrollY < elIFITop) this.currentActive = 7;
                                    else if (window.scrollY >= elIFITop && window.scrollY < elUPCTop) this.currentActive = 9;
                                    else if (window.scrollY >= elUPCTop && window.scrollY < elCheckListTop) this.currentActive = 11;
                                    else if (window.scrollY >= elCheckListTop) this.currentActive = 18;
                                } else {
                                    if (window.scrollY >= elBIPTop && window.scrollY < elCheckListTop) this.currentActive = 7;
                                    else if (window.scrollY >= elCheckListTop) this.currentActive = 18;
                                }
                                break;
                        }
                    }

                }
            }

            if (this.stepper.selectedIndex == 2) {
                var elSOCSignDoc = document.getElementById('dvSOCSignDoc');
                var elADSSignDoc = document.getElementById('dvADSSignDoc');
                var elNDASignDoc = document.getElementById('dvNDASignDoc');
                var elSDASignDoc = document.getElementById('dvSDASignDoc');
                var elWaitStateDoc = document.getElementById('dvWaitSignDoc');
                var elBIPDocument = document.getElementById('dvBIPDocument');
                var elPPSODocument = document.getElementById('dvPPSODocument');
                var elPPADocument = document.getElementById('dvPPADocument');
                var elInfoInventDocument = document.getElementById('dvInfoInventDocument');
                var elRetailInsDocument = document.getElementById('dvRetailInsDocument');
                var elUniPayDocument = document.getElementById('dvUniPayDocument');
                var elROIDocument = document.getElementById('dvROIDocument');
                var elCheckListDocument = document.getElementById('dvCheckListDocument');
                var elSubDocument = document.getElementById('dvSUBDocument');
                var elAddlDoc = document.getElementById('divAddlDoc');
                var elImpDoc = document.getElementById('dvIMPDocument');
                var elFinalSignature = document.getElementById('divFinalSignature');

                var elSOCSignDocTop = elSOCSignDoc.getBoundingClientRect().top + window.scrollY - 120;
                var elADSSignDocTop = elADSSignDoc.getBoundingClientRect().top + window.scrollY - 120;
                var elNDASignDocTop = elNDASignDoc.getBoundingClientRect().top + window.scrollY - 120;
                var elSDASignDocTop = elSDASignDoc.getBoundingClientRect().top + window.scrollY - 120;
                var elWaitStateDocTop = elWaitStateDoc.getBoundingClientRect().top + window.scrollY - 120;
                var elBIPDocumentTop = elBIPDocument.getBoundingClientRect().top + window.scrollY - 120;
                var elPPSODocumentTop = elPPSODocument.getBoundingClientRect().top + window.scrollY - 120;
                var elPPADocumentTop = elPPADocument.getBoundingClientRect().top + window.scrollY - 120;
                var elInfoInventDocumentTop = elInfoInventDocument.getBoundingClientRect().top + window.scrollY - 120;
                var elRetailInsDocumentTop = elRetailInsDocument.getBoundingClientRect().top + window.scrollY - 120;
                var elUniPayDocumentTop = elUniPayDocument.getBoundingClientRect().top + window.scrollY - 120;
                var elROIDocumentTop = elROIDocument.getBoundingClientRect().top + window.scrollY - 120;
                var elCheckListDocumentTop = elCheckListDocument.getBoundingClientRect().top + window.scrollY - 120;
                var elSubDocTop = elSubDocument.getBoundingClientRect().top + window.scrollY - 120;
                var elAddlDocTop = elAddlDoc.getBoundingClientRect().top + window.scrollY - 120;
                var elImpDocTop = elImpDoc.getBoundingClientRect().top + window.scrollY - 120;
                var elFinalSignatureTop = elFinalSignature.getBoundingClientRect().top + window.scrollY - 120;

                if (this.isNavBarClick == false) {
                    if (window.scrollY >= elSOCSignDocTop && window.scrollY < elADSSignDocTop) this.currentActive = 1;

                    if (this.isStateExists) {
                        if (window.scrollY >= elADSSignDocTop && window.scrollY < elSDASignDocTop) this.currentActive = 2;
                    }
                    switch (!isNullOrUndefined(this.contractSession) && this.contractSession.productId) {
                        case 1:
                            if (this.contractSession && (this.contractSession.CountryID == 3 || this.contractSession.CountryID == 4 || this.contractSession.CountryID == 6)) {
                                if (window.scrollY >= elSOCSignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 1;
                                else if (window.scrollY >= elBIPDocumentTop && window.scrollY < elPPSODocumentTop) this.currentActive = 7;
                                if (this.flgInstallment) {
                                    if (window.scrollY >= elPPSODocumentTop && window.scrollY < elPPADocumentTop) this.currentActive = 8;
                                    else if (window.scrollY >= elPPADocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 19;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 11;
                                }
                                else {
                                    if (window.scrollY >= elPPSODocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 8;
                                }
                                if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;
                                else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else if (this.contractSession && (this.contractSession.CountryID == 399)) {
                                if (window.scrollY >= elADSSignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 2;
                                else if (window.scrollY >= elBIPDocumentTop && window.scrollY < elPPSODocumentTop) this.currentActive = 7;
                                if (this.flgInstallment) {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elPPADocumentTop) this.currentActive = 8;
                                    }
                                    else {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 8;
                                        else if (window.scrollY >= elNDASignDocTop && window.scrollY < elPPADocumentTop) this.currentActive = 3;
                                    }
                                    if (window.scrollY >= elPPADocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 19;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 11;
                                }
                                else {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 8;
                                    }
                                    else {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 8;
                                        else if (window.scrollY >= elNDASignDocTop && window.scrollY < elROIDocumentTop) this.currentActive = 3;
                                    }
                                }
                                if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;
                                else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else if (this.isNewCanadianContract) {
                                if (window.scrollY >= elADSSignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 2;
                                else if (window.scrollY >= elBIPDocumentTop && window.scrollY < elPPSODocumentTop) this.currentActive = 7;
                                if (this.flgInstallment) {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 8;
                                    }
                                    else {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 8;
                                    }
                                    if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                    else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 11;
                                } else {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 8;
                                    }
                                    else {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 8;
                                    }
                                }
                                if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;
                                else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else {
                                if (window.scrollY >= elBIPDocumentTop && window.scrollY < elPPSODocumentTop) this.currentActive = 7;
                                else if (window.scrollY >= elPPSODocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 8;
                                if (this.isStateExists) {
                                    if (window.scrollY >= elSDASignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 4;
                                }
                                else {
                                    if (window.scrollY >= elADSSignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 2;
                                }
                                if (this.isAddlDocExists) {
                                    if (this.flgInstallment) {
                                        if (window.scrollY >= elBIPDocumentTop && window.scrollY < elPPSODocumentTop) this.currentActive = 7;
                                        else if (window.scrollY >= elPPSODocumentTop && window.scrollY < elAddlDocTop) this.currentActive = 8;

                                        if (this.isWaitStateExists) {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                            }
                                            if (window.scrollY >= elWaitStateDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 14;
                                        }
                                        else {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 3;
                                            }
                                        }
                                        if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 11;
                                    } else {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elAddlDocTop) this.currentActive = 8;
                                        else if (this.isWaitStateExists) {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                            }
                                            if (window.scrollY >= elWaitStateDocTop && window.scrollY < elROIDocumentTop) this.currentActive = 14;
                                        }
                                        else {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elROIDocumentTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elROIDocumentTop) this.currentActive = 3;
                                            }
                                        }
                                    }
                                    if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;
                                    else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                                }
                                else {
                                    if (this.flgInstallment) {
                                        if (this.isSecondContract) {
                                            if (window.scrollY >= elPPSODocumentTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 8;
                                        }
                                        else {
                                            if (window.scrollY >= elPPSODocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 8;
                                            else if (window.scrollY >= elNDASignDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 3;
                                        }
                                        if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 11;
                                    } else {
                                        if (this.isSecondContract) {
                                            if (window.scrollY >= elPPSODocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 8;
                                        }
                                        else {
                                            if (window.scrollY >= elPPSODocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 8;
                                            else if (window.scrollY >= elNDASignDocTop && window.scrollY < elROIDocumentTop) this.currentActive = 3;
                                        }
                                    }
                                    if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;
                                    else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                                }
                            }
                            break;
                        case 2:
                            if (this.contractSession && (this.contractSession.CountryID == 3 || this.contractSession.CountryID == 4 || this.contractSession.CountryID == 6)) {
                                if (window.scrollY >= elSOCSignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 1;
                                if (this.flgInstallment) {
                                    if (window.scrollY >= elBIPDocumentTop && window.scrollY < elPPADocumentTop) this.currentActive = 7;
                                    else if (window.scrollY >= elPPADocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 19;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 11;
                                }
                                else {
                                    if (window.scrollY >= elBIPDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 7;
                                }
                                if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;
                                else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else if (this.contractSession && (this.contractSession.CountryID == 399)) {
                                if (window.scrollY >= elADSSignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 2;
                                if (this.flgInstallment) {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elBIPDocumentTop && window.scrollY < elPPADocumentTop) this.currentActive = 7;
                                    }
                                    else {
                                        if (window.scrollY >= elBIPDocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 7;
                                        else if (window.scrollY >= elNDASignDocTop && window.scrollY < elROIDocumentTop) this.currentActive = 3;
                                    }
                                    if (window.scrollY >= elPPADocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 19;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 11;
                                }
                                else {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elBIPDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 7;
                                    }
                                    else {
                                        if (window.scrollY >= elBIPDocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 7;
                                        else if (window.scrollY >= elNDASignDocTop && window.scrollY < elROIDocumentTop) this.currentActive = 3;
                                    }
                                }
                                if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;
                                else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else if (this.isNewCanadianContract) {
                                if (window.scrollY >= elADSSignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 2;
                                if (this.flgInstallment) {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elBIPDocumentTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 7;
                                    }
                                    else {
                                        if (window.scrollY >= elBIPDocumentTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 7;
                                    }
                                    if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                    else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 11;
                                } else {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elBIPDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 7;
                                    }
                                    else {
                                        if (window.scrollY >= elBIPDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 7;
                                    }
                                }
                                if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;
                                else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else {
                                if (this.isStateExists) {
                                    if (window.scrollY >= elSDASignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 4;
                                }
                                else {
                                    if (window.scrollY >= elADSSignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 2;
                                }

                                if (this.isAddlDocExists) {
                                    if (window.scrollY >= elBIPDocumentTop && window.scrollY < elAddlDocTop) this.currentActive = 7;
                                    if (this.flgInstallment) {
                                        if (this.isWaitStateExists) {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                            }
                                            if (window.scrollY >= elWaitStateDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 14;
                                        }
                                        else {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 3;
                                            }
                                        }
                                        if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 11;
                                    } else {
                                        if (this.isWaitStateExists) {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                            }
                                            if (window.scrollY >= elWaitStateDocTop && window.scrollY < elROIDocumentTop) this.currentActive = 14;
                                        }
                                        else {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elROIDocumentTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elROIDocumentTop) this.currentActive = 3;
                                            }
                                        }
                                    }
                                    if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;
                                    else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                                }
                                else {
                                    if (this.flgInstallment) {
                                        if (this.isSecondContract) {
                                            if (window.scrollY >= elBIPDocumentTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 7;
                                        }
                                        else {
                                            if (window.scrollY >= elBIPDocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 7;
                                            else if (window.scrollY >= elNDASignDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 3;
                                        }
                                        if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 11;
                                    } else {
                                        if (this.isSecondContract) {
                                            if (window.scrollY >= elBIPDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 7;
                                        }
                                        else {
                                            if (window.scrollY >= elBIPDocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 7;
                                            else if (window.scrollY >= elNDASignDocTop && window.scrollY < elROIDocumentTop) this.currentActive = 3;
                                        }
                                    }
                                    if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;
                                    else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                                }
                            }
                            break;
                        case 6:
                        case 11:
                            if (this.contractSession && (this.contractSession.CountryID == 3 || this.contractSession.CountryID == 4 || this.contractSession.CountryID == 6)) {
                                if (window.scrollY >= elSOCSignDocTop && window.scrollY < elPPSODocumentTop) this.currentActive = 1;
                                if (this.flgInstallment) {
                                    if (window.scrollY >= elPPSODocumentTop && window.scrollY < elPPADocumentTop) this.currentActive = 8;
                                    else if (window.scrollY >= elPPADocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 19;
                                    else if (window.scrollY >= elUniPayDocumentTop) this.currentActive = 11;
                                }
                                else {
                                    if (window.scrollY >= elPPSODocumentTop) this.currentActive = 8;
                                }
                            }
                            else if (this.contractSession && (this.contractSession.CountryID == 399)) {
                                if (window.scrollY >= elADSSignDocTop && window.scrollY < elPPSODocumentTop) this.currentActive = 2;
                                if (this.flgInstallment) {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elPPADocumentTop) this.currentActive = 8;
                                    }
                                    else {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 8;
                                        else if (window.scrollY >= elNDASignDocTop && window.scrollY < elPPADocumentTop) this.currentActive = 3;
                                    }
                                    if (window.scrollY >= elPPADocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 19;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 11;
                                }
                                else {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 8;
                                    }
                                    else {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 8;
                                        else if (window.scrollY >= elNDASignDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 3;
                                    }
                                }
                                if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else if (this.isNewCanadianContract) {
                                if (window.scrollY >= elADSSignDocTop && window.scrollY < elPPSODocumentTop) this.currentActive = 2;
                                if (this.flgInstallment) {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 11;
                                    }
                                    else {
                                        if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 11;
                                        else if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;

                                    }
                                    if (window.scrollY >= elPPSODocumentTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 8;
                                    else if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                    else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                } else {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 8;
                                    }
                                    else {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elROIDocumentTop) this.currentActive = 8;
                                        else if (window.scrollY >= elROIDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 12;
                                    }
                                }
                                if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else {
                                if (window.scrollY >= elPPSODocumentTop && window.scrollY < elAddlDocTop) this.currentActive = 8;
                                if (this.isStateExists) {
                                    if (window.scrollY >= elSDASignDocTop && window.scrollY < elPPSODocumentTop) this.currentActive = 4;
                                }
                                else {
                                    if (window.scrollY >= elADSSignDocTop && window.scrollY < elPPSODocumentTop) this.currentActive = 2;
                                }

                                if (this.isAddlDocExists) {
                                    if (this.flgInstallment) {
                                        if (this.isWaitStateExists) {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                            }
                                            if (window.scrollY >= elWaitStateDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 14;
                                        } else
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 3;
                                            }
                                        if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 11;
                                    } else {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elAddlDocTop) this.currentActive = 8;
                                        else if (this.isWaitStateExists) {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                            }
                                            if (window.scrollY >= elWaitStateDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 14;
                                        }
                                        else {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 3;
                                            }
                                        }
                                    }
                                    if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                                }
                                else {
                                    if (this.flgInstallment) {
                                        if (this.isSecondContract) {
                                            if (window.scrollY >= elPPSODocumentTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 8;
                                        }
                                        else {
                                            if (window.scrollY >= elPPSODocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 8;
                                            else if (window.scrollY >= elNDASignDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 3;
                                        }
                                        if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 11;
                                    } else {
                                        if (this.isSecondContract) {
                                            if (window.scrollY >= elPPSODocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 8;
                                        }
                                        else {
                                            if (window.scrollY >= elPPSODocumentTop && window.scrollY < elNDASignDocTop) this.currentActive = 8;
                                            else if (window.scrollY >= elNDASignDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 3;
                                        }
                                    }
                                    if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                                }
                            }
                            break;
                        case 3: //Sub Only         
                        case 7: // Sub With Patent
                        case 8:
                        case 9:
                        case 10:
                        case 12:
                        case 13:
                        case 14:
                            if (this.contractSession && (this.contractSession.CountryID == 3 || this.contractSession.CountryID == 4 || this.contractSession.CountryID == 6)) {
                                if (window.scrollY >= elSOCSignDocTop && window.scrollY < elSubDocTop) this.currentActive = 1;
                                if (this.flgInstallment) {
                                    if (window.scrollY >= elSubDocTop && window.scrollY < elPPADocumentTop) this.currentActive = 15;
                                    else if (window.scrollY >= elPPADocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 19;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 11;
                                }
                                else {
                                    if (window.scrollY >= elSubDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 15;
                                }
                                if (window.scrollY >= elCheckListDocumentTop) this.currentActive = 18;
                            }
                            else if (this.contractSession && (this.contractSession.CountryID == 399)) {
                                if (window.scrollY >= elADSSignDocTop && window.scrollY < elSubDocTop) this.currentActive = 2;
                                if (this.flgInstallment) {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elPPADocumentTop) this.currentActive = 15;
                                    }
                                    else {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 15;
                                        else if (window.scrollY >= elNDASignDocTop && window.scrollY < elPPADocumentTop) this.currentActive = 3;
                                    }
                                    if (window.scrollY >= elPPADocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 19;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 11;
                                }
                                else {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 15;
                                    }
                                    else {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 15;
                                        else if (window.scrollY >= elNDASignDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 3;
                                    }
                                }
                                if (window.scrollY >= elCheckListDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 18;
                                else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else if (this.isNewCanadianContract) {
                                if (window.scrollY >= elADSSignDocTop && window.scrollY < elSubDocTop) this.currentActive = 2;
                                if (this.flgInstallment) {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 15;

                                    } else {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 15;
                                    }
                                    if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                    else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 11;
                                } else {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 15;
                                    }
                                    else {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 15;
                                    }
                                }
                                if (window.scrollY >= elCheckListDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 18;
                                else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else {
                                if (this.isWaitStateExists) {
                                    if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                    else if (window.scrollY >= elWaitStateDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 14;
                                } else
                                    if (window.scrollY >= elNDASignDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 3;

                                if (this.isStateExists) {
                                    if (window.scrollY >= elSDASignDocTop && window.scrollY < elSubDocTop) this.currentActive = 4;
                                }
                                else {
                                    if (window.scrollY >= elADSSignDocTop && window.scrollY < elSubDocTop) this.currentActive = 2;
                                }

                                if (this.isAddlDocExists) {
                                    if (window.scrollY >= elSubDocTop && window.scrollY < elAddlDocTop) this.currentActive = 15;
                                    if (this.flgInstallment) {
                                        if (this.isWaitStateExists) {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                            }
                                            if (window.scrollY >= elWaitStateDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 14;
                                        }
                                        else {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 3;
                                            }
                                        }
                                        if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 11;
                                    } else {
                                        if (this.isWaitStateExists) {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                            }
                                            if (window.scrollY >= elWaitStateDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 14;
                                        }
                                        else {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 3;
                                            }
                                        }
                                    }
                                    if (window.scrollY >= elCheckListDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 18;
                                    else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                                }
                                else {
                                    if (this.flgInstallment) {
                                        if (this.isSecondContract) {
                                            if (window.scrollY >= elSubDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 15;

                                        } else {
                                            if (window.scrollY >= elSubDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 15;
                                            else if (window.scrollY >= elNDASignDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 3;
                                        }
                                        if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 11;
                                    } else {
                                        if (this.isSecondContract) {
                                            if (window.scrollY >= elSubDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 15;
                                        }
                                        else {
                                            if (window.scrollY >= elSubDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 15;
                                            else if (window.scrollY >= elNDASignDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 3;
                                        }
                                    }
                                    if (window.scrollY >= elCheckListDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 18;
                                    else if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                                }
                            }
                            break;

                        case 4: case 5:// IMP
                            if (window.scrollY >= elImpDocTop && window.scrollY < elSubDocTop) this.currentActive = 16;
                            if (this.contractSession && (this.contractSession.CountryID == 3 || this.contractSession.CountryID == 4 || this.contractSession.CountryID == 6)) {
                                if (window.scrollY >= elSOCSignDocTop && window.scrollY < elImpDocTop) this.currentActive = 1;
                                if (this.flgInstallment) {
                                    if (window.scrollY >= elSubDocTop && window.scrollY < elPPADocumentTop) this.currentActive = 15;
                                    else if (window.scrollY >= elPPADocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 19;
                                    else if (window.scrollY >= elUniPayDocumentTop) this.currentActive = 11;
                                }
                                else {
                                    if (window.scrollY >= elSubDocTop) this.currentActive = 15;
                                }
                                if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else if (this.contractSession && (this.contractSession.CountryID == 399)) {
                                if (window.scrollY >= elADSSignDocTop && window.scrollY < elImpDocTop) this.currentActive = 2;
                                else if (window.scrollY >= elImpDocTop && window.scrollY < elSubDocTop) this.currentActive = 16;
                                if (this.flgInstallment) {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elPPADocumentTop) this.currentActive = 15;
                                    }
                                    else {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 15;
                                        else if (window.scrollY >= elNDASignDocTop && window.scrollY < elPPADocumentTop) this.currentActive = 3;
                                    }
                                    if (window.scrollY >= elPPADocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 19;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 11;
                                }
                                else {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 15;
                                    }
                                    else {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 15;
                                        else if (window.scrollY >= elNDASignDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 3;
                                    }
                                }
                                if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else if (this.isNewCanadianContract) {
                                if (window.scrollY >= elADSSignDocTop && window.scrollY < elImpDocTop) this.currentActive = 2;
                                if (this.flgInstallment) {
                                    if (this.isSecondContract) {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 15;
                                    }
                                    else {
                                        if (window.scrollY >= elSubDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 15;
                                    }
                                    if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                    else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                    else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 11;
                                } else {
                                    if (window.scrollY >= elSubDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 15;
                                }
                                if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                            }
                            else {
                                if (this.isStateExists) {
                                    if (window.scrollY >= elSDASignDocTop && window.scrollY < elImpDocTop) this.currentActive = 4;
                                }
                                else {
                                    if (window.scrollY >= elADSSignDocTop && window.scrollY < elImpDocTop) this.currentActive = 2;
                                }

                                if (this.isAddlDocExists) {
                                    if (window.scrollY >= elSubDocTop && window.scrollY < elAddlDocTop) this.currentActive = 15;
                                    if (this.flgInstallment) {
                                        if (this.isWaitStateExists) {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                            }
                                            if (window.scrollY >= elWaitStateDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 14;
                                        }
                                        else {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 3;
                                            }
                                        }
                                        if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop) this.currentActive = 11;
                                    } else {
                                        if (this.isWaitStateExists) {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                            }
                                            if (window.scrollY >= elWaitStateDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 14;
                                        }
                                        else {
                                            if (this.isSecondContract) {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 17;
                                            }
                                            else {
                                                if (window.scrollY >= elAddlDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 17;
                                                else if (window.scrollY >= elNDASignDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 3;
                                            }
                                        }
                                    }
                                    if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                                }
                                else {
                                    if (this.flgInstallment) {
                                        if (this.isSecondContract) {
                                            if (window.scrollY >= elSubDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 15;
                                        }
                                        else {
                                            if (window.scrollY >= elSubDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 15;
                                            else if (window.scrollY >= elNDASignDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 3;
                                        }
                                        if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elFinalSignatureTop) this.currentActive = 11;
                                    } else {
                                        if (this.isSecondContract) {
                                            if (window.scrollY >= elSubDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 15;
                                        }
                                        else {
                                            if (window.scrollY >= elSubDocTop && window.scrollY < elNDASignDocTop) this.currentActive = 15;
                                            else if (window.scrollY >= elNDASignDocTop && window.scrollY < elFinalSignatureTop) this.currentActive = 3;
                                        }
                                    }
                                    if (window.scrollY >= elFinalSignatureTop) this.currentActive = 20;
                                }
                            }
                            break;

                        default:
                            if (this.contractSession && (this.contractSession.CountryID == 3 || this.contractSession.CountryID == 4 || this.contractSession.CountryID == 6)) {
                                if (window.scrollY >= elSOCSignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 1;
                                else if (window.scrollY >= elBIPDocumentTop && window.scrollY < elPPSODocumentTop) this.currentActive = 7;
                                else if (window.scrollY >= elPPSODocumentTop) this.currentActive = 8;
                            }
                            else {
                                if (this.isWaitStateExists) {
                                    if (window.scrollY >= elNDASignDocTop && window.scrollY < elWaitStateDocTop) this.currentActive = 3;
                                    else if (window.scrollY >= elWaitStateDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 14;
                                } else
                                    if (window.scrollY >= elNDASignDocTop && window.scrollY < elBIPDocumentTop) this.currentActive = 3;

                                if (window.scrollY >= elBIPDocumentTop && window.scrollY < elPPSODocumentTop) this.currentActive = 7;

                                if (this.isAddlDocExists) {
                                    if (this.flgInstallment) {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elAddlDocTop) this.currentActive = 8;
                                        else if (window.scrollY >= elAddlDocTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 17;
                                        else if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 11;
                                        else if (window.scrollY >= elCheckListDocumentTop) this.currentActive = 18;
                                    } else {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elAddlDocTop) this.currentActive = 8;
                                        else if (window.scrollY >= elAddlDocTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 17;
                                        else if (window.scrollY >= elCheckListDocumentTop) this.currentActive = 18;
                                    }
                                }
                                else {
                                    if (this.flgInstallment) {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elRetailInsDocumentTop) this.currentActive = 8;
                                        else if (window.scrollY >= elRetailInsDocumentTop && window.scrollY < elInfoInventDocumentTop) this.currentActive = 10;
                                        else if (window.scrollY >= elInfoInventDocumentTop && window.scrollY < elUniPayDocumentTop) this.currentActive = 9;
                                        else if (window.scrollY >= elUniPayDocumentTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 11;
                                        else if (window.scrollY >= elCheckListDocumentTop) this.currentActive = 18;
                                    } else {
                                        if (window.scrollY >= elPPSODocumentTop && window.scrollY < elCheckListDocumentTop) this.currentActive = 8;
                                        else if (window.scrollY >= elCheckListDocumentTop) this.currentActive = 18;
                                    }
                                }
                            }
                            break;
                    }
                }
            }
        }
        setTimeout(() => {
            this.isNavBarClick = false;
        }, 300);
    }

    @HostListener('window:popstate', ['$event'])
    dismissModal() {
        $('#modalCheckCountry').modal('hide');
        $('#modalBIPConfirmation').modal('hide');
    }

    changeProduct() {
        switch (!isNullOrUndefined(this.contractSession) && this.contractSession.productId) {
            case 1: this.isShowBIP = true; this.isShowPPSO = true; this.isShowPatent = false; this.isShowSub = false; this.isShowCheckList = false; this.isShowIMP = false; this.isShowROI = true; break;
            case 2: this.isShowBIP = true; this.isShowPPSO = false; this.isShowPatent = false; this.isShowSub = false; this.isShowCheckList = false; this.isShowIMP = false; this.isShowROI = true; break;
            case 3: case 10: this.isShowBIP = false; this.isShowPPSO = false; this.isShowPatent = false; this.isShowSub = true; ((this.contractSession.productId == 10 && new Date(this.checkList123StartDate?.configValue) <= new Date(this.contractActionlog.dtCreated)) || this.contractSession.productId == 3) ? this.isShowCheckList = true : this.isShowCheckList = false; this.isShowIMP = false; this.isShowROI = false; break;
            //case 10: this.isShowBIP = false; this.isShowPPSO = false; this.isShowPatent = false; this.isShowSub = true; this.isShowCheckList = false; this.isShowIMP = false; this.isShowROI = false; break;
            case 4: case 5: this.isShowBIP = false; this.isShowPPSO = false; this.isShowPatent = true; this.isShowSub = true; this.isShowCheckList = false; this.isShowIMP = true; this.isShowROI = false;
                if (!isNullOrUndefined(this.addendumServicesResponse) && !this.addendumServicesResponse.addendum.isPatentServices) this.docSignPatent = "No service selected."; break;
            case 6: case 11: this.isShowBIP = false; this.isShowPPSO = true; this.isShowPatent = false; this.isShowSub = false; this.isShowCheckList = false; this.isShowIMP = false;
                if (!this.isBIPExist && !isNullOrUndefined(this.bipConfirmation) && (this.bipConfirmation.isNo || (!this.bipConfirmation.isYes && !this.bipConfirmation.isNo))) this.isShowROI = true; else this.isShowROI = false; break;
            //case 11: this.isShowBIP = false; this.isShowPPSO = true; this.isShowPatent = false; this.isShowCheckList = false; this.isShowSub = false; this.isShowIMP = false; this.isShowROI = true; break;
            case 7: case 8: case 9: case 12: case 13: case 14: this.isShowBIP = false; this.isShowPPSO = false; this.isShowPatent = true; this.isShowSub = true; ((this.contractSession.productId == 9 && new Date(this.checkList123StartDate?.configValue) <= new Date(this.contractActionlog.dtCreated)) || (this.contractSession.productId == 7 || this.contractSession.productId == 8 || this.contractSession.productId == 12 || this.contractSession.productId == 13 || this.contractSession.productId == 14)) ? this.isShowCheckList = true : this.isShowCheckList = false; this.isShowIMP = false; this.isShowROI = false; this.docSignPatent = "The document is loading. Please wait..."; break;
            //case 9: this.isShowBIP = false; this.isShowPPSO = false; this.isShowPatent = true; this.isShowSub = true; this.isShowCheckList = false; this.isShowIMP = false; this.isShowROI = false; this.docSignPatent = "The document is loading. Please wait..."; break;

            default:
                this.isShowBIP = true; this.isShowPPSO = true; this.isShowPatent = false; this.isShowSub = false; this.isShowCheckList = false; this.isShowROI = true; break;
        }
    }

    move(stepper: CdkStepper, index: number) {
        stepper.selectedIndex = index;
    }

    showDivItem(stepper: CdkStepper, index: number, divId: string) {
        this.isNavBarClick = true;
        this.dvId = divId;
        this.recalcAllIframes();

        switch (this.dvId) {
            case "#divSOCForm": if (!this.isSecondContract) { this.backSOC(); this.currentActive = 1; this.ctrMandDocs = 0; } break;
            case "#divSOCDoc": if (!this.isSecondContract) {
                document.getElementById('tdIsSOCDoc').className.split(/\s+/)[2] == "fa-check-square-o" ? this.dvId = "#dvSOCSignDoc" : this.dvId = "#dvSOCMandDoc"; this.chkSOC = true; this.chkADS = false; this.ctrMandDocs = 1;
                this.socSignatureShow();
            } break;
            case "#divADSDoc": if (!this.isSecondContract) {
                document.getElementById('tdIsADSDoc').className.split(/\s+/)[2] == "fa-check-square-o" ? this.dvId = "#dvADSSignDoc" : this.dvId = "#dvADSMandDoc"; this.chkSOC = false; this.chkADS = true; this.ctrMandDocs = 2;
                this.adsSignatureShow();
            } break;
            case "#divSDADoc": document.getElementById('tdIsSDADoc').className.split(/\s+/)[2] == "fa-check-square-o" ? this.dvId = "#dvSDASignDoc" : this.dvId = "#dvSDAMandDoc"; this.chkSOC = false; this.chkADS = false; this.ctrMandDocs = 3; break;
            case "#divNDADoc": this.currentActive = 3; this.divOtherMandDocs = false; this.isNDAMandDoc = false; this.isWaitStateDoc = false; this.scrollPageUp('#divNDADoc'); break;
            case "#divWaitDoc": this.currentActive = 14; this.divOtherMandDocs = false; this.isNDAMandDoc = false; this.isWaitStateDoc = false; this.scrollPageUp('#divWaitDoc'); break;
            case "#divPS": this.currentActive = 5; this.divOtherMandDocs = false; this.isNDAMandDoc = false; this.isWaitStateDoc = false; break;
            case "#divBIP": this.currentActive = 7; this.divOtherMandDocs = false; this.isNDAMandDoc = false; this.isWaitStateDoc = false; this.scrollPageUp('#divBIP'); break;
            case "#divSUB": this.currentActive = 15; this.divOtherMandDocs = false; this.isNDAMandDoc = false; this.isWaitStateDoc = false; this.scrollPageUp('#divSUB'); break;

            case "#divIMP": this.currentActive = 16; this.divOtherMandDocs = false; this.isNDAMandDoc = false; this.isWaitStateDoc = false; this.scrollPageUp('#divIMP'); break;
            case "#dvIMPDocument": this.currentActive = 16; break;
            case "#divAddlDoc": this.currentActive = 17; this.divOtherMandDocs = false; this.isNDAMandDoc = false; this.isWaitStateDoc = false; this.scrollPageUp('#divAddlDoc'); break;

            case "#dvBIPDocument": this.currentActive = 7; break;
            case "#dvPPSODocument": this.currentActive = 8; break;
            case "#divIFI": this.currentActive = 9; this.divOtherMandDocs = false; this.isNDAMandDoc = false; this.isWaitStateDoc = false; break;
            case "#dvInfoInventDocument": this.currentActive = 9; break;
            case "#dvRetailInsDocument": this.currentActive = 10; break;
            case "#dvPPADocument": this.currentActive = 19; break;
            case "#divUPC": this.currentActive = 11; this.divOtherMandDocs = false; this.isNDAMandDoc = false; this.isWaitStateDoc = false; break;
            case "#dvUniPayDocument": this.currentActive = 11; break;
            case "#divROI": this.currentActive = 12; this.divOtherMandDocs = false; this.isNDAMandDoc = false; this.isWaitStateDoc = false; break;
            case "#dvROIDocument": this.currentActive = 12; this.loadDocument_DocTypeId(2); break;
            case "#divCheckList": this.currentActive = 18; this.divOtherMandDocs = false; this.isNDAMandDoc = false; this.isWaitStateDoc = false; this.scrollPageUp('#divCheckList'); break;
            case "#dvCheckListDocument": this.currentActive = 18; break;
            case "#divCPG": this.currentActive = 13; break;
            case "#divFinalSignature": this.currentActive = 20; this.finalSinatureShow(); break;
            default: break;
        }

        switch (this.dvId) {

            case "#dvSOCMandDoc": this.isSOCMandDoc = true; this.isADSMandDoc = false; this.isSDAMandDoc = false; this.chkSOC = true; this.divMmandDocs = true; this.divSOC = false; this.currentActive = 1;
                this.socSignatureShow(); break;

            case "#dvADSMandDoc": this.isSOCMandDoc = false; this.isADSMandDoc = true; this.isSDAMandDoc = false; this.chkSOC = false; this.divMmandDocs = true; this.divSOC = false; this.currentActive = 2; this.signaturePad.clear(); break;
            case "#dvSDAMandDoc": this.isSOCMandDoc = false; this.isADSMandDoc = false; this.isSDAMandDoc = true; this.chkSOC = false; this.divMmandDocs = true; this.divSOC = false; this.currentActive = 4; this.signaturePad.clear(); break;

            case "#dvNDAMandDoc": this.divOtherMandDocs = true; this.isNDAMandDoc = true; this.isWaitStateDoc = false; this.currentActive = 3; break;
            case "#dvWaitMandDoc": this.divOtherMandDocs = true; this.isNDAMandDoc = false; this.isWaitStateDoc = true; this.currentActive = 14; this.scrollPageUp('#dvWaitMandDoc'); break;

            default: break;
        }

        this.dvId.includes("Sign") == true ? index = 2 : index = index;
        if (stepper.selectedIndex == index) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(this.dvId).length > 0 ? $(this.dvId).offset().top - 104 : 0
            }, 100);
        }
        else {
            stepper.selectedIndex = index;
            setTimeout(() => {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(this.dvId).offset().top - 104
                }, 100);
            }, 800);
        }

        switch (this.dvId) {
            case "#divSOCForm": if (!this.isSecondContract) { this.currentActive = 1; } break;
            case "#dvSOCSignDoc": if (!this.isSecondContract) { this.currentActive = 1; } break;
            case "#dvSOCMandDoc": if (!this.isSecondContract) { this.currentActive = 1; this.socSignatureShow(); } break;
            case "#dvADSSignDoc": if (!this.isSecondContract) { this.currentActive = 2; } break;
            case "#dvADSMandDoc": if (!this.isSecondContract) { this.currentActive = 2; } break;
            case "#dvNDASignDoc": if (!this.isSecondContract) { this.currentActive = 3; } break;
            case "#dvNDAMandDoc": if (!this.isSecondContract) { this.currentActive = 3; } break;
            case "#dvSDASignDoc": this.currentActive = 4; break;
            case "#dvSDAMandDoc": this.currentActive = 4; break;
            case "#divPS": this.currentActive = 5; break;
            case "#divBI": this.currentActive = 6; break;
            case "#dvBIIDocument": this.currentActive = 6; break;
            case "#divBIP": this.currentActive = 7;
            case "#dvBIPDocument": this.currentActive = 7; break;
            case "#dvPPSODocument": this.currentActive = 8; break;
            case "#divIFI": this.currentActive = 9; break;
            case "#dvInfoInventDocument": this.currentActive = 9; break;
            case "#dvRetailInsDocument": this.currentActive = 10; break;
            case "#dvPPADocument": this.currentActive = 19; break;
            case "#divUPC": this.currentActive = 11; break;
            case "#dvUniPayDocument": this.currentActive = 11; break;
            case "#divROI": this.currentActive = 12; break;
            case "#dvROIDocument": this.currentActive = 12; break;
            case "#divCheckList": this.currentActive = 18; break;
            case "#dvCheckListDocument": this.currentActive = 18; break;
            case "#divSUB": this.currentActive = 15; break;
            case "#divIMP": this.currentActive = 16; break;
            case "#divCPG": this.currentActive = 13; break;
            case "#divWaitDoc": this.currentActive = 14; break;
            case "#dvWaitSignDoc": this.currentActive = 14; break;
            case "#dvWaitMandDoc": this.currentActive = 14; break;
            case "#divAddlDoc": this.currentActive = 17; break;
            case "#dvSUBDocument": this.currentActive = 15; break;
            case "#dvIMPDocument": this.currentActive = 16; break;
            default: break;
        }
    }
    async socSignatureShow() {
        await this.loadSignature();
        if (this.inventionResponse.inventionDetails.isCoInventor) {
            if (this.documentSignature.signature2 === '' && this.documentSignature.initial2 === '') {
                if (this.documentSignature.signature1) {
                    this.signaturePad.fromDataURL(this.documentSignature.signature1, { width: canvaswidgth, height: canvasheight });
                    this.socGroup.patchValue({ initialSignature: '' });
                    this.signatureOnEnd();
                    this.signaturePad.off();
                    this.isExistSoc = true;
                    this.titleMsg = 'To resign, please clear the signature first!';
                    this.signaturePadCoInv.clear();
                    this.socGroup.patchValue({ initialCoInvSignature: '' });
                    this.signaturePadCoInv.on();
                    this.initialCoInvDisabled = false;
                }
                else if (this.documentSignature.initial1) {
                    this.socGroup.patchValue({ initialSignature: this.documentSignature.initial1 });
                    this.signaturePad.clear();
                    this.signaturePad.off();
                    this.initialDisabled = false;
                    this.initialCoInvDisabled = false;
                }
                else {

                    this.signaturePad.clear();
                    this.signaturePadCoInv.clear();
                    this.socGroup.patchValue({ initialSignature: '' });
                    this.socGroup.patchValue({ initialCoInvSignature: '' });
                    this.titleMsg = '';
                    this.signaturePad.on();
                    this.signaturePadCoInv.on();
                    this.initialDisabled = false;
                    this.initialCoInvDisabled = false;
                }
            }
            else {
                this.isExistSoc = false;
                this.signaturePad.clear()
                this.signaturePadCoInv.clear();
                this.socGroup.patchValue({ initialSignature: '' });
                this.socGroup.patchValue({ initialCoInvSignature: '' });
                this.socGroup.patchValue({ initialAdsSignature: '' });
                this.signDocsGroup.patchValue({ initialFinalSignature: '' });
                this.signaturePad.on();
                this.signaturePadCoInv.on();
                this.initialDisabled = false;
                this.initialCoInvDisabled = false;
            }
        } else {
            this.isExistSoc = false;
            this.signaturePad.clear();
            this.signaturePadCoInv.clear();
            this.socGroup.patchValue({ initialSignature: '' });
            this.socGroup.patchValue({ initialCoInvSignature: '' });
            this.socGroup.patchValue({ initialAdsSignature: '' });
            this.signDocsGroup.patchValue({ initialFinalSignature: '' });
            this.signaturePad.on();
            this.signaturePadCoInv.on();
            this.initialDisabled = false;
            this.initialCoInvDisabled = false;
        }
    }
    async adsSignatureShow() {
        await this.loadSignature();
        if (this.inventionResponse.inventionDetails.isCoInventor) {
            this.socGroup.patchValue({ initialAdsCoInvSignature: '' });
            if (this.documentSignature.i2SignatureADS === '' && this.documentSignature.i2InitialADS === '') {
                if (this.documentSignature.i1SignatureADS) {
                    this.signaturePadADS.fromDataURL(this.documentSignature.i1SignatureADS, { width: canvaswidgth, height: canvasheight });
                    this.signatureAdsOnEnd();
                    this.signaturePadADS.off();
                    this.socGroup.patchValue({ initialAdsSignature: '' });
                    this.isExistADS = true;
                    this.titleMsg = 'To resign, please clear the signature first!';
                    this.signaturePadADSCoInv.clear();
                    this.socGroup.patchValue({ initialAdsSignature: '' });
                    this.signaturePadADSCoInv.on();
                    this.initialAdsCoInvDisabled = false;
                }
                else if (this.documentSignature.i1InitialADS) {
                    this.socGroup.patchValue({ initialAdsSignature: this.documentSignature.i1InitialADS });
                    this.signaturePadADS.clear();
                    this.signaturePadADS.off();
                    this.initialAdsDisabled = false;
                    this.initialAdsCoInvDisabled = false;
                }
                else {

                    this.signaturePadADS.clear();
                    this.signaturePadADSCoInv.clear();
                    this.socGroup.patchValue({ initialAdsSignature: '' });
                    this.titleMsg = '';
                    this.signaturePadADS.on();
                    this.signaturePadADSCoInv.on();
                    this.initialAdsDisabled = false;
                    this.initialAdsCoInvDisabled = false;
                }
            }
            else {
                this.isExistADS = false;
                this.signaturePadADS.clear();
                this.signaturePadADSCoInv.clear();
                this.socGroup.patchValue({ initialSignature: '' });
                this.socGroup.patchValue({ initialAdsSignature: '' });
                this.signDocsGroup.patchValue({ initialFinalSignature: '' });
                this.socGroup.patchValue({ initialAdsCoInvSignature: '' });
                this.signaturePadADS.on();
                this.signaturePadADSCoInv.on();
                this.initialAdsDisabled = false;
                this.initialAdsCoInvDisabled = false;
            }
        } else {
            this.isExistADS = false;
            this.signaturePadADS.clear();
            this.signaturePadADSCoInv.clear();
            this.socGroup.patchValue({ initialSignature: '' });
            this.socGroup.patchValue({ initialAdsSignature: '' });
            this.signDocsGroup.patchValue({ initialFinalSignature: '' });
            this.socGroup.patchValue({ initialAdsCoInvSignature: '' });
            this.signaturePadADS.on();
            this.signaturePadADSCoInv.on();
            this.initialAdsDisabled = false;
            this.initialAdsCoInvDisabled = false;
        }
    }
    async finalSinatureShow() {
        await this.loadSignature();
        if (this.inventionResponse.inventionDetails.isCoInventor) {
            if (this.documentSignature.i2SignatureFinal === '' && this.documentSignature.i2InitialFinal === '') {
                if (this.documentSignature.i1SignatureFinal) {
                    this.signaturePadFinal.fromDataURL(this.documentSignature.i1SignatureFinal, { width: canvaswidgth, height: canvasheight });
                    this.socGroup.patchValue({ initialSignature: '' });
                    this.socGroup.patchValue({ initialAdsSignature: '' });
                    this.signatureFinalOnEnd(); this.signaturePadFinal.off(); this.isExistFinal = true;
                    this.titleMsg = 'To resign, please clear the signature first!';
                    this.signaturePad.clear();
                    this.signaturePadADS.clear();
                    this.signaturePadFinalCoInv.clear();
                    this.signDocsGroup.patchValue({ initialFinalCoInvSignature: '' });
                    this.signaturePadFinalCoInv.on();
                    this.initialFinalCoInvDisabled = false;
                }
                else if (this.documentSignature.i1InitialFinal) {
                    this.signDocsGroup.patchValue({ initialFinalSignature: this.documentSignature.i1InitialFinal });
                    this.socGroup.patchValue({ initialAdsSignature: '' });
                    this.socGroup.patchValue({ initialSignature: '' });
                    this.signaturePadFinal.off();
                    this.signaturePad.clear();
                    this.signaturePadADS.clear();
                }
                else {
                    this.signaturePadFinal.clear();
                    this.signaturePadFinalCoInv.clear();
                    this.signDocsGroup.patchValue({ initialFinalSignature: '' });
                    this.signDocsGroup.patchValue({ initialFinalCoInvSignature: '' });
                    this.titleMsg = '';
                    this.signaturePadFinal.on();
                    this.signaturePadFinalCoInv.on();
                    this.initialFinalDisabled = false;
                    this.initialFinalCoInvDisabled = false;
                }
            }
            else {
                this.isExistFinal = false;
                this.signaturePadFinal.clear();
                this.signaturePadFinalCoInv.clear();
                this.signDocsGroup.patchValue({ initialFinalSignature: '' });
                this.signDocsGroup.patchValue({ initialFinalCoInvSignature: '' });
                this.signaturePadFinal.on();
                this.signaturePadFinalCoInv.on();
                this.initialFinalDisabled = false;
                this.initialFinalCoInvDisabled = false;
                if (this.contractSession.isCancelled == true) {
                    this.signaturePadFinal.off();
                    this.signaturePadFinalCoInv.off();
                    this.initialFinalDisabled = true;
                    this.initialFinalCoInvDisabled = true;
                    $(':button').prop('disabled', true);
                    $('#backButton').prop('disabled', false);
                    $('#closeFileButton').prop('disabled', false);
                    $('#backContractList').prop('disabled', false);
                }
            }
        } else {
            this.isExistFinal = false;
            this.signaturePadFinal.clear();
            this.signaturePadFinalCoInv.clear();
            this.signDocsGroup.patchValue({ initialFinalSignature: '' });
            this.signDocsGroup.patchValue({ initialFinalCoInvSignature: '' });
            this.signaturePadFinal.on();
            this.signaturePadFinalCoInv.on();
            this.initialFinalDisabled = false;
            this.initialFinalCoInvDisabled = false;
            if (this.contractSession.isCancelled == true) {
                this.signaturePadFinal.off();
                this.signaturePadFinalCoInv.off();
                this.initialFinalDisabled = true;
                this.initialFinalCoInvDisabled = true;
                $(':button').prop('disabled', true);
                $('#backButton').prop('disabled', false);
                $('#closeFileButton').prop('disabled', false);
                $('#backContractList').prop('disabled', false);
            }
        }
    }
    async docUpload(env) {
        this.fetchMediaDocListUpload(this.inventionId);
        this.fetchCurruptedhMediaImages(this.inventionId);
        this.loadDocument_DocTypeId(2);
    }

    paymentdocUpload(payType: number) {
        this.fetchPaymentDocList(this.contractSessionId, this.currentMultiPayId, payType);
    }

    checkListUpload(env) {
        this.fetchCheckList(this.contractSessionId);
        this.updateUserSteps("tdIsCheckListForm");
        this.updateContractLogObjectModel("checkListFormSubmit", false);
        this.saveContrActionAcitonLog();
    }

    showNotSignedDoc() {
        let dvNotSigned: string = "";
        let currentStep: number = 0;

        this.productId = + $("#contract option:selected").val();
        if (!this.navigationResponse.navigation.isSOCDoc) {
            dvNotSigned = "#dvSOCMandDoc"; currentStep = 0; this.currentActive = 1;
        }
        else if (!this.navigationResponse.navigation.isADSDoc) {
            dvNotSigned = "#dvADSMandDoc"; currentStep = 0; this.currentActive = 2;
        }
        else if (!this.navigationResponse.navigation.isStateDoc && this.isStateExists) {
            dvNotSigned = "#dvSDAMandDoc"; currentStep = 0; this.currentActive = 3;
        }
        else if (!this.navigationResponse.navigation.isBIPDoc && (this.productId == 1 || this.productId == 2)) {
            dvNotSigned = "#dvBIPDocument"; currentStep = 2;
        }
        else if (!this.navigationResponse.navigation.isSUBDoc && ((this.productId >= 3 && this.productId <= 10 && this.productId != 6 && this.productId != 11) || this.productId == 7 || this.productId == 8 || this.productId == 12 || this.productId == 13 || this.productId == 14)) {
            dvNotSigned = "#dvSUBDocument"; currentStep = 2;
        }
        else if (!this.navigationResponse.navigation.isIMPDoc && ((this.productId == 4) || (this.productId == 5))) {
            dvNotSigned = "#dvIMPDocument"; currentStep = 2;
        }
        else if (!this.navigationResponse.navigation.isPPSODoc && (this.productId == 1 || this.productId == 6 || this.productId == 11)) {
            dvNotSigned = "#dvPPSODocument"; currentStep = 2;
        }
        else if (!this.navigationResponse.navigation.isAddlDoc && this.isAddlDocExists) {
            dvNotSigned = "#divAddlDoc"; currentStep = 2;
        }
        else if (!this.navigationResponse.navigation.isRetailDoc && this.payOption == 2) {
            dvNotSigned = "#dvRetailInsDocument"; currentStep = 2;
        }
        else if (!this.navigationResponse.navigation.isPPADoc && this.payOption == 2) {
            dvNotSigned = "#dvPPADocument"; currentStep = 2;
        }
        else if (!this.navigationResponse.navigation.isInformInventDoc && this.payOption == 2) {
            dvNotSigned = "#dvInfoInventDocument"; currentStep = 2;
        }
        else if (!this.navigationResponse.navigation.isUniPayDoc && this.payOption == 2) {
            dvNotSigned = "#dvUniPayDocument"; currentStep = 2;
        }
        else if (!this.navigationResponse.navigation.isNDADoc) {
            dvNotSigned = "#dvNDASignDoc"; currentStep = 1;
        }
        else if (!this.navigationResponse.navigation.isWaitDoc && this.isWaitStateExists) {
            dvNotSigned = "#dvWaitSignDoc"; currentStep = 1;
        }
        else if (!this.navigationResponse.navigation.isROIDoc) {
            dvNotSigned = "#dvROIDocument"; currentStep = 2;
        }
        else if (!this.navigationResponse.navigation.isCheckListDoc && (this.productId == 3 || this.productId == 7 || this.productId == 8 || this.productId == 12 || this.productId == 13 || this.productId == 14)) {
            dvNotSigned = "#dvCheckListDocument"; currentStep = 2;
        }
        else { dvNotSigned = "#dvSOCSignDoc"; currentStep = 2; }

        this.showDivItem(this.stepper, currentStep, dvNotSigned);

    }

    matClick(e) {
        setTimeout(() => {
            switch (e.selectedIndex) {
                case 0: this.scrollPageUp('#divSOCForm'); this.showDivItem(this.stepper, 0, '#divSOCForm'); break;
                case 3: this.showFirstMultiPayment(); this.showDivItem(this.stepper, 3, '#divCPG'); break;
                //case 1: this.scrollPageUp('#divPS'); this.showDivItem(this.stepper, 1, '#divPS'); break;
                //case 2: !this.isSecondContract ? this.scrollPageUp('#dvSOCSignDoc') : this.scrollPageUp('#divPS');
                //    !this.isSecondContract ? this.showDivItem(this.stepper, 2, '#dvSOCSignDoc') : this.showDivItem(this.stepper, 2, '#divPS'); break;
                //case 3: this.scrollPageUp('#divCPG'); this.showDivItem(this.stepper, 3, '#divCPG'); break;
                default: break;
            }
        }, 300);
    }
    Requiredclick(type) {
        //if (type == 1) {
        //    this.scrollPageUp('#divSOCForm'); this.showDivItem(this.stepper, 0, '#divSOCForm');
        //}
        //else if (type == 2) {
        //    this.scrollPageUp('#divPS'); this.showDivItem(this.stepper, 1, '#divPS');
        //}
        //else if (type == 3) {
        //    !this.isSecondContract ? this.scrollPageUp('#dvSOCSignDoc') : this.scrollPageUp('#divPS');
        //}
        //else {
        //    this.showFirstMultiPayment();
        //}
    }

    showMandtoryDocs() {
        if (this.dvId == "#dvSOCMandDoc") {
            this.isSOCMandDoc = true; this.isADSMandDoc = false; this.isNDAMandDoc = false; this.isSDAMandDoc = false; this.chkSOC = false;
        }
    }

    uncheckNavBar(divId) {
        $("#" + divId).removeClass("fa-check-square-o");
        $("#" + divId).addClass("fa-square-o");
    }

    checkNavBar(divId) {
        $("#" + divId).removeClass("fa-square-o");
        $("#" + divId).addClass("fa-check-square-o");
    }

    updateUserSteps(divId) {
        $("#" + divId).removeClass("fa-square-o");
        $("#" + divId).addClass("fa-check-square-o");
        if (this.navigationResponse) {
            if (this.navigationResponse.navigation) {
                this.navigationResponse.navigation.clpUserId = this.clpUserId;
                this.navigationResponse.navigation.contractSessionId = this.contractSessionId;
                this.navigationResponse.navigation.inventionId = this.inventionId;
                this.navigationResponse.navigation.dtModified = new Date();
                if (!this.isProductV) {
                    this.navigationResponse.navigation.isSUBForm = true;
                    //this.navigationResponse.navigation.isSUBDoc = true;
                    this.navigationResponse.navigation.currentStep = 2; this.checkNavBar('tdIsSUBForm');
                }

                switch (divId) {
                    case "tdIsSOCForm":
                        this.navigationResponse.navigation.isSOCForm = true;
                        this.navigationResponse.navigation.currentStep = 1;
                        this.navigationResponse.navigation.isSOCDoc = false; this.uncheckNavBar('tdIsSOCDoc');
                        if (this.socGroup.controls.chkinvent.value) {
                            this.navigationResponse.navigation.isADSDoc = false; this.uncheckNavBar('tdIsADSDoc');
                            this.navigationResponse.navigation.isFinalSign = false; this.uncheckNavBar('tdIsFinalDocuments');
                        }
                        break;
                    case "tdIsSOCDoc":
                        this.navigationResponse.navigation.isSOCDoc = true;
                        this.navigationResponse.navigation.isSOCForm = true;
                        this.navigationResponse.navigation.currentStep = 1; this.checkNavBar('tdIsSOCForm');
                        break;
                    case "tdIsADSDoc":
                        this.navigationResponse.navigation.isADSDoc = true;
                        this.navigationResponse.navigation.currentStep = 1;
                        break;
                    case "tdIsSDADoc":
                        this.navigationResponse.navigation.isStateDoc = true;
                        this.navigationResponse.navigation.currentStep = 1;
                        break;
                    case "tdIsProdServicesForm":
                        this.navigationResponse.navigation.isProdServicesForm = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        this.navigationResponse.navigation.isRetailDoc = false; this.uncheckNavBar('tdIsRetailDoc');
                        this.isRetailAccept = false; this.isRetailHeadAccept = false;
                        this.navigationResponse.navigation.isSUBForm = false;
                        this.navigationResponse.navigation.isSUBDoc = false; this.uncheckNavBar('tdIsSUBForm'); this.uncheckNavBar('tdIsSUBDoc');
                        this.isSUBAccept = false; this.isSUBHeadAccept = false;
                        if (this.prodConfigGroup.controls.coInventor.value) {
                            this.navigationResponse.navigation.isFinalSign = false; this.uncheckNavBar('tdIsFinalDocuments');
                        }
                        break;
                    case "tdIsNDADoc":
                        this.navigationResponse.navigation.isNDADoc = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        break;
                    case "tdIsWaitDoc":
                        this.navigationResponse.navigation.isWaitDoc = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        break;
                    case "tdIsBIPForm":
                        this.navigationResponse.navigation.isBIPForm = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        this.navigationResponse.navigation.isBIPDoc = false; this.uncheckNavBar('tdIsBIPDoc');
                        this.isBIPAccept = false; this.isBIPHeadAccept = false;
                        break;
                    case "tdIsBIPDoc":
                        this.navigationResponse.navigation.isBIPForm = true;
                        this.navigationResponse.navigation.isBIPDoc = true;
                        this.navigationResponse.navigation.currentStep = 3; this.checkNavBar('tdIsBIPForm');
                        break;
                    case "tdIsPPSODoc":
                        this.navigationResponse.navigation.isPPSODoc = true;
                        this.navigationResponse.navigation.currentStep = 3;
                        break;
                    case "tdIsInformInventForm":
                        this.navigationResponse.navigation.isInformInventForm = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        this.navigationResponse.navigation.isInformInventDoc = false; this.uncheckNavBar('tdIsInformInventDoc');
                        this.isInfoInventAccept = false; this.isInfoInventHeadAccept = false;
                        break;
                    case "tdIsInformInventDoc":
                        this.navigationResponse.navigation.isInformInventForm = true;
                        this.navigationResponse.navigation.isInformInventDoc = true;
                        this.navigationResponse.navigation.currentStep = 3; this.checkNavBar('tdIsInformInventForm');
                        break;
                    case "tdIsRetailDoc":
                        this.navigationResponse.navigation.isRetailDoc = true;
                        this.navigationResponse.navigation.currentStep = 3;
                        break;
                    case "tdIsPPADoc":
                        this.navigationResponse.navigation.isPPADoc = true;
                        this.navigationResponse.navigation.currentStep = 3;
                        break;
                    case "tdIsUniPayForm":
                        this.navigationResponse.navigation.isUniPayForm = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        this.navigationResponse.navigation.isUniPayDoc = false; this.uncheckNavBar('tdIsUniPayDoc');
                        this.isUniPayAccept = false; this.isUniPayHeadAccept = false;
                        break;
                    case "tdIsUniPayDoc":
                        this.navigationResponse.navigation.isUniPayForm = true;
                        this.navigationResponse.navigation.isUniPayDoc = true;
                        this.navigationResponse.navigation.currentStep = 3; this.checkNavBar('tdIsUniPayForm');
                        break;
                    case "tdIsPayCollectForm":
                        this.navigationResponse.navigation.isPayCollectForm = true;
                        this.navigationResponse.navigation.currentStep = 4;
                        this.disabledAgreement = true;
                        break;
                    case "tdIsPayCollectAgain":
                        this.navigationResponse.navigation.isPayCollectForm = false;
                        this.navigationResponse.navigation.currentStep = 4;
                        this.uncheckNavBar('tdIsPayCollectForm');
                        break;
                    case "tdIsROIForm":
                        this.navigationResponse.navigation.isROIForm = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        this.navigationResponse.navigation.isROIDoc = true; this.isROIAccept = false; this.isROIHeadAccept = false; this.checkNavBar('tdIsROIForm'); this.checkNavBar('tdIsROIDoc');
                        break;
                    case "tdIsROIDoc":
                        this.navigationResponse.navigation.isROIDoc = true;
                        this.navigationResponse.navigation.isROIForm = true;
                        this.navigationResponse.navigation.currentStep = 3; this.checkNavBar('tdIsROIForm');
                        break;
                    case "tdIsCheckListForm":
                        this.navigationResponse.navigation.isCheckListForm = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        this.navigationResponse.navigation.isCheckListDoc = false; this.isCheckListAccept = false; this.isCheckListHeadAccept = false; this.uncheckNavBar('tdIsCheckListDoc');
                        break;
                    case "tdIsCheckListDoc":
                        this.navigationResponse.navigation.isCheckListDoc = true;
                        this.navigationResponse.navigation.isCheckListForm = true;
                        this.navigationResponse.navigation.currentStep = 3; this.checkNavBar('tdIsCheckListForm');
                        break;
                    case "IsPaymentReminder":
                        this.navigationResponse.navigation.IsPaymentReminder = true;
                        break;
                    case "tdIsIMPForm":
                        this.navigationResponse.navigation.isIMPForm = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        this.navigationResponse.navigation.isIMPDoc = false; this.isIMPAccept = false; this.isIMPHeadAccept = false; this.uncheckNavBar('tdIsIMPDoc');
                        break;
                    case "tdIsIMPDoc":
                        this.navigationResponse.navigation.isIMPForm = true;
                        this.navigationResponse.navigation.isIMPDoc = true;
                        this.navigationResponse.navigation.currentStep = 2; this.checkNavBar('tdIsIMPForm');
                        break;
                    case "tdIsSUBForm":
                        this.navigationResponse.navigation.isSUBForm = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        this.navigationResponse.navigation.isSUBDoc = false; this.isSUBAccept = false; this.isSUBHeadAccept = false; this.uncheckNavBar('tdIsSUBDoc');
                        break;
                    case "tdIsSUBDoc":
                        if (this.validateSubmissionServices()) {
                            this.navigationResponse.navigation.isSUBForm = true;
                            this.navigationResponse.navigation.isSUBDoc = true;
                            this.navigationResponse.navigation.currentStep = 2; this.checkNavBar('tdIsSUBForm');
                        }
                        break;
                    case "tdIsAddmBDoc":
                        if (this.validateSubmissionServices()) {
                            this.navigationResponse.navigation.isSUBForm = true;
                            this.navigationResponse.navigation.isSUBDoc = true;
                            this.navigationResponse.navigation.currentStep = 2; this.checkNavBar('tdIsSUBForm');
                        }
                        break;
                    case "tdIsAddmGDoc":
                        if (this.validateSubmissionServices()) {
                            this.navigationResponse.navigation.isSUBForm = true;
                            this.navigationResponse.navigation.isSUBDoc = true;
                            this.navigationResponse.navigation.currentStep = 2; this.checkNavBar('tdIsSUBForm');
                        }
                        break;
                    case "tdIsAddmPDoc":
                        if (this.validateSubmissionServices()) {
                            this.navigationResponse.navigation.isSUBForm = true;
                            this.navigationResponse.navigation.isSUBDoc = true;
                            this.navigationResponse.navigation.currentStep = 2; this.checkNavBar('tdIsSUBForm');
                        }
                        break;
                    case "tdIsAddmTDoc":
                        if (this.validateSubmissionServices()) {
                            this.navigationResponse.navigation.isSUBForm = true;
                            this.navigationResponse.navigation.isSUBDoc = true;
                            this.navigationResponse.navigation.currentStep = 2; this.checkNavBar('tdIsSUBForm');
                        }
                        break;
                    case "tdIsAddmVDoc":
                        if (this.validateSubmissionServices()) {
                            this.navigationResponse.navigation.isSUBForm = true;
                            this.navigationResponse.navigation.isSUBDoc = true;
                            this.navigationResponse.navigation.currentStep = 2; this.checkNavBar('tdIsSUBForm');
                        }
                        break;
                    case "tdIsPatentDoc":
                        if (this.validateSubmissionServices()) {
                            this.navigationResponse.navigation.isSUBForm = true;
                            this.navigationResponse.navigation.isSUBDoc = true;
                            this.navigationResponse.navigation.currentStep = 2; this.checkNavBar('tdIsSUBForm');
                        }
                        break;
                    case "tdIsIntroMarkDoc":
                        if (this.validateSubmissionServices()) {
                            this.navigationResponse.navigation.isSUBForm = true;
                            this.navigationResponse.navigation.isSUBDoc = true;
                            this.navigationResponse.navigation.currentStep = 2; this.checkNavBar('tdIsSUBForm');
                        }
                        break;
                    case "tdIsAddlDoc":
                        this.navigationResponse.navigation.isAddlDoc = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        break;
                    case "tdIsFinalDocuments":
                        this.navigationResponse.navigation.isFinalSign = true;
                        this.navigationResponse.navigation.currentStep = 2;
                        break;
                    default:
                        break;
                }
                this.highlightNaBar();
            }
        }
        this.saveNavigationWizard();
    }

    validateSubmissionServices(): boolean {
        if (+ $("#contract option:selected").val() == 3 && !isNullOrUndefined(this.contractActionlog)
            && (this.contractActionlog.dtIntroMarkDoc || this.isIntroMarkAccept) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept) && (this.addendumServicesResponse.addendum.isAddendumB || this.addendumServicesResponse.addendum.isAddendumG || this.addendumServicesResponse.addendum.isAddendumP)) {
            return this.validateAddendums();
        }
        if (+ $("#contract option:selected").val() == 10 && !isNullOrUndefined(this.contractActionlog)
            && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept) && (this.addendumServicesResponse.addendum.isAddendumB || this.addendumServicesResponse.addendum.isAddendumG || this.addendumServicesResponse.addendum.isAddendumP)) {
            return this.validateAddendums();
        }
        if ((+ $("#contract option:selected").val() == 7 || + $("#contract option:selected").val() == 8 || + $("#contract option:selected").val() == 12 || + $("#contract option:selected").val() == 13 || + $("#contract option:selected").val() == 14) && !isNullOrUndefined(this.contractActionlog)
            && (this.contractActionlog.dtIntroMarkDoc || this.isIntroMarkAccept) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept)
            && (this.contractActionlog.dtPatentDoc || this.isPatentAccept) && (this.addendumServicesResponse.addendum.isAddendumB || this.addendumServicesResponse.addendum.isAddendumG || this.addendumServicesResponse.addendum.isAddendumP)) {
            return this.validateAddendums();
        }
        if ((+ $("#contract option:selected").val() == 9) && !isNullOrUndefined(this.contractActionlog)
            && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept)
            && (this.contractActionlog.dtPatentDoc || this.isPatentAccept) && (this.addendumServicesResponse.addendum.isAddendumB || this.addendumServicesResponse.addendum.isAddendumG || this.addendumServicesResponse.addendum.isAddendumP)) {
            return this.validateAddendums();
        }
        //IMP
        if (this.isShowIMP) {
            if (this.isShowPatent) {
                if (!isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtPatentDoc) || this.isPatentAccept)
                    return true;
            }
            //No Patent
            else
                return true;
        }
        //Submission Service
        if (this.isShowSub || this.isShowIMP) {
            if (this.isShowIMP && this.isShowPatent && !isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtPatentDoc || this.isPatentAccept))
                return true;
            if (+ $("#contract option:selected").val() == 3 && !this.addendumServicesResponse.addendum.isAddendumB && !this.addendumServicesResponse.addendum.isAddendumG && !this.addendumServicesResponse.addendum.isAddendumP && !isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept) && (this.contractActionlog.dtIntroMarkDoc || this.isIntroMarkAccept))
                return true;
            if (+ $("#contract option:selected").val() == 10 && !this.addendumServicesResponse.addendum.isAddendumG && !this.addendumServicesResponse.addendum.isAddendumP && !isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept))
                return true;
            if ((+ $("#contract option:selected").val() == 7 || + $("#contract option:selected").val() == 8 || + $("#contract option:selected").val() == 12 || + $("#contract option:selected").val() == 13 || + $("#contract option:selected").val() == 14) && !this.addendumServicesResponse.addendum.isAddendumB && !this.addendumServicesResponse.addendum.isAddendumG && !this.addendumServicesResponse.addendum.isAddendumP && !isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept) && (this.contractActionlog.dtIntroMarkDoc || this.isIntroMarkAccept) && (this.contractActionlog.dtPatentDoc || this.isPatentAccept))
                return true;
            if ((+ $("#contract option:selected").val() == 9) && !this.addendumServicesResponse.addendum.isAddendumG && !this.addendumServicesResponse.addendum.isAddendumP && !isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept) && (this.contractActionlog.dtPatentDoc || this.isPatentAccept))
                return true;
        }
        else
            return false;
    }

    validateAddendums(): boolean {
        //AddendumB
        if (this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14) {
            if (this.addendumServicesResponse.addendum.isAddendumB && !this.addendumServicesResponse.addendum.isAddendumG && !this.addendumServicesResponse.addendum.isAddendumP) {
                if (this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept)
                    return true;
            }
        }
        //AddendumG
        if (this.addendumServicesResponse.addendum.isAddendumG && !this.addendumServicesResponse.addendum.isAddendumB && !this.addendumServicesResponse.addendum.isAddendumP) {
            if (this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept)
                return true;
        }
        //AddendumP
        if (this.addendumServicesResponse.addendum.isAddendumP && !this.addendumServicesResponse.addendum.isAddendumG && !this.addendumServicesResponse.addendum.isAddendumB) {
            if (this.productId > 8 && this.productId < 12) {
                if ((this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept) /*&& (this.contractActionlog.dtAddendumVDoc || this.isAddmVAccept)*/)
                    return true;
            }
            else {
                if ((this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept) && (this.contractActionlog.dtAddendumVDoc || this.isAddmVAccept))
                    return true;
            }
        }
        //AddendumB & AddendumG
        if (this.addendumServicesResponse.addendum.isAddendumB && this.addendumServicesResponse.addendum.isAddendumG && !this.addendumServicesResponse.addendum.isAddendumP) {
            if ((this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept) && (this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept))
                return true;
        }
        //AddendumG & AddendumP
        if (!this.addendumServicesResponse.addendum.isAddendumB && this.addendumServicesResponse.addendum.isAddendumG && this.addendumServicesResponse.addendum.isAddendumP) {
            if (this.productId > 8 && this.productId < 12) {
                if ((this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept) /*&& (this.contractActionlog.dtAddendumVDoc || this.isAddmVAccept)*/)
                    return true;
            }
            else {
                if ((this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept) && (this.contractActionlog.dtAddendumVDoc || this.isAddmVAccept))
                    return true;
            }
        }
        //AddendumB & AddendumP
        if (this.addendumServicesResponse.addendum.isAddendumB && !this.addendumServicesResponse.addendum.isAddendumG && this.addendumServicesResponse.addendum.isAddendumP) {
            if (this.productId > 8 && this.productId < 12) {
                if ((this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept) /*&& (this.contractActionlog.dtAddendumVDoc || this.isAddmVAccept)*/)
                    return true;
            }
            else {
                if ((this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept) && (this.contractActionlog.dtAddendumVDoc || this.isAddmVAccept))
                    return true;
            }
        }
        //AddendumB, AddendumG & AddendumP
        if (this.addendumServicesResponse.addendum.isAddendumB && this.addendumServicesResponse.addendum.isAddendumG && this.addendumServicesResponse.addendum.isAddendumP) {
            if (this.productId > 8 && this.productId < 12) {
                if ((this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept) && (this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept))
                    return true;
            }
            else {
                if ((this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept) && (this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept) && (this.contractActionlog.dtAddendumVDoc || this.isAddmVAccept))
                    return true;
            }
        }
    }

    validateContractSteps() {
        if (!isNullOrUndefined(this.contractSession)) {
            if (this.productId == 1) {
                if (this.contractSession.CountryID > 2) {
                    if (this.navigationResponse.navigation.isBIPForm &&
                        this.navigationResponse.navigation.isBIPDoc &&
                        this.navigationResponse.navigation.isPPSODoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
                else if (this.isNewCanadianContract) {
                    if (this.navigationResponse.navigation.isBIPForm &&
                        this.navigationResponse.navigation.isBIPDoc &&
                        this.navigationResponse.navigation.isPPSODoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isADSDoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
                else {
                    if (this.navigationResponse.navigation.isBIPForm &&
                        this.navigationResponse.navigation.isBIPDoc &&
                        this.navigationResponse.navigation.isPPSODoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isADSDoc &&
                        this.navigationResponse.navigation.isNDADoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
            }

            if (this.productId == 2) {
                if (this.contractSession.CountryID > 2) {
                    if (this.navigationResponse.navigation.isBIPForm &&
                        this.navigationResponse.navigation.isBIPDoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
                else if (this.isNewCanadianContract) {
                    if (this.navigationResponse.navigation.isBIPForm &&
                        this.navigationResponse.navigation.isBIPDoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isADSDoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
                else {
                    if (this.navigationResponse.navigation.isBIPForm &&
                        this.navigationResponse.navigation.isBIPDoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isADSDoc &&
                        this.navigationResponse.navigation.isNDADoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
            }

            if (this.productId == 6 || this.productId == 11) {
                if (this.contractSession.CountryID > 2) {
                    if (this.navigationResponse.navigation.isPPSODoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
                else if (this.isNewCanadianContract) {
                    if (this.navigationResponse.navigation.isPPSODoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isADSDoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
                else {
                    if (this.navigationResponse.navigation.isPPSODoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isADSDoc &&
                        this.navigationResponse.navigation.isNDADoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
            }

            if ((this.productId == 4) || (this.productId == 5)) {
                if (this.contractSession.CountryID > 2) {
                    if (this.navigationResponse.navigation.isIMPForm &&
                        this.navigationResponse.navigation.isIMPDoc &&
                        this.navigationResponse.navigation.isSUBForm &&
                        this.navigationResponse.navigation.isSUBDoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
                else if (this.isNewCanadianContract) {
                    if (this.navigationResponse.navigation.isIMPForm &&
                        this.navigationResponse.navigation.isSUBForm &&
                        this.navigationResponse.navigation.isSUBDoc &&
                        this.navigationResponse.navigation.isIMPDoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isADSDoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
                else {
                    if (this.navigationResponse.navigation.isIMPForm &&
                        this.navigationResponse.navigation.isSUBForm &&
                        this.navigationResponse.navigation.isSUBDoc &&
                        this.navigationResponse.navigation.isIMPDoc &&
                        this.navigationResponse.navigation.isSOCForm &&
                        this.navigationResponse.navigation.isSOCDoc &&
                        this.navigationResponse.navigation.isADSDoc &&
                        this.navigationResponse.navigation.isNDADoc &&
                        this.navigationResponse.navigation.isProdServicesForm
                    ) {
                        this.isContractDone = true;
                    } else {
                        this.isContractDone = false;
                    }
                }
            }

            if ((this.productId == 3 || this.productId == 12 || this.productId == 13 || this.productId == 14) || (this.productId >= 7 && this.productId <= 10)/*this.productId == 7 || this.productId == 8*/) {
                if (this.contractSession.CountryID > 2) {
                    if (this.productId > 8 && this.productId < 12) {
                        if (this.navigationResponse.navigation.isSUBForm &&
                            this.navigationResponse.navigation.isSUBDoc &&
                            this.navigationResponse.navigation.isSOCForm &&
                            this.navigationResponse.navigation.isSOCDoc &&
                            this.navigationResponse.navigation.isProdServicesForm
                        ) {
                            this.isContractDone = true;
                        } else {
                            this.isContractDone = false;
                        }
                    }
                    else {
                        if (this.navigationResponse.navigation.isSUBForm &&
                            this.navigationResponse.navigation.isSUBDoc &&
                            this.navigationResponse.navigation.isCheckListForm &&
                            this.navigationResponse.navigation.isCheckListDoc &&
                            this.navigationResponse.navigation.isSOCForm &&
                            this.navigationResponse.navigation.isSOCDoc &&
                            this.navigationResponse.navigation.isProdServicesForm
                        ) {
                            this.isContractDone = true;
                        } else {
                            this.isContractDone = false;
                        }
                    }
                }
                else if (this.isNewCanadianContract) {
                    if (this.productId > 8 && this.productId < 12) {
                        if (this.navigationResponse.navigation.isSUBForm &&
                            this.navigationResponse.navigation.isSUBDoc &&
                            this.navigationResponse.navigation.isSOCForm &&
                            this.navigationResponse.navigation.isSOCDoc &&
                            this.navigationResponse.navigation.isADSDoc &&
                            this.navigationResponse.navigation.isProdServicesForm
                        ) {
                            this.isContractDone = true;
                        } else {
                            this.isContractDone = false;
                        }
                    }
                    else {
                        if (this.productId > 8 && this.productId < 12) {
                            if (this.navigationResponse.navigation.isSUBForm &&
                                this.navigationResponse.navigation.isSUBDoc &&
                                this.navigationResponse.navigation.isSOCForm &&
                                this.navigationResponse.navigation.isSOCDoc &&
                                this.navigationResponse.navigation.isADSDoc &&
                                this.navigationResponse.navigation.isProdServicesForm
                            ) {
                                this.isContractDone = true;
                            } else {
                                this.isContractDone = false;
                            }
                        }
                        else {
                            if (this.navigationResponse.navigation.isSUBForm &&
                                this.navigationResponse.navigation.isSUBDoc &&
                                this.navigationResponse.navigation.isCheckListForm &&
                                this.navigationResponse.navigation.isCheckListDoc &&
                                this.navigationResponse.navigation.isSOCForm &&
                                this.navigationResponse.navigation.isSOCDoc &&
                                this.navigationResponse.navigation.isADSDoc &&
                                this.navigationResponse.navigation.isProdServicesForm
                            ) {
                                this.isContractDone = true;
                            } else {
                                this.isContractDone = false;
                            }
                        }
                    }
                }
                else {
                    if (this.productId > 8 && this.productId < 12) {
                        if (this.navigationResponse.navigation.isSUBForm &&
                            this.navigationResponse.navigation.isSUBDoc &&
                            this.navigationResponse.navigation.isSOCForm &&
                            this.navigationResponse.navigation.isSOCDoc &&
                            this.navigationResponse.navigation.isNDADoc &&
                            this.navigationResponse.navigation.isProdServicesForm
                        ) {
                            this.isContractDone = true;
                        } else {
                            this.isContractDone = false;
                        }
                    }
                    else {
                        if (this.navigationResponse.navigation.isSUBForm &&
                            this.navigationResponse.navigation.isSUBDoc &&
                            this.navigationResponse.navigation.isCheckListForm &&
                            this.navigationResponse.navigation.isCheckListDoc &&
                            this.navigationResponse.navigation.isSOCForm &&
                            this.navigationResponse.navigation.isSOCDoc &&
                            this.navigationResponse.navigation.isADSDoc &&
                            this.navigationResponse.navigation.isNDADoc &&
                            this.navigationResponse.navigation.isProdServicesForm
                        ) {
                            this.isContractDone = true;
                        } else {
                            this.isContractDone = false;
                        }
                    }
                }
            }

            if (this.contractPayment) {
                if (this.contractPayment.paymentOptionId == 2) {
                    if (this.contractSession.CountryID > 2) {
                        if (this.isContractDone &&
                            this.navigationResponse.navigation.isUniPayForm &&
                            this.navigationResponse.navigation.isUniPayDoc &&
                            this.navigationResponse.navigation.isPPADoc) {
                            this.isContractDone = true;
                        } else {
                            this.isContractDone = false;
                        }
                    }
                    else {
                        if (this.isContractDone &&
                            this.navigationResponse.navigation.isInformInventForm &&
                            this.navigationResponse.navigation.isInformInventDoc &&
                            this.navigationResponse.navigation.isRetailDoc &&
                            this.navigationResponse.navigation.isUniPayForm &&
                            this.navigationResponse.navigation.isUniPayDoc) {
                            this.isContractDone = true;
                        } else {
                            this.isContractDone = false;
                        }
                    }
                }
            }

            if (this.isContractDone && this.contractSession.CountryID < 3 && this.isWaitStateExists) {
                this.isWaitStateExists && this.navigationResponse.navigation.isWaitDoc ? this.isContractDone = true : this.isContractDone = false;
            }

            if (this.isStateExists && this.isContractDone && this.contractSession.CountryID < 3) {
                this.navigationResponse.navigation.isStateDoc ? this.isContractDone = true : this.isContractDone = false;
            }

            if (this.isContractDone && this.isAddlDocExists && this.contractSession.CountryID < 3) {
                this.navigationResponse.navigation.isAddlDoc ? this.isContractDone = true : this.isContractDone = false;
            }

            if (this.isContractDone && this.navigationResponse.navigation.isFinalSign && this.navigationResponse.navigation.isPayCollectForm) {
                this.navigationResponse.navigation.isFinalSign ? this.isContractDone = true : this.isContractDone = false;
                this.navigationResponse.navigation.isPayCollectForm ? this.isContractDone = true : this.isContractDone = false;
            } else this.isContractDone = false;

            if (this.isContractDone && ((this.productId == 1) || (this.productId == 2) || this.productId == 11 || (this.productId == 6 && !this.isBIPExist && !isNullOrUndefined(this.bipConfirmation) && this.bipConfirmation.isNo))) {
                this.navigationResponse.navigation.isROIForm && this.navigationResponse.navigation.isROIDoc ? this.isContractDone = true : this.isContractDone = false;
            }
            if (this.contractSession) {
                if (this.contractSession.sendToCorp && !this._transferDataService.isChangedFileNumber)
                    this.sendToCorpMsg = "Resend to Corp";
                else
                    this.sendToCorpMsg = "Send to Corp";
            }
            this.refreshNavBar();
        }
    }

    contractComplete() {
        if (this.contractSession) {
            this.contractSession.sendToCorp ? !this.contractSession.isReSendToCorp ? this.msgConfirm = "Please enter your comments below to resend this contract." : this.msgConfirm = "Do you want to resend this contract?"
                : this.flgInstallment && !this.inventorInformation.i1SSN && this.contractSession.CountryID < 2 ?
                    this.msgConfirm = "The SSN is not filled in. Do you want to continue?" : this.msgConfirm = "Do you want to send to Corp?";
            $('#modalSendToCorp').modal('show');
        }
    }


    async GetGenerateContractDetails() {
        await this._documentService.getContractsAzureDetailsAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res)
                    this.gencontractDetailsResponse = UtilityService.clone(res);

                if (this.gencontractDetailsResponse) {
                    this.generateContractsAzure = UtilityService.clone(this.gencontractDetailsResponse.getGenerateContractsAzure);

                    if (this.generateContractsAzure) {
                        this.isExecuted = this.generateContractsAzure.find(rows => rows.filePath != '' && rows.productId > 0) ? true : false;
                        const ELEMENT_DATA: GenerateContractsAzure[] = this.generateContractsAzure;
                        this.dataSourceGenContract = new MatTableDataSource(ELEMENT_DATA.filter(rows => rows.filePath != '' && rows.productId > 0));
                        this.dataSourceGenContract.sort = this.sortDoc;
                        this.dataSourceGenContractPopUp = new MatTableDataSource(ELEMENT_DATA.filter(rows => rows.filePath != '' && rows.productId > 0));
                        this.dataSourceGenContractPopUp.sort = this.sortDocPopUp;
                        this.generateContractsMedia = ELEMENT_DATA.filter(rows => rows.filePath == '' && rows.productId == 0);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    updateContactInSalesOptima() {
        this._contactService.updateContactInSalesOptimaAsync(this.encryptedUser, this.soContactDetails)
            .then(res => {
                this._contactService.getContactAsync(this.encryptedUser, this.contactId)
                    .then(async (result: ContactResponse) => {
                        if (result) {
                            if (result.statusCode == 0) {
                                this.contactResponse = UtilityService.clone(result);
                                if (this.contactResponse) {
                                    this.contactDetails = UtilityService.clone(this.contactResponse.contactDetails);
                                    var invName = this.contactDetails.inventionName;
                                    this.exInventionName = this.contactDetails.inventionName;
                                    if (!isNullOrUndefined(this.inventionName) && this.inventionName != '' && !isNullOrUndefined(invName) && invName != '') {
                                        if (invName.toLowerCase() == this.inventionName.toLowerCase()) {
                                            this.isBIPClient = this.contactDetails.isBIPClient;
                                            this.isSubClient = this.contactDetails.isSubClient;
                                            this.isPPSOClient = this.contactDetails.isPPSOClient;
                                            this.isPlusClient = this.contactDetails.isPlusClient;
                                        }
                                        else {
                                            this.isBIPClient = this.isSubClient = this.isPPSOClient = this.isPlusClient = false;
                                        }
                                    }
                                    else {
                                        this.isBIPClient = this.isSubClient = this.isPPSOClient = this.isPlusClient = false;
                                    }
                                    this.loadProductList();
                                }
                            }
                            else {
                                console.log("contact result status code: " + result.statusCode);
                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this._utilityService.handleErrorResponse(err);
                    });
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    BIPConfirmation(val) {
        this.bipConfirmation = {} as BIPConfirmation;
        this.bipConfirmation.contractSessionId = this.contractSessionId;
        this.bipConfirmation.clpUserID = this.clpUserId;
        this.bipConfirmation.inventionName = this.inventionName;
        if (val == 'Yes') {
            if (this.contractSession) {
                this.contractSession.IsSecondContract = true;
                this.CreateUpdate_ContractSession();
                this.isShowROI = false;
                this.bipConfirmation.isYes = true;
                this.bipConfirmation.isNo = false;
                this.bipConfirmation.step = "ContractLoad";
                if (this.navigationResponse)
                    this.updateManDocSC();
                else {
                    this._navigationService.getNavigationWizardAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
                        .then(res => {
                            if (res) {
                                if (res.statusCode == 0) {
                                    this.navigationResponse = UtilityService.clone(res);
                                    if (this.navigationResponse) {
                                        this.updateManDocSC();
                                    }
                                } else {
                                    console.log("Navigation Wizard result status code: " + res.statusCode);
                                }
                            }
                        })
                        .catch((err: HttpErrorResponse) => {
                            this._utilityService.handleErrorResponse(err);
                        });
                }
                $('#modalBIPConfirmation').modal('hide');
            }
        }
        else {
            this.bipConfirmation.isNo = true;
            this.bipConfirmation.isYes = false;
            this.bipConfirmation.step = "ContractLoad";
            $('#modalBIPConfirmation').modal('hide');
        }
        this.CreateUpdate_BIPConfirmation(val);
    }

    cancelContract(val) {
        this.canConfirm = "Do you want to cancel this contract?";
        $('#modalCancelContract').modal('show');
        if (val == 'Yes') {
            if (this.contractSession) {
                if (this.contractSession.sendToCorp) {
                    this.contractSession.isCancelled = true;
                    this.contractSession.status = 2;
                    this.isCancelled = true;
                    this.openSnackBar("Contract has been cancelled successfully!", "");
                    this.emailCancelLink();
                    this.updateContractLogObjectModel("cancelled", false);
                    this.saveContrActionAcitonLog();
                    this.CreateUpdate_ContractSession();
                    $('#modalCancelContract').modal('hide');
                    this.createNetSuiteTransactions();
                    this.copyContactDetailsToDataObject(true);
                    this.updateContactInSalesOptima();
                }
            }
        }
        else
            $('#modalCancelContract').modal('hide');
    }

    validateSignatures(): boolean {
        this.strMsg = "";
        if (!isNullOrUndefined(this.documentSignature) && !isNullOrUndefined(this.contractSession)) {
            if (this.inventionResponse.inventionDetails.isCoInventor) {
                if (this.documentSignature.signature2 == '' && this.documentSignature.initial2 == '' && !this.contractSession.IsSecondContract) {
                    this.strMsg == '' ? this.strMsg = "CoInventor SOC" : this.strMsg += "/CoInventor SOC";
                }
                if (this.documentSignature.i2SignatureADS == '' && this.documentSignature.i2InitialADS == '' && (this.contractSession.CountryID != 3 && this.contractSession.CountryID != 4 && this.contractSession.CountryID != 6) && !this.contractSession.IsSecondContract) {
                    this.strMsg == '' ? this.strMsg = "CoInventor ADS" : this.strMsg += "/CoInventor ADS";
                }
                if (this.documentSignature.i2SignatureFinal == '' && this.documentSignature.i2InitialFinal == '') {
                    this.strMsg == '' ? this.strMsg = "CoInventor Final" : this.strMsg += "/CoInventor Final";
                }
            }

            if (this.documentSignature.signature1 == '' && this.documentSignature.initial1 == '' && !this.contractSession.IsSecondContract) {
                this.strMsg == '' ? this.strMsg = "SOC" : this.strMsg += "/SOC";
            }
            if (this.documentSignature.i1SignatureADS == '' && this.documentSignature.i1InitialADS == '' && (this.contractSession.CountryID != 3 && this.contractSession.CountryID != 4 && this.contractSession.CountryID != 6) && !this.contractSession.IsSecondContract) {
                this.strMsg == '' ? this.strMsg = "ADS" : this.strMsg += "/ADS";
            }
            if (this.documentSignature.i1SignatureFinal == '' && this.documentSignature.i1InitialFinal == '') {
                this.strMsg == '' ? this.strMsg = "Final" : this.strMsg += "/Final";
            }

            if (this.strMsg != '')
                this.strMsg = this.strMsg + " signature is missing. Please reopen the " + this.strMsg + " and sign it again.";

        } else {
            this.strMsg = "Issue encountered! Please reload the contract and try again.";
        }

        if (this.strMsg != '') {
            if (!isNullOrUndefined(this.navigationResponse)) {
                if (this.strMsg.includes("SOC"))
                    this.navigationResponse.navigation.isSOCDoc = false; this.uncheckNavBar('tdIsSOCDoc');
                if (this.strMsg.includes("ADS"))
                    this.navigationResponse.navigation.isADSDoc = false; this.uncheckNavBar('tdIsADSDoc');
                if (this.strMsg.includes("Final"))
                    this.navigationResponse.navigation.isFinalSign = false; this.uncheckNavBar('tdIsFinalDocuments');
                this.saveNavigationWizard();
            }
            return false;
        }
        return true;
    }

    async sendToCorp(val) {
        if (val == 'Yes') {
            await this._documentService.getDocumentSignatureAsync(this.encryptedUser, this.contractSessionId)
                .then(res => {
                    if (res) {
                        if (res.statusCode == 0) {
                            this.documentSignatureResponse = UtilityService.clone(res);
                            this.documentSignature = this.documentSignatureResponse.documentSignature;
                            if (this.documentSignature) {
                                if (this.validateSignatures()) {
                                    if (this.contractSession) {
                                        $('#modalSendToCorpProcess').modal('show');
                                        if (!this.contractSession.isReSendToCorp)
                                            this.salesRepComments = $("#salesRepComments").val();
                                        else
                                            this.salesRepComments = 'ResendToCorp';
                                        this.contractSession.sendToCorp = true;
                                        this.contractSession.status = 0;
                                        this.sendToCorpMsg = "Sent to Corp";
                                        this.isSendToCorp = true;
                                        this.sendExportToPDF("Sendtocorp");
                                        this.updateContractLogObjectModel("sendToCorp", false);
                                        this.saveContrActionAcitonLog();
                                        this.CreateUpdate_ContractSession();
                                        this.divOtherMandDocs = false;
                                        $('#modalSendToCorp').modal('hide');
                                        this.navScrrol = '';
                                        this.isPaymentDone = true;
                                        this._transferDataService.isChangedFileNumber = false;
                                    }
                                }
                                else {
                                    $('#modalSendToCorp').modal('hide');
                                    this._utilityService.showAlertMsg("Document Signature", this.strMsg);
                                }
                            }
                        } else {
                            console.log("Document Signature result status code: " + res.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else
            $('#modalSendToCorp').modal('hide');
    }

    acceptAgreement(val) {
        if (val == 'Yes') {
            if (this.contractSession.CountryID < 2 && !this.clientLocation) {
                if ($("#clientstate option:selected").val() == -1) {
                    $("#idLocationMsg").text("Please select a State.");
                    return;
                }
                else
                    this.contractSession.clientState = $("#clientstate option:selected").val();
                this.loadUserState(this.contractSession.clientState);
            }
            if (this.contractSession.CountryID == 2)
                this.contractSession.USFeeConfirm = 2;
            this.contractSession.isClientRemote = this.locationPOPUP.controls.isClientRemote.value ? this.locationPOPUP.controls.isClientRemote.value : false;
            if (this.locationPOPUP.controls.isClientRemote.value) {
                this._router.navigate(['/contract-remote', this.contactId, this.inventionId, this.contractSessionId, this.rdClpUserId], {
                    queryParams: { w: 1, 'i': this.inventionId, 'c': this.contactId, 'cs': this.contractSessionId, 'rd': this.rdClpUserId, 'r': this.encryptedUser }
                });
            }
            this.CreateUpdate_ContractSession();
            $('#modalCheckCountry').modal('hide');

        }
        var IsBIPExistInSystem = !isNullOrUndefined(this.contractSessionListResponse) && this.contractSessionListResponse.contractSession.find(i => i.productId < 3);
        if (this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14) {
            if (!isNullOrUndefined(this.bipConfirmation) && this.bipConfirmation.contractSessionId < 1 && !IsBIPExistInSystem && !this.isSecondContract && !this.isBIPClient)
                $('#modalBIPConfirmation').modal('show');
        }
        if (!isNullOrUndefined(this.contractSession) && this.contractSession.IsSecondContract) {
            this.stepper.selectedIndex = 1;
            this.showDivItem(this.stepper, 1, '#divPS');
            this.currentActive = 5;
            setTimeout(() => {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('#divPS').offset().top - 104
                }, 100);
            }, 200);
        }
    }

    highlightNaBar() {
        if (this.navigationResponse) {
            if (this.navigationResponse.navigation) {
                this.navigationResponse.navigation.isSOCForm && this.navigationResponse.navigation.isSOCDoc ? this.socDone = true : this.socDone = false;
                this.navigationResponse.navigation.isADSDoc == true ? this.adsDone = true : this.adsDone = false;
                this.navigationResponse.navigation.isNDADoc == true ? this.ndaDone = true : this.ndaDone = false;
                this.navigationResponse.navigation.isWaitDoc == true ? this.waitDone = true : this.waitDone = false;
                this.navigationResponse.navigation.isStateDoc == true ? this.sdaDone = true : this.sdaDone = false;
                this.navigationResponse.navigation.isProdServicesForm ? this.prodDone = true : this.prodDone = false;
                this.navigationResponse.navigation.isBIPForm && this.navigationResponse.navigation.isBIPDoc ? this.bipDone = true : this.bipDone = false;
                this.navigationResponse.navigation.isPPSODoc ? this.ppsoDone = true : this.ppsoDone = false;
                this.navigationResponse.navigation.isInformInventForm && this.navigationResponse.navigation.isInformInventDoc ? this.informDone = true : this.informDone = false;
                this.navigationResponse.navigation.isRetailDoc ? this.retailDone = true : this.retailDone = false;
                this.navigationResponse.navigation.isPPADoc ? this.ppaDone = true : this.ppaDone = false;
                this.navigationResponse.navigation.isUniPayForm && this.navigationResponse.navigation.isUniPayDoc ? this.upcDone = true : this.upcDone = false;
                this.navigationResponse.navigation.isPayCollectForm ? this.paymentDone = true : this.paymentDone = false;
                this.navigationResponse.navigation.isROIForm && this.navigationResponse.navigation.isROIDoc ? this.roiDone = true : this.roiDone = false;
                if (this.productId <= 9 || this.productId == 12 || this.productId == 13 || this.productId == 10 || this.productId == 14)
                    this.navigationResponse.navigation.isCheckListForm && this.navigationResponse.navigation.isCheckListDoc ? this.checkListDone = true : this.checkListDone = false;
                this.navigationResponse.navigation.isIMPForm && this.navigationResponse.navigation.isIMPDoc ? this.impDone = true : this.impDone = false;
                this.navigationResponse.navigation.isSUBForm && this.navigationResponse.navigation.isSUBDoc ? this.subDone = true : this.subDone = false;
                this.navigationResponse.navigation.isAddlDoc == true ? this.addlDone = true : this.addlDone = false;
                this.navigationResponse.navigation.isFinalSign == true ? this.finalSignDone = true : this.finalSignDone = false;

                this.checkMandDocSigned();
            }
        }
    }

    checkMandDocSigned() {
        this.isMandDocSigned = false;
        if (this.navigationResponse) {
            if (this.navigationResponse.navigation) {
                if (this.productId >= 9 && this.productId < 12) {
                    this.isMandDocSigned = this.navigationResponse.navigation.isSOCDoc || this.isSecondContract ? true : false;
                }
                else {
                    if (!isNullOrUndefined(this.contractSession) && ((this.contractSession.CountryID == 3) || (this.contractSession.CountryID == 4) || this.contractSession.CountryID == 6))
                        (this.navigationResponse.navigation.isSOCDoc == true) ? this.isMandDocSigned = true : this.isMandDocSigned = false;
                    else if (!isNullOrUndefined(this.contractSession) && this.contractSession.CountryID == 2)
                        (this.navigationResponse.navigation.isSOCDoc == true) && (this.navigationResponse.navigation.isADSDoc == true) ? this.isMandDocSigned = true : this.isMandDocSigned = false;
                    else if (this.isStateExists == false) {
                        (this.navigationResponse.navigation.isSOCDoc == true) && (this.navigationResponse.navigation.isADSDoc == true) && (this.navigationResponse.navigation.isStateDoc == false) ? this.isMandDocSigned = true : this.isMandDocSigned = false;
                    }
                    else if (this.isStateExists == true) {
                        (this.navigationResponse.navigation.isSOCDoc == true) && (this.navigationResponse.navigation.isADSDoc == true) && (this.navigationResponse.navigation.isStateDoc == true) ? this.isMandDocSigned = true : this.isMandDocSigned = false;
                    }
                }
                if (this.isSecondContract == true)
                    this.isMandDocSigned = true
            }
        }
    }

    updateCheckClass(divId) {
        $("#" + divId).removeClass("fa-square-o");
        $("#" + divId).addClass("fa-check-square-o");

        switch (divId) {
            case "tdIsNDADoc": this.isNDAHeadAccept = true; break;
            case "tdIsWaitDoc": this.isWaitHeadAccept = true; break;
            case "tdIsBIPDoc": this.isBIPAccept = true; break;
            case "tdIsPPSODoc": this.isPPSOAccept = true; break;
            case "tdIsInformInventDoc": this.isInfoInventAccept = true; break;
            case "tdIsRetailDoc": this.isRetailAccept = true; break;
            case "tdIsPPADoc": this.isPPAAccept = true; break;
            case "tdIsUniPayDoc": this.isUniPayAccept = true; break;
            case "tdIsROIDoc": this.isROIAccept = true; break;
            case "tdIsCheckListDoc": (this.productId <= 9 || this.productId == 12 || this.productId == 13 || this.productId == 10 || this.productId == 14) ? this.isCheckListAccept = true : this.isCheckListAccept = false; break;
            case "tdIsIMPDoc": this.isIMPAccept = true; break;
            case "tdIsSUBDoc": this.isSUBAccept = true; break;
            case "tdIsAddlDoc": this.isAddlAccept = true; this.isAddlHeadAccept = true; break;
            default:
        }
    }

    updateBanClass(divId) {
        $("#" + divId).removeClass("fa-check-square-o");
        $("#" + divId).addClass("fa-square-o");
    }

    updateNotActiveClass(divId) {
        $("#" + divId).css('color', 'lightgray');
    }

    removeNotActiveClass(divId) {
        $("#" + divId).css('color', '');
    }

    async CustomerAccept(divId) {
        let documentId: number = 0;
        let auditActionFlag = "";

        if (!this.isProductV) {
            documentId = this.addmVDocumentId;
            this.isAddmVAccept = true;
            auditActionFlag = "addmVDocSign";
        }

        switch (divId) {
            case "tdIsBIPDoc": documentId = 22; this.isBIPAccept = true; this.isBIPHeadAccept = true; auditActionFlag = "bipDocSign"; break;
            case "tdIsPPSODoc": this.productId > 8 && this.productId < 12 ? documentId = 6 : documentId = 23; this.isPPSOAccept = true; this.isPPSOHeadAccept = true; auditActionFlag = "ppsoDocsign"; break;
            case "tdIsInformInventDoc": documentId = 24; this.isInfoInventAccept = true; this.isInfoInventHeadAccept = true; auditActionFlag = "inventDocSign"; break;
            case "tdIsRetailDoc": documentId = 25; this.isRetailAccept = true; this.isRetailHeadAccept = true; auditActionFlag = "retailInstallmentDocSign"; break;
            case "tdIsPPADoc": (this.contractSession.productId == 1 || this.contractSession.productId == 2 || this.contractSession.productId == 6 || this.contractSession.productId == 11) ? documentId = 132 : documentId = 130; this.isPPAAccept = true; this.isPPAHeadAccept = true; auditActionFlag = "ppaDocSign"; break;
            case "tdIsROIDoc": documentId = 2; this.isROIAccept = true; this.isROIHeadAccept = true; auditActionFlag = "roiDocSign"; this.updateNavBar(); break;
            case "tdIsUniPayDoc": documentId = 26; this.isUniPayAccept = true; this.isUniPayHeadAccept = true; auditActionFlag = "uniPayDocSign"; break;
            case "tdIsIMPDoc": this.productId == 5 ? this.isWestern == false ? documentId = 133 : documentId = 135 : this.isWestern == false ? documentId = 36 : documentId = 128; this.isIMPAccept = true; this.isIMPHeadAccept = true; auditActionFlag = "impDocSign"; break;
            case "tdIsSUBDoc": this.productId == 14 ? documentId = 142 : documentId = -1; this.isSUBAccept = true; this.isSUBHeadAccept = true; auditActionFlag = "subDocSign"; break;
            case "tdIsAddmBDoc": documentId = this.addmBDocumentId; this.isAddmBAccept = true; auditActionFlag = "addmBDocSign"; break;
            case "tdIsAddmGDoc": documentId = this.addmGDocumentId; this.isAddmGAccept = true; auditActionFlag = "addmGDocSign"; break;
            case "tdIsAddmPDoc": documentId = this.addmPDocumentId; this.isAddmPAccept = true; auditActionFlag = "addmPDocSign"; break;
            case "tdIsAddmTDoc": documentId = this.addmTDocumentId; this.isAddmTAccept = true; auditActionFlag = "addmTDocSign"; break;
            case "tdIsAddmVDoc": documentId = this.addmVDocumentId; this.isAddmVAccept = true; auditActionFlag = "addmVDocSign"; break;
            case "tdIsPatentDoc": documentId = this.patentDocumentId; this.isPatentAccept = true; auditActionFlag = "patentDocSign"; break;
            case "tdIsIntroMarkDoc": documentId = this.introMarkDocumentId; this.isIntroMarkAccept = true; auditActionFlag = "introMarkDocSign"; break;
            case "tdIsAddlDoc": documentId = -2; this.isAddlAccept = true; this.isAddlHeadAccept = true; auditActionFlag = "additionalDocSign"; break;
            case "tdIsCheckListDoc": documentId = -3; this.isCheckListAccept = true; this.isCheckListHeadAccept = true; auditActionFlag = "checkListDocSign"; this.updateNavBar(); break;
            case "tdIsFinalDocuments": auditActionFlag = "contractSign"; break;
            default:
        }

        if (auditActionFlag === "contractSign") {
            this.updateContractLogObjectModel(auditActionFlag, true);
        }
        else
            this.updateContractLogObjectModel(auditActionFlag, false);

        await this.saveContrActionAcitonLog("CustomerAccept", divId);
        this.loadDocument_DocTypeId(documentId);
    }

    updateNavBar() {
        if (this.navigationResponse) {
            if (this.navigationResponse.navigation) {
                this.navigationResponse.navigation.isSOCForm == true ? this.updateCheckClass("tdIsSOCForm") : this.updateBanClass("tdIsSOCForm");
                this.navigationResponse.navigation.isSOCForm == true ? this.isSOCFormSaved = true : this.isSOCFormSaved = false;
                if (!isNullOrUndefined(this.contractSession) && this.contractSession.IsSecondContract && this.contractSession.ContractSessionId == this.contractSessionId) this.updateNotActiveClass("tdIsSOCForm"); else this.removeNotActiveClass("tdIsSOCForm");

                this.navigationResponse.navigation.isSOCDoc == true ? this.updateCheckClass("tdIsSOCDoc") : this.updateBanClass("tdIsSOCDoc");
                this.navigationResponse.navigation.isSOCDoc == true ? this.isSOCHeadAccept = true : this.isSOCHeadAccept = false;
                if (!isNullOrUndefined(this.contractSession) && this.contractSession.IsSecondContract && this.contractSession.ContractSessionId == this.contractSessionId) this.updateNotActiveClass("tdIsSOCDoc"); else this.removeNotActiveClass("tdIsSOCDoc");

                this.navigationResponse.navigation.isADSDoc == true ? this.updateCheckClass("tdIsADSDoc") : this.updateBanClass("tdIsADSDoc");
                this.navigationResponse.navigation.isADSDoc == true ? this.isADSHeadAccept = true : this.isADSHeadAccept = false;
                if (!isNullOrUndefined(this.contractSession) && this.contractSession.IsSecondContract && this.contractSession.ContractSessionId == this.contractSessionId) this.updateNotActiveClass("tdIsADSDoc"); else this.removeNotActiveClass("tdIsADSDoc");

                this.navigationResponse.navigation.isNDADoc == true ? this.updateCheckClass("tdIsNDADoc") : this.updateBanClass("tdIsNDADoc");
                this.navigationResponse.navigation.isNDADoc == true ? this.isNDAHeadAccept = true : this.isNDAHeadAccept = false;
                if (!isNullOrUndefined(this.contractSession) && this.contractSession.IsSecondContract && this.contractSession.ContractSessionId == this.contractSessionId) this.updateNotActiveClass("tdIsNDADoc"); else this.removeNotActiveClass("tdIsNDADoc");

                this.navigationResponse.navigation.isWaitDoc == true ? this.updateCheckClass("tdIsWaitDoc") : this.updateBanClass("tdIsWaitDoc");
                this.navigationResponse.navigation.isWaitDoc == true ? this.isWaitHeadAccept = true : this.isWaitHeadAccept = false;

                this.navigationResponse.navigation.isStateDoc == true ? this.updateCheckClass("tdIsSDADoc") : this.updateBanClass("tdIsSDADoc");
                this.navigationResponse.navigation.isStateDoc == true ? this.isSDAHeadAccept = true : this.isSDAHeadAccept = false;

                this.navigationResponse.navigation.isProdServicesForm == true ? this.updateCheckClass("tdIsProdServicesForm") : this.updateBanClass("tdIsProdServicesForm");
                this.navigationResponse.navigation.isProdServicesForm == true ? this.isServiceFormSaved = true : this.isServiceFormSaved = false;

                this.navigationResponse.navigation.isROIForm == true ? this.updateCheckClass("tdIsROIForm") : this.updateBanClass("tdIsROIForm");
                this.navigationResponse.navigation.isROIForm == true ? this.isROISaved = true : this.isROISaved = false;

                this.navigationResponse.navigation.isROIForm == true ? this.updateCheckClass("tdIsROIDoc") : this.updateBanClass("tdIsROIDoc");

                this.navigationResponse.navigation.isROIDoc == true ? this.updateCheckClass("tdIsROIDoc") : this.updateBanClass("tdIsROIDoc");
                this.navigationResponse.navigation.isROIDoc == true ? this.isROIHeadAccept = true : this.isROIHeadAccept = false;

                this.navigationResponse.navigation.isCheckListForm == true ? this.updateCheckClass("tdIsCheckListForm") : this.updateBanClass("tdIsCheckListForm");
                this.navigationResponse.navigation.isCheckListForm == true ? this.isCheckListSaved = true : this.isCheckListSaved = false;

                if (this.productId <= 9 || this.productId == 12 || this.productId == 13 || this.productId == 10 || this.productId == 14) {
                    this.navigationResponse.navigation.isCheckListDoc == true ? this.updateCheckClass("tdIsCheckListDoc") : this.updateBanClass("tdIsCheckListDoc");
                    this.navigationResponse.navigation.isCheckListDoc == true ? this.isCheckListHeadAccept = true : this.isCheckListHeadAccept = false;
                }

                this.navigationResponse.navigation.isSUBForm == true ? this.updateCheckClass("tdIsSUBForm") : this.updateBanClass("tdIsSUBForm");
                this.navigationResponse.navigation.isSUBForm == true ? this.isSUBSaved = true : this.isSUBSaved = false;

                this.navigationResponse.navigation.isSUBDoc == true ? this.updateCheckClass("tdIsSUBDoc") : this.updateBanClass("tdIsSUBDoc");
                /*this.navigationResponse.navigation.isSUBDoc == true ? this.isSUBHeadAccept = true : this.isSUBHeadAccept = false;*/

                this.navigationResponse.navigation.isBIForm == true ? this.updateCheckClass("tdIsBIForm") : this.updateBanClass("tdIsBIForm");
                this.navigationResponse.navigation.isBIForm == true ? this.isBIISaved = true : this.isBIISaved = false;

                this.navigationResponse.navigation.isBIDoc == true ? this.updateCheckClass("tdIsBIDoc") : this.updateBanClass("tdIsBIDoc");
                this.navigationResponse.navigation.isBIDoc == true ? this.isBIHeadAccept = true : this.isBIHeadAccept = false;

                this.navigationResponse.navigation.isBIPForm == true ? this.updateCheckClass("tdIsBIPForm") : this.updateBanClass("tdIsBIPForm");
                this.navigationResponse.navigation.isBIPForm == true ? this.isBIPSaved = true : this.isBIPSaved = false;

                this.navigationResponse.navigation.isBIPDoc == true ? this.updateCheckClass("tdIsBIPDoc") : this.updateBanClass("tdIsBIPDoc");
                this.navigationResponse.navigation.isBIPDoc == true ? this.isBIPHeadAccept = true : this.isBIPHeadAccept = false;

                this.navigationResponse.navigation.isPPSODoc == true ? this.updateCheckClass("tdIsPPSODoc") : this.updateBanClass("tdIsPPSODoc");
                this.navigationResponse.navigation.isPPSODoc == true ? this.isPPSOHeadAccept = true : this.isPPSOHeadAccept = false;

                this.navigationResponse.navigation.isInformInventForm == true ? this.updateCheckClass("tdIsInformInventForm") : this.updateBanClass("tdIsInformInventForm");
                this.navigationResponse.navigation.isInformInventForm == true ? this.isIISaved = true : this.isIISaved = false;

                this.navigationResponse.navigation.isInformInventDoc == true ? this.updateCheckClass("tdIsInformInventDoc") : this.updateBanClass("tdIsInformInventDoc");
                this.navigationResponse.navigation.isInformInventDoc == true ? this.isInfoInventHeadAccept = true : this.isInfoInventHeadAccept = false;

                this.navigationResponse.navigation.isRetailDoc == true ? this.updateCheckClass("tdIsRetailDoc") : this.updateBanClass("tdIsRetailDoc");
                this.navigationResponse.navigation.isRetailDoc == true ? this.isRetailAccept = this.isRetailHeadAccept = true : this.isRetailAccept = this.isRetailHeadAccept = false;

                this.navigationResponse.navigation.isPPADoc == true ? this.updateCheckClass("tdIsPPADoc") : this.updateBanClass("tdIsPPADoc");
                this.navigationResponse.navigation.isPPADoc == true ? this.isPPAHeadAccept = true : this.isPPAHeadAccept = false;

                this.navigationResponse.navigation.isUniPayForm == true ? this.updateCheckClass("tdIsUniPayForm") : this.updateBanClass("tdIsUniPayForm");
                this.navigationResponse.navigation.isUniPayForm == true ? this.isUPSaved = true : this.isUPSaved = false;

                this.navigationResponse.navigation.isUniPayDoc == true ? this.updateCheckClass("tdIsUniPayDoc") : this.updateBanClass("tdIsUniPayDoc");
                this.navigationResponse.navigation.isUniPayDoc == true ? this.isUniPayHeadAccept = true : this.isUniPayHeadAccept = false;

                this.navigationResponse.navigation.isIMPForm == true ? this.updateCheckClass("tdIsIMPForm") : this.updateBanClass("tdIsIMPForm");
                this.navigationResponse.navigation.isIMPForm == true ? this.isIMPSaved = true : this.isIMPSaved = false;

                this.navigationResponse.navigation.isIMPDoc == true ? this.updateCheckClass("tdIsIMPDoc") : this.updateBanClass("tdIsIMPDoc");
                this.navigationResponse.navigation.isIMPDoc == true ? this.isIMPHeadAccept = true : this.isIMPHeadAccept = false;

                this.navigationResponse.navigation.isAddlDoc == true ? this.updateCheckClass("tdIsAddlDoc") : this.updateBanClass("tdIsAddlDoc");
                this.navigationResponse.navigation.isAddlDoc == true ? this.isAddlHeadAccept = true : this.isAddlHeadAccept = false;

                this.navigationResponse.navigation.isPayCollectForm == true ? this.updateCheckClass("tdIsPayCollectForm") : this.updateBanClass("tdIsPayCollectForm");

                this.navigationResponse.navigation.isFinalSign == true ? this.updateCheckClass("tdIsFinalDocuments") : this.updateBanClass("tdIsFinalDocuments");

                this.highlightNaBar();
            }
            if (this.isSecondContract && (this.isBIPClient || this.isSubClient || this.isPPSOClient || this.isPlusClient)) {
                if (this.navigationResponse) {
                    this.updateManDocSC();
                } else {
                    this._navigationService.getNavigationWizardAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
                        .then(res => {
                            if (res) {
                                if (res.statusCode == 0) {
                                    this.navigationResponse = UtilityService.clone(res);
                                    if (this.navigationResponse) {
                                        this.updateManDocSC();
                                    }
                                } else {
                                    console.log("Navigation Wizard result status code: " + res.statusCode);
                                }
                            }
                        })
                        .catch((err: HttpErrorResponse) => {
                            this._utilityService.handleErrorResponse(err);
                        });
                }
            }
        }
    }

    updateManDocSC() {
        if ((!this.navigationResponse.navigation.isSOCDoc) ||
            (!this.navigationResponse.navigation.isSOCForm) ||
            (!this.navigationResponse.navigation.isADSDoc) ||
            (!this.navigationResponse.navigation.isNDADoc)) {
            this.navigationResponse.navigation.isSOCDoc = true;
            this.navigationResponse.navigation.isSOCForm = true;
            this.navigationResponse.navigation.isADSDoc = true;
            this.navigationResponse.navigation.isNDADoc = true;
            this.navigationResponse.navigation.currentStep = 2;
            this.navigationResponse.navigation.inventionId = this.inventionId;
            this.navigationResponse.navigation.contractSessionId = this.contractSessionId;
            this.saveNavigationWizard();
        }
    }

    backSOC() {
        this.isSOCMandDoc = false;
        this.isADSMandDoc = false;
        this.isSDAMandDoc = false;
        this.divSOC = true;
        this.divMmandDocs = false;
        this.chkSOC = false;
        this.chkADS = false;
        this.ctrMandDocs = 0;
        this.signaturePadCoInv.clear();
        this.signaturePadADS.clear();
        this.signaturePadADSCoInv.clear();
        this.signaturePadFinal.clear();
        this.signaturePadFinalCoInv.clear();
    }

    maskI1SSN(e) {
        let actualVal: string = "";
        let stars: string = "";
        let res: string = "";

        if (e.key == "Backspace" || e.key == "Delete") {
            this._i1SSN = "";
            this.i1SSNPatch(this._i1SSN);

        }
        if ((e.key >= 0 && e.key <= 9) && (this._i1SSN != null && this._i1SSN.length < 9)) {
            this._i1SSN += e.key;
            var len = this._i1SSN.length;
            var max = 9;
            if (len == 1)
                stars = 'X';
            else if (len == 2)
                stars = 'XX';
            else if (len == 3)
                stars = 'XXX';
            else if (len == 4)
                stars = 'XXX-';
            else if (len == 5)
                stars = 'XXX-X';
            else if (len == 6)
                stars = 'XXX-XX-';
            else if (len > 6)
                stars = 'XXX-XX-' + this._i1SSN.substring(5);
            this.i1SSNMaskPatch(stars);
        }
    }

    i1SSNMaskPatch(ssnVal) {
        this.prodConfigGroup.patchValue({
            i1SSNMask: ssnVal,
            i1SSN: this._i1SSN
        });
    }

    getSSNMaskString(val) {
        let stars: string = "";
        if (val != null) {
            let res: string = "";
            var len = val.length;
            var max = 9;
            if (len == 1)
                stars = 'X';
            else if (len == 2)
                stars = 'XX';
            else if (len == 3)
                stars = 'XXX-';
            else if (len == 5)
                stars = 'XXX-X';
            else if (len == 6)
                stars = 'XXX-XX-';
            else if (len > 6)
                stars = 'XXX-XX-' + val.substring(5);
        }
        return stars;
    }

    replaceSSN(val) {
        if (val) {
            let unmaskVal = val.substr(5);
            return 'XXX-XX-' + unmaskVal;
        }
        else
            return '';
    }

    i1SSNPatch(ssnVal) {
        this.prodConfigGroup.patchValue({

            i1SSNMask: this.getSSNMaskString(this._i1SSN),
            i1SSN: this._i1SSN

        });
    }

    unmaskI1SSN(e) {
        let actualVal: string = "";
        let stars: string = "";
        let res: string = "";

        this.unmaski1SSNPatch(this._i1SSN);
    }

    unmaski1SSNPatch(unmaksSsnVal) {
        this.prodConfigGroup.patchValue({
            i1SSNMask: unmaksSsnVal
        });
    }

    maskI2SSN(e) {
        let actualVal: string = "";
        let stars: string = "";
        let res: string = "";

        if (e.key == "Backspace" || e.key == "Delete") {
            this._i2SSN = "";
            this.i2SSNPatch(this._i2SSN);
        }

        if ((e.key >= 0 && e.key <= 9) && (this._i2SSN.length < 9)) {
            this._i2SSN += e.key;
            var len = this.prodConfigGroup.controls.i2SSN.value.length;
            var max = 9;
            if (len == 1)
                stars = 'X';
            else if (len == 2)
                stars = 'XX';
            else if (len == 3)
                stars = 'XXX-';
            else if (len == 5)
                stars = 'XXX-X';
            else if (len == 6)
                stars = 'XXX-XX-';
            else if (len > 6)
                stars = 'XXX-XX-' + this._i2SSN.substring(5);
            this.i2SSNPatch(stars);
        }
    }

    i2SSNPatch(ssnVal) {
        this.prodConfigGroup.patchValue({
            i2SSN: ssnVal
        });
    }

    initialOnPress(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.socGroup.controls.initialSignature.value.length == 0)
                this.signaturePad.on();
            return;
        }
        this.signaturePad.off();
    }

    initialOnPressCoInv(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.socGroup.controls.initialCoInvSignature.value.length == 0)
                this.signaturePadCoInv.on();
            return;
        }
        this.signaturePadCoInv.off();
    }

    signatureOnEnd() {
        if (this.signaturePad.isEmpty() == false) {
            this.initialDisabled = true;
        }
    }

    signatureOnEndCoInv() {
        if (this.signaturePadCoInv.isEmpty() == false) {
            this.initialCoInvDisabled = true;
        }
    }



    initialAdsOnPress(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.socGroup.controls.initialAdsSignature.value.length == 0)
                this.signaturePadADS.on();
            return;
        }
        this.signaturePadADS.off();
    }

    initialAdsCoInvOnPress(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.socGroup.controls.initialAdsCoInvSignature.value.length == 0)
                this.signaturePadADSCoInv.on();
            return;
        }
        this.signaturePadADSCoInv.off();
    }

    signatureAdsOnEnd() {
        if (this.signaturePadADS.isEmpty() == false) {
            this.initialAdsDisabled = true;
        }
    }

    signatureAdsOnEndCoInv() {
        if (this.signaturePadADSCoInv.isEmpty() == false) {
            this.initialAdsCoInvDisabled = true;
        }
    }

    initialFinalOnPress(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.signDocsGroup.controls.initialFinalSignature.value.length == 0)
                this.signaturePadFinal.on();
            return;
        }
        this.signaturePadFinal.off();
    }

    initialFinalCoInvOnPress(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.signDocsGroup.controls.initialFinalCoInvSignature.value.length == 0)
                this.signaturePadFinalCoInv.on();
            return;
        }
        this.signaturePadFinalCoInv.off();
    }

    signatureFinalOnEnd() {
        if (this.signaturePadFinal.isEmpty() == false) {
            this.initialFinalDisabled = true;
        }
    }

    signatureFinalCoInvOnEnd() {
        if (this.signaturePadFinalCoInv.isEmpty() == false) {
            this.initialFinalCoInvDisabled = true;
        }
    }

    async getInventHelpSite() {
        await this._appconfigService.getAppConfigValues(this.encryptedUser, ["InventHelp_CS_Site", "ProductYCutOffDate", "CanadaNDACutOffDate", "ProductMCutOffDate", "Product123CutOffDate", "DocumentVCutOffDate","CheckList123StartDate"])
            .then(async (result: any) => {
                if (result) {
                    var resultvalue = UtilityService.clone(result);
                    if (resultvalue) {
                        let paramValue = (this.productId > 8 && this.productId < 12) ? 1 : 0;
                        this.inventHelpSite = resultvalue.filter(i => i.configKey == "InventHelp_CS_Site")[0].configValue + 'roi-document/' + this.contactId + '/' + this.inventionId + '/' + this.contractSessionId + '/' + this.clpUserId + '/' + paramValue;
                        this.productYCutOffDate = resultvalue.filter(i => i.configKey == "ProductYCutOffDate")[0];
                        this.productMCutOffDate = resultvalue.filter(i => i.configKey == "ProductMCutOffDate")[0];
                        this.canadaNDACutOffDate = resultvalue.filter(i => i.configKey == "CanadaNDACutOffDate")[0];
                        this.product123CutOffDate = resultvalue.filter(i => i.configKey == "Product123CutOffDate")[0];
                        this.documentVCutOffDate = resultvalue.filter(i => i.configKey == "DocumentVCutOffDate")[0];
                        this.checkList123StartDate = resultvalue.filter(i => i.configKey == "CheckList123StartDate")[0];
                    } else {
                        console.log("Config Details error - InventHelp_CS_Site/ProductYCutOffDate/CanadaNDACutOffDate/productMCutOffDate/product123CutOffDate/documentVCutOffDate");
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    async textLink() {
        let sms: SMSDetails = { ContactId: 0, InventionId: 0, WizardId: 0, siteURL: "" };
        this.smsDetails = sms;
        this.smsDetails.ContactId = this.contactId;
        this.smsDetails.InventionId = this.inventionId;
        this.smsDetails.WizardId = 1;
        this.smsDetails.siteURL = this.inventHelpSite;

        if (this.smsDetails.siteURL == "" && this.inventHelpSite != "") {
            this.smsDetails.siteURL = this.inventHelpSite;
            this.sendROILink();
        }
        else if (this.smsDetails.siteURL == "" && this.inventHelpSite == "") {
            await this._appconfigService.getAppConfigValues(this.encryptedUser, ["InventHelp_CS_Site"])
                .then(async (result: any) => {
                    if (result) {
                        var resultvalue = UtilityService.clone(result);
                        if (resultvalue) {
                            this.inventHelpSite = resultvalue?.filter(i => i.configKey == "InventHelp_CS_Site")[0].configValue + 'roi-document/' + this.contactId + '/' + this.inventionId + '/' + this.contractSessionId + '/' + this.clpUserId + '/0';
                            this.smsDetails.siteURL = this.inventHelpSite;
                            this.sendROILink();
                        } else {
                            console.log("Config Details error - InventHelp_CS_Site");
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else
            this.sendROILink();
    }

    setReminderDetails(reminderDate: string) {
        let sms: SMSDetails = {
            ContactId: 0,
            InventionId: 0,
            WizardId: 0,
            siteURL: ""
        }
        this.smsDetails = sms;

        this.smsDetails.ContactId = this.contactId;
        this.smsDetails.InventionId = this.inventionId;
        this.smsDetails.WizardId = 1;
        this.smsDetails.siteURL = "Just a reminder that a payment for " + this.contactDetails.firstname + " " +
            this.contactDetails.lastname + " (invention - " + this.inventionName + "), is pending on " + reminderDate +
            ". Please go to the contract and charge it.";
    }

    setEmailDetails(source: string) {
        let email: EmailDetails = {
            from: "",
            message: "",
            subject: "",
            toList: "",
        }
        this.emailDetails = email;

        this.emailDetails.from = "";
        this.emailDetails.toList = this.contactDetails.email;
        this.emailDetails.message = source == 'ROI' ? this.inventHelpSite : "";
        this.emailDetails.subject = source == 'ROI' ? "Record of Invention" : "InventHelp: Contract Cancelation - " + this.fileNumber;
        this.emailTemplateType = source == 'ROI' ? "EmailROILink" : "CancelContract";
    }

    async sendROILink() {
        if (this.smsDetails.siteURL != '') {
            await this._smsService.sndSMSAsync(this.encryptedUser, this.smsDetails)
                .then(res => {
                    if (res) {
                        if (res.statusCode == 0) {
                            this.smsResponse = UtilityService.clone(res);
                            if (!isNullOrUndefined(this.smsResponse) && this.smsResponse.txtMsgId > 0) {
                                this.inventionDetails.isROIEnable = true;
                                this.updateInvention();
                                this.openSnackBar("ROI link has been sent to customer registered mobile.", "");
                            }
                            else
                                this.openSnackBar("Failed to send the message. Please refresh the page and try again or contact administrator.", "");

                        } else {
                            console.log("SMS Send result status code: " + res.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
            this.saveContrActionAcitonLog();
        }
        else
            this.openSnackBar("Failed to send the message. Please refresh the page and try again.", "");
    }

    async emailLink() {
        this.setEmailDetails('ROI');
        if (this.emailDetails) {
            await this._emailService.sndEmailAsync(this.encryptedUser, this.emailDetails, this.contactId, this.emailTemplateType, this.contractSessionId)
                .then(res => {
                    if (res) {
                        if (res.statusCode == 0) {
                            this.emailResponse = UtilityService.clone(res);
                            if (this.emailResponse.emailStatus) {
                                this.inventionDetails.isROIEnable = true;
                                this.updateInvention();
                                this.openSnackBar("The Record of Invention link has been sent to your registered email.", "");
                            }
                            else
                                this.openSnackBar("Sending the email failed. Please try again or contact administrator.", "");

                        } else {
                            console.log("Email send result status code: " + res.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
            this.saveContrActionAcitonLog();
        }
    }
    async emailCancelLink() {
        this.setEmailDetails('');
        if (this.emailDetails) {
            await this._emailService.sndEmailAsync(this.encryptedUser, this.emailDetails, this.contactId, this.emailTemplateType, this.contractSessionId)
                .then(res => {
                    if (res) {
                        if (res.statusCode == 0) {
                            this.emailResponse = UtilityService.clone(res);
                        } else {
                            console.log("Email send result status code: " + res.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    openROI() {
        this.inventionDetails.isROIEnable = true;
        this.updateInvention();
        window.open(this.inventHelpSite, '_blank');
        this.saveContrActionAcitonLog();
    }

    showUpload() {
        this.showUploadFlg = !this.showUploadFlg;
    }

    PaymentshowUpload() {
        this.paymentDocshowUploadFlg = !this.paymentDocshowUploadFlg;
    }

    onCancelClick(): void {
        this._router.navigate(['/'], {
            queryParamsHandling: "preserve"
        });
    }

    openSnackBar(message: string, action: string, durationTime: number = 5000) {
        this._snackBar.open(message, action, {
            verticalPosition: 'top',
            horizontalPosition: 'right',
            duration: durationTime,
        });
    }


    private async loadContactDetails_Email(email) {
        await this._contactService.getContact_EmailAsync(this.encryptedUser, email)
            .then(async (result: ContactResponse) => {
                if (result) {
                    if (result.statusCode == 0 && result.contactDetails) {
                        this.contactCoInventResponse = UtilityService.clone(result);
                        if (this.contactCoInventResponse) {
                            this.contactCoInventDetails = UtilityService.clone(this.contactCoInventResponse.contactDetails);

                            this.firstNameExistCoInvent = this.contactCoInventDetails.firstname;
                            this.lastNameExistCoInvent = this.contactCoInventDetails.lastname;
                            $('#modalSOCCoInventor').modal('show');
                        }
                    } else {
                        this.contactCoInventDetails.contactid = -1;
                        console.log("contact result status code: " + result.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadContactDetails_Cell(cell) {
        await this._contactService.getContact_CellAsync(this.encryptedUser, cell)
            .then(async (result: ContactResponse) => {
                if (result) {
                    if (result.statusCode == 0 && result.contactDetails) {
                        this.contactCoInventResponse = UtilityService.clone(result);
                        if (this.contactCoInventResponse) {
                            this.contactCoInventDetails = UtilityService.clone(this.contactCoInventResponse.contactDetails);

                            this.firstNameExistCoInvent = this.contactCoInventDetails.firstname;
                            this.lastNameExistCoInvent = this.contactCoInventDetails.lastname;
                            $('#modalSOCCoInventor').modal('show');
                        }
                    } else {
                        this.contactCoInventDetails.contactid = -1;
                        console.log("contact result status code: " + result.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    changeContract(e) {
        this.productId = e.target.value;
    }

    private async loadProduct() {
        this._productService.getProductAsync(this.encryptedUser, this.contractSession.productId, this.contractSession.CountryID, (this.contractSession.productId > 8 && this.productId < 12) ? "Plus" : "Normal")
            .then(async (result: ProductResponse) => {
                if (result) {
                    this.productResponse = UtilityService.clone(result);
                    if (this.productResponse) {
                        this.productDetail = UtilityService.clone(this.productResponse.productDetails);
                        this.productName = this.productDetail.productDescription;
                        //Done by akshay for disabled.
                        if (this.productDetail)
                            this.validateProduct(this.productDetail.productId);
                    } else {
                        console.log("Product result status code: " + result.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }


    private async loadDocument() {
        this.chkExpPDF = true;
        let arrDocType = new Array();
        let documentTypeId: string;
        let ctrDoc: number;
        this.clearDocuments();

        if (this.productDetails) {
            if (this.productId) {
                var product = this.productDetails.find(i => i.productId == this.productId);
                if (product) {
                    if (this.contractPayment) {
                        if (this.contractPayment.paymentOptionId == 1 || this.contractPayment.paymentOptionId == 0)
                            this.documentTypeIds = this.isWestern == false ? product.ihFullPaymentDoc : product.iwhFullPaymentDoc;
                        else if (this.contractPayment.paymentOptionId == 2)
                            this.documentTypeIds = this.isWestern == false ? product.ihInstallPaymentDoc : product.iwhInstallPaymentDoc;
                    }
                }
            }
            else {
                if (this.contractPayment) {
                    if (this.contractPayment.paymentOptionId == 1 || this.contractPayment.paymentOptionId == 0)
                        this.documentTypeIds = this.isWestern == false ? this.productDetails[0].ihFullPaymentDoc : this.productDetails[0].iwhFullPaymentDoc;
                    else if (this.contractPayment.paymentOptionId == 2)
                        this.documentTypeIds = this.isWestern == false ? this.productDetails[0].ihInstallPaymentDoc : this.productDetails[0].iwhInstallPaymentDoc;
                }
            }
        }

        if (this.contractSession.USFeeConfirm == 2 || this.contractSession.CountryID == 2) {
            this.documentTypeIds = this.isWestern == true ? this.documentTypeIds.replace("32", "37") : this.documentTypeIds.replace("22", "37");
            this.documentTypeIds = this.documentTypeIds.replace(",3,", ",38,");
        }

        if (this.documentTypeIds != '' && !isNullOrUndefined(this.documentTypeIds)) {
            await this._documentService.getProductDocumentListAsync(this.encryptedUser, this.documentTypeIds, this.inventionId, this.contactId, this.contractSessionId, (this.productId > 8 && this.productId < 12) ? "Plus" : "Normal")
                .then(async (result: DocumentResponseList) => {
                    if (result) {
                        if (result.statusCode == 0) {
                            this.documentListResponse = UtilityService.clone(result);

                            if (this.documentListResponse && this.documentListResponse.docList.length > 0) {
                                for (var i = 0; i < this.documentListResponse.docList.length; i++) {

                                    let doc: DocType = this.documentListResponse.docList[i];
                                    switch (doc.documentTypeID) {
                                        case 2: if (!this.navigationResponse.navigation.isROIForm) { this.docSignROI = "<h4 style='text-align: center;'><i>The Record of Invention form is incomplete. Once the form is filled in and submitted, it will appear in this area.</h4></i>" } else { this.docSignROI = UtilityService.clone(doc.document); this.isROISignDoc = true; this.addAddlDocHeight(); } break;
                                        case 21: this.documentBII = UtilityService.clone(doc.document); this.isBIIDocument = true; break;
                                        case 22:
                                        case 32:
                                        case 37: case 129:
                                            this.documentBIP = UtilityService.clone(doc.document); this.isBIPDocument = true; break;
                                        case 4: this.docSignNDA = UtilityService.clone(doc.document); break;
                                        case 6: this.documentPPSO = UtilityService.clone(doc.document); this.isPPSODocument = true; break;
                                        case 23: this.documentPPSO = UtilityService.clone(doc.document); this.isPPSODocument = true; break;
                                        case 33: this.documentPPSO = UtilityService.clone(doc.document); this.isPPSODocument = true; break;
                                        case 24: this.documentInfoInvent = UtilityService.clone(doc.document); this.isInfoInventDocument = true; break;
                                        case 25: this.documentRetailIns = UtilityService.clone(doc.document); this.isRetailInsDocument = true; break;
                                        case 26: this.documentUniPay = UtilityService.clone(doc.document); this.isUniPayDocument = true; break;
                                        case 27: case 28: case 29: case 30: case 31: this.docSignWaitState = UtilityService.clone(doc.document); break;
                                        case 36: case 128: case 133: case 135: this.docSignIMP = UtilityService.clone(doc.document); this.isIMPSignDoc = true; break;
                                        case 39: case 42: case 45: case 48: case 51: case 54: case 57: case 60: case 63: case 0: this.docSignSDA = UtilityService.clone(doc.document); break;
                                        case -1: case 142: this.docSignSUB = UtilityService.clone(doc.document); this.isSUBSignDoc = true; break;
                                        case 88: case 89: this.docSignAddmB = UtilityService.clone(doc.document); this.addmBDocumentId = doc.documentTypeID; break;
                                        case 86: case 87: case 143: case 146: this.docSignAddmG = UtilityService.clone(doc.document); this.addmGDocumentId = doc.documentTypeID; break;
                                        case 84: case 85: this.docSignAddmP = UtilityService.clone(doc.document); this.addmPDocumentId = doc.documentTypeID; break;
                                        case 137: case 138: case 144: case 147: this.docSignAddmT = UtilityService.clone(doc.document); this.addmTDocumentId = doc.documentTypeID; break;
                                        case 139: case 140: ((this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14) && this.isProductV) ? this.docSignAddmV = UtilityService.clone(doc.document) : ''; ((this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14) && this.isProductV) ? this.addmVDocumentId = doc.documentTypeID : ''; break;
                                        case 82: case 83: case 124: case 125: case 134: case 136: case 145: case 148:
                                            if ((this.contractPayment.productId == 0 || this.contractPayment.productId == 4 || this.contractPayment.productId == 5) && !isNullOrUndefined(this.addendumServicesResponse) && !this.addendumServicesResponse.addendum.isPatentServices)
                                                this.docSignPatent = "No service selected.";
                                            else
                                                this.docSignPatent = UtilityService.clone(doc.document);
                                            this.patentDocumentId = doc.documentTypeID; break;
                                        case 93: case 94: this.docSignIntroMark = UtilityService.clone(doc.document); this.introMarkDocumentId = doc.documentTypeID; break;
                                        case -2: this.docSignAddlState = UtilityService.clone(doc.document); this.isAddlSignDoc = true; this.addAddlDocHeight(); break;
                                        case -3: case 141: (this.productId <= 9 || this.productId == 12 || this.productId == 13 || this.productId == 10 || this.productId == 14) ? this.docSignCheckList = UtilityService.clone(doc.document) : ''; (this.productId <= 9 || this.productId == 12 || this.productId == 13 || this.productId == 10 || this.productId == 14) ? this.isCheckListSignDoc = true : ''; if (this.docSignCheckList == "") (this.productId <= 9 || this.productId == 12 || this.productId == 13 || this.productId == 10 || this.productId == 14) ? this.docSignCheckList = "Please select the options from Invention checklist." : ''; break;
                                        case 130: case 132: this.documentPPA = UtilityService.clone(doc.document); this.isPPADocument = true; break;
                                        default: break;
                                    }

                                }
                                if (this.isWaitStateExists)
                                    this.loadMandatoryDocument(this.waitStateDocTypeId.toString() + ",4,0");
                                else
                                    this.loadMandatoryDocument("4,0");
                            }

                        } else {
                            console.log("result.statusCode: " + result.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
            // }
        }
        this.chkExpPDF = false;
    }

    addAddlDocHeight() {
        var iframe = document.getElementById("addlDocIframe");
        var roiIframe = document.getElementById("roiDocIframe");
        if (this.docSignAddlState && iframe) {
            var doc = this.docSignAddlState.valueOf();
            doc += "ClientHeight: " + iframe ? iframe.clientHeight : 20
                + "px" + "<br>";
        }
        if (this.docSignROI && roiIframe) {
            var doc = this.docSignROI.valueOf();
            doc += "ClientHeight: " + iframe ? iframe.clientHeight : 20
                + "px" + "<br>";
        }
    }

    private async loadDocument_DocTypeId(docId) {
        if (isNumber(docId)) {
            await this._documentService.getProductDocumentListAsync(this.encryptedUser, docId.toString(), this.inventionId, this.contactId, this.contractSessionId, (this.contractSession.productId > 8 && this.contractSession.productId < 12) ? "Plus" : "Normal")
                .then(async (result: DocumentResponseList) => {
                    if (result) {
                        if (result.statusCode == 0) {
                            this.documentListResponse = UtilityService.clone(result);
                            if (this.documentListResponse && this.documentListResponse.docList.length > 0) {

                                let doc: DocType = this.documentListResponse.docList[0];

                                if (doc) {
                                    switch (doc.documentTypeID) {
                                        case 2: if (!this.navigationResponse.navigation.isROIForm) { this.docSignROI = "<h4 style='text-align: center;'><i>The Record of Invention form is incomplete. Once the form is filled in and submitted, it will appear in this area.</h4></i>" } else { this.docSignROI = UtilityService.clone(doc.document); this.isROISignDoc = true; this.addAddlDocHeight(); } break;
                                        case 22:
                                        case 32:
                                        case 37: case 129:
                                            this.documentBIP = UtilityService.clone(doc.document); this.isBIPDocument = true; break;
                                        case 6: this.documentPPSO = UtilityService.clone(doc.document); this.isPPSODocument = true; break;
                                        case 23: this.documentPPSO = UtilityService.clone(doc.document); this.isPPSODocument = true; break;
                                        case 33: this.documentPPSO = UtilityService.clone(doc.document); this.isPPSODocument = true; break;
                                        case 24: this.documentInfoInvent = UtilityService.clone(doc.document); this.isInfoInventDocument = true; break;
                                        case 25: this.documentRetailIns = UtilityService.clone(doc.document); this.isRetailInsDocument = true; break;
                                        case 26: this.documentUniPay = UtilityService.clone(doc.document); this.isUniPayDocument = true; break;
                                        case 36: case 128: case 133: case 135: this.docSignIMP = UtilityService.clone(doc.document); this.isIMPSignDoc = true; break;
                                        case -1: case 142: this.docSignSUB = UtilityService.clone(doc.document); this.isSUBSignDoc = true; break;
                                        case 88: case 89: this.docSignAddmB = UtilityService.clone(doc.document); break;
                                        case 86: case 87: this.docSignAddmG = UtilityService.clone(doc.document); break;
                                        case 84: case 85: case 143: case 146: this.docSignAddmP = UtilityService.clone(doc.document); break;
                                        case 137: case 138: case 144: case 147: this.docSignAddmT = UtilityService.clone(doc.document); break;
                                        case 139: case 140: this.docSignAddmV = this.isProductV ? UtilityService.clone(doc.document) : ''; break;
                                        case 82: case 83: case 124: case 125: case 134: case 136: case 145: case 148:
                                            if ((this.contractPayment.productId == 0 || this.contractPayment.productId == 4 || this.contractPayment.productId == 5) && !isNullOrUndefined(this.addendumServicesResponse) && !this.addendumServicesResponse.addendum.isPatentServices)
                                                this.docSignPatent = "No service selected.";
                                            else
                                                this.docSignPatent = UtilityService.clone(doc.document); break;
                                        case 93: case 94: this.docSignIntroMark = UtilityService.clone(doc.document); break;
                                        case -2: this.docSignAddlState = UtilityService.clone(doc.document); this.isAddlSignDoc = true; this.addAddlDocHeight(); break;
                                        case -3: case 141: this.docSignCheckList = UtilityService.clone(doc.document); this.isCheckListSignDoc = true; if (this.docSignCheckList == "") this.docSignCheckList = "Please upload the checklist images."; break;
                                        case 130: case 132: this.documentPPA = UtilityService.clone(doc.document); this.isPPADocument = true; break;
                                        default: break;
                                    }
                                }
                            }
                        } else {
                            console.log("loadDocument_DocTypeId.statusCode: " + result.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }


    private async loadConfigMaster(item, itemDetail) {
        await this._configMasterService.getConfigMasterAsync(this.encryptedUser)
            .then(async (result: ConfigMasterResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.configMasterResponse = UtilityService.clone(result);
                        this.configMaster = UtilityService.clone(this.configMasterResponse.configMaster);
                        this.IsPromo = this.configMaster.filter(i => i.itemDetail == 'Promotions' && i.itemValue == 'true').length > 0 ? true : false;
                    } else {
                        this._utilityService.handleError(result.statusCode, result.errorMsg);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private clearDocuments() {
        this.isBIIDocument = false;
        this.isBIPDocument = false;
        this.isPPSODocument = false;
        this.isInfoInventDocument = false;
        this.isRetailInsDocument = false;
        this.isUniPayDocument = false;
        this.isPPADocument = false;

        this.documentBII = "";
        this.documentBIP = "";
        this.documentPPSO = "";
        this.documentInfoInvent = "";
        this.documentRetailIns = "";
        this.documentUniPay = "";
    }

    checklistItems(controlName, e) {
        switch (controlName) {
            case "isSubmitYes": this.prodConfigGroup.patchValue({ isSubmitYes: !e.target.checked }); break;
            case "isSubmitNo": this.prodConfigGroup.patchValue({ isSubmitNo: !e.target.checked }); break;
            case 'isAcceptYes': this.prodConfigGroup.patchValue({ isAcceptYes: !e.target.checked }); break;
            case 'isAcceptNo': this.prodConfigGroup.patchValue({ isAcceptNo: !e.target.checked }); break;
            case 'isDataBankYes': this.prodConfigGroup.patchValue({ isDataBankYes: !e.target.checked }); break;
            case 'isDataBankNo': this.prodConfigGroup.patchValue({ isDataBankNo: !e.target.checked }); break;
            case 'isSolicitsYes': this.prodConfigGroup.patchValue({ isSolicitsYes: !e.target.checked }); break;
            case 'isSolicitsNo': this.prodConfigGroup.patchValue({ isSolicitsNo: !e.target.checked }); break;
            case 'isPrepareYes': this.prodConfigGroup.patchValue({ isPrepareYes: !e.target.checked }); break;
            case 'isPrepareNo': this.prodConfigGroup.patchValue({ isPrepareNo: !e.target.checked }); break;
            case 'isStaffYes': this.prodConfigGroup.patchValue({ isStaffYes: !e.target.checked }); break;
            case 'isStaffNo': this.prodConfigGroup.patchValue({ isStaffNo: !e.target.checked }); break;
            case 'isBIPSYes': this.prodConfigGroup.patchValue({ isBIPSYes: !e.target.checked }); break;
            case 'isBIPSNo': this.prodConfigGroup.patchValue({ isBIPSNo: !e.target.checked }); break;
            case 'isPRSYes': this.prodConfigGroup.patchValue({ isPRSYes: !e.target.checked }); break;
            case 'isPRSNo': this.prodConfigGroup.patchValue({ isPRSNo: !e.target.checked }); break;
            case 'isSoldYes': this.prodConfigGroup.patchValue({ isSoldYes: !e.target.checked }); break;
            case 'isSoldNo': this.prodConfigGroup.patchValue({ isSoldNo: !e.target.checked }); break;
            case 'isSendYes': this.prodConfigGroup.patchValue({ isSendYes: !e.target.checked }); break;
            case 'isSendNo': this.prodConfigGroup.patchValue({ isSendNo: !e.target.checked }); break;
            case 'isIdeasYes': this.prodConfigGroup.patchValue({ isIdeasYes: !e.target.checked }); break;
            case 'isIdeasNo': this.prodConfigGroup.patchValue({ isIdeasNo: !e.target.checked }); break;
            case 'isShowsYes': this.prodConfigGroup.patchValue({ isShowsYes: !e.target.checked }); break;
            case 'isShowsNo': this.prodConfigGroup.patchValue({ isShowsNo: !e.target.checked }); break;
            case 'isWorkBrochureYes': this.prodConfigGroup.patchValue({ isWorkBrochureYes: !e.target.checked }); break;
            case 'isWorkBrochureNo': this.prodConfigGroup.patchValue({ isWorkBrochureNo: !e.target.checked }); break;
            case 'isBIPYes': this.prodConfigGroup.patchValue({ isBIPYes: !e.target.checked }); break;
            case 'isBIPNo': this.prodConfigGroup.patchValue({ isBIPNo: !e.target.checked }); break;
            case 'isBIPReportYes': this.prodConfigGroup.patchValue({ isBIPReportYes: true, isBIPReportNo: false, isNABIPReport: false }); break;
            case 'isBIPReportNo': this.prodConfigGroup.patchValue({ isBIPReportNo: true, isBIPReportYes: false, isNABIPReport: false }); break;
            case 'isNABIPReport': this.prodConfigGroup.patchValue({ isNABIPReport: true, isBIPReportYes: false, isBIPReportNo: false }); break;
            case 'isServiceFeesYes': this.prodConfigGroup.patchValue({ isServiceFeesYes: !e.target.checked }); break;
            case 'isServiceFeesNo': this.prodConfigGroup.patchValue({ isServiceFeesNo: !e.target.checked }); break;
            case 'isADSYes': this.prodConfigGroup.patchValue({ isADSYes: !e.target.checked }); break;
            case 'isADSNo': this.prodConfigGroup.patchValue({ isADSNo: !e.target.checked }); break;
            case 'isNDAYes': this.prodConfigGroup.patchValue({ isNDAYes: !e.target.checked }); break;
            case 'isNDANo': this.prodConfigGroup.patchValue({ isNDANo: !e.target.checked }); break;
            case 'isPRSBrochureYes': this.prodConfigGroup.patchValue({ isPRSBrochureYes: !e.target.checked }); break;
            case 'isPRSBrochureNo': this.prodConfigGroup.patchValue({ isPRSBrochureNo: !e.target.checked }); break;
            case 'isPPSOYes': this.prodConfigGroup.patchValue({ isPPSOYes: true, isPPSONo: false, isNAPPSO: false }); break;
            case 'isPPSONo': this.prodConfigGroup.patchValue({ isPPSONo: true, isPPSOYes: false, isNAPPSO: false }); break;
            case 'isNAPPSO': this.prodConfigGroup.patchValue({ isNAPPSO: true, isPPSOYes: false, isPPSONo: false }); break;

            case 'isSolicitYes': this.prodConfigGroup.patchValue({ isSolicitYes: !e.target.checked }); break;
            case 'isSolicitNo': this.prodConfigGroup.patchValue({ isSolicitNo: !e.target.checked }); break;
            case 'isRefineNo': this.prodConfigGroup.patchValue({ isRefineNo: !e.target.checked }); break;
            case 'isRefineYes': this.prodConfigGroup.patchValue({ isRefineYes: !e.target.checked }); break;
            case 'isIndependentNo': this.prodConfigGroup.patchValue({ isIndependentNo: !e.target.checked }); break;
            case 'isIndependentYes': this.prodConfigGroup.patchValue({ isIndependentYes: !e.target.checked }); break;
            case 'isAttorneyNo': this.prodConfigGroup.patchValue({ isAttorneyNo: !e.target.checked }); break;
            case 'isAttorneyYes': this.prodConfigGroup.patchValue({ isAttorneyYes: !e.target.checked }); break;
            case 'isPurchasedNo': this.prodConfigGroup.patchValue({ isPurchasedNo: !e.target.checked }); break;
            case 'isPurchasedYes': this.prodConfigGroup.patchValue({ isPurchasedYes: !e.target.checked }); break;
            default:
                break;
        }
    }

    chkAgreement(e) {
        if (e.target.checked == true)
            this.contractSession.USFeeConfirm = 1;
        else
            this.contractSession.USFeeConfirm = 2;
        this.CreateUpdate_ContractSession();
    }

    chkinventChange() {
        this.otherInventor = !this.otherInventor;

        if (this.otherInventor == true) {
            setTimeout(() => {
                this.socGroup.controls.firstnamei2.setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);
                this.socGroup.controls.lastnamei2.setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);
                //this.socGroup.controls.mobilei2.setValidators([Validators.required, Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)]);
                //this.socGroup.controls.emaili2.setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/)]);

                if (!this.contactCoInventDetails) {
                    let newContact: ContactDetails = {
                        contactid: -1,
                        firstname: '',
                        lastname: '',
                        address1: '',
                        address2: '',
                        address3: '',
                        city: '',
                        state: '',
                        country: '',
                        zipcode: '',
                        homephone: '',
                        workphone: '',
                        mobile: '',
                        email: '',
                        clpuserid: -1,
                        contactid1: -1,
                        inventionName: '',
                        isBIPClient: false,
                        isSubClient: false,
                        isPPSOClient: false,
                        isPlusClient: false,
                        salutation: '',
                        editOrigin: ''
                    };
                    this.contactCoInventDetails = newContact;
                }

            });
        }
        else {
            setTimeout(() => {
                this.socGroup.controls.firstnamei2.setValidators([Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);
                this.socGroup.controls.lastnamei2.setValidators([Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);
            });
        }

        this.socGroup.patchValue({
            chkinvent: this.otherInventor
        });
    }
    coInventorChange() {
        this.coInventor = !this.coInventor;
        if (this.coInventor == true) {
            setTimeout(() => {
                this.prodConfigGroup.controls.i2firstname.setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);
                this.prodConfigGroup.controls.i2lastname.setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);

                if (!this.contactCoInventDetails) {
                    let newContact = {} as ContactDetails;
                    this.contactCoInventDetails = newContact;
                }
            });
        }
        else {
            setTimeout(() => {
                this.prodConfigGroup.controls.i2firstname.setValidators([Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);
                this.prodConfigGroup.controls.i2lastname.setValidators([Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);
            });
        }

        this.prodConfigGroup.patchValue({
            coInventor: this.coInventor
        });
    }

    chkPaymentFullChange(e) {
        e.target.checked = true;
        this.prodConfigGroup.patchValue({
            paymentInstallment: !e.target.checked,
            rolloverAmount: e.target.checked == true ? 0 : this.contractPayment.rollOverAmount,
        });

        this.setServicesControl('downPayment', !e.target.checked);
        this.flgInstallment = !e.target.checked;
        if (this.flgInstallment) {
            this.prodConfigGroup.patchValue({
                payCreditCard: true,
                payCheck: false,
                payMoneyOrder: false,
                payCash: false,
                payOther: false,
                payCarryOver: false,
                payMonterey: false
            });
        }
    }

    chkPaymentInstallmentChange(e) {
        e.target.checked = true;
        this.prodConfigGroup.patchValue({
            paymentFull: !e.target.checked,
        });

        this.setServicesControl('downPayment', e.target.checked);
        this.flgInstallment = e.target.checked;

        if (this.flgInstallment) {
            this.prodConfigGroup.patchValue({
                payCreditCard: this.payCreditCard || false,
                payCheck: this.payCheck || false,
                payMoneyOrder: this.payMoneyOrder || false,
                payCash: this.payCash || false,
                payOther: this.payOther || false,
                payCarryOver: this.payCarryOver || false,
                payMonterey: this.payMonterey || false
            });
        }
    }

    checkPaymentType(event) {
        if (this.prodForm.payCash.value || this.prodForm.payCheck.value || this.prodForm.payOther.value || this.prodForm.payCarryOver.value || this.prodForm.payMonterey.value)
            this.disabledAgreement = !event.target.checked;
        else if (!this.paymentForm.fileNo.value)
            this.disabledAgreement = true;
        else if (this.paymentForm.fileNo.value && !this.paymentForm.paymentType.value)
            this.disabledAgreement = true;
        else if (!this.paymentForm.fileNo.value && !this.paymentForm.paymentType.value)
            this.disabledAgreement = true;
        else if (!this.paymentForm.fileNo.value && this.paymentForm.paymentType.value)
            this.disabledAgreement = true;
        else if (this.paymentForm.fileNo.value && this.paymentForm.paymentType.value)
            this.disabledAgreement = false;
    }

    checkFileNo(event) {
        if (this.paymentForm.paymentType.value)
            this.disabledAgreement = !event.target.checked;
        else if (!this.paymentForm.paymentType.value)
            this.disabledAgreement = true;
        else if (!this.paymentForm.paymentType.value && !this.paymentForm.fileNo.value)
            this.disabledAgreement = true;
        else if (this.paymentForm.fileNo.value && !this.paymentForm.paymentType.value)
            this.disabledAgreement = true;
        else if (this.paymentForm.fileNo.value && this.paymentForm.paymentType.value)
            this.disabledAgreement = false;
    }

    chkAutoYesChange(e) {
        this.prodConfigGroup.patchValue({
            autoPaymentNo: !e.target.checked
        });
    }

    chkAutoNoChange(e) {
        this.prodConfigGroup.patchValue({
            autoPaymentYes: !e.target.checked
        });
    }

    chkPayCashChange(e) {
        this.collectPaymentGroup.patchValue({
            paymentType: false,
            fileNo: false,
            disabledAgreement: true,

        });
        this.prodConfigGroup.patchValue({
            payCash: e.target.checked == true ? true : false,
            payCreditCard: e.target.checked == true ? false : false,
            payCheck: e.target.checked == true ? false : false,
            payMoneyOrder: e.target.checked == true ? false : true,
            payOther: e.target.checked == true ? false : false,
            payCarryOver: e.target.checked == true ? false : false,
            payMonterey: e.target.checked == true ? false : false
        });
    }

    chkPayCheckChange(e) {
        this.collectPaymentGroup.patchValue({
            paymentType: false,
            fileNo: false,
            disabledAgreement: true,
        });
        this.prodConfigGroup.patchValue({
            payCash: e.target.checked == true ? false : false,
            payCreditCard: e.target.checked == true ? false : false,
            payCheck: e.target.checked == true ? true : false,
            payMoneyOrder: e.target.checked == true ? false : true,
            payOther: e.target.checked == true ? false : false,
            payCarryOver: e.target.checked == true ? false : false,
            payMonterey: e.target.checked == true ? false : false
        });
    }

    chkPayMoneyOrderChange(e) {
        this.collectPaymentGroup.patchValue({
            paymentType: false,
            fileNo: false,
            disabledAgreement: true,
        });
        this.prodConfigGroup.patchValue({
            payCash: e.target.checked == true ? false : false,
            payCreditCard: e.target.checked == true ? false : true,
            payCheck: e.target.checked == true ? false : false,
            payMoneyOrder: e.target.checked == true ? true : false,
            payOther: e.target.checked == true ? false : false,
            payCarryOver: e.target.checked == true ? false : false,
            payMonterey: e.target.checked == true ? false : false
        });
    }

    chkPayCreditCardChange(e) {
        this.collectPaymentGroup.patchValue({
            paymentType: false,
            fileNo: false,
            disabledAgreement: true,
        });
        this.prodConfigGroup.patchValue({
            payCash: e.target.checked == true ? false : false,
            payCreditCard: e.target.checked == true ? true : false,
            payCheck: e.target.checked == true ? false : true,
            payMoneyOrder: e.target.checked == true ? false : false,
            payOther: e.target.checked == true ? false : false,
            payCarryOver: e.target.checked == true ? false : false,
            payMonterey: e.target.checked == true ? false : false
        });
    }

    chkPayOtherChange(e) {
        this.collectPaymentGroup.patchValue({
            paymentType: false,
            fileNo: false,
            disabledAgreement: true,

        });
        this.prodConfigGroup.patchValue({
            payCash: e.target.checked == true ? false : false,
            payCreditCard: e.target.checked == true ? false : false,
            payCheck: e.target.checked == true ? false : false,
            payMoneyOrder: e.target.checked == true ? false : true,
            payOther: e.target.checked == true ? true : false,
            payCarryOver: e.target.checked == true ? false : false,
            payMonterey: e.target.checked == true ? false : false
        });
    }

    chkPayMontereyChange(e) {
        this.collectPaymentGroup.patchValue({
            paymentType: false,
            fileNo: false,
            disabledAgreement: true,

        });
        this.prodConfigGroup.patchValue({
            payCash: e.target.checked == true ? false : false,
            payCreditCard: e.target.checked == true ? false : false,
            payCheck: e.target.checked == true ? false : false,
            payMoneyOrder: e.target.checked == true ? false : true,
            payOther: e.target.checked == true ? false : false,
            payCarryOver: e.target.checked == true ? false : false,
            payMonterey: e.target.checked == true ? true : false
        });
    }

    chkCarryOverChange(e) {
        this.collectPaymentGroup.patchValue({
            paymentType: false,
            fileNo: false,
            disabledAgreement: true,

        });
        this.prodConfigGroup.patchValue({
            payCash: e.target.checked == true ? false : false,
            payCreditCard: e.target.checked == true ? false : false,
            payCheck: e.target.checked == true ? false : false,
            payMoneyOrder: e.target.checked == true ? false : true,
            payOther: e.target.checked == true ? false : false,
            payCarryOver: e.target.checked == true ? true : false,
            payMonterey: e.target.checked == true ? false : false
        });
    }


    chkCoInventorConfirmChange() {
        this.coInventorConfirm = !this.coInventorConfirm;
        this.socGroup.patchValue({
            chkcoInventConfirm: this.coInventorConfirm
        });
    }

    showHideMenuBar(action) {
        action == 'Hide' ? this.IsMenu = false : this.IsMenu = true;
        this._transferDataService.showHideBtn = action;
    }

    setInfoCollecControl(name: any, Isenable: boolean): void {
        let ctrl = this.prodConfigGroup.controls[name];
        Isenable ? ctrl.enable() : ctrl.disable();
    }

    setServicesControl(name: any, Isenable: boolean): void {
        let ctrl = this.prodConfigGroup.controls[name];
        Isenable ? ctrl.enable() : ctrl.disable();
    }

    chkMarriedYesChange(e) {
        this.prodConfigGroup.patchValue({
            isMarriedNo: !e.target.checked,
            marriageYear: '',
        });
        this.setInfoCollecControl('marriageYear', e.target.checked);
    }

    chkMarriedNoChange(e) {
        this.prodConfigGroup.patchValue({
            isMarriedYes: !e.target.checked,
            marriageYear: '',
        });
        this.setInfoCollecControl('marriageYear', !e.target.checked);
    }

    chkChildrenYesChange(e) {
        this.prodConfigGroup.patchValue({
            isChildrenNo: !e.target.checked,
            childrenName: '',
        });
        this.setInfoCollecControl('childrenName', e.target.checked);
    }

    chkChildrenNoChange(e) {
        this.prodConfigGroup.patchValue({
            isChildrenYes: !e.target.checked,
            childrenName: '',
        });
        this.setInfoCollecControl('childrenName', !e.target.checked);
    }

    chki1HomeOwnerChange(e) {
        this.prodConfigGroup.patchValue({
            i1HomeOwner: e.target.checked == true ? true : false,
            i1HomeRent: e.target.checked == true ? false : true,
            i1HomeOther: e.target.checked == true ? false : false,
        });
    }

    chki1HomeRentChange(e) {
        this.prodConfigGroup.patchValue({
            i1HomeOwner: e.target.checked == true ? false : false,
            i1HomeRent: e.target.checked == true ? true : false,
            i1HomeOther: e.target.checked == true ? false : true,
        });
    }

    chki1HomeOtherChange(e) {
        this.prodConfigGroup.patchValue({
            i1HomeOwner: e.target.checked == true ? false : true,
            i1HomeRent: e.target.checked == true ? false : false,
            i1HomeOther: e.target.checked == true ? true : false,
        });
    }

    chkIsPatentIssued(e) {
        this.setInfoCollecControl('patentissuednumber', e.target.checked);
        this.prodConfigGroup.patchValue({
            patentissuednumber: ''
        });
    }

    chkNoService(e) {
        this.prodConfigGroup.patchValue({
            isAddendumB: false,
            isAddendumG: false,
            isAddendumP: false,
            isPatentServices: false,
        });
    }

    chkAnyService(e) {
        this.prodConfigGroup.patchValue({
            isNoService: false,
        });
        if (+$("#contract option:selected").val() == 7 || +$("#contract option:selected").val() == 8 || +$("#contract option:selected").val() == 9 || +$("#contract option:selected").val() == 12 || +$("#contract option:selected").val() == 13 || +$("#contract option:selected").val() == 14) {
            this.prodConfigGroup.patchValue({
                isPatentServices: true,
            });
        }
    }

    chkSaveAcChange(e) {
        this.hideOptionalDoc = false;
        this.expiry = false;
        if (!e.target.checked) {
            this.divPayCard = true;
            this.divPaySaveAc = false;
            this.divNoAutoPay = false;
            this.prodConfigGroup.patchValue({
                chkSaveAc: false,
                chkCCard: true,
                chkNoAutoPay: false,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
        else {
            this.divPaySaveAc = e.target.checked;
            this.divPayCard = !e.target.checked;
            this.divNoAutoPay = !e.target.checked;
            this.prodConfigGroup.patchValue({
                chkSaveAc: e.target.checked,
                chkCCard: !e.target.checked,
                chkNoAutoPay: !e.target.checked,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
    }

    chkCCardChange(e) {
        this.hideOptionalDoc = false;
        this.expiry = false;
        if (!e.target.checked) {
            this.divPayCard = false;
            this.divPaySaveAc = true;
            this.divNoAutoPay = false;
            this.prodConfigGroup.patchValue({
                chkSaveAc: true,
                chkCCard: false,
                chkNoAutoPay: false,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
        else {
            this.divPaySaveAc = !e.target.checked;
            this.divNoAutoPay = !e.target.checked;
            this.divPayCard = e.target.checked;
            this.prodConfigGroup.patchValue({
                chkSaveAc: !e.target.checked,
                chkCCard: e.target.checked,
                chkNoAutoPay: !e.target.checked,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
    }

    chkNoAutoPayChange(e) {
        this.hideOptionalDoc = true;
        this.expiry = false;
        if (!e.target.checked) {
            this.divPayCard = false;
            this.divPaySaveAc = true;
            this.divNoAutoPay = false;
            this.prodConfigGroup.patchValue({
                chkSaveAc: true,
                chkCCard: false,
                chkNoAutoPay: false,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
        else {
            this.divPaySaveAc = !e.target.checked;
            this.divNoAutoPay = e.target.checked;
            this.divPayCard = !e.target.checked;
            this.prodConfigGroup.patchValue({
                chkSaveAc: !e.target.checked,
                chkCCard: !e.target.checked,
                chkNoAutoPay: e.target.checked,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
    }

    changeUpperCase(e) {
        //this.cardName = (<HTMLInputElement>document.getElementById("cardName")).value;
        //(<HTMLInputElement>document.getElementById("cardName")).value = this.cardName.toUpperCase();
    }

    cc_brand_id(e, divid) {
        var jcb_regex = new RegExp('^(?:2131|1800|35)[0-9]{0,}$');
        var amex_regex = new RegExp('^3[47][0-9]{0,}$'); //34, 37
        var diners_regex = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$');
        var visa_regex = new RegExp('^4[0-9]{0,}$'); //4
        var mastercard_regex = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$');
        var maestro_regex = new RegExp('^(5[06789]|6)[0-9]{0,}$');
        var discover_regex = new RegExp('^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$');

        var cur_val = divid == 'divCPG' ? this.collectPaymentGroup.controls.creditCard.value : divid == 'divUPC' ? this.prodConfigGroup.controls.cCardNo.value : '';

        cur_val = cur_val.replace(/\D/g, '');
        var sel_brand = "unknown";
        if (cur_val.match(jcb_regex)) {
            sel_brand = "jcb";
        } else if (cur_val.match(amex_regex)) {
            sel_brand = "amex";
        } else if (cur_val.match(diners_regex)) {
            sel_brand = "diners_club";
        } else if (cur_val.match(visa_regex)) {
            sel_brand = "visa";
        } else if (cur_val.match(mastercard_regex)) {
            sel_brand = "mastercard";
        } else if (cur_val.match(discover_regex)) {
            sel_brand = "discover";
        } else if (cur_val.match(maestro_regex)) {
            if (cur_val[0] == '5') {
                sel_brand = "mastercard";
            } else {
                sel_brand = "stripe";
            }
        }
        if (divid == 'divCPG')
            this.sel_brand = sel_brand;
        else if (divid == 'divUPC')
            this.sel_brandUPC = sel_brand;
    }

    async exportToPDF() {
        if (this.isExecuted && this.isContractDone) {
            $('#modalExportDocument').modal('hide');
            $('#modalExportDocumentAzure').modal('show');
        }
        else {
            $('#modalExportDocumentAzure').modal('hide');
            $('#modalExportDocument').modal('show');
            this.dvSpinner = true;
            this.chkExpPDF = true;
            await this.getDocumentTypeIds();
            if (Number.isNaN(+this.exportDocumentIds.replace(/,/g, '').replace(/-/g, '')))
                setTimeout(() => {
                    this.generatePDF(this.getDocumentIds());
                }, 2000);
            else
                this.generatePDF(this.exportDocumentIds);
        }
    }

    generatePDF(docIds: string) {
        this.docIds = docIds;
        if (this.exportDocumentIds != '') {
            this._documentService.getGetDocumentPDFBinaryAsync(this.encryptedUser, docIds, this.inventionId, this.contactId, this.contractSessionId, (this.contractSession.productId > 8 && this.contractSession.productId < 12) ? "Plus" : "Normal")
                .then((result: any) => {
                    if (result) {
                        let file = new Blob([result], { type: 'application/pdf' });
                        let fileURL = URL.createObjectURL(file);
                        let fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        if (this.contactDetails)
                            fileLink.download = "ContractDocuments_" + this.contactDetails.firstname + this.contactDetails.lastname;
                        else
                            fileLink.download = "ContractDocuments.pdf";

                        fileLink.click();
                        this.dvSpinner = false;
                        this.chkExpPDF = false;
                        setTimeout(function () {
                            window.open(fileURL, '_blank');
                        }, 1000);
                        $('#modalExportDocument').modal('hide');
                    } else {
                        console.log("exportToPDF.statusCode: Error Getting Data");
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                    $('#modalExportDocument').modal('hide');
                    $('#modalExportDocumentAzure').modal('hide');
                });
        }
    }

    async sendExportToPDF(mode) {
        this.dvSpinner = true;
        this.chkExpPDF = true;
        this.mode = mode;
        await this.getDocumentTypeIds();
        if (Number.isNaN(+this.exportDocumentIds.replace(/,/g, '').replace(/-/g, '')))
            setTimeout(() => {
                this.sendPDF(this.getDocumentIds());
            }, 2000);
        else
            this.sendPDF(this.exportDocumentIds);
    }

    sendPDF(docIds: string) {
        this.docIds = docIds;
        if (this.exportDocumentIds != '') {
            let documentsMedia = {} as DocumentsMedia;
            documentsMedia.documentTypeIds = docIds;
            documentsMedia.inventionId = this.inventionId;
            documentsMedia.contactId = this.contactId;
            documentsMedia.productId = this.productId;
            documentsMedia.contractSessionId = this.contractSessionId;
            documentsMedia.email = documentsMedia.ccEmail = this.mode == "Sendtocorp" ? "0" : "SendPdf";
            documentsMedia.salesRepComments = this.salesRepComments;

            this._documentService.sendToCorpOrEmailDocuments(this.encryptedUser, documentsMedia)
                .then((result: any) => {
                    if (result) {
                        this.dvSpinner = false;
                        this.chkExpPDF = false;
                        if (this.mode == "Sendtocorp") {
                            this.isPaymentDone = true;
                            this.isGenerateContractsDone = true;
                        }
                        else
                            this.openSnackBar("Mail sent successfully.", "");
                    }
                    else {
                        console.log("sendExportToPDF.statusCode: Error Getting Data");
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else
            $('#modalExportDocument').modal('show');
    }

    hideDocList() {
        $('#modalExportDocumentAzure').modal('hide');
    }

    hideFilesList() {
        $('#modalExportCompressFile').modal('hide');
    }

    closeGeneratePDF() {
        this.docIds = "";
        $('#modalExportDocument').modal('hide');
    }

    async downloadFile(fileName: string, containerName: string, source: string) {
        if (source == 'popup')
            this.popLoading = true;
        else
            this.loading = true;
        this._documentService.getContractsAzureZipEncriptAsync(this.encryptedUser, fileName, containerName, "AllFiles", 0, false)
            .then(async (result: any) => {
                if (result) {
                    console.log('downloadFile-' + result);
                    let file = new Blob([result], { type: 'application/zip' });
                    let fileURL = URL.createObjectURL(file);
                    let fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.download = fileName;
                    fileLink.click();
                    this.loading = false;
                    this.popLoading = false;
                } else {
                    console.log("exportToZIP.statusCode: Error Getting Data");
                    this.loading = false;
                    this.popLoading = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.loading = false;
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);
            });

    }
    async getCompressedFiles(fileName: string, containerName: string, source: string) {
        if (source == 'popup')
            this.popLoading = true;
        else if (source == 'extpopup') {
            this.popext2Loading = true;
        }
        else
            this.loading = true;
        this._documentService.getCompressedFileNamesAsync(this.encryptedUser, fileName, containerName, 0, false)
            .then(async (result: any) => {
                if (result) {
                    var str_array = result.split(',');
                    this.createListItem(fileName, str_array);
                    this.loading = false;
                    this.popLoading = false;
                    this.popext2Loading = false;
                } else {
                    this.loading = false;
                    this.popLoading = false;
                    this.popext2Loading = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.loading = false;
                this.popLoading = false;
                this.popext2Loading = false;
                this._utilityService.handleErrorResponse(err);
            });

    }

    async playMedia(fileName: string) {
        let azureMedia = {} as AzureMedia;
        azureMedia.contractSessionId = this.contractSessionId;
        azureMedia.fileName = fileName;
        this._documentService.getROIVideoURL(azureMedia, this.encryptedUser)
            .then(async (url: any) => {
                if (url) {
                    window.open(url, '_blank');
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    createListItem(fileName: string, str_array: any): void {
        this.singalDownload = [];
        for (var i = 0; i < str_array.length; i++) {
            this.singalDownload.push({ zipName: fileName, fileName: str_array[i] });
        }
        const ELEMENT_DATA: ContractsSingalFile[] = UtilityService.clone(this.singalDownload);;
        this.dataSourceSingleFile = new MatTableDataSource(ELEMENT_DATA);
        this.dataSourceSingleFile.sort = this.sortDoc;
        $('#modalExportCompressFile').modal('show');
    }
    downloadSingalFile(zipName, containerName, fileName) {
        this.pop2Loading = true;
        var fileExtensio = fileName.split('.').pop();
        this._documentService.getContractsAzureZipEncriptAsync(this.encryptedUser, zipName, containerName, fileName, 0, false)
            .then(async (result: any) => {
                if (result) {
                    if (fileExtensio.toLowerCase() == 'pdf') {
                        let file = new Blob([result], { type: 'application/pdf' });
                        window.open(URL.createObjectURL(file), '_blank')
                    }
                    else {
                        let file = new Blob([result]);
                        let fileURL = URL.createObjectURL(file);
                        let fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.download = fileName;
                        fileLink.click();
                    }
                    this.pop2Loading = false;
                    this.loading = false;
                    this.popLoading = false;
                }
            }).catch((err: HttpErrorResponse) => {
                this.pop2Loading = false;
                this.loading = false;
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    private download(file) {
        let fileName = file;
        let checkFileType = '.' + fileName.split('.').pop();
        var fileType;
        if (checkFileType.toLowerCase() == ".txt") {
            fileType = "text/plain";
        }
        else if (checkFileType.toLowerCase() == ".pdf") {
            fileType = "application/pdf";
        }
        else if (checkFileType.toLowerCase() == ".doc") {
            fileType = "application/vnd.ms-word";
        }
        else if (checkFileType.toLowerCase() == ".docx") {
            fileType = "application/vnd.ms-word";
        }
        else if (checkFileType.toLowerCase() == ".xls") {
            fileType = "application/vnd.ms-excel";
        }
        else if (checkFileType.toLowerCase() == ".xlsx") {
            fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        }
        else if (checkFileType.toLowerCase() == ".png") {
            fileType = "image/png";
        }
        else if (checkFileType.toLowerCase() == ".jpg") {
            fileType = "image/jpeg";
        }
        else if (checkFileType.toLowerCase() == ".jpeg") {
            fileType = "image/jpeg";
        }
        else if (checkFileType.toLowerCase() == ".gif") {
            fileType = "image/gif";
        }
        else if (checkFileType.toLowerCase() == ".csv") {
            fileType = "text/csv";
        }
        return fileType;
    }

    changeRoutingNo() {
        this.isRoutingNumberBlank = this.collectPaymentGroup.controls.chkRoutingNo.value.length > 0 ? false : true;
    }

    changeAccountNo() {
        this.isAccountNumberBlank = this.collectPaymentGroup.controls.chkAccNo.value.length > 0 ? false : true;
    }

    changeAccountName() {
        this.isBankAccountNameBlank = this.collectPaymentGroup.controls.bankAccountName.value.length > 0 ? false : true;
    }

    printReceipt() {
        if (isNullOrUndefined(this._transferDataService.fileNumber) || this._transferDataService.fileNumber === '' || this._transferDataService.fileNumber === '0')
            this.openSnackBar("Before making a payment, please save the correct File Number.", "");
        else if (!isNullOrUndefined(this.contractPayment) && this.contractPayment.cashPrice <= 0)
            this.openSnackBar("Please enter Total price of Services in Service section.", "");
        else if (Number(this.partialFee) <= 0)
            this.openSnackBar("Amount should be greater than Zero.", "");
        else if (this.prodConfigGroup.controls.payCheck.value && (this.collectPaymentGroup.controls.chkAccNo.value.trim() == "" ||
            this.collectPaymentGroup.controls.chkRoutingNo.value.trim() == "" || this.collectPaymentGroup.controls.bankAccountName.value.trim() == "")) {
            if (this.collectPaymentGroup.controls.chkAccNo.value.trim() == "")
                this.isAccountNumberBlank = true;
            if (this.collectPaymentGroup.controls.chkRoutingNo.value.trim() == "")
                this.isRoutingNumberBlank = true;
            if (this.collectPaymentGroup.controls.bankAccountName.value.trim() == "")
                this.isBankAccountNameBlank = true;
        }
        else {
            this.collectionError = '';
            var isPaid = false;
            let downPaymentPart: number = 0;
            this.isAccountNumberBlank = false;
            this.isRoutingNumberBlank = false;
            this.isBankAccountNameBlank = false;
            this.copyPayFormValuesToDataObject();
            if (this.prodForm.payCash.value || this.prodForm.payOther.value || this.prodForm.payCarryOver.value || this.prodForm.payMonterey.value)
                this.billingDetails.chkFileNumber = false;
            if (this._transferDataService.fileNumber)
                this.billingDetails.fileNumber = this._transferDataService.fileNumber
            else
                this.billingDetails.fileNumber = "1";

            if (!isNullOrUndefined(this.contractMultiPaymentResponse.contractMultiPayment)) {
                for (var i = 0; i < this.contractMultiPaymentResponse.contractMultiPayment.length; i++) {
                    var downPayment: any = this.contractMultiPaymentResponse.contractMultiPayment[i].downPaymentPart;
                    if (downPayment == 0) {
                        this.collectionError = 'Down Payment can not be ' + this.currencySterling + '0';
                        return;
                    }
                    if (downPayment && typeof downPayment == "number")
                        downPayment = downPayment.toString();
                    downPayment = downPayment ? downPayment.toString().replace(this.currencySterling, "").replace(',', "") : 0;
                    downPaymentPart += Number(downPayment);
                }

                if (!isNullOrUndefined(downPaymentPart) && downPaymentPart > 0) {
                    if ((downPaymentPart != this.oneTimeFee) || (downPaymentPart != this.oneTimeFeeInitial)) {
                        if (!isNullOrUndefined(this.navigationResponse.navigation)) {
                            this.navigationResponse.navigation.isPayCollectForm = false;
                            this.navigationResponse.navigation.isRetailDoc = false;
                            this.uncheckNavBar('tdIsRetailDoc');
                            this.retailDone = false;
                            this.isRetailAccept = false;
                            this.isRetailHeadAccept = false;
                            this.saveNavigationWizard();
                        }
                    }
                }
            }
            let totalPayment: number = 0;
            totalPayment = parseFloat(this.prodForm.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', ""));
            if (downPaymentPart > totalPayment) {
                this.openSnackBar("Down Payment can not be greater than Cash Price", "");
                this.downpaymentExceed = true;
                this.serviceButtonText = "Please Wait...";
                return;
            }
            else {
                this.downpaymentExceed = false;
                this.serviceButtonText = "Save";
            }
            this._billingService.payAmountAsync(this.encryptedUser, this.billingDetails)
                .then(res => {
                    if (res) {
                        this.billingResponse = UtilityService.clone(res);
                        if (this.billingResponse) {
                            if (this.billingResponse.billingDetails.cardTxnStatus == 1) {
                                isPaid = true;
                                this.disabledAgreement = true;
                                this.openSnackBar("The billing details were saved.", "");
                            }
                            else
                                this.openSnackBar("The billing details weren't saved. Please try again!", "");
                        }
                        this.updateContractMultiPayment(isPaid);
                    }
                    else {
                        this.updateContractMultiPayment(isPaid);
                    }
                }).catch((err: HttpErrorResponse) => {
                    this.isPaymentDone = false;
                    this.isPaymentProcessing = false;
                    this._utilityService.handleErrorResponse(err);
                });
            this.saveContrActionAcitonLog();
        }
    }

    updateContractMultiPayment(isPaid) {
        if (!isNullOrUndefined(this.contractMultiPayments.find(x => x.id == this.currentMultiPayId).isPaid)) {
            this.contractMultiPayments.find(x => x.id == this.currentMultiPayId).isPaid = isPaid;

            this.CopyMultiPaymentToDataObject(2);
            this.contractMultiPaymentResponse.contractMultiPayment = this.contractMultiPayments;
            this.contractMultiPaymentResponse.contractSessionId = this.contractSessionId;
            this.copyCheckDetailToDataObject(2);
            let totalPayment: number = 0;
            let downPaymentPart: number = 0;
            for (var i = 0; i < this.contractMultiPaymentResponse.contractMultiPayment.length; i++) {
                this.contractMultiPaymentResponse.contractMultiPayment[i].downPaymentPart = this.contractMultiPaymentResponse.contractMultiPayment[i].downPaymentPart.toString().replace(this.currencySterling, "").replace(',', "") ? (this.contractMultiPaymentResponse.contractMultiPayment[i].downPaymentPart.toString().replace(this.currencySterling, "").replace(',', "")) : '0';
                downPaymentPart += parseFloat(this.contractMultiPaymentResponse.contractMultiPayment[i].downPaymentPart.toString().replace(this.currencySterling, "").replace(',', ""));
            }
            totalPayment = parseFloat(this.prodForm.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', ""));
            if (downPaymentPart == totalPayment)
                this.contractPaymentResponse.contractPayment.paymentOptionId = 1;
            else if (downPaymentPart > totalPayment) {
                this.openSnackBar("Down Payment can not be greater than Cash Price", "");
                this.downpaymentExceed = true;
                this.serviceButtonText = "Please Wait...";
                return;
            }
            else {
                this.contractPaymentResponse.contractPayment.paymentOptionId = 2;
                this.downpaymentExceed = false;
                this.serviceButtonText = "Save";
            }
            if ((downPaymentPart != this.oneTimeFee) || (downPaymentPart != this.contractPaymentResponse.contractPayment.downPayment) || (downPaymentPart != this.oneTimeFeeInitial)) {
                this.contractPaymentResponse.contractPayment.downPayment = downPaymentPart;
                this.saveContractPaymentAfterMultiCRUD();
            }
            this.ContractMultiPaymentCRUD('');
        }
    }

    copyCheckDetailToDataObject(grdType) {
        if (grdType == 2) {
            if (this.contractMultiPaymentResponse.contractMultiPayment.length > 0) {
                var that = this;
                this.contractMultiPaymentResponse.contractMultiPayment.forEach(function (multiPaymentObj) {
                    if ((multiPaymentObj.id == that.currentMultiPayId) && (multiPaymentObj.payOption == 3)) {
                        multiPaymentObj.isChkAmount = that.paymentForm.paymentType.value;
                        multiPaymentObj.chkBankName = that.collectPaymentGroup.controls.chkBankName.value;
                        multiPaymentObj.chkCity = that.collectPaymentGroup.controls.chkCity.value;
                        multiPaymentObj.chkState = that.collectPaymentGroup.controls.chkState.value;
                        multiPaymentObj.chkRoutingNo = that.collectPaymentGroup.controls.chkRoutingNo.value;
                        multiPaymentObj.chkAccNo = that.collectPaymentGroup.controls.chkAccNo.value;
                        multiPaymentObj.chkNumber = that.collectPaymentGroup.controls.chkNumber.value;
                        multiPaymentObj.bankAccountName = that.collectPaymentGroup.controls.bankAccountName.value;
                        multiPaymentObj.chkDate = $("#chkDate").val();
                    }
                })
            }

        }
    }

    async saveContractPaymentAfterMultiCRUD(grdType?: number) {
        if (this.contractPaymentResponse.contractPayment.countryId == 0)
            this.contractPaymentResponse.contractPayment.countryId = this.customerCountryID;
        if (grdType != 1)
            this.contractPaymentResponse.contractPayment.isPaymentAction = true;
        await this._billingService.ContractPayment_CreateUpdateAsync(this.encryptedUser, this.contractPaymentResponse)
            .then(res => {
                if (res) {
                    this.contractPaymentResponse = UtilityService.clone(res);

                    if (this.contractPaymentResponse) {

                        this.navigationResponse.navigation.isProdServicesForm = true;
                        this.isServiceFormSaved = true;
                        this.contractPayment = this.contractPaymentResponse.contractPayment;
                        this.payOption = this.contractPayment.paymentOptionId;
                        this.payMode = this.contractPayment.paymentOptionId == 1 ? "Full Payment" : "Down Payment";
                        this.convertNumberToCurrency(this.contractPayment.downPayment, 'downPayment');
                        this.divOtherMandDocs = true;
                        if (this.contractPayment.paymentOptionId == 2) {
                            this.isCalcPayment = false;
                            this.isCalc = true;
                            this.isRetailInsDocument = true;
                            this.isInfoInventDocument = true;
                            this.isUniPayDocument = true;
                            this.isPPADocument = true;
                            this.flgInstallment = true;
                            this.documentTypeIds = "24,25,26";
                            this.loadDocument();
                        }
                        if (grdType == 1)
                            this.showDivItem(this.stepper, 1, '#divPS');
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    sendReceiptEmail() {
        this._billingService.sendReceiptEmailAsync(this.encryptedUser, this.clpUserId, this.contractSessionId)
            .then().catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    printCardReceipt() {
        if (this.validatePrintReceipt()) {
            $('#modalPrintReceipt').modal('show');
            this.dvSpinner = true;
            this.chkExpPDF = true;
            let docIds: string = "";
            docIds = '35';
            this._documentService.getGetDocumentPDFBinaryAsync(this.encryptedUser, docIds, this.inventionId, this.contactId, this.contractSessionId, (this.contractSession.productId > 8 && this.contractSession.productId < 12) ? "Plus" : "Normal")
                .then(async (result: any) => {
                    if (result) {
                        let file = new Blob([result], { type: 'application/pdf' });
                        let fileURL = URL.createObjectURL(file);
                        let fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        if (this.contactDetails)
                            fileLink.download = "Payment_Receipt_" + this.contactDetails.firstname + this.contactDetails.lastname;
                        else
                            fileLink.download = "Payment_Receipt.pdf";

                        fileLink.click();
                        this.dvSpinner = false;
                        this.chkExpPDF = false;
                        setTimeout(function () {
                            window.open(fileURL, '_blank');
                        }, 1000);

                        if (!this.verifyMultiPayments())
                            this.updateUserSteps("tdIsPayCollectForm");
                        $('#modalPrintReceipt').modal('hide');
                    } else {
                        console.log("printReceipt.statusCode: Error Getting Data");
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                    $('#modalPrintReceipt').modal('hide');
                });
        }
        else
            this.openSnackBar("Please make atleast one payment first before print receipt", "");
    }

    verifyMultiPayments(): boolean {
        let isMultiPaymentPending: boolean = false;

        if (!isNullOrUndefined(this.contractMultiPaymentResponse.contractMultiPayment)) {
            for (var i = 0; i < this.contractMultiPaymentResponse.contractMultiPayment.length; i++) {
                if (!this.contractMultiPaymentResponse.contractMultiPayment[i].isPaid) {
                    isMultiPaymentPending = true;
                    return isMultiPaymentPending;
                }
            }
        } else {
            isMultiPaymentPending = false;
            return isMultiPaymentPending;
        }
    }

    validatePrintReceipt(): boolean {
        let isMultiPaymentPending: boolean = false;

        if (!isNullOrUndefined(this.contractMultiPaymentResponse.contractMultiPayment)) {
            for (var i = 0; i < this.contractMultiPaymentResponse.contractMultiPayment.length; i++) {
                if (this.contractMultiPaymentResponse.contractMultiPayment[i].isPaid) {
                    isMultiPaymentPending = true;
                    return isMultiPaymentPending;
                }
            }
        } else {
            isMultiPaymentPending = false;
            return isMultiPaymentPending;
        }
    }

    hideModalSOCCoInventor(): boolean {
        this.contactCoInventDetails.contactid = -1;
        this.contactCoInventResponse.contactDetails.contactid = -1;
        $('#modalSOCCoInventor').modal('hide');
        return false;
    }

    confirmModalSOCCoInventor(): boolean {
        this.socGroup.patchValue({
            firstnamei2: this.contactCoInventDetails.firstname || '',
            lastnamei2: this.contactCoInventDetails.lastname || '',
            //mobilei2: this.contactCoInventDetails.mobile || '',
            //emaili2: this.contactCoInventDetails.email || '',
            contactid1: this.contactId
        });
        $('#modalSOCCoInventor').modal('hide');
        return false;
    }

    private copyDataObjectToPopupFormValues() {

        if (!isNullOrUndefined(this.contactDetails)) {
            this.locationPOPUP.patchValue({
                clientstate: this.contractSession.CountryID.toString() == this.contactDetails.country ? this.getState(this.contactDetails.state, this.contactDetails.country) : "-1",
                isClientRemote: false,
            });
        }
        else {
            this.locationPOPUP.patchValue({
                clientstate: "-1",
                isClientRemote: false,
            });
        }
    }

    private copyDataObjectToFormValues() {
        let maxSize: number = 10;
        this.zipLength = 10;
        this.isOtherCountry = false;
        if (!isNullOrUndefined(this.contactDetails)) {
            if ((this.contactDetails.country.toLowerCase() == "united states of america") || (this.contactDetails.country.toLowerCase() == "usa")
                || (this.contactDetails.country.toLowerCase() == "us") || (this.contactDetails.country.toLowerCase() == "united states") || (this.contactDetails.country.toLowerCase() == "america")
                || (this.contactDetails.country == "1") || (this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country))
                || (this.contactDetails.country.toLowerCase() == "can") || (this.contactDetails.country.toLowerCase() == "canada") || (this.contactDetails.country == "2")) {
                this.contactDetails.country = ((this.contactDetails.country.toLowerCase() == "can") || (this.contactDetails.country.toLowerCase() == "canada") || (this.contactDetails.country == "2")) ? "2" : "1";
                this.phoneMask = '(000) 000-0000';
                this.maxLength = '14';
                this.socGroup.controls.otherState.clearValidators();
                setTimeout(() => {
                    this.socGroup.controls.homephone.setValidators([Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
                    this.socGroup.controls.workphone.setValidators([Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
                    this.socGroup.controls.mobile.setValidators([Validators.required, Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
                });
            }
            else {
                switch (this.contactDetails.country.toLowerCase()) {
                    case "united kingdom": case "uk": case "england": case "great britain": this.contactDetails.country = "4"; break;
                    case "ireland": case "ire": this.contactDetails.country = "6"; break;
                    case "australia": case "aus": this.contactDetails.country = "3"; break;
                    default: break;
                }
                maxSize = 50;
                this.phoneMask = '';
                this.maxLength = '50';
                this.socGroup.controls.homephone.clearValidators();
                this.socGroup.controls.workphone.clearValidators();
                this.socGroup.controls.mobile.setValidators([Validators.required]);
                if (this.contractSession.CountryID == 399) {
                    this.isOtherCountry = true;
                    this.zipLength = 50;
                    this.socGroup.controls.otherState.setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);
                    this.socGroup.controls.country.clearValidators();
                    this.socGroup.controls.state.clearValidators();
                }
                else {
                    this.isOtherCountry = false;
                    this.socGroup.controls.otherState.clearValidators();
                }
            }

            this.socGroup.patchValue({
                firstname: this.contactDetails.firstname || '',
                lastname: this.contactDetails.lastname || '',
                address1: this.contactDetails.address1 || '',
                address2: this.contactDetails.address2 || '',
                address3: this.contactDetails.address3 || '',
                country: this.isOtherCountry ? '-1' : this.contactDetails.country,
                state: this.isOtherCountry ? '-1' : this.getState(this.contactDetails.state, this.contactDetails.country),
                city: this.contactDetails.city || '',
                zipcode: this.contactDetails.zipcode || '',
                homephone: this.contactDetails.homephone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                workphone: this.contactDetails.workphone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                mobile: this.contactDetails.mobile.replace(/[() -]/g, '').substring(0, maxSize) || '',
                email: this.contactDetails.email || '',
                inventname: this.inventionDetails.InventionName || '',
                chkinvent: this.inventionDetails.isCoInventor || false,
                firstnamei2: this.inventionDetails.i2FirstName || '',
                lastnamei2: this.inventionDetails.i2LastName || '',
                otherCountry: this.isOtherCountry ? this.contactDetails.country === "4" ? "United Kingdom" : this.contactDetails.country === "3" ? "Australia" : this.contactDetails.country === "6" ? "Ireland" : this.contactDetails.country === '2' ? "Canada" : (this.contactDetails.country === "1" || ((this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country)))) ? "USA" : this.contactDetails.country : '',
                otherState: this.isOtherCountry ? this.contactDetails.state : '',
                //mobilei2: '',
                //emaili2: '',
                initialSignature: '',
                initialCoInvSignature: '',
                initialAdsSignature: '',
                initialAdsCoInvSignature: ''
            });
            if (this.socGroup.controls.chkinvent.value)
                this.otherInventor = true;
            this.isCoInventor = this.socGroup.controls.chkinvent.value ? this.socGroup.controls.chkinvent.value : false;
            this.i2person = this.socGroup.controls.firstnamei2.value ? this.socGroup.controls.firstnamei2.value + ' ' + this.socGroup.controls.lastnamei2.value : "";
        }
    }

    private copyFormValuesToDataObject() {

        this.infoCollectPhone = "";
        this.infoCollectAddress = "";

        if (this.socGroup.controls.address1.value != "")
            this.infoCollectAddress = this.socGroup.controls.address1.value;
        if (this.socGroup.controls.address2.value != "")
            this.infoCollectAddress += ", " + this.socGroup.controls.address2.value;
        if (this.socGroup.controls.address3.value != "")
            this.infoCollectAddress += ", " + this.socGroup.controls.address3.value;
        if (this.socGroup.controls.city.value != "")
            this.infoCollectAddress += ", " + this.socGroup.controls.city.value;
        if (this.socGroup.controls.country.value != "-1")
            this.infoCollectAddress += ", " + $("#country option:selected").text();
        else if (this.socGroup.controls.otherCountry.value != "")
            this.infoCollectAddress += ", " + this.socGroup.controls.otherCountry.value;
        if (this.socGroup.controls.state.value != "-1")
            this.infoCollectAddress += ", " + $("#state option:selected").text();
        else if (this.socGroup.controls.otherState.value != "")
            this.infoCollectAddress += ", " + this.socGroup.controls.otherState.value;

        if (this.socGroup.controls.zipcode.value != "")
            this.infoCollectAddress += ", " + this.socGroup.controls.zipcode.value;

        if (this.socGroup.controls.homephone.value != "")
            this.infoCollectPhone = "Home Phone :" + this.socGroup.controls.homephone.value;

        if (this.socGroup.controls.workphone.value != "") {
            if (this.infoCollectPhone.trim().length > 0)
                this.infoCollectPhone += ", Work Phone: " + this.socGroup.controls.workphone.value;
            else
                this.infoCollectPhone += "Work Phone: " + this.socGroup.controls.workphone.value;
        }

        if (this.socGroup.controls.mobile.value != "") {
            if (this.infoCollectPhone.trim().length > 0)
                this.infoCollectPhone += ",  Cell Phone: " + this.socGroup.controls.mobile.value;
            else
                this.infoCollectPhone += "Cell Phone: " + this.socGroup.controls.mobile.value;
        }

        this.contactDetails.firstname = this.socGroup.controls.firstname.value;
        this.contactDetails.lastname = this.socGroup.controls.lastname.value;
        this.contactDetails.salutation = "";
        this.contactDetails.address1 = this.socGroup.controls.address1.value;
        this.contactDetails.address2 = this.socGroup.controls.address2.value;
        this.contactDetails.address3 = this.socGroup.controls.address3.value;
        this.contactDetails.country = this.socGroup.controls.country.value === "4" ? "United Kingdom" : this.socGroup.controls.country.value === "3" ? "Australia" : this.socGroup.controls.country.value === "6" ? "Ireland" : this.socGroup.controls.country.value === "2" ? "Canada" : this.socGroup.controls.country.value === "1" ? "USA" : this.socGroup.controls.otherCountry.value;
        this.contactDetails.state = this.socGroup.controls.otherCountry.value === "" ? this.socGroup.controls.state.value : this.socGroup.controls.otherState.value;
        this.contactDetails.city = this.socGroup.controls.city.value;
        this.contactDetails.zipcode = this.socGroup.controls.zipcode.value;
        if (this.contactDetails.country == "United Kingdom") {
            if (this.socGroup.controls.homephone.value.trim() != "")
                this.contactDetails.homephone = this.socGroup.controls.homephone.value.replace(/^(\d{0,4})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.homephone = this.socGroup.controls.homephone.value;
        }
        else if (this.contactDetails.country == "Ireland") {
            if (this.socGroup.controls.homephone.value.trim() != "")
                this.contactDetails.homephone = this.socGroup.controls.homephone.value.replace(/^(\d{0,2})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.homephone = this.socGroup.controls.homephone.value;
        }
        else if ((this.contactDetails.country == "USA") || (this.contactDetails.country == "Canada") || ((this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country)))) {
            if (this.socGroup.controls.homephone.value.trim() != "")
                this.contactDetails.homephone = this.socGroup.controls.homephone.value.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.homephone = this.socGroup.controls.homephone.value;
        }
        else
            this.contactDetails.homephone = this.socGroup.controls.homephone.value;

        if (this.contactDetails.country == "United Kingdom") {
            if (this.socGroup.controls.workphone.value.trim() != "")
                this.contactDetails.workphone = this.socGroup.controls.workphone.value.replace(/^(\d{0,4})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.workphone = this.socGroup.controls.workphone.value;
        }
        else if (this.contactDetails.country == "Ireland") {
            if (this.socGroup.controls.workphone.value.trim() != "")
                this.contactDetails.workphone = this.socGroup.controls.workphone.value.replace(/^(\d{0,2})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.workphone = this.socGroup.controls.workphone.value;
        }
        else if ((this.contactDetails.country == "USA") || (this.contactDetails.country == "Canada") || ((this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country)))) {
            if (this.socGroup.controls.workphone.value.trim() != "")
                this.contactDetails.workphone = this.socGroup.controls.workphone.value.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.workphone = this.socGroup.controls.workphone.value;
        }
        else
            this.contactDetails.workphone = this.socGroup.controls.workphone.value;



        if (this.contactDetails.country == "United Kingdom") {
            if (this.socGroup.controls.mobile.value.trim() != "")
                this.contactDetails.mobile = this.socGroup.controls.mobile.value.replace(/^(\d{0,4})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.mobile = this.socGroup.controls.mobile.value;
        }
        else if (this.contactDetails.country == "Ireland") {
            if (this.socGroup.controls.mobile.value.trim() != "")
                this.contactDetails.mobile = this.socGroup.controls.mobile.value.replace(/^(\d{0,2})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.mobile = this.socGroup.controls.mobile.value;
        }
        else if ((this.contactDetails.country == "USA") || (this.contactDetails.country == "Canada") || ((this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country)))) {
            if (this.socGroup.controls.mobile.value.trim() != "")
                this.contactDetails.mobile = this.socGroup.controls.mobile.value.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.mobile = this.socGroup.controls.mobile.value;
        }
        else
            this.contactDetails.mobile = this.socGroup.controls.mobile.value;

        this.contactDetails.email = this.socGroup.controls.email.value;
        this.contactDetails.editOrigin = "SOC";
        this.inventionDetails.InventionName = this.socGroup.controls.inventname.value;


        this.inventionDetails.i2FirstName = this.socGroup.controls.firstnamei2.value;
        this.inventionDetails.i2LastName = this.socGroup.controls.lastnamei2.value;
        this.inventionDetails.isCoInventor = this.socGroup.controls.chkinvent.value;


        this.inventionDetails.Inventor2Present = this.coInventorConfirm;

        if (this.signaturePad.isEmpty() == false)
            this.base64Str = this.isExistSoc ? this.documentSignature.signature1 : this.signaturePad.toDataURL('image/png', 0.9);
        if (this.signaturePadCoInv.isEmpty() == false)
            this.base64StrCoInv = this.isExistSocinv ? this.documentSignature.signature2 : this.signaturePadCoInv.toDataURL('image/png', 0.9);
        if (this.signaturePadADS.isEmpty() == false)
            this.base64StrADS = this.isExistADS ? this.documentSignature.i1SignatureADS : this.signaturePadADS.toDataURL('image/png', 0.9);
        if (this.signaturePadADSCoInv.isEmpty() == false)
            this.base64StrADSCoInv = this.isExistADSinv ? this.documentSignature.i2SignatureADS : this.signaturePadADSCoInv.toDataURL('image/png', 0.9);

        if (this.signaturePadFinal.isEmpty() == false)
            this.base64StrFinal = this.isExistFinal ? this.documentSignature.i1SignatureFinal : this.signaturePadFinal.toDataURL('image/png', 0.9);
        if (this.signaturePadFinalCoInv.isEmpty() == false)
            this.base64StrFinalCoInv = this.isExistFinalinv ? this.documentSignature.i2SignatureFinal : this.signaturePadFinalCoInv.toDataURL('image/png', 0.9);

        let dc: DocumentContainer = {} as any;
        dc.contractSessionId = this.contractSessionId;
        dc.contactId = this.contactId;

        dc.currentUser = this.currentUser;
        dc.documentTypeId = 1;
        dc.inventionId = this.inventionId

        dc.signature = !this.signaturePad.isEmpty() ? this.base64Str : "";
        dc.initial = this.socGroup.controls.initialSignature.value ? this.socGroup.controls.initialSignature.value.trim() : "";
        dc.i1SignatureADS = !this.signaturePadADS.isEmpty() ? this.base64StrADS : "";
        dc.i1InitialADS = this.socGroup.controls.initialAdsSignature.value ? this.socGroup.controls.initialAdsSignature.value.trim() : "";
        dc.i1SignatureFinal = !this.signaturePadFinal.isEmpty() ? this.base64StrFinal : "";
        dc.i1InitialFinal = this.signDocsGroup.controls.initialFinalSignature.value ? this.signDocsGroup.controls.initialFinalSignature.value.trim() : "";

        if (this.inventionDetails.isCoInventor) {
            dc.i2signature = !this.signaturePadCoInv.isEmpty() ? this.base64StrCoInv : "";
            dc.i2initial = this.socGroup.controls.initialCoInvSignature.value ? this.socGroup.controls.initialCoInvSignature.value.trim() : "";
            dc.i2SignatureADS = !this.signaturePadADSCoInv.isEmpty() ? this.base64StrADSCoInv : "";
            dc.i2InitialADS = this.socGroup.controls.initialAdsCoInvSignature.value ? this.socGroup.controls.initialAdsCoInvSignature.value.trim() : "";
            dc.i2SignatureFinal = !this.signaturePadFinalCoInv.isEmpty() ? this.base64StrFinalCoInv : "";
            dc.i2InitialFinal = this.signDocsGroup.controls.initialFinalCoInvSignature.value ? this.signDocsGroup.controls.initialFinalCoInvSignature.value.trim() : "";
        } else {
            dc.i2signature = "";
            dc.i2initial = "";
            dc.i2SignatureADS = "";
            dc.i2InitialADS = "";
            dc.i2SignatureFinal = "";
            dc.i2InitialFinal = "";
        }

        dc.wizardId = 1;
        dc.ipAddress = this.ipAddress;
        this.documentContainer = dc;

    }

    private copyProdConfigValuesToDataObject(action?: string) {
        return new Observable(observer => {
            this.contractPayment.contractSessionId = this.contractSessionId;
            this.contractPayment.productId = + $("#contract option:selected").val() ? $("#contract option:selected").val() : this.productId;
            this.contractPayment.inventionId = this.inventionId;
            this.contractPayment.countryId = this.customerCountryID;
            this.contractPayment.cashPrice = this.prodConfigGroup.controls.cashPrice.value ? this.prodConfigGroup.controls.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', "") : 0;
            this.contractPayment.downPayment = this.prodConfigGroup.controls.downPayment.value ? this.prodConfigGroup.controls.downPayment.value.toString().replace(this.currencySterling, "").replace(',', "") : 0;
            this.contractPayment.contractNo = this.prodConfigGroup.controls.contractNo.value;
            this.contractPayment.officeId = this.prodConfigGroup.controls.officeCode.value;
            this.contractPayment.rollOverAmount = this.prodConfigGroup.controls.rolloverAmount.value ? this.prodConfigGroup.controls.rolloverAmount.value.toString().replace(this.currencySterling, "").replace(',', "") : 0;

            if (this.contractSession.CountryID < 3)
                this.contractPayment.repaymentTermId = this.prodConfigGroup.controls.repaymentTerm.value == 3 && this.contractSession.CountryID > 2 ?
                    (this.contractPayment.productId == 1 || this.contractPayment.productId == 2 || this.contractPayment.productId == 6 || this.contractPayment.productId == 11) ? 2 : 11
                    : this.prodConfigGroup.controls.repaymentTerm.value ? this.prodConfigGroup.controls.repaymentTerm.value : 3;
            else
                this.contractPayment.repaymentTermId = $("#repaymentTerm option:selected").val() ? +$("#repaymentTerm option:selected").val() : 3;
            this.contractPayment.promotionId = this.prodConfigGroup.controls.promotionOffer.value;
            this.contractPayment.months = +this.prodConfigGroup.controls.paymentFull.value ? 0 : this.prodConfigGroup.controls.repaymentTerm.value;
            if (action != 'D') {
                if (this.contractPayment.downPayment == this.contractPayment.cashPrice) {
                    this.contractPayment.paymentOptionId = 1;
                    this.payOption = 1;
                }
                else {
                    this.contractPayment.paymentOptionId = 2;
                    this.payOption = 2;
                    this.paymentAuth = this.contractSession.CountryID > 2 ? "Pay Auth" : "UPC Auth";
                }
            }
            this.impOrWeb = this.contractPayment.productId == 4 ? "IMP" : "Web Services";
            if (this.prodConfigGroup.controls.autoPaymentYes.value == true)
                this.contractPayment.isAutoPayment = true;
            else
                this.contractPayment.isAutoPayment = false;

            if (this.prodConfigGroup.controls.payMonterey.value == true)
                this.contractPayment.payOption = 7;
            else if (this.prodConfigGroup.controls.payCarryOver.value == true)
                this.contractPayment.payOption = 6;
            else if (this.prodConfigGroup.controls.payOther.value == true)
                this.contractPayment.payOption = 5;
            else if (this.prodConfigGroup.controls.payCash.value == true)
                this.contractPayment.payOption = 4;
            else if (this.prodConfigGroup.controls.payCheck.value == true)
                this.contractPayment.payOption = 3;
            else if (this.prodConfigGroup.controls.payMoneyOrder.value == true)
                this.contractPayment.payOption = 2;
            else
                this.contractPayment.payOption = 1;

            this.contractSession.OfficeNumber = this.prodConfigGroup.controls.officeCode.value;
            this.contractPayment.fxRate = this.currencyRate;
            this.contractPayment.fileNumber = this._transferDataService.fileNumber;
            this.contractPayment.i1CLPContactId = this.contactId;
            this.contractPayment.clpUserId = this.clpUserId;
            observer.next("success");
        });
    }
    private copyDataObjectToProdConfigCoInventorValues() {
        this.prodConfigGroup.patchValue({
            coInventor: this.inventionDetails.isCoInventor || false,
            i2firstname: this.inventionDetails.i2FirstName || '',
            i2lastname: this.inventionDetails.i2LastName || '',
        });
        if (this.prodConfigGroup.controls.coInventor.value)
            this.coInventor = true;
    }

    private copyDataObjectToProdConfigValues(source?: string) {
        if (this.contractPayment.paymentOptionId == 1) {
            this.flgInstallment = false;
            this.payFull = true;
            this.payInstall = false;
            this.setServicesControl('downPayment', false);
        }
        else {
            this.payFull = false;
            this.payInstall = true;
            this.isCalc = true;
            this.isCalcPayment = false;
            this.flgInstallment = true;
            this.setServicesControl('downPayment', true);
        }

        this.prodConfigGroup.patchValue({
            payCheck: false,
            payMoneyOrder: false,
            payCreditCard: false,
            payCash: false,
            payOther: false,
            payCarryOver: false,
            payMonterey: false
        });

        if (!isNullOrUndefined(this.contractMultiPaymentResponse) && this.contractMultiPaymentResponse.contractMultiPayment.length > 0) {
            var currentMultiPayment = this.contractMultiPaymentResponse.contractMultiPayment.find(x => x.id == this.currentMultiPayId);
            if (!isNullOrUndefined(currentMultiPayment)) {
                this.prodConfigGroup.patchValue({
                    payCheck: currentMultiPayment.payOption == 3 ? true : false,
                    payMoneyOrder: currentMultiPayment.payOption == 2 ? true : false,
                    payCreditCard: currentMultiPayment.payOption == 1 ? true : false,
                    payCash: currentMultiPayment.payOption == 4 ? true : false,
                    payOther: currentMultiPayment.payOption == 5 ? true : false,
                    payCarryOver: currentMultiPayment.payOption == 6 ? true : false,
                    payMonterey: currentMultiPayment.payOption == 7 ? true : false
                });
            }
        }

        if (this.contractPayment.isAutoPayment == true)
            this.autoPayYes = true;
        else
            this.autoPayNo = false;

        this.productId = this.contractPayment.productId || -1;
        this.payOption = this.contractPayment.paymentOptionId;

        if (this.payOption == 2) {
            this.paymentAuth = this.contractSession.CountryID > 2 ? "Pay Auth" : "UPC Auth";
            this.paymentAuthTitle = this.contractSession.CountryID > 2 ? "Partial Auto Payment" : "Universal Payment Corporation";
        }
        this.impOrWeb = this.contractPayment.productId == 4 ? "IMP" : "Web Services";

        if (this.contractPayment.paymentOptionId == 1) {
            this.convertNumberToCurrency(this.contractPayment.cashPrice, 'cashPrice');
            this.convertNumberToCurrency(this.contractPayment.downPayment, 'downPayment');
            this.convertNumberToCurrency(0, 'rolloverAmount');
            if (this.contractPayment.downPayment != 0)
                this.payMode = this.contractPayment.paymentOptionId == 1 ? "Full Payment" : "Down Payment";
            this.prodConfigGroup.patchValue({
                paymentFull: this.payFull || false,
                paymentInstallment: this.payInstall || false,
                autoPaymentYes: this.autoPayYes || false,
                autoPaymentNo: this.autoPayNo || false,
                contractNo: this.contractPayment.contractNo || '',
                officeCode: this.contractPayment.officeId || 1,
                repaymentTerm: 0,
                promotionOffer: this.contractPayment.promotionId || -1,
                contract: $("#contract option:selected").val() ? +$("#contract option:selected").val() : this.contractPayment.productId || 1,
                firstDueDate: '',
                unpaidBalance: 0,
                regularPayment: 0,
                firstPayment: 0,
                months: 0,
                APR: 0,
                totalSalePrice: 0,
                totalPayment: 0,
                financeChargeB: 0,
                financeChargeA: 0,
                financeCharge: 0,
                financeAmount: 0,
                financeAmountA: 0,
                financeAmountB: 0,
            });
        }
        else {
            var rollOverAmt = this.contractPayment.rollOverAmount ? this.contractPayment.rollOverAmount : 0;

            this.convertNumberToCurrency(this.contractPayment.cashPrice, 'cashPrice');
            this.convertNumberToCurrency(this.contractPayment.downPayment, 'downPayment');
            this.convertNumberToCurrency(rollOverAmt, 'rolloverAmount');
            this.prodConfigGroup.patchValue({
                paymentFull: this.payFull || false,
                paymentInstallment: this.payInstall || false,
                autoPaymentYes: this.autoPayYes || false,
                autoPaymentNo: this.autoPayNo || false,
                contractNo: this.contractPayment.contractNo || '',
                officeCode: this.contractPayment.officeId || 1,
                promotionOffer: this.contractPayment.promotionId || -1,
                contract: $("#contract option:selected").val() ? +$("#contract option:selected").val() : this.contractPayment.productId || 1,
                firstDueDate: this.contractPayment.firstDueDate || '',
                unpaidBalance: this.contractPayment.unpaidBalance || 0,
                regularPayment: this.contractPayment.regularPayment || 0,
                firstPayment: this.contractPayment.firstPayment || 0,
                months: this.contractPayment.months || 0,
                APR: this.contractPayment.APR || 0,
                totalSalePrice: this.contractPayment.totalSalePrice || 0,
                totalPayment: this.contractPayment.totalPayment || 0,
                financeChargeB: this.contractPayment.financeChargeB || 0,
                financeChargeA: this.contractPayment.financeChargeA || 0,
                financeCharge: this.contractPayment.financeCharge || 0,
                financeAmount: this.contractPayment.financeAmount || 0,
                financeAmountA: this.contractPayment.financeAmountA || 0,
                financeAmountB: this.contractPayment.financeAmountB || 0,
            });
            this.productId = $("#contract option:selected").val() ? +$("#contract option:selected").val() : this.contractPayment.productId || 1
            if (source == "OnLoad") {
                this.prodConfigGroup.patchValue({
                    repaymentTerm: this.contractPayment.repaymentTermId ? this.contractPayment.repaymentTermId :
                        this.contractSession.CountryID > 2 && (this.contractSession.productId == 1 || this.contractSession.productId == 2 || this.contractSession.productId == 6 || this.contractSession.productId == 11) ? 2
                            : this.contractSession.CountryID > 2 && ((this.contractSession.productId >= 3 && this.contractSession.productId <= 10 && this.contractSession.productId != 6 && this.contractSession.productId != 11) || this.contractSession.productId == 7 || this.contractSession.productId == 8 || this.contractSession.productId == 12 || this.contractSession.productId == 13 || this.contractSession.productId == 14) ? 11 : 3,
                });
            }
        }
        this.identifyFinaldocument();
    }

    private copyDataObjectToPayFormValues() {
        this.collectPaymentGroup.patchValue({
            paymentType: false,
            fileNo: false
        });
        if (!isNullOrUndefined(this.contractMultiPayments) && this.contractMultiPayments.length > 0) {
            this.collectPaymentGroup.patchValue({
                chkBankName: this.contractMultiPayments[0].chkBankName || '',
                chkCity: this.contractMultiPayments[0].chkCity || '',
                chkState: this.contractMultiPayments[0].chkState || '',
                chkRoutingNo: this.contractMultiPayments[0].chkRoutingNo || '',
                chkAccNo: this.contractMultiPayments[0].chkAccNo || '',
                chkNumber: this.contractMultiPayments[0].chkNumber || '',
                bankAccountName: this.contractMultiPayments[0].bankAccountName || '',
            });
            $("#chkDate").val(this.contractMultiPayments[0].chkDate);
        }
    }

    private copyInfoCollectValuesToDataObject(frmName) {
        if (this.contractSession && this.contractSession.sendToCorp) {
            this.contractSession.sendToCorp = false;
            this.contractSession.productId = + $("#contract option:selected").val();
            this.CreateUpdate_ContractSession();
        }
        /*BIP Form*/
        if (this.contractSession && frmName == "BIP") {
            this.contractSession.ContractSessionId = this.contractSessionId;
            this.contractSession.I1CLPContactId = this.contactId;
            this.contractSession.I2CLPContactId = this.contactId2;
            this.contractSession.CLPUserId = this.clpUserId;
            this.contractSession.HasIllustrations = this.prodConfigGroup.controls.hasillustrations.value || false;
            this.contractSession.IsProductInProduction = this.prodConfigGroup.controls.isproductinproduction.value || false;
            this.contractSession.IsClientInventory = this.prodConfigGroup.controls.isclientinventory.value || false;
            this.contractSession.HasPhotographs = this.prodConfigGroup.controls.hasphotographs.value || false;
            this.contractSession.HasCopyrightTradmark = this.prodConfigGroup.controls.hascopyrighttradmark.value || false;
            this.contractSession.HasPrototype = this.prodConfigGroup.controls.hasprototype.value || false;
            this.contractSession.HasPatentPending = this.prodConfigGroup.controls.haspatentpending.value || false;
            this.contractSession.IsPatentIssued = this.prodConfigGroup.controls.ispatentissued.value || false;
            this.contractSession.PatentIssuedNumber = this.prodConfigGroup.controls.patentissuednumber.value || '';
            this.contractSession.isPPSOConfirmed = true;

            this.saveBIP();
        }

        //SUB Form
        if (this.addendumServicesResponse.addendum && frmName == "SUB") {
            if (this.inventionId > 0)
                this.addendumServicesResponse.addendum.inventionId = this.inventionId;

            this.addendumServicesResponse.addendum.contractSessionId = this.contractSessionId;
            this.addendumServicesResponse.addendum.clpUserId = this.clpUserId;

            this.addendumServicesResponse.addendum.isNoService = this.prodConfigGroup.controls.isNoService.value || false;
            this.addendumServicesResponse.addendum.isAddendumB = this.prodConfigGroup.controls.isAddendumB.value || false;
            this.addendumServicesResponse.addendum.isAddendumG = this.prodConfigGroup.controls.isAddendumG.value || false;
            this.addendumServicesResponse.addendum.isAddendumP = this.prodConfigGroup.controls.isAddendumP.value || false;
            this.addendumServicesResponse.addendum.isPatentServices = this.prodConfigGroup.controls.isPatentServices.value || false;
            this.addendumServicesResponse.addendum.productId = + $("#contract option:selected").val();
            this.saveSUB();

            if (this.productId >= 9 && this.productId < 11) {
                this.contractSession.ContractSessionId = this.contractSessionId;
                this.contractSession.I1CLPContactId = this.contactId;
                this.contractSession.I2CLPContactId = this.contactId2;
                this.contractSession.CLPUserId = this.clpUserId;
                this.contractSession.HasIllustrations = this.prodConfigGroup.controls.hasillustrations.value || false;
                this.contractSession.IsProductInProduction = this.prodConfigGroup.controls.isproductinproduction.value || false;
                this.contractSession.IsClientInventory = this.prodConfigGroup.controls.isclientinventory.value || false;
                this.contractSession.HasPhotographs = this.prodConfigGroup.controls.hasphotographs.value || false;
                this.contractSession.HasCopyrightTradmark = this.prodConfigGroup.controls.hascopyrighttradmark.value || false;
                this.contractSession.HasPrototype = this.prodConfigGroup.controls.hasprototype.value || false;
                this.contractSession.HasPatentPending = this.prodConfigGroup.controls.haspatentpending.value || false;
                this.contractSession.IsPatentIssued = this.prodConfigGroup.controls.ispatentissued.value || false;
                this.contractSession.PatentIssuedNumber = this.prodConfigGroup.controls.patentissuednumber.value || '';
                this.contractSession.isPPSOConfirmed = true;
                this.saveBIP();
            }
        }
        //IMP Form
        if (this.contractSession && frmName == "IMP") {

            this.contractSession.ContractSessionId = this.contractSessionId;
            this.contractSession.I1CLPContactId = this.contactId;
            this.contractSession.I2CLPContactId = this.contactDetails.contactid1;
            this.contractSession.CLPUserId = this.clpUserId;
            this.contractSession.isIMPAuth = this.prodConfigGroup.controls.isIMPAgree.value || false;
            this.saveIMP();
        }

        if (this.inventorInformation && frmName == "InfoInvent") {
            if (this.inventionId > 0)
                this.inventorInformation.inventionId = this.inventionId;

            if (this.contractSessionId > 0)
                this.inventorInformation.contractSessionId = this.contractSessionId;

            this.inventorInformation.i1CLPContactId = this.contactDetails.contactid;
            this.inventorInformation.i2CLPContactId = this.contactDetails.contactid1;

            /*Information For InventHelp - Buyer*/
            this.inventorInformation.i1DOB = $("#i1DOB").val() || '';
            this.inventorInformation.i1SSN = this.prodConfigGroup.controls.i1SSN.value || '';
            this.inventorInformation.i1AddressYear = this.prodConfigGroup.controls.i1AddressYear.value || 0;
            this.inventorInformation.i1AddressMonth = this.prodConfigGroup.controls.i1AddressMonth.value || 0;

            if (this.prodConfigGroup.controls.i1HomeOwner.value == true)
                this.inventorInformation.i1HomeType = 1;
            else if (this.prodConfigGroup.controls.i1HomeRent.value == true)
                this.inventorInformation.i1HomeType = 2;
            else if (this.prodConfigGroup.controls.i1HomeOther.value == true)
                this.inventorInformation.i1HomeType = 3;

            this.inventorInformation.i1PreviousHomeAdd = this.prodConfigGroup.controls.i1PreviousHomeAdd.value || '';
            this.inventorInformation.i1PreviousHomeCity = this.prodConfigGroup.controls.i1PreviousHomeCity.value || '';
            this.inventorInformation.i1PreviousHomeState = this.prodConfigGroup.controls.i1PreviousHomeState.value || '';
            this.inventorInformation.i1PreviousHomeZip = this.prodConfigGroup.controls.i1PreviousHomeZip.value || '';
            this.inventorInformation.i1PreviousAddYear = this.prodConfigGroup.controls.i1PreviousAddYear.value || 0;
            this.inventorInformation.i1PreviousAddMonth = this.prodConfigGroup.controls.i1PreviousAddMonth.value || 0;

            this.inventorInformation.i1PresentPosition = this.prodConfigGroup.controls.i1PresentPosition.value || '';
            this.inventorInformation.i1PresentEmp = this.prodConfigGroup.controls.i1PresentEmp.value || '';
            this.inventorInformation.i1PresentEmpYear = this.prodConfigGroup.controls.i1PresentEmpYear.value || 0;
            this.inventorInformation.i1PresentEmpMonth = this.prodConfigGroup.controls.i1PresentEmpMonth.value || 0;
            this.inventorInformation.i1PresentMonthlyInc = this.prodConfigGroup.controls.i1PresentMonthlyInc.value || 0;

            this.inventorInformation.i1BusinessAdd = this.prodConfigGroup.controls.i1BusinessAdd.value || '';
            this.inventorInformation.i1BusinessHomeCity = this.prodConfigGroup.controls.i1BusinessHomeCity.value || '';
            this.inventorInformation.i1BusinessHomeState = this.prodConfigGroup.controls.i1BusinessHomeState.value || '';
            this.inventorInformation.i1BusinessHomeZip = this.prodConfigGroup.controls.i1BusinessHomeZip.value || '';
            this.inventorInformation.i1BusinessPhone = this.prodConfigGroup.controls.i1BusinessPhone.value || '';
            this.inventorInformation.i1PreviousEmpName = this.prodConfigGroup.controls.i1PreviousEmpName.value || '';
            this.inventorInformation.i1PreviousEmpPos = this.prodConfigGroup.controls.i1PreviousEmpPos.value || '';
            this.inventorInformation.i1PreviousEmpAdd = this.prodConfigGroup.controls.i1PreviousEmpAdd.value || '';
            this.inventorInformation.i1PreviousEmpYear = this.prodConfigGroup.controls.i1PreviousEmpYear.value || 0;
            this.inventorInformation.i1PreviousEmpMonth = this.prodConfigGroup.controls.i1PreviousEmpMonth.value || 0;
            this.inventorInformation.i1PreviousMonthlyInc = this.prodConfigGroup.controls.i1PreviousMonthlyInc.value || 0;

            this.inventorInformation.i1MonthlytOtherInc = this.prodConfigGroup.controls.i1MonthlytOtherInc.value || 0;
            this.inventorInformation.iI1MonthlyOtherIncSrc = this.prodConfigGroup.controls.iI1MonthlyOtherIncSrc.value || '';

            this.inventorInformation.i1RelativeName = this.prodConfigGroup.controls.i1RelativeName.value || '';
            this.inventorInformation.i1RelativeAdd = this.prodConfigGroup.controls.i1RelativeAdd.value || '';
            this.inventorInformation.i1RelativeCity = this.prodConfigGroup.controls.i1RelativeCity.value || '';
            this.inventorInformation.i1RelativeState = this.prodConfigGroup.controls.i1RelativeState.value || '';
            this.inventorInformation.i1RelativeRelation = this.prodConfigGroup.controls.i1RelativeRelation.value || '';
            this.inventorInformation.i1RelativePhone = this.prodConfigGroup.controls.i1RelativePhone.value || '';

            /*Information For InventHelp - Co-Buyer*/

            this.inventorInformation.i2DOB = $("#i2DOB").val() || '';
            this.inventorInformation.i2SSN = this.prodConfigGroup.controls.i2SSN.value || '';
            this.inventorInformation.i2PresentHomeAdd1 = this.prodConfigGroup.controls.i2PresentHomeAdd1.value || '';
            this.inventorInformation.i2PresentHomeAdd2 = this.prodConfigGroup.controls.i2PresentHomeAdd2.value || '';
            this.inventorInformation.i2PresentHomeCity = this.prodConfigGroup.controls.i2PresentHomeCity.value || '';
            this.inventorInformation.i2PresentHomeState = this.prodConfigGroup.controls.i2PresentHomeState.value || '';
            this.inventorInformation.i2PresentHomeZip = this.prodConfigGroup.controls.i2PresentHomeZip.value || '';
            this.inventorInformation.i2PresentPhone = this.prodConfigGroup.controls.i2PresentPhone.value || '';
            this.inventorInformation.i2RelationshipI1 = this.prodConfigGroup.controls.i2RelationshipI1.value || '';

            this.inventorInformation.i2PresentPosition = this.prodConfigGroup.controls.i2PresentPosition.value || '';
            this.inventorInformation.i2PresentEmp = this.prodConfigGroup.controls.i2PresentEmp.value || '';
            this.inventorInformation.i2PresentEmpYear = this.prodConfigGroup.controls.i2PresentEmpYear.value || 0;
            this.inventorInformation.i2PresentEmpMonth = this.prodConfigGroup.controls.i2PresentEmpMonth.value || 0;
            this.inventorInformation.i2PresentMonthlyInc = this.prodConfigGroup.controls.i2PresentMonthlyInc.value || 0;

            this.inventorInformation.i2BusinessAdd = this.prodConfigGroup.controls.i2BusinessAdd.value || '';
            this.inventorInformation.i2BusinessHomeCity = this.prodConfigGroup.controls.i2BusinessHomeCity.value || '';
            this.inventorInformation.i2BusinessHomeState = this.prodConfigGroup.controls.i2BusinessHomeState.value || '';
            this.inventorInformation.i2BusinessHomeZip = this.prodConfigGroup.controls.i2BusinessHomeZip.value || '';
            this.inventorInformation.i2BusinessPhone = this.prodConfigGroup.controls.i2BusinessPhone.value || '';

            this.inventorInformation.i2PreviousEmpName = this.prodConfigGroup.controls.i2PreviousEmpName.value || '';
            this.inventorInformation.i2PreviousEmpPos = this.prodConfigGroup.controls.i2PreviousEmpPos.value || '';
            this.inventorInformation.i2PreviousEmpAdd = this.prodConfigGroup.controls.i2PreviousEmpAdd.value || '';
            this.inventorInformation.i2PreviousEmpYear = this.prodConfigGroup.controls.i2PreviousEmpYear.value || 0;
            this.inventorInformation.i2PreviousEmpMonth = this.prodConfigGroup.controls.i2PreviousEmpMonth.value || 0;
            this.inventorInformation.i2PreviousMonthlyInc = this.prodConfigGroup.controls.i2PreviousMonthlyInc.value || 0;

            this.inventorInformation.i2MonthlytOtherInc = this.prodConfigGroup.controls.i2MonthlytOtherInc.value || 0;
            this.inventorInformation.i2MonthlyOtherIncSrc = this.prodConfigGroup.controls.i2MonthlyOtherIncSrc.value || '';
            this.saveInventorInvention();
        }

        if (this.universalPayment && frmName == "UniPay") {

            this.universalPayment.inventionId = this.inventionId;
            this.universalPayment.contractSessionId = this.contractSessionId;
            this.universalPayment.chkSaveAc = this.contractSession.CountryID > 2 ? false : this.prodConfigGroup.controls.chkSaveAc.value || false;
            this.universalPayment.bankName = this.prodConfigGroup.controls.bankName.value || '';
            this.universalPayment.ABANo = this.prodConfigGroup.controls.ABANo.value || '';
            this.universalPayment.chkAcNo = this.prodConfigGroup.controls.chkAcNo.value || '';
            this.universalPayment.accountType = this.prodConfigGroup.controls.accountType.value || -1;
            this.universalPayment.chkCCard = this.contractSession.CountryID > 2 ? true : this.prodConfigGroup.controls.chkCCard.value || false;
            this.universalPayment.cCardNo = this.prodConfigGroup.controls.cCardNo.value || '';
            this.universalPayment.cCardExpDT = this.prodConfigGroup.controls.cCardExpDT.value || '';
            this.universalPayment.cCardCVV = this.prodConfigGroup.controls.cCardCVV.value || '';
            this.universalPayment.altDayMonth = this.prodConfigGroup.controls.altDayMonth.value || '';
            this.universalPayment.altAmount = this.prodConfigGroup.controls.altAmount.value ? this.prodConfigGroup.controls.altAmount.value.toString().replace(this.currencySterling, "").replace(',', "") : 0;
            this.universalPayment.cardType = '';
            this.universalPayment.chkNoAutoPay = this.contractSession.CountryID == 2 ? this.prodConfigGroup.controls.chkNoAutoPay.value != '' ? true : false : false;

            if (this.universalPayment.chkCCard) {
                this.universalPayment.cardType = this.cc_brand_type(this.universalPayment.cCardNo);
            }

            this.saveUtilityPayment();
        }

        /*Invention CheckList Form*/
        if (this.inventionCheckListResponse?.inventionCheckList && frmName == "CheckList") {
            if (this.inventionId > 0)
                this.inventionCheckListResponse.inventionCheckList.inventionId = this.inventionId;
            this.inventionCheckListResponse.inventionCheckList.productId = this.productId;
            this.inventionCheckListResponse.inventionCheckList.contractSessionId = this.contractSessionId;
            this.inventionCheckListResponse.inventionCheckList.clpUserId = this.clpUserId;

            this.prodConfigGroup.controls.isSubmitYes.value ? this.inventionCheckListResponse.inventionCheckList.isSubmit = true : this.inventionCheckListResponse.inventionCheckList.isSubmit = false;
            this.prodConfigGroup.controls.isSubmitNo.value ? this.inventionCheckListResponse.inventionCheckList.isSubmit = false : this.inventionCheckListResponse.inventionCheckList.isSubmit = true;
            this.prodConfigGroup.controls.isAcceptYes.value ? this.inventionCheckListResponse.inventionCheckList.isAccept = true : this.inventionCheckListResponse.inventionCheckList.isAccept = false;
            this.prodConfigGroup.controls.isAcceptNo.value ? this.inventionCheckListResponse.inventionCheckList.isAccept = false : this.inventionCheckListResponse.inventionCheckList.isAccept = true;
            this.prodConfigGroup.controls.isDataBankYes.value ? this.inventionCheckListResponse.inventionCheckList.isDataBank = true : this.inventionCheckListResponse.inventionCheckList.isDataBank = false;
            this.prodConfigGroup.controls.isDataBankNo.value ? this.inventionCheckListResponse.inventionCheckList.isDataBank = false : this.inventionCheckListResponse.inventionCheckList.isDataBank = true;
            this.prodConfigGroup.controls.isSolicitsYes.value ? this.inventionCheckListResponse.inventionCheckList.isSolicits = true : this.inventionCheckListResponse.inventionCheckList.isSolicits = false;
            this.prodConfigGroup.controls.isSolicitsNo.value ? this.inventionCheckListResponse.inventionCheckList.isSolicits = false : this.inventionCheckListResponse.inventionCheckList.isSolicits = true;
            this.prodConfigGroup.controls.isPrepareYes.value ? this.inventionCheckListResponse.inventionCheckList.isPrepare = true : this.inventionCheckListResponse.inventionCheckList.isPrepare = false;
            this.prodConfigGroup.controls.isPrepareNo.value ? this.inventionCheckListResponse.inventionCheckList.isPrepare = false : this.inventionCheckListResponse.inventionCheckList.isPrepare = true;
            this.prodConfigGroup.controls.isStaffYes.value ? this.inventionCheckListResponse.inventionCheckList.isStaff = true : this.inventionCheckListResponse.inventionCheckList.isStaff = false;
            this.prodConfigGroup.controls.isStaffNo.value ? this.inventionCheckListResponse.inventionCheckList.isStaff = false : this.inventionCheckListResponse.inventionCheckList.isStaff = true;
            this.prodConfigGroup.controls.isBIPSYes.value ? this.inventionCheckListResponse.inventionCheckList.isBIPS = true : this.inventionCheckListResponse.inventionCheckList.isBIPS = false;
            this.prodConfigGroup.controls.isBIPSNo.value ? this.inventionCheckListResponse.inventionCheckList.isBIPS = false : this.inventionCheckListResponse.inventionCheckList.isBIPS = true;
            this.prodConfigGroup.controls.isPRSYes.value ? this.inventionCheckListResponse.inventionCheckList.isPRS = true : this.inventionCheckListResponse.inventionCheckList.isPRS = false;
            this.prodConfigGroup.controls.isPRSNo.value ? this.inventionCheckListResponse.inventionCheckList.isPRS = false : this.inventionCheckListResponse.inventionCheckList.isPRS = true;
            this.prodConfigGroup.controls.isSoldYes.value ? this.inventionCheckListResponse.inventionCheckList.isSold = true : this.inventionCheckListResponse.inventionCheckList.isSold = false;
            this.prodConfigGroup.controls.isSoldNo.value ? this.inventionCheckListResponse.inventionCheckList.isSold = false : this.inventionCheckListResponse.inventionCheckList.isSold = true;
            this.prodConfigGroup.controls.isSendYes.value ? this.inventionCheckListResponse.inventionCheckList.isSend = true : this.inventionCheckListResponse.inventionCheckList.isSend = false;
            this.prodConfigGroup.controls.isSendNo.value ? this.inventionCheckListResponse.inventionCheckList.isSend = false : this.inventionCheckListResponse.inventionCheckList.isSend = true;
            this.prodConfigGroup.controls.isIdeasYes.value ? this.inventionCheckListResponse.inventionCheckList.isIdeas = true : this.inventionCheckListResponse.inventionCheckList.isIdeas = false;
            this.prodConfigGroup.controls.isIdeasNo.value ? this.inventionCheckListResponse.inventionCheckList.isIdeas = false : this.inventionCheckListResponse.inventionCheckList.isIdeas = true;
            this.prodConfigGroup.controls.isShowsYes.value ? this.inventionCheckListResponse.inventionCheckList.isShows = true : this.inventionCheckListResponse.inventionCheckList.isShows = false;
            this.prodConfigGroup.controls.isShowsNo.value ? this.inventionCheckListResponse.inventionCheckList.isShows = false : this.inventionCheckListResponse.inventionCheckList.isShows = true;
            this.prodConfigGroup.controls.isWorkBrochureYes.value ? this.inventionCheckListResponse.inventionCheckList.isWorkBrochure = true : this.inventionCheckListResponse.inventionCheckList.isWorkBrochure = false;
            this.prodConfigGroup.controls.isWorkBrochureNo.value ? this.inventionCheckListResponse.inventionCheckList.isWorkBrochure = false : this.inventionCheckListResponse.inventionCheckList.isWorkBrochure = true;
            this.prodConfigGroup.controls.isBIPYes.value ? this.inventionCheckListResponse.inventionCheckList.isBIP = true : this.inventionCheckListResponse.inventionCheckList.isBIP = false;
            this.prodConfigGroup.controls.isBIPNo.value ? this.inventionCheckListResponse.inventionCheckList.isBIP = false : this.inventionCheckListResponse.inventionCheckList.isBIP = true;
            this.prodConfigGroup.controls.isBIPReportYes.value ? this.inventionCheckListResponse.inventionCheckList.isBIPReport = true : this.inventionCheckListResponse.inventionCheckList.isBIPReport = false;
            if (this.prodConfigGroup.controls.isBIPReportNo.value) this.inventionCheckListResponse.inventionCheckList.isBIPReport = false;
            if (this.prodConfigGroup.controls.isNABIPReport.value) this.inventionCheckListResponse.inventionCheckList.isNABIPReport = true; else this.inventionCheckListResponse.inventionCheckList.isNABIPReport = false;
            this.prodConfigGroup.controls.isServiceFeesYes.value ? this.inventionCheckListResponse.inventionCheckList.isServiceFees = true : this.inventionCheckListResponse.inventionCheckList.isServiceFees = false;
            this.prodConfigGroup.controls.isServiceFeesNo.value ? this.inventionCheckListResponse.inventionCheckList.isServiceFees = false : this.inventionCheckListResponse.inventionCheckList.isServiceFees = true;
            this.prodConfigGroup.controls.isADSYes.value ? this.inventionCheckListResponse.inventionCheckList.isADS = true : this.inventionCheckListResponse.inventionCheckList.isADS = false;
            this.prodConfigGroup.controls.isADSNo.value ? this.inventionCheckListResponse.inventionCheckList.isADS = false : this.inventionCheckListResponse.inventionCheckList.isADS = true;
            this.prodConfigGroup.controls.isNDAYes.value ? this.inventionCheckListResponse.inventionCheckList.isNDA = true : this.inventionCheckListResponse.inventionCheckList.isNDA = false;
            this.prodConfigGroup.controls.isNDANo.value ? this.inventionCheckListResponse.inventionCheckList.isNDA = false : this.inventionCheckListResponse.inventionCheckList.isNDA = true;
            this.prodConfigGroup.controls.isPRSBrochureYes.value ? this.inventionCheckListResponse.inventionCheckList.isPRSBrochure = true : this.inventionCheckListResponse.inventionCheckList.isPRSBrochure = false;
            this.prodConfigGroup.controls.isPRSBrochureNo.value ? this.inventionCheckListResponse.inventionCheckList.isPRSBrochure = false : this.inventionCheckListResponse.inventionCheckList.isPRSBrochure = true;
            this.prodConfigGroup.controls.isPPSOYes.value ? this.inventionCheckListResponse.inventionCheckList.isPPSO = true : this.inventionCheckListResponse.inventionCheckList.isPPSO = false;
            if (this.prodConfigGroup.controls.isPPSONo.value) this.inventionCheckListResponse.inventionCheckList.isPPSO = false;
            if (this.prodConfigGroup.controls.isNAPPSO.value) this.inventionCheckListResponse.inventionCheckList.isNAPPSO = true; else this.inventionCheckListResponse.inventionCheckList.isNAPPSO = false;
            this.prodConfigGroup.controls.comments.value == '' ? this.inventionCheckListResponse.inventionCheckList.comments = '' : this.inventionCheckListResponse.inventionCheckList.comments = this.prodConfigGroup.controls.comments.value;
            this.prodConfigGroup.controls.bestTimeToReach.value == '' ? this.inventionCheckListResponse.inventionCheckList.bestTimeToReach = '' : this.inventionCheckListResponse.inventionCheckList.bestTimeToReach = this.prodConfigGroup.controls.bestTimeToReach.value;

            this.prodConfigGroup.controls.isSolicitYes.value ? this.inventionCheckListResponse.inventionCheckList.isSolicitYes = true : this.inventionCheckListResponse.inventionCheckList.isSolicitYes = false;
            this.prodConfigGroup.controls.isSolicitNo.value ? this.inventionCheckListResponse.inventionCheckList.isSolicitYes = false : this.inventionCheckListResponse.inventionCheckList.isSolicitYes = true;
            this.prodConfigGroup.controls.isRefineYes.value ? this.inventionCheckListResponse.inventionCheckList.isRefineYes = true : this.inventionCheckListResponse.inventionCheckList.isRefineYes = false;
            this.prodConfigGroup.controls.isRefineNo.value ? this.inventionCheckListResponse.inventionCheckList.isRefineYes = false : this.inventionCheckListResponse.inventionCheckList.isRefineYes = true;
            this.prodConfigGroup.controls.isIndependentYes.value ? this.inventionCheckListResponse.inventionCheckList.isIndependentYes = true : this.inventionCheckListResponse.inventionCheckList.isIndependentYes = false;
            this.prodConfigGroup.controls.isIndependentNo.value ? this.inventionCheckListResponse.inventionCheckList.isIndependentYes = false : this.inventionCheckListResponse.inventionCheckList.isIndependentYes = true;
            this.prodConfigGroup.controls.isAttorneyYes.value ? this.inventionCheckListResponse.inventionCheckList.isAttorneyYes = true : this.inventionCheckListResponse.inventionCheckList.isAttorneyYes = false;
            this.prodConfigGroup.controls.isAttorneyNo.value ? this.inventionCheckListResponse.inventionCheckList.isAttorneyYes = false : this.inventionCheckListResponse.inventionCheckList.isAttorneyYes = true;
            this.prodConfigGroup.controls.isPurchasedYes.value ? this.inventionCheckListResponse.inventionCheckList.isPurchasedYes = true : this.inventionCheckListResponse.inventionCheckList.isPurchasedYes = false;
            this.prodConfigGroup.controls.isPurchasedNo.value ? this.inventionCheckListResponse.inventionCheckList.isPurchasedYes = false : this.inventionCheckListResponse.inventionCheckList.isPurchasedYes = true;

            this.saveInventionCheckList();
        }
    }

    cc_brand_type(cur_val) {
        let jcb_regex = new RegExp('^(?:2131|1800|35)[0-9]{0,}$');
        let amex_regex = new RegExp('^3[47][0-9]{0,}$');
        let diners_regex = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$');
        let visa_regex = new RegExp('^4[0-9]{0,}$');
        let mastercard_regex = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$');
        let maestro_regex = new RegExp('^(5[06789]|6)[0-9]{0,}$');
        let discover_regex = new RegExp('^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$');

        cur_val = cur_val.replace(/\D/g, '');

        var sel_brand = "unknown";
        if (cur_val.match(jcb_regex)) {
            sel_brand = "JCB";
        } else if (cur_val.match(amex_regex)) {
            sel_brand = "AMEX";
        } else if (cur_val.match(diners_regex)) {
            sel_brand = "DINERS_CLUB";
        } else if (cur_val.match(visa_regex)) {
            sel_brand = "VISA";
        } else if (cur_val.match(mastercard_regex)) {
            sel_brand = "MASTERCARD";
        } else if (cur_val.match(discover_regex)) {
            sel_brand = "DISCOVER";
        } else if (cur_val.match(maestro_regex)) {
            if (cur_val[0] == '5') {
                sel_brand = "MASTERCARD";
            } else {
                sel_brand = "MAESTRO";
            }
        }
        return sel_brand;
    }

    private copyDataObjectToInfoCollectValues() {
        if (this.contractSession) {
            this.contractSession.PatentIssuedNumber ? this.setInfoCollecControl('patentissuednumber', true) : this.setInfoCollecControl('patentissuednumber', false);
            this.isSendToCorp = this.contractSession.sendToCorp;
            this.isCancelled = this.contractSession.isCancelled;

            this.prodConfigGroup.patchValue({
                hasillustrations: this.contractSession.HasIllustrations || false,
                isproductinproduction: this.contractSession.IsProductInProduction || false,
                isclientinventory: this.contractSession.IsClientInventory || false,
                hasphotographs: this.contractSession.HasPhotographs || false,
                hascopyrighttradmark: this.contractSession.HasCopyrightTradmark || false,
                ispatentissued: this.contractSession.IsPatentIssued || false,
                hasprototype: this.contractSession.HasPrototype || false,
                haspatentpending: this.contractSession.HasPatentPending || false,
                haspatentinterestuseevolve: this.contractSession.HasPatentInterestUseEvolve || false,
                haspatentinterestuseown: this.contractSession.HasPatentInterestUseOwn || false,
                hasnopatentinterest: this.contractSession.HasNoPatentInterest || false,
                patentissuednumber: this.contractSession.PatentIssuedNumber || '',
            });
        }

        if (this.addendumServicesResponse) {
            this.prodConfigGroup.patchValue({
                isNoService: this.addendumServicesResponse.addendum.isNoService || '',
                isAddendumB: this.addendumServicesResponse.addendum.isAddendumB || '',
                isAddendumG: this.addendumServicesResponse.addendum.isAddendumG || '',
                isAddendumP: this.addendumServicesResponse.addendum.isAddendumP || '',
                isPatentServices: this.addendumServicesResponse.addendum.isPatentServices || '',
            })
        }

        if (this.contractSession) {
            this.prodConfigGroup.patchValue({
                isIMPAgree: this.contractSession.isIMPAuth || ''

            })
        }

        if (this.inventorInformation) {
            /*Information For InventHelp - Buyer*/
            $("#i1DOB").val(this.inventorInformation.i1DOB);
            $("#i2DOB").val(this.inventorInformation.i2DOB);

            if (this.inventorInformation.i1SSN)
                this._i1SSN = this.inventorInformation.i1SSN;
            this.prodConfigGroup.patchValue({
                i1SSN: this.inventorInformation.i1SSN != "" ? this.inventorInformation.i1SSN : '',
                i1SSNMask: this.inventorInformation.i1SSN != "" ? this.getSSNMaskString(this.inventorInformation.i1SSN) : '',
                i1HomeOwner: this.inventorInformation.i1HomeType == 1 ? true : false,
                i1HomeRent: this.inventorInformation.i1HomeType == 2 ? true : false,
                i1HomeOther: this.inventorInformation.i1HomeType == 3 ? true : false,

                i1AddressYear: this.inventorInformation.i1AddressYear || 0,
                i1AddressMonth: this.inventorInformation.i1AddressMonth || 0,
                /*Home Owner ToDo*/
                i1PreviousHomeAdd: this.inventorInformation.i1PreviousHomeAdd || '',
                i1PreviousHomeCity: this.inventorInformation.i1PreviousHomeCity || '',
                i1PreviousHomeState: this.inventorInformation.i1PreviousHomeState || '',
                i1PreviousHomeZip: this.inventorInformation.i1PreviousHomeZip || '',
                i1PreviousAddYear: this.inventorInformation.i1PreviousAddYear || 0,
                i1PreviousAddMonth: this.inventorInformation.i1PreviousAddMonth || 0,

                i1PresentPosition: this.inventorInformation.i1PresentPosition || '',
                i1PresentEmp: this.inventorInformation.i1PresentEmp || '',
                i1PresentEmpYear: this.inventorInformation.i1PresentEmpYear || 0,
                i1PresentEmpMonth: this.inventorInformation.i1PresentEmpMonth || 0,
                i1PresentMonthlyInc: this.inventorInformation.i1PresentMonthlyInc || 0,

                i1BusinessAdd: this.inventorInformation.i1BusinessAdd || '',
                i1BusinessHomeCity: this.inventorInformation.i1BusinessHomeCity || '',
                i1BusinessHomeState: this.inventorInformation.i1BusinessHomeState || '',
                i1BusinessHomeZip: this.inventorInformation.i1BusinessHomeZip || '',
                i1BusinessPhone: this.inventorInformation.i1BusinessPhone || '',

                i1PreviousEmpName: this.inventorInformation.i1PreviousEmpName || '',
                i1PreviousEmpPos: this.inventorInformation.i1PreviousEmpPos || '',
                i1PreviousEmpAdd: this.inventorInformation.i1PreviousEmpAdd || '',
                i1PreviousEmpYear: this.inventorInformation.i1PreviousEmpYear || 0,
                i1PreviousEmpMonth: this.inventorInformation.i1PreviousEmpMonth || 0,
                i1PreviousMonthlyInc: this.inventorInformation.i1PreviousMonthlyInc || 0,

                i1MonthlytOtherInc: this.inventorInformation.i1MonthlytOtherInc || 0,
                iI1MonthlyOtherIncSrc: this.inventorInformation.iI1MonthlyOtherIncSrc || '',

                i1RelativeName: this.inventorInformation.i1RelativeName || '',
                i1RelativeAdd: this.inventorInformation.i1RelativeAdd || '',
                i1RelativeCity: this.inventorInformation.i1RelativeCity || '',
                i1RelativeState: this.inventorInformation.i1RelativeState || '',
                i1RelativeRelation: this.inventorInformation.i1RelativeRelation || '',
                i1RelativePhone: this.inventorInformation.i1RelativePhone || '',

                /*Information For InventHelp - Co-Buyer*/
                i2SSN: this.inventorInformation.i2SSN != "" ? this.inventorInformation.i2SSN : '',

                i2PresentHomeAdd1: this.inventorInformation.i2PresentHomeAdd1 || '',
                i2PresentHomeAdd2: this.inventorInformation.i2PresentHomeAdd2 || '',
                i2PresentHomeCity: this.inventorInformation.i2PresentHomeCity || '',
                i2PresentHomeState: this.inventorInformation.i2PresentHomeState || '',
                i2PresentHomeZip: this.inventorInformation.i2PresentHomeZip || '',
                i2PresentPhone: this.inventorInformation.i2PresentPhone || '',
                i2RelationshipI1: this.inventorInformation.i2RelationshipI1 || '',

                i2PresentPosition: this.inventorInformation.i2PresentPosition || '',
                i2PresentEmp: this.inventorInformation.i2PresentEmp || '',
                i2PresentEmpYear: this.inventorInformation.i2PresentEmpYear || '',
                i2PresentEmpMonth: this.inventorInformation.i2PresentEmpMonth || '',
                i2PresentMonthlyInc: this.inventorInformation.i2PresentMonthlyInc || '',

                i2BusinessAdd: this.inventorInformation.i2BusinessAdd || '',
                i2BusinessHomeCity: this.inventorInformation.i2BusinessHomeCity || '',
                i2BusinessHomeState: this.inventorInformation.i2BusinessHomeState || '',
                i2BusinessHomeZip: this.inventorInformation.i2BusinessHomeZip || '',
                i2BusinessPhone: this.inventorInformation.i2BusinessPhone || '',

                i2PreviousEmpName: this.inventorInformation.i2PreviousEmpName || '',
                i2PreviousEmpPos: this.inventorInformation.i2PreviousEmpPos || '',
                i2PreviousEmpAdd: this.inventorInformation.i2PreviousEmpAdd || '',
                i2PreviousEmpYear: this.inventorInformation.i2PreviousEmpYear || '',
                i2PreviousEmpMonth: this.inventorInformation.i2PreviousEmpMonth || '',
                i2PreviousMonthlyInc: this.inventorInformation.i2PreviousMonthlyInc || '',

                i2MonthlytOtherInc: this.inventorInformation.i2MonthlytOtherInc || '',
                i2MonthlyOtherIncSrc: this.inventorInformation.i2MonthlyOtherIncSrc || '',
            });
        }

        if (this.universalPayment) {
            var altAmount = this.universalPayment.altAmount ? this.universalPayment.altAmount : 0;
            this.convertNumberToCurrency(altAmount, 'altAmount');

            this.prodConfigGroup.patchValue({
                chkSaveAc: this.universalPayment.chkSaveAc || '',
                bankName: this.universalPayment.bankName || '',
                ABANo: this.universalPayment.ABANo || '',
                chkAcNo: this.universalPayment.chkAcNo || '',
                accountType: this.universalPayment.accountType || '-1',
                chkCCard: this.universalPayment.chkCCard || '',
                cCardNo: this.universalPayment.cCardNo || '',
                cCardExpDT: this.universalPayment.cCardExpDT || '',
                cCardCVV: this.universalPayment.cCardCVV || '',
                altDayMonth: this.universalPayment.altDayMonth || '',
                chkNoAutoPay: this.universalPayment.chkNoAutoPay || '',
            });

            if (this.universalPayment.chkSaveAc == true) {
                this.divPaySaveAc = true;
                this.divPayCard = false;
                this.divNoAutoPay = false;
            }
            else if (this.universalPayment.chkCCard == true) {
                this.divPaySaveAc = false;
                this.divNoAutoPay = false;
                this.divPayCard = true;
            }
            else if (this.universalPayment.chkNoAutoPay == true) {
                this.divPaySaveAc = false;
                this.divPayCard = false;
                this.divNoAutoPay = true;
                this.hideOptionalDoc = true;
            }
        }
        this.showSSnDiv = this.inventorInformation != null ? (this.inventorInformation.i1SSN ? true : false) : false;
    }

    copyDataObjectToInventionCheckListValue() {
        if (this.inventionCheckListResponse && this.inventionCheckListResponse.inventionCheckList) {

            this.prodConfigGroup.patchValue({
                isSubmitYes: this.inventionCheckListResponse.inventionCheckList.isSubmit == true ? true : false,
                isSubmitNo: this.inventionCheckListResponse.inventionCheckList.isSubmit == true ? false : this.inventionCheckListResponse.inventionCheckList.isSubmit == false ? true : false,

                isAcceptYes: this.inventionCheckListResponse.inventionCheckList.isAccept == true ? true : false,
                isAcceptNo: this.inventionCheckListResponse.inventionCheckList.isAccept == true ? false : this.inventionCheckListResponse.inventionCheckList.isAccept == false ? true : false,

                isDataBankYes: this.inventionCheckListResponse.inventionCheckList.isDataBank == true ? true : false,
                isDataBankNo: this.inventionCheckListResponse.inventionCheckList.isDataBank == true ? false : this.inventionCheckListResponse.inventionCheckList.isDataBank == false ? true : false,

                isSolicitsYes: this.inventionCheckListResponse.inventionCheckList.isSolicits == true ? true : false,
                isSolicitsNo: this.inventionCheckListResponse.inventionCheckList.isSolicits == true ? false : this.inventionCheckListResponse.inventionCheckList.isSolicits == false ? true : false,

                isPrepareYes: this.inventionCheckListResponse.inventionCheckList.isPrepare == true ? true : false,
                isPrepareNo: this.inventionCheckListResponse.inventionCheckList.isPrepare == true ? false : this.inventionCheckListResponse.inventionCheckList.isPrepare == false ? true : false,

                isStaffYes: this.inventionCheckListResponse.inventionCheckList.isStaff == true ? true : false,
                isStaffNo: this.inventionCheckListResponse.inventionCheckList.isStaff == true ? false : this.inventionCheckListResponse.inventionCheckList.isStaff == false ? true : false,

                isBIPSYes: this.inventionCheckListResponse.inventionCheckList.isBIPS == true ? true : false,
                isBIPSNo: this.inventionCheckListResponse.inventionCheckList.isBIPS == true ? false : this.inventionCheckListResponse.inventionCheckList.isBIPS == false ? true : false,

                isPRSYes: this.inventionCheckListResponse.inventionCheckList.isPRS == true ? true : false,
                isPRSNo: this.inventionCheckListResponse.inventionCheckList.isPRS == true ? false : this.inventionCheckListResponse.inventionCheckList.isPRS == false ? true : false,

                isSoldYes: this.inventionCheckListResponse.inventionCheckList.isSold == true ? true : false,
                isSoldNo: this.inventionCheckListResponse.inventionCheckList.isSold == true ? false : this.inventionCheckListResponse.inventionCheckList.isSold == false ? true : false,

                isSendYes: this.inventionCheckListResponse.inventionCheckList.isSend == true ? true : false,
                isSendNo: this.inventionCheckListResponse.inventionCheckList.isSend == true ? false : this.inventionCheckListResponse.inventionCheckList.isSend == false ? true : false,

                isIdeasYes: this.inventionCheckListResponse.inventionCheckList.isIdeas == true ? true : false,
                isIdeasNo: this.inventionCheckListResponse.inventionCheckList.isIdeas == true ? false : this.inventionCheckListResponse.inventionCheckList.isIdeas == false ? true : false,

                isShowsYes: this.inventionCheckListResponse.inventionCheckList.isShows == true ? true : false,
                isShowsNo: this.inventionCheckListResponse.inventionCheckList.isShows == true ? false : this.inventionCheckListResponse.inventionCheckList.isShows == false ? true : false,

                isWorkBrochureYes: this.inventionCheckListResponse.inventionCheckList.isWorkBrochure == true ? true : false,
                isWorkBrochureNo: this.inventionCheckListResponse.inventionCheckList.isWorkBrochure == true ? false : this.inventionCheckListResponse.inventionCheckList.isWorkBrochure == false ? true : false,

                isBIPYes: this.inventionCheckListResponse.inventionCheckList.isBIP == true ? true : false,
                isBIPNo: this.inventionCheckListResponse.inventionCheckList.isBIP == true ? false : this.inventionCheckListResponse.inventionCheckList.isBIP == false ? true : false,

                isServiceFeesYes: this.inventionCheckListResponse.inventionCheckList.isServiceFees == true ? true : false,
                isServiceFeesNo: this.inventionCheckListResponse.inventionCheckList.isServiceFees == true ? false : this.inventionCheckListResponse.inventionCheckList.isServiceFees == false ? true : false,

                isADSYes: this.inventionCheckListResponse.inventionCheckList.isADS == true ? true : false,
                isADSNo: this.inventionCheckListResponse.inventionCheckList.isADS == true ? false : this.inventionCheckListResponse.inventionCheckList.isADS == false ? true : false,

                isNDAYes: this.inventionCheckListResponse.inventionCheckList.isNDA == true ? true : false,
                isNDANo: this.inventionCheckListResponse.inventionCheckList.isNDA == true ? false : this.inventionCheckListResponse.inventionCheckList.isNDA == false ? true : false,

                isPRSBrochureYes: this.inventionCheckListResponse.inventionCheckList.isPRSBrochure == true ? true : false,
                isPRSBrochureNo: this.inventionCheckListResponse.inventionCheckList.isPRSBrochure == true ? false : this.inventionCheckListResponse.inventionCheckList.isPRSBrochure == false ? true : false,


                comments: this.inventionCheckListResponse.inventionCheckList.comments || '',
                bestTimeToReach: this.inventionCheckListResponse.inventionCheckList.bestTimeToReach || '',

                isSolicitYes: this.inventionCheckListResponse.inventionCheckList.isSolicitYes == true ? true : false,
                isSolicitNo: this.inventionCheckListResponse.inventionCheckList.isSolicitYes == true ? false : this.inventionCheckListResponse.inventionCheckList.isSolicitYes == false ? true : false,

                isRefineYes: this.inventionCheckListResponse.inventionCheckList.isRefineYes == true ? true : false,
                isRefineNo: this.inventionCheckListResponse.inventionCheckList.isRefineYes == true ? false : this.inventionCheckListResponse.inventionCheckList.isRefineYes == false ? true : false,

                isIndependentYes: this.inventionCheckListResponse.inventionCheckList.isIndependentYes == true ? true : false,
                isIndependentNo: this.inventionCheckListResponse.inventionCheckList.isIndependentYes == true ? false : this.inventionCheckListResponse.inventionCheckList.isIndependentYes == false ? true : false,

                isAttorneyYes: this.inventionCheckListResponse.inventionCheckList.isAttorneyYes == true ? true : false,
                isAttorneyNo: this.inventionCheckListResponse.inventionCheckList.isAttorneyYes == true ? false : this.inventionCheckListResponse.inventionCheckList.isAttorneyYes == false ? true : false,

                isPurchasedYes: this.inventionCheckListResponse.inventionCheckList.isPurchasedYes == true ? true : false,
                isPurchasedNo: this.inventionCheckListResponse.inventionCheckList.isPurchasedYes == true ? false : this.inventionCheckListResponse.inventionCheckList.isPurchasedYes == false ? true : false,
            })
        }

        if (this.inventionCheckListResponse.inventionCheckList.isNABIPReport) {
            this.prodConfigGroup.patchValue({
                isNABIPReport: true,
                isBIPReportYes: false,
                isBIPReportNo: false
            })
        }
        else if (!this.inventionCheckListResponse.inventionCheckList.isNABIPReport && this.inventionCheckListResponse.inventionCheckList.isBIPReport) {
            this.prodConfigGroup.patchValue({
                isBIPReportYes: true,
                isBIPReportNo: false,
                isNABIPReport: false
            })
        }
        else if (this.inventionCheckListResponse.inventionCheckList.isNABIPReport == false && this.inventionCheckListResponse.inventionCheckList.isBIPReport == false) {
            this.prodConfigGroup.patchValue({
                isBIPReportYes: false,
                isBIPReportNo: true,
                isNABIPReport: false
            })
        }
        else {
            this.prodConfigGroup.patchValue({
                isBIPReportYes: false,
                isBIPReportNo: false,
                isNABIPReport: false
            })
        }

        if (this.inventionCheckListResponse.inventionCheckList.isNAPPSO) {
            this.prodConfigGroup.patchValue({
                isNAPPSO: true,
                isPPSOYes: false,
                isPPSONo: false
            })
        }
        else if (!this.inventionCheckListResponse.inventionCheckList.isNAPPSO && this.inventionCheckListResponse.inventionCheckList.isPPSO) {
            this.prodConfigGroup.patchValue({
                isPPSOYes: true,
                isPPSONo: false,
                isNAPPSO: false
            })
        }
        else if (this.inventionCheckListResponse.inventionCheckList.isNAPPSO == false && this.inventionCheckListResponse.inventionCheckList.isPPSO == false) {
            this.prodConfigGroup.patchValue({
                isPPSOYes: false,
                isPPSONo: true,
                isNAPPSO: false
            })
        }
        else {
            this.prodConfigGroup.patchValue({
                isPPSOYes: false,
                isPPSONo: false,
                isNAPPSO: false
            })
        }
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control && field == "creditCard" && control.value.length >= 14) {
                control.clearValidators();
            }
            if (formGroup.status == "INVALID") {
                if (formGroup.controls.creditCard) {
                    if ((formGroup.controls.creditCard.status == "INVALID") && (formGroup.controls.creditCard.value.length < 14)) {
                        this.openSnackBar("The card number must be between 14 and 20 digits.", "");
                    }
                }
                else {
                    if (formGroup.controls.cashPrice) {
                        if (formGroup.controls.cashPrice.status == "INVALID") {
                            this.openSnackBar("Please save Services before proceeding.", "");
                        }
                    }
                    else
                        this.openSnackBar("Form has Invalid Data. Please check your inputs and save again !", "");
                }
            }
            if (control instanceof FormControl) {
                control.markAsTouched();
                control.updateValueAndValidity();
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    validate2ndInventor(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched();
                control.updateValueAndValidity();
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    async payAlert() {
        this.sentPayAlert = true;
        var u = this.currentUser;

        var dtWaitDate = new DatePipe("en-US");
        var dtSend = dtWaitDate.transform(this.businessDays, 'MM-dd-yyyy');

        this.setReminderDetails(dtSend);
        if (this.smsDetails.siteURL != "") {
            await this._smsService.sndPayRemSMSAsync(this.encryptedUser, this.smsDetails, dtSend)
                .then(res => {
                    if (res) {
                        if (res.statusCode == 0) {
                            this.smsResponse = UtilityService.clone(res);
                            if (!isNullOrUndefined(this.smsResponse) && this.smsResponse.txtMsgId > 0) {
                                this.openSnackBar("Payment reminder SMS has been set.", "");
                                this.updateUserSteps('IsPaymentReminder');
                                this.updateContractLogObjectModel("payReminder", false);
                                this.saveContrActionAcitonLog();
                            }
                            else
                                this.openSnackBar("Failed to send the message. Please refresh the page and try again or contact administrator.", "");

                        } else {
                            console.log("SMS Send result status code: " + res.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async socFormSubmit(stepper: CdkStepper): Promise<void> {
        if ($("#state option:selected").val() === '-1') {
            this.openSnackBar("Please select State.", "");
            return;
        }
        else {
            if (this.socGroup.controls.homephone.value.trim() != "" && this.socGroup.controls.workphone.value.trim() != "" && this.socGroup.controls.mobile.value.trim() != "") {
                var repHomePhone = this.socGroup.controls.homephone.value.replace(/[() -]/g, '');
                var repWorkphone = this.socGroup.controls.workphone.value.replace(/[() -]/g, '');
                var repMobile = this.socGroup.controls.mobile.value.replace(/[() -]/g, '');
                this.socGroup.patchValue({
                    homephone: repHomePhone,
                    workphone: repWorkphone,
                    mobile: repMobile
                });
            }
            this.validateAllFormFields(this.socGroup);
            if (this.socGroup.valid) {
                this.socGroup.markAsPristine();
                await this.saveData();
                this.isSOCFormSaved = true;
                this.divMmandDocs = true;
                this.divSOC = false;
                this.updateUserSteps("tdIsSOCForm");
                this.mandateDocSign(stepper);
                this.updateContractLogObjectModel("socSubmit", false);
                this.saveContrActionAcitonLog();
                this.loadMandatoryDocument(0);
                this.loadAddlDoc();
            }
        }
    }

    loadAddlDoc() {
        this.filterAddlDoc().then(async res => {
            var filteredAddlDoc = res;
            if (filteredAddlDoc.length > 0) {
                if (!isNullOrUndefined(this.contractSession)) {
                    var selectedProductID = +$("#contract option:selected").val() ? +$("#contract option:selected").val() : this.contractSession.productId;
                    if (this.contractSession.CountryID == 1) {
                        this.isAddlDocExists = (this.contractSession.conSessnClientState == "KS" && selectedProductID > 2) ? false : true;
                    }
                    this.loadDocument_DocTypeId(-2);
                }
            }
            else {
                this.isAddlDocExists = false;
            }
        });
    }

    scrollPageDown() {
        $([document.documentElement, document.body]).animate({ scrollTop: $(document).height() }, 100);
    }

    scrollPageUp(divId) {
        $([document.documentElement, document.body]).animate({ scrollTop: $(divId).height() }, 100);
    }

    getOtherMandateDoc() {
        this.divOtherMandDocs = false;
        if (this.isShowBIP)
            this.showDivItem(this.stepper, 1, '#divBIP');
        else if (this.isShowCheckList)
            this.showDivItem(this.stepper, 1, '#divSUB');
        else if (this.isShowIMP)
            this.showDivItem(this.stepper, 1, '#divIMP');
        else if (this.payOption == 1 && !this.isShowBIP && this.isShowPPSO)
            this.showDivItem(this.stepper, 1, '#divPS');
        else if (this.payOption == 2 && !this.isShowBIP && this.isShowPPSO)
            (this.contractSession.CountryID <= 2) ?
                this.showDivItem(this.stepper, 1, '#divIFI') : this.showDivItem(this.stepper, 1, '#divUPC');
    }

    otherMandateDocSign(source: string) {
        if (!this.navigationResponse.navigation.isNDADoc && source == "nda") {
            this.updateUserSteps('tdIsNDADoc');
            this.isNDAMandDoc = false;
            this.loadMandatoryDocument(0);
            this.loadDocument_DocTypeId(-2);
            this.isNDAHeadAccept = true;
            if (this.isWaitingPeriod)
                this.isWaitStateDoc = true;
            else {
                this.isWaitStateDoc = false;
                this.divOtherMandDocs = false;
            }
            this.updateContractLogObjectModel("ndaDocSign", false);
            forkJoin(this.saveContrActionAcitonLog(), this.loadOtherMandDocument("4")).subscribe(results => {
            });

        }
        else if (this.isWaitingPeriod && !this.navigationResponse.navigation.isWaitDoc && source == "w") {
            this.updateUserSteps('tdIsWaitDoc');
            this.isNDAMandDoc = false;
            this.isWaitStateDoc = true;
            this.divOtherMandDocs = false;
            this.isWaitHeadAccept = true;
            this.updateContractLogObjectModel("waitStateDocSign", false);
            forkJoin(this.saveContrActionAcitonLog(), this.loadOtherMandDocument(this.waitStateDocTypeId)).subscribe(results => {
            });
        }
    }

    updateOtherMandateDoc() {
        if (!this.navigationResponse.navigation.isNDADoc) {
            this.loadOtherMandDocument("4");
            this.isNDAMandDoc = true;
            this.isWaitStateDoc = false;
        }
        else {
            this.loadOtherMandDocument(this.waitStateDocTypeId);
            this.isNDAMandDoc = false;
            this.isWaitStateDoc = true;
            this.showDivItem(this.stepper, 1, '#divBIP');
        }
    }

    async mandateDocSign(stepper: CdkStepper) {
        this.isMandDocSigned = false;
        if (this.ctrMandDocs == 0) {
            this.showDivItem(this.stepper, 0, '#dvSOCMandDoc');
            this.loadMandatoryDocument("1");
            this.loadMandatoryDocument(this.sdaDocTypeId);
            this.loadMandatoryDocument(0);
            this.changeMandateDocBtn('#dvSOCMandDoc');
            if (this.socGroup.valid) {
                if (this.ctrMandDocs <= 2)
                    this.showMandatoryDocs(stepper);
                else {
                    this.showDivItem(this.stepper, 1, '#divPS');
                    this.loadMandatoryDocument("1");
                }
            }
        }
        else if (this.ctrMandDocs == 1) {
            this.validateAllFormFields(this.socGroup);
            if (this.socGroup.valid) {
                if (this.signaturePad.isEmpty() && !this.socGroup.controls.initialSignature.value.trim()) {
                    this.openSnackBar("Please sign the document.", "");
                    return;
                }
                if (this.isCoInventor) {
                    if (this.signaturePadCoInv.isEmpty() && !this.socGroup.controls.initialCoInvSignature.value.trim()) {
                        this.openSnackBar("Please sign the document.", "");
                        return;
                    }
                }
                this.copyFormValuesToDataObject();
                await this._documentService.checkSignAsync(this.documentContainer, this.encryptedUser)
                    .then(res => {
                        if (res) {
                            this.documentResponse = UtilityService.clone(res);
                            if (this.documentResponse.statusCode == 1) {
                                this._utilityService.showAlertMsg("SOC Sign Confirmation", "Signature could not be capture properly. Please sign it again!");
                                this.ctrMandDocs = 1;
                                this.currentActive = 0;
                                return;
                            }
                            else {
                                this.updateUserSteps("tdIsSOCDoc");
                                this.loadMandatoryDocument("1");
                                this.currentActive = 2;
                                this.chkSOC = false;
                                this.chkADS = true;
                                this.updateContractLogObjectModel("socDocSign", false);
                                this.saveContrActionAcitonLog();
                                this.changeMandateDocBtn('#dvSOCMandDoc');

                                if (this.navigationResponse.navigation.isSOCDoc) {
                                    var dialogResult = this._utilityService.showAlertMsg("SOC Sign Confirmation", "Please hand over the device to the Sales Representative.");
                                    if (this.contractSession && (this.contractSession.CountryID >= 3 && this.contractSession.CountryID <= 6)) {
                                        /*this.scrollPageUp('#divPS'); */
                                        this.showDivItem(this.stepper, 1, '#divPS');
                                        dialogResult.subscribe(result => {
                                            if (result) {
                                                $([document.documentElement, document.body]).animate({
                                                    scrollTop: $('#divPS').offset().top - 104
                                                }, 100);

                                            }
                                        });

                                    }
                                    else {
                                        dialogResult.subscribe(result => {
                                            if (result) {
                                                $([document.documentElement, document.body]).animate({
                                                    scrollTop: $('#dvADSMandDoc').offset().top - 104
                                                }, 100);

                                            }
                                        });
                                    }
                                }
                                if (this.socGroup.valid) {
                                    if (this.ctrMandDocs <= 2)
                                        this.showMandatoryDocs(stepper);
                                    else {
                                        this.showDivItem(this.stepper, 1, '#divPS');
                                        this.loadMandatoryDocument("1");
                                    }
                                }
                            }
                        }
                    });

            }
            else {
                this.ctrMandDocs = 1;
                this.openSnackBar("Please fill mandatory information first before SOC sign.", "");
            }
        }
        else if (this.ctrMandDocs == 2) {
            if (this.signaturePadADS.isEmpty() && !this.socGroup.controls.initialAdsSignature.value.trim()) {
                this.openSnackBar("Please sign the document.", "");
                return;
            }
            if (this.isCoInventor) {
                if (this.signaturePadADSCoInv.isEmpty() && !this.socGroup.controls.initialAdsCoInvSignature.value.trim()) {
                    this.openSnackBar("Please sign the document.", "");
                    return;
                }
            } else {
                this.signaturePadADS.on();
            }
            this.copyFormValuesToDataObject();
            await this._documentService.checkSignAsync(this.documentContainer, this.encryptedUser)
                .then(res => {
                    if (res) {
                        this.documentResponse = UtilityService.clone(res);
                        if (this.documentResponse.statusCode == 1) {
                            this._utilityService.showAlertMsg("ADS Sign Confirmation", "Signature could not be capture properly. Please sign it again!");
                            this.ctrMandDocs = 2;
                            this.currentActive = 1;
                            return;
                        }
                        else {
                            this.updateUserSteps("tdIsADSDoc");
                            this.loadMandatoryDocument(this.sdaDocTypeId);
                            this.currentActive = 4;
                            if (!isNullOrUndefined(this.contractSession) && this.contractSession.CountryID == 2)
                                this.showDivItem(this.stepper, 1, '#divPS');
                            else
                                this.showDivItem(this.stepper, 0, '#dvSDAMandDoc');
                            this.updateContractLogObjectModel("adsDocSign", false);
                            this.saveContrActionAcitonLog();

                            if (this.navigationResponse.navigation.isADSDoc && this.isStateExists == false) {
                                var dialogResult = this._utilityService.showAlertMsg("ADS Sign Confirmation", "Please hand over the device to the Sales Representative.");
                                dialogResult.subscribe(result => {
                                    if (result) {
                                        $([document.documentElement, document.body]).animate({
                                            scrollTop: $('#dvSDAMandDoc').offset().top - 104
                                        }, 100);

                                    }
                                }
                                );
                            }
                            this.changeMandateDocBtn('#dvADSMandDoc');
                            if (this.isStateExists == false)
                                this.isMandDocSigned = true;

                            if (this.socGroup.valid) {
                                if (this.ctrMandDocs <= 2)
                                    this.showMandatoryDocs(stepper);
                                else {
                                    this.showDivItem(this.stepper, 1, '#divPS');
                                    this.loadMandatoryDocument("1");
                                }
                            }
                        }
                    }
                })
        }
        else if (this.ctrMandDocs == 3) {
            this.updateUserSteps("tdIsSDADoc");
            this.updateContractLogObjectModel("stateDocSign", false);
            forkJoin(this.saveContrActionAcitonLog(), this.loadMandatoryDocument(0)).subscribe(results => {
            });
            this.showDivItem(this.stepper, 1, '#divPS');
            this.changeMandateDocBtn('#dvSDAMandDoc');
            this.isMandDocSigned = true;
            if (this.navigationResponse.navigation.isStateDoc && this.isStateExists == true) {
                var dialogResult = this._utilityService.showAlertMsg("SDA Sign Confirmation", "Please hand over the device to the Sales Representative.");
                dialogResult.subscribe(result => {
                    if (result) {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('#divPS').offset().top - 104
                        }, 100);

                    }
                });
            }
            if (this.socGroup.valid) {
                if (this.ctrMandDocs <= 2)
                    this.showMandatoryDocs(stepper);
                else {
                    this.showDivItem(this.stepper, 1, '#divPS');
                    this.loadMandatoryDocument("1");
                }
            }
        }

        $("#dvSOCMandDoc img:last-child").remove();
        $("#dvADSMandDoc img:last-child").remove();
        $("#dvNDAMandDoc img:last-child").remove();
        $("#dvSDAMandDoc img:last-child").remove();

    }

    changeMandateDocBtn(dvId) {
        switch (dvId) {
            case "#dvSOCMandDoc": this.mandateDocBtn = "Accept & Sign"; break;
            case "#dvADSMandDoc": this.mandateDocBtn = "Accept"; break;
            case "#dvSDAMandDoc": this.mandateDocBtn = "Accept & Sign"; break;
            default: this.mandateDocBtn = "Accept & Sign"; break;
        }
    }

    signatureNotSaved(): string {
        let strMsg = "";

        if (!isNullOrUndefined(this.documentSignature) && !isNullOrUndefined(this.contractSession)) {
            if (this.inventionResponse.inventionDetails.isCoInventor) {
                if (this.documentSignature.signature2 == '' && this.documentSignature.initial2 == '' && !this.contractSession.IsSecondContract) {
                    strMsg == '' ? strMsg = "CoInventor SOC" : strMsg += "/CoInventor SOC";
                }
                if (this.documentSignature.i2SignatureADS == '' && this.documentSignature.i2InitialADS == '' && (this.contractSession.CountryID != 3 && this.contractSession.CountryID != 4 && this.contractSession.CountryID != 6) && !this.contractSession.IsSecondContract) {
                    strMsg == '' ? strMsg = "CoInventor ADS" : strMsg += "/CoInventor ADS";
                }
                if (this.documentSignature.i2SignatureFinal == '' && this.documentSignature.i2InitialFinal == '') {
                    strMsg == '' ? strMsg = "CoInventor Final" : strMsg += "/CoInventor Final";
                }
            }

            if (this.documentSignature.signature1 == '' && this.documentSignature.initial1 == '' && !this.contractSession.IsSecondContract) {
                strMsg == '' ? strMsg = "SOC" : strMsg += "/SOC";
            }
            if (this.documentSignature.i1SignatureADS == '' && this.documentSignature.i1InitialADS == '' && (this.contractSession.CountryID != 3 && this.contractSession.CountryID != 4 && this.contractSession.CountryID != 6) && !this.contractSession.IsSecondContract) {
                strMsg == '' ? strMsg = "ADS" : strMsg += "/ADS";
            }
            if (this.documentSignature.i1SignatureFinal == '' && this.documentSignature.i1InitialFinal == '') {
                strMsg == '' ? strMsg = "Final" : strMsg += "/Final";
            }

            if (strMsg != '')
                strMsg = strMsg + " signature is missing. Please reopen the " + strMsg + " and sign it again.";

        } else {
            strMsg = "Issue encountered! Please reload the contract and try again.";
        }
        return strMsg;
    }

    async saveFinalDocSign() {
        this.drawCompleteFinal();
        this.copyFormValuesToDataObject();
        if (isNullOrUndefined(this.documentContainer.i1SignatureFinal) && isNullOrUndefined(this.documentContainer.i1InitialFinal)) {
            this.openSnackBar("Please sign the document.", "");
            return;
        }
        if (this.documentContainer.i1SignatureFinal == "" && this.documentContainer.i1InitialFinal == "") {
            this.openSnackBar("Please sign the document.", "");
            return;
        }
        if (this.isCoInventor) {
            if (isNullOrUndefined(this.documentContainer.i2SignatureFinal) && isNullOrUndefined(this.documentContainer.i2InitialFinal)) {
                this.openSnackBar("Please sign the document.", "");
                return;
            }
            if (this.documentContainer.i2SignatureFinal == "" && this.documentContainer.i2InitialFinal == "") {
                this.openSnackBar("Please sign the document.", "");
                return;
            }
        }
        this._documentService.checkSignAsync(this.documentContainer, this.encryptedUser)
            .then(res => {
                if (res) {
                    this.documentResponse = UtilityService.clone(res);
                    if (this.documentResponse.statusCode == 1) {
                        this._utilityService.showAlertMsg("Final Sign Confirmation", "Signature could not be capture properly. Please sign it again!");

                        return;
                    }
                    else {
                        this.copyFormValuesToDataObject();
                        let strMsg = "";
                        if (this.validateSignBeforeSave()) {
                            this._documentService.saveDocumentAsync(this.documentContainer, this.encryptedUser)
                                .then(res => {
                                    if (res) {
                                        if (res.statusCode == 0) {
                                            this._documentService.getDocumentSignatureAsync(this.encryptedUser, this.contractSessionId)
                                                .then(resu => {
                                                    if (resu) {
                                                        if (resu.statusCode == 0) {
                                                            this.openSnackBar("Signature was saved.", "");
                                                            this.documentSignatureResponse = UtilityService.clone(resu);
                                                            this.documentSignature = this.documentSignatureResponse.documentSignature;
                                                            if (this.documentSignature) {
                                                                strMsg = this.signatureNotSaved();
                                                                if (strMsg != '') {
                                                                    this._utilityService.showAlertMsg("Document Signature", strMsg);
                                                                    if (!isNullOrUndefined(this.navigationResponse)) {
                                                                        if (strMsg.includes("SOC"))
                                                                            this.navigationResponse.navigation.isSOCDoc = false; this.uncheckNavBar('tdIsSOCDoc');
                                                                        if (strMsg.includes("ADS"))
                                                                            this.navigationResponse.navigation.isADSDoc = false; this.uncheckNavBar('tdIsADSDoc');
                                                                        if (strMsg.includes("Final"))
                                                                            this.navigationResponse.navigation.isFinalSign = false; this.uncheckNavBar('tdIsFinalDocuments');
                                                                        this.saveNavigationWizard();
                                                                    }
                                                                }
                                                                else {
                                                                    this.CustomerAccept("tdIsFinalDocuments");
                                                                    this.loadDocumentSignature();
                                                                    this.loadDocument();
                                                                }
                                                            }
                                                            this.drawClear();
                                                            this.drawClearCoInv();
                                                            this.drawClearFinal();
                                                            this.drawClearFinalCoInv();
                                                        }
                                                        else {
                                                            console.log("Document Signature result status code: " + res.statusCode);
                                                        }
                                                    }
                                                })
                                                .catch((err: HttpErrorResponse) => {
                                                    this._utilityService.handleErrorResponse(err);
                                                });
                                        }
                                    }
                                }).catch((err: HttpErrorResponse) => {
                                    this._utilityService.handleErrorResponse(err);
                                });
                        }
                        else {
                            this.openSnackBar("Signature could not captured. Please refresh the contract and sign it again.", "");
                        }
                    }
                }
            });
    }

    private loadMandatoryDocs() {
        if (this.contractSession.USFeeConfirm == 2 || this.contractSession.CountryID == 2) {
            this.productDetails[0].ihMandatoryDoc = this.productDetails[0].ihMandatoryDoc.replace(",3,", ",38,");
            this.sdaDocTypeId = 38;
        }
        let docids: string = this.contractSession.CountryID > 2 ? this.productDetails[0].ihMandatoryDoc : this.productDetails[0].ihMandatoryDoc + "," + this.productDetails[0].ihOthMandDoc;
        docids = docids.replace("S", "0");

        docids = this.isWaitStateExists ? docids.replace("W", this.waitStateDocTypeId.toString()) : docids.replace(",W", "");
        this.loadMandatoryDocument(docids);

    }

    private async loadMandatoryDocument(docId) {
        if (docId != '' && !isNullOrUndefined(docId)) {
            this._documentService.getProductDocumentListAsync(this.encryptedUser, docId, this.inventionId, this.contactId, this.contractSessionId, (this.contractSession.productId > 8 && this.contractSession.productId < 12) ? "Plus" : "Normal")
                .then(async (result: DocumentResponseList) => {
                    if (result) {

                        if (result.statusCode == 0) {

                            this.documentListResponse = UtilityService.clone(result);
                            if (this.documentListResponse && this.documentListResponse.docList.length > 0) {
                                for (var i = 0; i < this.documentListResponse.docList.length; i++) {
                                    let doc: DocType = this.documentListResponse.docList[i];
                                    switch (doc.documentTypeID) {
                                        case 1: this.docMandSOC = UtilityService.clone(doc.document); this.docSignSOC = UtilityService.clone(doc.document); break;
                                        case 3: case 38: this.docMandADS = UtilityService.clone(doc.document); this.docSignADS = UtilityService.clone(doc.document); break;
                                        case 0: this.docMandSDA = UtilityService.clone(doc.document); this.docSignSDA = UtilityService.clone(doc.document); break;
                                        case 4: this.docMandNDA = UtilityService.clone(doc.document); this.docSignNDA = UtilityService.clone(doc.document); break;
                                        case 27: this.docWaitState = UtilityService.clone(doc.document); this.docSignWaitState = UtilityService.clone(doc.document); break;
                                        case 28: this.docWaitState = UtilityService.clone(doc.document); this.docSignWaitState = UtilityService.clone(doc.document); break;
                                        case 29: this.docWaitState = UtilityService.clone(doc.document); this.docSignWaitState = UtilityService.clone(doc.document); break;
                                        case 30: this.docWaitState = UtilityService.clone(doc.document); this.docSignWaitState = UtilityService.clone(doc.document); break;
                                        case 31: this.docWaitState = UtilityService.clone(doc.document); this.docSignWaitState = UtilityService.clone(doc.document); break;
                                        default: break;
                                    }

                                    if (doc.documentTypeID == 0) {
                                        if (this.docMandSDA == "") {
                                            this.isStateExists = false;
                                            this.isSDAMandDoc = false;
                                            this.isSDASignDoc = false;
                                        } else {
                                            if (!isNullOrUndefined(this.contractSession)) {
                                                if (this.contractSession.CountryID == 1)
                                                    this.isStateExists = true;
                                            }
                                        }
                                        setTimeout(() => {
                                            this.updateNavBar();
                                        }, 5000);
                                    }
                                    else {
                                        this.updateNavBar();
                                    }
                                    this.documentContainer = UtilityService.clone(this.documentListResponse.documentContainer);
                                    this.documentTypeId = doc.documentTypeID;
                                }
                                this.recalcAllIframes();
                            }
                        } else {
                            console.log("loadMandatoryDocument.statusCode: " + result.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async loadOtherMandDocument(docId) {
        if (docId != '' && !isNullOrUndefined(docId)) {
            this._documentService.getProductDocumentListAsync(this.encryptedUser, docId, this.inventionId, this.contactId, this.contractSessionId, (this.contractSession.productId > 8 && this.contractSession.productId < 12) ? "Plus" : "Normal")
                .then(async (result: DocumentResponseList) => {
                    if (result) {
                        if (result.statusCode == 0) {

                            this.documentListResponse = UtilityService.clone(result);
                            if (this.documentListResponse && this.documentListResponse.docList.length > 0) {
                                for (var i = 0; i < this.documentListResponse.docList.length; i++) {

                                    let doc: DocType = this.documentListResponse.docList[i];
                                    switch (doc.documentTypeID) {
                                        case 4: this.docMandNDA = UtilityService.clone(doc.document); this.docSignNDA = UtilityService.clone(doc.document); break;
                                        case 27: this.docWaitState = UtilityService.clone(doc.document); this.docSignWaitState = UtilityService.clone(doc.document); break;
                                        case 28: this.docWaitState = UtilityService.clone(doc.document); this.docSignWaitState = UtilityService.clone(doc.document); break;
                                        case 29: this.docWaitState = UtilityService.clone(doc.document); this.docSignWaitState = UtilityService.clone(doc.document); break;
                                        case 30: this.docWaitState = UtilityService.clone(doc.document); this.docSignWaitState = UtilityService.clone(doc.document); break;
                                        case 31: this.docWaitState = UtilityService.clone(doc.document); this.docSignWaitState = UtilityService.clone(doc.document); break;
                                        default: break;
                                    }
                                    this.documentContainer = UtilityService.clone(this.documentListResponse.documentContainer);
                                    this.documentTypeId = doc.documentTypeID;
                                }
                                this.recalcAllIframes()
                            }
                        } else {
                            console.log("loadOtherMandDocument.statusCode: " + result.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private showMandatoryDocs(stepper) {
        let arrProduct = new Array();
        arrProduct = this.productDetails[0].ihMandatoryDoc.split(',');

        if (this.ctrMandDocs > 1)
            this.chkSOC = false;
        else
            this.chkSOC = true;

        if (this.chkSOC == true && this.ctrMandDocs == 1) {
            this.drawComplete();
            this.drawCompleteCoInv();
            this.saveSignature();
            this.loadDocument();
            this.loadMandatoryDocument("4");

            if (this.isWaitStateExists)
                this.loadMandatoryDocument(this.waitStateDocTypeId);

            this.chkSOC = false;
        }

        if (this.chkADS == true && this.ctrMandDocs == 2) {
            this.drawCompleteADS();
            this.drawCompleteADSCoInv();
            this.saveSignature();
            this.chkADS = false;
        }

        if (this.docMandSDA == "" && this.ctrMandDocs == 2) {
            this.showDivItem(this.stepper, 1, '#divPS');
        }
        switch (this.ctrMandDocs) {
            case 0: this.isSOCMandDoc = true; this.isADSMandDoc = false; this.isSDAMandDoc = false; this.currentActive = 1; this.socSignatureShow(); break;

            case 1: this.isSOCMandDoc = false; this.isADSMandDoc = true; this.isSDAMandDoc = false; this.currentActive = 2;
                this.adsSignatureShow(); break;

            case 3: this.isSOCMandDoc = false; this.isADSMandDoc = false; this.isSDAMandDoc = true; this.currentActive = 4; break;
            default: break;
        }

        this.ctrMandDocs = this.ctrMandDocs + 1;
    }

    private async getMandatoryDocument(docId, stepper) {
        if (docId != '' && !isNullOrUndefined(docId)) {
            this._documentService.getProductDocumentListAsync(this.encryptedUser, docId, this.inventionId, this.contactId, this.contractSessionId, (this.contractSession.productId > 8 && this.contractSession.productId < 12) ? "Plus" : "Normal")
                .then(async (result: DocumentResponseList) => {
                    if (result) {

                        if (result.statusCode == 0) {

                            this.documentListResponse = UtilityService.clone(result);
                            if (this.documentListResponse && this.documentListResponse.docList.length > 0) {

                                let doc: DocType = this.documentListResponse.docList[0];

                                switch (doc.documentTypeID) {
                                    case 1: this.docMandSOC = UtilityService.clone(doc.document); $("#dvSOCMandDoc img:last-child").remove(); break;
                                    case 3: this.docMandADS = UtilityService.clone(doc.document); $("#dvADSMandDoc img:last-child").remove(); break;
                                    case 0: this.docMandSDA = UtilityService.clone(doc.document); $("#dvSDAMandDoc img:last-child").remove(); break;
                                    default: break;
                                }

                                this.documentContainer = UtilityService.clone(this.documentListResponse.documentContainer);
                                this.documentTypeId = doc.documentTypeID;
                                this.recalcAllIframes();
                            }
                        }
                    } else {
                        console.log("result.statusCode: " + result.statusCode);
                    }

                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async getSetContractPaymentPrice() {

        await this._billingService.getContractPaymentAsync(this.encryptedUser, this.inventionId, this.productId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.contractPaymentResponse = UtilityService.clone(res);
                        this.initContractPayment = Object.assign({}, this.contractPaymentResponse.contractPayment);
                        this.contractPayment = this.contractPaymentResponse.contractPayment;
                        this.convertNumberToCurrency(this.contractPayment.cashPrice, 'cashPrice');
                    }
                }
            })

    }

    prodConfigSubmit(stepper: CdkStepper): Promise<void> {
        //#region Validation
        this.cardErrorMsg = "";
        if (this.contractSession && this.contractSession.sendToCorp) {
            this.contractSession.sendToCorp = false;
        }

        this.isExist = false;
        var repCashPrice = this.prodConfigGroup.controls.cashPrice.value;
        repCashPrice = repCashPrice ? repCashPrice.toString().replace(this.currencySterling, "").replace(',', "") : 0;

        var repDownPayment = this.prodConfigGroup.controls.downPayment.value;
        repDownPayment = repDownPayment ? repDownPayment.toString().replace(this.currencySterling, "").replace(',', "") : 0;

        var repRolloverAmount = this.prodConfigGroup.controls.rolloverAmount.value;
        repRolloverAmount = repRolloverAmount ? repRolloverAmount.toString().replace(this.currencySterling, "").replace(',', "") : 0;

        var repAltAmount = this.prodConfigGroup.controls.altAmount.value;
        repAltAmount = repAltAmount ? repAltAmount.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.prodConfigGroup.patchValue({
            cashPrice: repCashPrice == 0 ? '' : repCashPrice,
            downPayment: repDownPayment == 0 ? '0.00' : repDownPayment,
            rolloverAmount: repRolloverAmount,
            altAmount: repAltAmount == 0 ? '' : repAltAmount,
        });
        let totalDownPayment: number = 0
        for (var i = 0; i < this.contractMultiPayments.length; i++) {
            var downPayment: any = this.contractMultiPayments[i].downPaymentPart;
            if (downPayment == 0) {
                this.openSnackBar("Down Payment can not be $0", "");
                return;
            }
            if (downPayment && typeof downPayment == "number")
                downPayment = downPayment.toString();
            this.contractMultiPayments[i].downPaymentPart = downPayment ? downPayment.toString().replace(this.currencySterling, "").replace(',', "") : 0;
            totalDownPayment += +this.contractMultiPayments[i].downPaymentPart;

        }
        if (totalDownPayment > this.prodConfigGroup.controls.cashPrice.value) {
            this.openSnackBar("Down Payment should not be greater than Cash Price!", "");
            return;
        }
        this.validateAllFormFields(this.prodConfigGroup);
        if (this.prodConfigGroup.valid) {

            this.prodConfigGroup.markAsPristine();
            if (this.prodConfigGroup.controls.cashPrice.value == 0) {
                this.convertNumberToCurrency(this.prodConfigGroup.controls.cashPrice.value, 'cashPrice');
                this.convertNumberToCurrency(this.prodConfigGroup.controls.downPayment.value, 'downPayment');
                this.getSetContractPaymentPrice();
                this.openSnackBar("Cash Price can not be $0", "");
                return;
            }
            else if (this.contractPayment.downPayment == 0 && totalDownPayment == 0) {
                this.convertNumberToCurrency(this.prodConfigGroup.controls.cashPrice.value, 'cashPrice');
                this.convertNumberToCurrency(this.prodConfigGroup.controls.downPayment.value, 'downPayment');
                this.openSnackBar("Down Payment can not be $0", "");
                return;
            }
            else if ((this.contractPayment.downPayment == 0 && totalDownPayment == 0) && this.contractPayment.cashPrice == 0) {
                this.convertNumberToCurrency(this.prodConfigGroup.controls.cashPrice.value, 'cashPrice');
                this.convertNumberToCurrency(this.prodConfigGroup.controls.downPayment.value, 'downPayment');
                this.openSnackBar("Cash Price & Down Payment can not be $0", "");
                return;
            }
            else if (this.contractPayment.downPayment > this.contractPayment.cashPrice) {
                this.convertNumberToCurrency(this.prodConfigGroup.controls.cashPrice.value, 'cashPrice');
                this.convertNumberToCurrency(this.prodConfigGroup.controls.downPayment.value, 'downPayment');
                this.openSnackBar("Down Payment should not be greater than Cash Price!", "");
                return;
            }
            //#endregion Validations
            if (this.productDetails) {
                if (this.contractSession.productId == + $("#contract option:selected").val()) {
                    this.loadProduct();
                    var IsBIPExistInSystem = this.contractSessionListResponse.contractSession.find(i => (i.productId < 3) && i.ContractSessionId != this.contractSessionId);
                    var NotBIP = !isNullOrUndefined(this.bipConfirmation?.isNo) ? this.bipConfirmation?.isNo : this.bipConfirmation["bipConfirmation"]?.isNo;
                    var ContractSessionIdBIP = !isNullOrUndefined(this.bipConfirmation?.contractSessionId) ? this.bipConfirmation?.contractSessionId : this.bipConfirmation["bipConfirmation"].contractSessionId;
                    var showMessage = (!isNullOrUndefined(IsBIPExistInSystem) && IsBIPExistInSystem.productId < 3) ? false
                        : ((ContractSessionIdBIP > 1) && (!NotBIP)) ? false : (this.isSecondContract) ? false : true;
                    if ((+$("#contract option:selected").val() > 2 && +$("#contract option:selected").val() <= 14 && +$("#contract option:selected").val() != 9 && +$("#contract option:selected").val() != 10 && +$("#contract option:selected").val() != 11) && (showMessage)) {
                        var dialogResult = this._utilityService.showConfirmMsg("BIP Confirmation!", "Does BIP exist?");
                        dialogResult.subscribe(result => {
                            this.bipConfirmation.contractSessionId = this.contractSessionId;
                            this.bipConfirmation.clpUserID = this.clpUserId;
                            this.bipConfirmation.inventionName = this.inventionName;
                            this.bipConfirmation.step = "SaveServices";
                            if (result) {
                                if (this.contractSession) {
                                    this.contractSession.IsSecondContract = true;
                                    this.CreateUpdate_ContractSession();
                                    this.isShowROI = false;
                                    this.bipConfirmation.isYes = true;
                                    this.bipConfirmation.isNo = false;
                                    if (this.navigationResponse)
                                        this.updateManDocSC();
                                    else {
                                        this._navigationService.getNavigationWizardAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
                                            .then(res => {
                                                if (res) {
                                                    if (res.statusCode == 0) {
                                                        this.navigationResponse = UtilityService.clone(res);
                                                        if (this.navigationResponse) {
                                                            this.updateManDocSC();
                                                        }
                                                    } else {
                                                        console.log("Navigation Wizard result status code: " + res.statusCode);
                                                    }
                                                }
                                            })
                                            .catch((err: HttpErrorResponse) => {
                                                this._utilityService.handleErrorResponse(err);
                                            });
                                    }
                                }
                            }
                            else {
                                this.bipConfirmation.isYes = false;
                                this.bipConfirmation.isNo = true;
                            }
                            if (this.contractSession) {
                                this.contractSession.OfficeNumber = this.prodConfigGroup.controls.officeCode.value;
                                this.contractSession.productId = + $("#contract option:selected").val();
                                this.contractSession.CLPUserId = this.clpUserId;
                                this.contractSession.I1CLPContactId = this.contactId;
                                this.contractSession.inventionId = this.inventionId;
                                this.CreateUpdate_ContractSession();
                                this.copyProdConfigValuesToDataObject().subscribe((value) => this.saveContractPayment());
                                this.updateContractLogObjectModel("serviceSubmit", false);
                                this.saveContrActionAcitonLog();
                                this.saveImpByService = 'service';
                                this.saveByService = "service";
                                //if (this.productId == 7 || this.productId == 8) {
                                if ((this.productId >= 7 && this.productId <= 9) || this.productId == 12 || this.productId == 13 || this.productId == 14) {
                                    this.prodConfigGroup.patchValue({
                                        isNoService: false, isAddendumB: false, isAddendumG: false, isAddendumP: false, isPatentServices: true,
                                    });
                                }
                                else {
                                    this.prodConfigGroup.patchValue({
                                        isNoService: false, isAddendumB: false, isAddendumG: false, isAddendumP: false, isPatentServices: false,
                                    });
                                }
                                this.addendumSubmit(false);
                                if (this.productId != 4 && this.productId != 5) {
                                    this.prodConfigGroup.patchValue({
                                        isIMPAgree: false
                                    })
                                    this.impSubmit(false);
                                }
                            }
                            if (this.bipConfirmation.isYes)
                                this.CreateUpdate_BIPConfirmation("Yes");
                            else
                                this.CreateUpdate_BIPConfirmation("No");
                        });
                    }
                    else {
                        if (this.contractSession) {
                            this.contractSession.OfficeNumber = this.prodConfigGroup.controls.officeCode.value;
                            this.contractSession.productId = + $("#contract option:selected").val();
                            this.contractSession.CLPUserId = this.clpUserId;
                            this.contractSession.I1CLPContactId = this.contactId;
                            this.contractSession.inventionId = this.inventionId;
                            this.CreateUpdate_ContractSession();
                            this.copyProdConfigValuesToDataObject().subscribe((value) => this.saveContractPayment());
                            this.updateContractLogObjectModel("serviceSubmit", false);
                            this.saveContrActionAcitonLog();
                            this.saveImpByService = 'service';
                            this.saveByService = "service";
                            if ((this.productId >= 7 && this.productId <= 9) || this.productId == 12 || this.productId == 13 || this.productId == 14) {
                                this.prodConfigGroup.patchValue({
                                    isNoService: false, isAddendumB: false, isAddendumG: false, isAddendumP: false, isPatentServices: true,
                                });
                            }
                            else {
                                this.prodConfigGroup.patchValue({
                                    isNoService: false, isAddendumB: false, isAddendumG: false, isAddendumP: false, isPatentServices: false,
                                });
                            }
                            this.addendumSubmit(false);
                            if (this.productId != 4 && this.productId != 5) {
                                this.prodConfigGroup.patchValue({
                                    isIMPAgree: false
                                })
                                this.impSubmit(false);
                            }
                        }
                    }
                }
                else if (this.isSecondContract && ((this.isBIPClient && +$("#contract option:selected").val() <= 2)
                    || (this.isSubClient && (+$("#contract option:selected").val() == 8 || +$("#contract option:selected").val() == 7 || +$("#contract option:selected").val() == 3 || +$("#contract option:selected").val() == 12 || +$("#contract option:selected").val() == 13 || +$("#contract option:selected").val() == 14))
                    || (this.isPPSOClient && +$("#contract option:selected").val() == 11) || (this.isPlusClient && (+$("#contract option:selected").val() == 9 || +$("#contract option:selected").val() == 10))
                )) {
                    for (var i = 0; i < this.productDetails.length; i++) {
                        if (this.isBIPClient) {
                            this.productDetails.find(p => p.productId == 1).isExists = true;
                            this.productDetails.find(p => p.productId == 2).isExists = true;
                        }
                        if (this.isSubClient) {
                            this.productDetails.find(p => p.productId == 3).isExists = true;
                            //this.productDetails.find(p => p.productId == 7).isExists = true;
                            this.productDetails.find(p => p.productId == 8).isExists = true;
                            this.productDetails.find(p => p.productId == 12).isExists = true;
                            this.productDetails.find(p => p.productId == 13).isExists = true;
                            this.productDetails.find(p => p.productId == 14).isExists = true;
                        }
                        if (this.isPPSOClient) {
                            this.productDetails.find(p => p.productId == 11).isExists = true;
                        }
                        if (this.isPlusClient) {
                            this.productDetails.find(p => p.productId == 9).isExists = true;
                            this.productDetails.find(p => p.productId == 10).isExists = true;
                        }
                        if (this.productDetails[i].isExists) {
                            this.isExist = true;
                            this._utilityService.showAlertMsg("Information!", "<b>" + $("#contract option:selected").text().substr(2) + "</b> is already been used for this invention in the old system.");
                            return;
                        }
                    }
                }
                else if (this.contractSession.productId != + $("#contract option:selected").val()) {
                    for (var i = 0; i < this.productDetails.length; i++) {
                        if (this.productDetails[i].productId == + $("#contract option:selected").val() && this.productDetails[i].contractSessionId > 0 && this.productDetails[i].status != 2) {
                            this.isExist = true;
                            var dialogResult = this._utilityService.showConfirmMsg("Information!", "<b>" + this.productDetails[i].productDescription + "</b> is already been used for this invention.  Do you want to open it?");

                            dialogResult.subscribe(result => {
                                if (result) {
                                    this.contractSessionId = this.productDetails[i].contractSessionId;
                                    if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
                                        this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                                            .then(res => {
                                                if (res) {
                                                    this.contractSession = UtilityService.clone(res);
                                                    this.isRemote = this.contractSession.isClientRemote;
                                                    if (this.isRemote) {
                                                        this._router.navigate(['/contract-remote', this.contactId, this.inventionId, this.contractSessionId, this.rdClpUserId], {
                                                            queryParams: { w: 1, 'i': this.inventionId, 'c': this.contactId, 'cs': this.contractSessionId, 'rd': this.rdClpUserId, 'r': this.encryptedUser }
                                                        });
                                                    }
                                                    else {
                                                        this._router.navigate(['/contract', this.contactId, this.inventionId, this.contractSessionId, this.rdClpUserId], {
                                                            queryParams: { w: 1, 'i': this.inventionId, 'c': this.contactId, 'cs': this.contractSessionId, 'rd': this.rdClpUserId, 'r': this.encryptedUser }
                                                        });
                                                    }
                                                }
                                            })
                                            .catch((err: HttpErrorResponse) => {
                                                this._utilityService.handleErrorResponse(err);
                                            });
                                    }
                                }
                            }
                            );
                            break;
                        }
                    }
                    if (!this.isExist) {
                        var IsBIPExistInSystem = this.contractSessionListResponse.contractSession.find(i => (i.productId < 3) && i.ContractSessionId != this.contractSessionId);
                        var NotBIP = !isNullOrUndefined(this.bipConfirmation.isNo) ? this.bipConfirmation.isNo : this.bipConfirmation["bipConfirmation"].isNo;
                        var ContractSessionIdBIP = !isNullOrUndefined(this.bipConfirmation.contractSessionId) ? this.bipConfirmation.contractSessionId : this.bipConfirmation["bipConfirmation"].contractSessionId;
                        var showMessage = (!isNullOrUndefined(IsBIPExistInSystem) && IsBIPExistInSystem.productId < 3) ? false
                            : ((ContractSessionIdBIP > 1) && (!NotBIP)) ? false : (this.isSecondContract) ? false : true;
                        if ((+$("#contract option:selected").val() > 2 && +$("#contract option:selected").val() <= 14 && +$("#contract option:selected").val() != 9 && +$("#contract option:selected").val() != 10 && +$("#contract option:selected").val() != 11) && (showMessage)) {
                            var dialogResult = this._utilityService.showConfirmMsg("BIP Confirmation!", "Does BIP exist?");
                            dialogResult.subscribe(result => {
                                this.bipConfirmation = {} as BIPConfirmation;
                                this.bipConfirmation.contractSessionId = this.contractSessionId;
                                this.bipConfirmation.clpUserID = this.clpUserId;
                                this.bipConfirmation.inventionName = this.inventionName;
                                this.bipConfirmation.step = "SaveServices";
                                if (result) {
                                    if (this.contractSession) {
                                        this.contractSession.IsSecondContract = true;
                                        this.CreateUpdate_ContractSession();
                                        this.isShowROI = false;
                                        this.bipConfirmation.isYes = true;
                                        this.bipConfirmation.isNo = false;
                                        if (this.navigationResponse)
                                            this.updateManDocSC();
                                        else {
                                            this._navigationService.getNavigationWizardAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
                                                .then(res => {
                                                    if (res) {
                                                        if (res.statusCode == 0) {
                                                            this.navigationResponse = UtilityService.clone(res);
                                                            if (this.navigationResponse) {
                                                                this.updateManDocSC();
                                                            }
                                                        } else {
                                                            console.log("Navigation Wizard result status code: " + res.statusCode);
                                                        }
                                                    }
                                                })
                                                .catch((err: HttpErrorResponse) => {
                                                    this._utilityService.handleErrorResponse(err);
                                                });
                                        }
                                    }
                                }
                                else {
                                    this.bipConfirmation.isYes = false;
                                    this.bipConfirmation.isNo = true;
                                }
                                if (this.contractSession) {
                                    this.contractSession.OfficeNumber = this.prodConfigGroup.controls.officeCode.value;
                                    this.contractSession.productId = + $("#contract option:selected").val();
                                    this.productId = + $("#contract option:selected").val();
                                    this.changeProduct();
                                    this.contractSession.CLPUserId = this.clpUserId;
                                    this.contractSession.I1CLPContactId = this.contactId;
                                    this.contractSession.inventionId = this.inventionId;
                                    this.CreateUpdate_ContractSession();
                                    this.copyProdConfigValuesToDataObject().subscribe((value) => this.saveContractPayment());
                                    this.updateContractLogObjectModel("serviceSubmit", false);
                                    this.saveContrActionAcitonLog();
                                    this.saveImpByService = 'service';
                                    this.saveByService = "service";
                                    if ((this.productId >= 7 && this.productId <= 9) || this.productId == 12 || this.productId == 13 || this.productId == 14) {
                                        this.prodConfigGroup.patchValue({
                                            isNoService: false, isAddendumB: false, isAddendumG: false, isAddendumP: false, isPatentServices: true,
                                        });
                                    }
                                    else {
                                        this.prodConfigGroup.patchValue({
                                            isNoService: false, isAddendumB: false, isAddendumG: false, isAddendumP: false, isPatentServices: false,
                                        });
                                    }
                                    this.addendumSubmit(false);
                                    if (this.productId != 4 && this.productId != 5) {
                                        this.prodConfigGroup.patchValue({
                                            isIMPAgree: false
                                        })
                                        this.impSubmit(false);
                                    }
                                }

                                if (this.bipConfirmation.isYes)
                                    this.CreateUpdate_BIPConfirmation("Yes");
                                else
                                    this.CreateUpdate_BIPConfirmation("No");
                            });
                        }
                        else {
                            if (this.contractSession) {
                                this.contractSession.OfficeNumber = this.prodConfigGroup.controls.officeCode.value;
                                this.contractSession.productId = + $("#contract option:selected").val();
                                this.productId = + $("#contract option:selected").val();
                                this.changeProduct();
                                this.contractSession.CLPUserId = this.clpUserId;
                                this.contractSession.I1CLPContactId = this.contactId;
                                this.contractSession.inventionId = this.inventionId;
                                this.CreateUpdate_ContractSession();
                                this.copyProdConfigValuesToDataObject().subscribe((value) => this.saveContractPayment());
                                this.updateContractLogObjectModel("serviceSubmit", false);
                                this.saveContrActionAcitonLog();
                                this.saveImpByService = 'service';
                                this.saveByService = "service";
                                if ((this.productId >= 7 && this.productId <= 9) || this.productId == 12 || this.productId == 13 || this.productId == 14) {
                                    this.prodConfigGroup.patchValue({
                                        isNoService: false, isAddendumB: false, isAddendumG: false, isAddendumP: false, isPatentServices: true,
                                    });
                                }
                                else {
                                    this.prodConfigGroup.patchValue({
                                        isNoService: false, isAddendumB: false, isAddendumG: false, isAddendumP: false, isPatentServices: false,
                                    });
                                }
                                this.addendumSubmit(false);
                                if (this.productId != 4 && this.productId != 5) {
                                    this.prodConfigGroup.patchValue({
                                        isIMPAgree: false
                                    })
                                    this.impSubmit(false);
                                }
                            }
                        }
                    }
                }
            }
        }
        this.saveContractMultiPayment();
        this.identifyFinaldocument();
        this.loadContractSessionByInventionId(this.inventionId);
        this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    this.contractSession = UtilityService.clone(res);
                    this.loadAddlDoc();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
        if (this.isSecondContract) {
            this.inventionDetails.i2FirstName = this.prodConfigGroup.controls.i2firstname.value;
            this.inventionDetails.i2LastName = this.prodConfigGroup.controls.i2lastname.value;
            this.inventionDetails.isCoInventor = this.prodConfigGroup.controls.coInventor.value;
            this.updateInvention();
        }
        this.getInventHelpSite();
    }

    identifyFinaldocument() {
        if (this.finaldocument == "tdIsFinalDocuments")
            this.contractActionlog.actionFlag = "contractSign";
    }

    infoBIPSubmit(stepper: CdkStepper): void {
        this.validateAllFormFields(this.prodConfigGroup);
        if (this.prodConfigGroup.valid) {
            this.prodConfigGroup.markAsPristine();
            this.navScrrol = '#divBIP';
            this.copyInfoCollectValuesToDataObject("BIP");
            this.updateContractLogObjectModel("bipFormSubmit", false);
            this.saveContrActionAcitonLog();
            if (this.payMode == 'Down Payment' && this.contractSession.CountryID >= 6)
                this.showDivItem(this.stepper, 1, '#divUPC');
            else if (this.payMode == 'Down Payment')
                this.showDivItem(this.stepper, 1, '#divIFI');
        }
    }

    addendumSubmit(ActionLogFlag: boolean = true): void {
        this.validateAllFormFields(this.prodConfigGroup);

        if (this.prodConfigGroup.valid) {
            this.prodConfigGroup.markAsPristine();
            this.copyInfoCollectValuesToDataObject("SUB");
            if (ActionLogFlag) {
                this.updateContractLogObjectModel("addendumSubmit", false);
                this.saveContrActionAcitonLog("addendumSubmit");
            }
            if (this.payMode == 'Down Payment' && ActionLogFlag)
                this.showDivItem(this.stepper, 1, '#divIFI');
            else if (((this.prodConfigGroup.controls.contract.value == 3) || (this.prodConfigGroup.controls.contract.value == 7 || this.prodConfigGroup.controls.contract.value == 8 || this.prodConfigGroup.controls.contract.value == 12 || this.prodConfigGroup.controls.contract.value == 13 || this.prodConfigGroup.controls.contract.value == 14)) && ActionLogFlag)
                this.showDivItem(this.stepper, 1, '#divCheckList');
        }
    }

    inventionCheckListSubmit(): void {
        this.checkListStatus = this.checkListValid();
        if (!this.checkListStatus)
            this.openSnackBar("Please select your appropriate choice before submit.", "");
        else {
            this.copyInfoCollectValuesToDataObject("CheckList");
            if (this.productId == 9 || this.productId == 10)
                this.loadDocument_DocTypeId(141);
            else
                this.loadDocument_DocTypeId(-3);
            this.updateContractLogObjectModel("checkListFormSubmit", false);
            this.saveContrActionAcitonLog();
        }
    }

    checkListValid(): boolean {
        if (this.productId == 9 || this.productId == 10) {
            if ((this.prodConfigGroup.controls.isSolicitYes.value == true || this.prodConfigGroup.controls.isSolicitNo.value == true) &&
                (this.prodConfigGroup.controls.isRefineYes.value == true || this.prodConfigGroup.controls.isRefineNo.value == true) &&
                (this.prodConfigGroup.controls.isIndependentYes.value == true || this.prodConfigGroup.controls.isIndependentNo.value == true) &&
                (this.prodConfigGroup.controls.isAttorneyYes.value == true || this.prodConfigGroup.controls.isAttorneyNo.value == true) &&
                (this.prodConfigGroup.controls.isPurchasedYes.value == true || this.prodConfigGroup.controls.isPurchasedNo.value == true) &&
                (this.prodConfigGroup.controls.isWorkBrochureYes.value == true || this.prodConfigGroup.controls.isWorkBrochureNo.value == true) &&
                //(this.prodConfigGroup.controls.isBIPYes.value == true || this.prodConfigGroup.controls.isBIPNo.value == true) &&
                //(this.prodConfigGroup.controls.isBIPReportYes.value == true || this.prodConfigGroup.controls.isBIPReportNo.value == true || this.prodConfigGroup.controls.isNABIPReport.value == true) &&
                //(this.prodConfigGroup.controls.isServiceFeesYes.value == true || this.prodConfigGroup.controls.isServiceFeesNo.value == true) &&
                (this.prodConfigGroup.controls.isPRSBrochureYes.value == true || this.prodConfigGroup.controls.isPRSBrochureNo.value == true) &&
                (this.prodConfigGroup.controls.isPPSOYes.value == true || this.prodConfigGroup.controls.isPPSONo.value == true)) {
                if (this.contractSession.CountryID > 2)
                    return true;
                else if (this.isNewCanadianContract) {
                    if (this.prodConfigGroup.controls.isADSYes.value == true || this.prodConfigGroup.controls.isADSNo.value == true)
                        return true;
                    else
                        return false;
                }
                else {
                    if ((this.prodConfigGroup.controls.isADSYes.value == true || this.prodConfigGroup.controls.isADSNo.value == true) &&
                        (this.prodConfigGroup.controls.isNDAYes.value == true || this.prodConfigGroup.controls.isNDANo.value == true))
                        return true;
                    else
                        return false;
                }
            }
            else
                return false;
        }
        else {
            if ((this.prodConfigGroup.controls.isSubmitYes.value == true || this.prodConfigGroup.controls.isSubmitNo.value == true) &&
                (this.prodConfigGroup.controls.isAcceptYes.value == true || this.prodConfigGroup.controls.isAcceptNo.value == true) &&
                (this.prodConfigGroup.controls.isDataBankYes.value == true || this.prodConfigGroup.controls.isDataBankNo.value == true) &&
                (this.prodConfigGroup.controls.isSolicitsYes.value == true || this.prodConfigGroup.controls.isSolicitsNo.value == true) &&
                (this.prodConfigGroup.controls.isPrepareYes.value == true || this.prodConfigGroup.controls.isPrepareNo.value == true) &&
                (this.prodConfigGroup.controls.isStaffYes.value == true || this.prodConfigGroup.controls.isStaffNo.value == true) &&
                (this.prodConfigGroup.controls.isBIPSYes.value == true || this.prodConfigGroup.controls.isBIPSNo.value == true) &&
                (this.prodConfigGroup.controls.isPRSYes.value == true || this.prodConfigGroup.controls.isPRSNo.value == true) &&
                (this.prodConfigGroup.controls.isSoldYes.value == true || this.prodConfigGroup.controls.isSoldNo.value == true) &&
                (this.prodConfigGroup.controls.isSendYes.value == true || this.prodConfigGroup.controls.isSendNo.value == true) &&
                (this.prodConfigGroup.controls.isIdeasYes.value == true || this.prodConfigGroup.controls.isIdeasNo.value == true) &&
                (this.prodConfigGroup.controls.isShowsYes.value == true || this.prodConfigGroup.controls.isShowsNo.value == true) &&
                (this.prodConfigGroup.controls.isWorkBrochureYes.value == true || this.prodConfigGroup.controls.isWorkBrochureNo.value == true) &&
                (this.prodConfigGroup.controls.isBIPYes.value == true || this.prodConfigGroup.controls.isBIPNo.value == true) &&
                (this.prodConfigGroup.controls.isBIPReportYes.value == true || this.prodConfigGroup.controls.isBIPReportNo.value == true || this.prodConfigGroup.controls.isNABIPReport.value == true) &&
                (this.prodConfigGroup.controls.isServiceFeesYes.value == true || this.prodConfigGroup.controls.isServiceFeesNo.value == true) &&
                (this.prodConfigGroup.controls.isPRSBrochureYes.value == true || this.prodConfigGroup.controls.isPRSBrochureNo.value == true) &&
                (this.prodConfigGroup.controls.isPPSOYes.value == true || this.prodConfigGroup.controls.isPPSONo.value == true || this.prodConfigGroup.controls.isNAPPSO.value == true)) {
                if (this.contractSession.CountryID > 2)
                    return true;
                else if (this.isNewCanadianContract) {
                    if (this.prodConfigGroup.controls.isADSYes.value == true || this.prodConfigGroup.controls.isADSNo.value == true)
                        return true;
                    else
                        return false;
                }
                else {
                    if ((this.prodConfigGroup.controls.isADSYes.value == true || this.prodConfigGroup.controls.isADSNo.value == true) &&
                        (this.prodConfigGroup.controls.isNDAYes.value == true || this.prodConfigGroup.controls.isNDANo.value == true))
                        return true;
                    else
                        return false;
                }
            }
            else
                return false;
        }
    }

    impSubmit(ActionLogFlag: boolean = true): void {
        this.validateAllFormFields(this.prodConfigGroup);
        if (this.prodConfigGroup.valid) {
            if (ActionLogFlag)
                this.saveImpByService = "";
            this.prodConfigGroup.markAsPristine();
            this.navScrrol = '#divIMP';
            this.copyInfoCollectValuesToDataObject("IMP");
            if (ActionLogFlag) {
                this.updateContractLogObjectModel("impSubmit", false);
                this.saveContrActionAcitonLog();
                this.showDivItem(this.stepper, 1, '#divSUB');
            }
        }
    }

    infoInventorSubmit(stepper: CdkStepper): void {
        var repAltAmount = this.prodConfigGroup.controls.altAmount.value;
        repAltAmount = repAltAmount ? repAltAmount.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.prodConfigGroup.patchValue({
            altAmount: repAltAmount == 0 ? '' : repAltAmount,
        });
        this.validateAllFormFields(this.prodConfigGroup);
        if (this.prodConfigGroup.valid) {
            this.prodConfigGroup.markAsPristine();
            this.copyInfoCollectValuesToDataObject("InfoInvent");
            this.updateContractLogObjectModel("inventFormSubmit", false);
            this.saveContrActionAcitonLog();
        }
        if (this.payMode == 'Down Payment')
            this.showDivItem(this.stepper, 1, '#divUPC');
    }

    infoUniversalPaymentSubmit(stepper: CdkStepper): void {
        var repAltAmount = this.prodConfigGroup.controls.altAmount.value;
        repAltAmount = repAltAmount ? repAltAmount.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.prodConfigGroup.patchValue({
            altAmount: repAltAmount == 0 ? '' : repAltAmount,
        });
        this.validateAllFormFields(this.prodConfigGroup);
        if (this.prodConfigGroup.valid) {
            this.prodConfigGroup.markAsPristine();
            this.copyInfoCollectValuesToDataObject("UniPay");
            this.updateContractLogObjectModel("uniPayFormSubmit", false);
            this.saveContrActionAcitonLog();
            this.convertNumberToCurrency(this.prodConfigGroup.controls.altAmount.value, 'altAmount');
        }
        if (this.isShowCheckList == true)
            this.showDivItem(this.stepper, 1, '#divCheckList');
    }

    infoRetailSubmit(stepper: CdkStepper): void {
        this.isRISaved = true;
        this.openSnackBar("The Retail Installment was saved.", "");
    }

    InformationCollectSubmit(stepper: CdkStepper): void {
        this.loadDocument();
        if (this.navigation) {
            if (this.payOption == 1) {
                if (this.navigationResponse.navigation.isBIForm && this.navigationResponse.navigation.isBIPForm) {
                    stepper.next();
                } else
                    this.openSnackBar("Please save all forms before going on to the next step.", "");
            }
            else if (this.payOption == 2) {
                if (this.navigationResponse.navigation.isBIForm && this.navigationResponse.navigation.isBIPForm && this.navigationResponse.navigation.isInformInventForm && this.navigationResponse.navigation.isUniPayForm) {
                    stepper.next();
                } else
                    this.openSnackBar("Please save all forms before going on to the next step.", "");
            }
        }
    }

    calculatePayment() {
        if (this.flgInstallment) {
            this.isCalcPayment = true;
            this.copyProdConfigValuesToDataObject().subscribe((value) => console.log("calculatePayment"));
            if (!isNullOrUndefined(this.contractPaymentResponse) && this.contractPaymentResponse.contractPayment.cashPrice != 0) {
                this._billingService.GetCalculatedInstalmentAsync(this.encryptedUser, this.contractPaymentResponse)
                    .then(res => {
                        if (res) {
                            if (res.statusCode == 0) {
                                this.contractPaymentResponse = UtilityService.clone(res);
                                if (this.contractPaymentResponse) {
                                    this.contractPayment = this.contractPaymentResponse.contractPayment;
                                    if (this.contractPayment.APR == -999) {
                                        this.isAPRStatus = true;
                                        this.openSnackBar("Facing issue to connect LoanPro API to calculate APR. Please try again!", "");                                       
                                    }
                                    else {
                                        this.isAPRStatus = false;
                                        this.copyDataObjectToProdConfigValues();
                                        this.isCalcPayment = false;
                                        this.isCalc = true;
                                        this.isRetailInsDocument = true;
                                        this.isInfoInventDocument = true;
                                        this.isUniPayDocument = true;
                                        this.isPPADocument = true;
                                    }
                                }
                            } else {
                                console.log("Calculate Payment result status code: " + res.statusCode);
                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this._utilityService.handleErrorResponse(err);
                        this.isCalcPayment = false;
                    });
            }
        }

        var cashPrice = this.prodConfigGroup.controls.cashPrice.value;
        cashPrice = cashPrice ? cashPrice.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.convertNumberToCurrency(cashPrice, 'cashPrice');

        var downPayment = this.prodConfigGroup.controls.downPayment.value;
        if (downPayment && typeof downPayment == "number")
            downPayment = downPayment.toString();
        downPayment = downPayment ? downPayment.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.convertNumberToCurrency(downPayment, 'downPayment');

        var rolloverAmount = this.prodConfigGroup.controls.rolloverAmount.value;
        rolloverAmount = rolloverAmount ? rolloverAmount.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.convertNumberToCurrency(rolloverAmount, 'rolloverAmount');

        var altAmount = this.prodConfigGroup.controls.altAmount.value;
        altAmount = altAmount ? altAmount.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.convertNumberToCurrency(altAmount, 'altAmount');
    }

    convertNumberToCurrency(cashPrice, valueFor) {
        if (cashPrice == 0) {
            return;
        }
        if (cashPrice > 99999) {
            if (valueFor == "cashPrice")
                this.openSnackBar("Cash Price cannot be greater than 99,999.00.", "");
            if (valueFor == "downPayment")
                this.openSnackBar("Down Payment cannot be greater than 99,999.00.", "");
            if (valueFor == "rolloverAmount")
                this.openSnackBar("Rollover amount cannot be greater than 99,999.00.", "");
            if (valueFor == "altAmount")
                this.openSnackBar("Alternate amount cannot be greater than 99,999.00.", "");
            return;
        }
        cashPrice = Number(cashPrice).toFixed(2);
        cashPrice += '';
        var x = cashPrice.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        var regxCashPrice = x1 + x2;

        if (valueFor == 'cashPrice') {
            this.prodConfigGroup.patchValue({
                cashPrice: this.currencySterling + regxCashPrice
            });
        }
        else if (valueFor == 'downPayment') {
            this.prodConfigGroup.patchValue({
                downPayment: this.currencySterling + regxCashPrice
            });
        }
        else if (valueFor == 'rolloverAmount') {
            this.prodConfigGroup.patchValue({
                rolloverAmount: this.currencySterling + regxCashPrice
            });
        }
        else if (valueFor == 'altAmount') {
            this.prodConfigGroup.patchValue({
                altAmount: this.currencySterling + regxCashPrice
            });
        }

    }

    checkExpiry(divid) {
        var datePipe = new DatePipe("en-US");
        this.expDate = datePipe.transform(new Date(), 'MMyyyy');
        if (divid == 'divUPC') {
            if (this.prodForm.cCardExpDT.value)
                this.cCardExpDTfield = this.prodForm.cCardExpDT.value.substring(0, 2) + this.expDate.substring(2, 4) + this.prodForm.cCardExpDT.value.substring(2, 4);
        }
        else if (divid == 'divCPG') {
            if (this.collectPaymentForm.expirationDate.value)
                this.cCardExpDTfield = this.collectPaymentForm.expirationDate.value.substring(0, 2) + this.expDate.substring(2, 4) + this.collectPaymentForm.expirationDate.value.substring(2, 4);
        }

        if (parseInt(this.cCardExpDTfield.substring(2, 6)) < parseInt(this.expDate.substring(2, 6))) {
            this.openSnackBar("Please check the card's expiration date.", "");
            return this.expiry = true;
        }

        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) == parseInt(this.expDate.substring(2, 6)) && parseInt(this.cCardExpDTfield.substring(0, 2)) < parseInt(this.expDate.substring(0, 2))) {
            this.openSnackBar("Please check the card's expiration date.", "");
            return this.expiry = true;
        }

        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) >= parseInt(this.expDate.substring(2, 6))) {
            return this.expiry = false;
        }

        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) == parseInt(this.expDate.substring(2, 6)) && parseInt(this.cCardExpDTfield.substring(0, 2)) == parseInt(this.expDate.substring(0, 2))) {
            return this.expiry = false;
        }

        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) == parseInt(this.expDate.substring(2, 6)) && parseInt(this.cCardExpDTfield.substring(0, 2)) < parseInt(this.expDate.substring(0, 2))) {
            this.openSnackBar("Please check the card's expiration date.", "");
            return this.expiry = true;
        }
        else
            return this.expiry = false;
    }

    private async saveContractSession() {
        this._wizardService.createContractSessionAsync(this.encryptedUser, this.inventionId, this.contactId, this.productId, false, 0, false, this.clpUserId, false, 1)
            .then(res => {
                if (res) {
                    this.contractSessionResponse = UtilityService.clone(res);
                    if (this.contractSessionResponse) {
                        if (this.contractPayment) {
                            this.contractPayment.contractSessionId = this.contractSessionId;
                        }
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async CreateUpdate_ContractSession() {
        this.contractSession.CLPUserId = this.clpUserId;
        this.contractSession.productId = + $("#contract option:selected").val();
        this._contractSessionService.createContactSessionAsync(this.encryptedUser, this.contractSession)
            .then(res => {
                if (res) {
                    this.contractSession = UtilityService.clone(res);
                    this.contractSessionId = this.contractSession.ContractSessionId;
                    forkJoin(this.loadContractSession(), this.contractSession.productId == 11 ? this.loadDocument_DocTypeId(-1) : this.loadDocument_DocTypeId(22)).subscribe(results => {
                    });
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
        this.isUpdateContractSessionDone = true;
    }

    private async CreateUpdate_BIPConfirmation(response: string) {
        this._contractSessionService.createBIPConfirmationAsync(this.encryptedUser, this.bipConfirmation)
            .then(res => {
                if (res) {
                    this.bipConfirmation = UtilityService.clone(res);
                    if (response == 'Yes') {
                        this.copyContactDetailsToDataObject();
                        this.updateContactInSalesOptima();
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async CreateUpdate_Addendum() {
        this._addendumService.AddendumServices_CreateAsync(this.encryptedUser, this.addendumServicesResponse)
            .then(res => {
                if (res) {
                    this.addendumServicesResponse = UtilityService.clone(res);

                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async CreateUpdate_InventionCheckList() {
        this._inventionCheckListService.InventionCheckList_CreateAsync(this.encryptedUser, this.inventionCheckListResponse)
            .then(res => {
                if (res) {
                    this.inventionCheckListResponse = UtilityService.clone(res);
                    this.openSnackBar("Invention CheckList saved successfully.", "");
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async saveContractPayment() {
        if (this.contractPayment.paymentOptionId == 1) {
            this.oneTimeFee = Number(this.contractPayment.cashPrice);
            this.oneTimeFeeInitial = Number(this.contractPayment.cashPrice);
        }
        else {
            this.oneTimeFee = Number(this.contractPayment.downPayment);
            this.oneTimeFeeInitial = Number(this.contractPayment.downPayment);
            this.isRetailInsDocument = this.flgInstallment;
            this.isInfoInventDocument = this.flgInstallment;
            this.isUniPayDocument = this.flgInstallment;
            this.isPPADocument = this.flgInstallment;
        }
        if (this.contractPaymentResponse.contractPayment.countryId == 0)
            this.contractPaymentResponse.contractPayment.countryId = this.customerCountryID;
        this._billingService.ContractPayment_CreateUpdateAsync(this.encryptedUser, this.contractPaymentResponse)
            .then(res => {
                if (res) {
                    this.contractPaymentResponse = UtilityService.clone(res);

                    if (this.contractPaymentResponse) {
                        if (this.contractPaymentResponse.contractPayment.countryId > 0) {
                            this.updateUserSteps("tdIsProdServicesForm");
                            this.openSnackBar("The product configuration was saved.", "");
                            this.isServiceFormSaved = true;
                            this.contractPayment = this.contractPaymentResponse.contractPayment;
                            this.divOtherMandDocs = true;
                            this.loadFileNumber();
                            this.loadDocument();
                            this.getOtherMandateDoc();
                            this.prodConfigGroup.patchValue({
                                officeCode: this.contractPayment.officeId || 1,
                            });
                        }
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async saveBIP() {
        if (this.contractSession) {
            this.CreateUpdate_ContractSession();
            if (this.contractSession.productId < 9 || this.contractSession.productId == 12 || this.contractSession.productId == 13 || this.contractSession.productId == 14) {
                this.isBIPSaved = true;
                this.updateUserSteps("tdIsBIPForm");
                this.openSnackBar("The Basic Information Package Agreement was saved.", "");
            }
        }
    }

    private async saveInventionCheckList() {
        if (this.contractSession) {
            this.CreateUpdate_InventionCheckList();
            this.updateUserSteps("tdIsCheckListForm");
        }
    }

    private async saveSUB() {
        if (this.addendumServicesResponse.addendum) {
            this.CreateUpdate_Addendum();
            if (this.saveByService == 'service') {
                this.isSUBSaved = false;
                this.uncheckNavBar('tdIsSUBForm');

                if (this.navigationResponse.navigation) {
                    this.navigationResponse.navigation.clpUserId = this.clpUserId;
                    this.navigationResponse.navigation.contractSessionId = this.contractSessionId;
                    this.navigationResponse.navigation.inventionId = this.inventionId;
                    this.navigationResponse.navigation.dtModified = new Date();

                    this.navigationResponse.navigation.isSUBForm = false;
                    this.navigationResponse.navigation.currentStep = 2;
                    this.navigationResponse.navigation.isSUBDoc = false; this.isSUBAccept = false; this.isSUBHeadAccept = false; this.uncheckNavBar('tdIsSUBDoc');
                }
            } else {
                this.isSUBSaved = true;
                this.updateUserSteps("tdIsSUBForm");
                this.openSnackBar("The Addendum was saved.", "");
            }
            this.saveByService = "";
        }
    }

    private async saveIMP() {
        if (this.contractSession) {
            if ((+$("#contract option:selected").val() == 4) || (+$("#contract option:selected").val() == 5))
                this.CreateUpdate_ContractSession();
            if (this.saveImpByService == 'service') {
                this.isIMPSaved = false;
                this.uncheckNavBar('tdIsIMPForm');

                if (this.navigationResponse.navigation) {
                    this.navigationResponse.navigation.clpUserId = this.clpUserId;
                    this.navigationResponse.navigation.contractSessionId = this.contractSessionId;
                    this.navigationResponse.navigation.inventionId = this.inventionId;
                    this.navigationResponse.navigation.dtModified = new Date();

                    this.navigationResponse.navigation.isIMPForm = false;
                    this.navigationResponse.navigation.currentStep = 2;
                    this.navigationResponse.navigation.isIMPDoc = false; this.isIMPAccept = false; this.isIMPHeadAccept = false; this.uncheckNavBar('tdIsIMPDoc');
                }

            } else {
                this.isIMPSaved = true;
                this.updateUserSteps("tdIsIMPForm");
                this.openSnackBar(+$("#contract option:selected").val() == 5 ? "Web Services was saved." : "IMP was saved.", "");
            }
            this.saveImpByService = "";
        }
    }

    private async saveInventorInvention() {
        this._infoCollectService.InventorInvention_CreateAsync(this.encryptedUser, this.inventorInformationResponse)
            .then(res => {
                if (res) {
                    this.inventorInformationResponse = UtilityService.clone(res);

                    if (this.inventorInformationResponse) {
                        this.updateUserSteps("tdIsInformInventForm");
                        if (this.inventorInformationResponse.inventorInformation.i1DOB != '' && this.inventorInformationResponse.inventorInformation.i1SSN != ''
                            && !isNullOrUndefined(this.inventorInformation.i1SSN) && !isNullOrUndefined(this.inventorInformation.i1DOB))
                            this.isIISaved = true;
                        this.loadDocument_DocTypeId(24);
                        this.openSnackBar("The Inventor Information was saved.", "");
                        this.inventorInformation = this.inventorInformationResponse.inventorInformation;
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async saveUtilityPayment() {
        this._infoCollectService.UniversalPayment_CreateAsync(this.encryptedUser, this.universalPaymentResponse)
            .then(res => {
                if (res) {

                    this.universalPaymentResponse = UtilityService.clone(res);
                    if (this.universalPaymentResponse) {
                        this.openSnackBar("The Universal Payment Corporation was saved.", "");
                        this.updateUserSteps("tdIsUniPayForm");
                        this.universalPayment = this.universalPaymentResponse.universalPayment;
                        this.loadDocument_DocTypeId(26);
                        this.loadMandatoryDocument(this.waitStateDocTypeId);
                        this.isUPSaved = true;
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async saveSignature() {
        await this.copyFormValuesToDataObject();
        if (this.validateSignBeforeSave()) {
            await this._documentService.saveDocumentAsync(this.documentContainer, this.encryptedUser)
                .then(res => {
                    if (res) {
                        this.documentResponse = UtilityService.clone(res);
                        if (this.documentResponse) {
                            this.loadMandatoryDocument(1);
                            this.loadMandatoryDocument(3);
                            if (this.isCoInventor) {
                                this.socGroup.patchValue({
                                    initialCoInvSignature: ''
                                })
                                this.signaturePadCoInv.on();
                            }
                            this.socGroup.patchValue({
                                initialSignature: ''
                            })
                            this.signaturePad.on();
                            this.loadDocumentSignature();
                        }
                    }
                }).catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else {
            this.openSnackBar("Signature could not captured. Please refresh the contract and sign it again.", "");
        }
    }

    validateSignBeforeSave(): boolean {
        this.strMsg = "";
        if (!isNullOrUndefined(this.documentContainer)) {
            if (this.documentContainer.signature == '' && this.documentContainer.initial == '' && this.documentContainer.i1SignatureADS == '' && this.documentContainer.i1InitialADS == ''
                && this.documentContainer.i1SignatureFinal == '' && this.documentContainer.i1InitialFinal == '' && this.documentContainer.i2signature == '' && this.documentContainer.i2initial == ''
                && this.documentContainer.i2SignatureADS == '' && this.documentContainer.i2InitialADS == '' && this.documentContainer.i2SignatureFinal == '' && this.documentContainer.i2InitialFinal == '') {
                this.strMsg == 'Signature could not captured. Please refresh the contract and sign it again.';
            }

        } else {
            this.strMsg = "Issue encountered! Please reload the contract and try again.";
        }
        if (this.strMsg != '') {
            if (!isNullOrUndefined(this.navigationResponse)) {
                this.navigationResponse.navigation.isSOCDoc = false; this.uncheckNavBar('tdIsSOCDoc');
                this.navigationResponse.navigation.isADSDoc = false; this.uncheckNavBar('tdIsADSDoc');
                this.navigationResponse.navigation.isFinalSign = false; this.uncheckNavBar('tdIsFinalDocuments');
                this.saveNavigationWizard();
            }
            return false;
        }
        return true;
    }

    private async saveSignatureNextContract() {
        let dc: DocumentContainer = {} as any;
        dc.contractSessionId = this.contractSessionId;
        dc.contactId = this.contactId;
        dc.currentUser = this.currentUser;
        dc.documentTypeId = 1;
        dc.inventionId = this.inventionId
        dc.signature = "";
        dc.i1SignatureADS = "";
        dc.i1SignatureFinal = "";
        dc.wizardId = 1;
        this.documentContainer = dc;

        await this._documentService.saveDocumentAsync(this.documentContainer, this.encryptedUser)
            .then(res => {
                if (res) {
                    this.documentResponse = UtilityService.clone(res);
                    if (this.documentResponse) {
                        this.loadDocumentSignature();
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async saveData() {
        this.isSaving = true;
        this.copyFormValuesToDataObject();
        if (this.contractSession && this.contractSession.sendToCorp) {
            this.contractSession.sendToCorp = false;
            this.CreateUpdate_ContractSession();
        }

        await this._contactService.updateContactAsync(this.encryptedUser, this.contactDetails)
            .then(res => {
                if (res) {
                    this.contactResponse = UtilityService.clone(res);
                    if (this.contactResponse) {
                        this.email = this.contactResponse.contactDetails.email;
                        this.collectPaymentGroup.patchValue({
                            firstName: this.contactResponse.contactDetails.firstname,
                            lastName: this.contactResponse.contactDetails.lastname,
                        })
                        this.loadMandatoryDocs();
                        this.loadDocument();
                        if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
                            this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                                .then(res => {
                                    if (res) {

                                        this.contractSession = UtilityService.clone(res);
                                        this.loadUserState(this.contractSession.clientState);
                                    }
                                }).then(r => { this.changeProduct() })
                                .catch((err: HttpErrorResponse) => {
                                    this._utilityService.handleErrorResponse(err);
                                });
                            this.isCoInventor = this.socGroup.controls.chkinvent.value ? this.socGroup.controls.chkinvent.value : false;
                            this.person = this.socGroup.controls.firstname.value ? this.socGroup.controls.firstname.value + ' ' + this.socGroup.controls.lastname.value : "";
                            this.i2person = this.socGroup.controls.firstnamei2.value ? this.socGroup.controls.firstnamei2.value + ' ' + this.socGroup.controls.lastnamei2.value : "";
                            this.openSnackBar("The SOC details were saved.", "");
                            this.updateInvention();
                        }
                    }
                    this.loadMandatoryDocument("1");
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
                this.openSnackBar("The SOC details were not saved. Please contact your administrator.", "");
            });
    }

    private async saveprodConfigData() {
        this.isSaving = true;
        this.copyProdConfigValuesToDataObject();
    }

    private async saveNavigationWizard() {
        if (isNullOrUndefined(this.navigationResponse)) {
            await this.refillNavigationWizard();
        }
        if (!isNullOrUndefined(this.navigationResponse) && (this.navigationResponse.navigation.inventionId > 0)) {
            this._navigationService.createNavigationWizardAsync(this.encryptedUser, this.navigationResponse)
                .then(res => {
                    if (res) {
                        this.navigationResponse = UtilityService.clone(res);
                        this.validateContractSteps();
                    }
                }).catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private updateInvention() {
        this._inventionService.updateInventionAsync(this.encryptedUser, this.inventionDetails)
            .then(res => {
                if (res) {
                    this.inventionResponse = UtilityService.clone(res);

                    if (this.inventionResponse) {

                        this.inventionDetails = UtilityService.clone(this.inventionResponse.inventionDetails);

                        this.contactId2 = -1;
                        this.c2Present = false;

                        if (this.inventionDetails.I2CLPContactId) {
                            this.contactId2 = this.inventionDetails.I2CLPContactId;
                        }

                        if (this.inventionDetails.Inventor2Present) {
                            this.c2Present = this.inventionDetails.Inventor2Present;
                        }
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    changeCountry(e) {
        this.handleSOCCountry(+e);
    }

    private fetchCountryList(): void {
        this._countryService.getCountryList(this.encryptedUser)
            .subscribe(
                (result: Country[]) => {
                    this.globalResponse = result;
                },
                error => {
                    console.error(error);
                },
                () => {
                    if (Array.isArray(this.globalResponse)) {
                        this.countryList = Object.assign([], this.globalResponse.filter(x => x.id != 399));
                        this.globalResponse = null;
                    }
                }
            );
    }
    private async handleChangeCountry(countryId: number) {
        await this.filterStateList(countryId).then(async res => {
            this.filteredStateList = res;
        });
    }

    private async handleSOCCountry(countryId: number) {
        this.isOtherCountry = false;
        let maxSize: number = 10;
        if (countryId == 1 || countryId == 2) {
            maxSize = 10;
            this.phoneMask = '(000) 000-0000';
            this.maxLength = '14';
            this.socGroup.controls.otherState.clearValidators();
            this.socGroup.controls.homephone.setValidators([Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
            this.socGroup.controls.workphone.setValidators([Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
            this.socGroup.controls.mobile.setValidators([Validators.required, Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
            await this.socGroup.patchValue({
                homephone: this.contactDetails.homephone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                workphone: this.contactDetails.workphone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                mobile: this.contactDetails.mobile.replace(/[() -]/g, '').substring(0, maxSize) || ''
            });
        }
        else {
            maxSize = 50;
            this.phoneMask = '';
            this.maxLength = '50';
            this.socGroup.controls.homephone.clearValidators();
            this.socGroup.controls.workphone.clearValidators();
            this.socGroup.controls.mobile.setValidators([Validators.required]);
            if (countryId == 399) {
                this.isOtherCountry = true;
                this.socGroup.controls.state.clearValidators();
                this.socGroup.controls.otherState.setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);
            }
            else {
                this.isOtherCountry = false;
                this.socGroup.controls.otherState.clearValidators();
            }
            await this.socGroup.patchValue({
                homephone: this.contactDetails.homephone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                workphone: this.contactDetails.workphone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                mobile: this.contactDetails.mobile.replace(/[() -]/g, '').substring(0, maxSize) || ''
            });
            switch (countryId) {
                case 3: await this.socGroup.patchValue({ state: 'AUS' }); break;
                case 4: await this.socGroup.patchValue({ state: 'UK' }); break;
                case 6: await this.socGroup.patchValue({ state: 'IRE' }); break;
                case 399: await this.socGroup.patchValue({ state: '-1' }); break;
                default: break;
            }
        }
        await this.filterSOCStateList(countryId).then(async res => {
            this.filteredSOCStateList = res;
        });

    }

    private async handlePOPUPState(countryId: number) {
        await this.filterPOPUPStateList(countryId).then(async res => {
            this.filteredPOPUPStateList = res;
        });
    }

    private filterStateforCountry() {
        this.filterStateList(this.defaultCountryId).then(async res => {
            this.filteredStateList = res;
            this.getUserState(this.currentUser.state)
        });
    }

    private async handlePOPUPCountry(countryId: number) {
        await this.filterStateList(countryId).then(async res => {
            this.filteredStateList = res;
        });
    }

    private async loadUserState(stateCode: string) {
        await this.filterUserStateList(stateCode).then(async res => {
            this.filterUserStateLst = res;
            if (this.filterUserStateLst[0]) {
                if (this.contractSession.CountryID < 2) {
                    this.waitDays = this.filterUserStateLst[0].waitDays || 0;
                    this.isWaitingPeriod = this.filterUserStateLst[0].waitPeriod || false;
                    this.userStateName = this.filterUserStateLst[0].name || '';
                    this.stateId = this.filterUserStateLst[0].id || 0;
                    this.isWestern = this.filterUserStateLst[0].isWestern;
                    this.isWaitStateDoc = this.isWaitingPeriod;
                    this.isWaitStateExists = this.isWaitingPeriod;
                    this.isWaitPrdForPayment = this.isWaitStateExists;
                    this._ClientsStateDataService.updateMessage(this.userStateName);
                }
            }
            this.loadDocumentType();
            this.loadAddlDoc();
        });
    }

    getUserState(state: string) {
        let stateCode: string = '-1';
        if (isNullOrUndefined(this.filteredStateList)) {
            this.filterStateList(this.defaultCountryId).then(async res => {
                this.filteredStateList = res;
                if (!isNullOrUndefined(this.filteredStateList)) {
                    for (let i = 0; i < this.filteredStateList.length; i++) {
                        if (this.filteredStateList[i].code.toLowerCase() == state.toLowerCase()) {
                            stateCode = state;
                            this.checkState = state;
                            this.loadsocDocument();
                        }
                    }
                }
            });
        } else {
            for (let i = 0; i < this.filteredStateList.length; i++) {
                if (this.filteredStateList[i].code.toLowerCase() == state.toLowerCase()) {
                    stateCode = state;
                    this.checkState = state;
                    this.loadsocDocument();
                }
            }
            if (this.checkState == "")
                this.openSnackBar("Please update the correct State Code in your SalesOptima User Profile Page.", "", 10000);
        }
        return stateCode;
    }

    getState(state: string, country: string) {
        let stateCode: string = '-1';
        if ((state == "United Kingdom") || (state == "UK") || (country == "4") || state.toLowerCase().startsWith("uk"))
            stateCode = "UK";
        else if ((state == "Ireland") || (state == "IRE") || (country == "6") || state.toLowerCase().startsWith("ire"))
            stateCode = "IRE";
        else if (state.toLowerCase().startsWith("aus") || (state == "AUS") || (country == "3"))
            stateCode = "AUS";
        else if ((this.contactDetails.country.toLowerCase() == "united states of america") || (this.contactDetails.country.toLowerCase() == "usa")
            || (this.contactDetails.country.toLowerCase() == "us") || (this.contactDetails.country.toLowerCase() == "united states") || (this.contactDetails.country.toLowerCase() == "america")
            || (this.contactDetails.country == "1") || ((this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country)))
            || (this.contactDetails.country.toLowerCase() == "can") || (this.contactDetails.country.toLowerCase() == "canada") || (this.contactDetails.country == "2"))
            stateCode = isNullOrUndefined(this.filteredSOCStateList) ? "-1" : this.filteredSOCStateList.filter(x => x.code.toLowerCase() == state.toLowerCase())[0].code;
        else
            stateCode = state;
        return stateCode;
    }

    private async fetchStateList() {
        await this._stateService.getStateList(this.encryptedUser)
            .then(async (result: State[]) => {
                this.stateList = UtilityService.clone(result);
                await this.handleChangeCountry(this.defaultCountryId);
                this.popUPStateList = UtilityService.clone(result);
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async fetchSOCStateList(country: number) {
        await this._stateService.getStateList(this.encryptedUser)
            .then(async (result: State[]) => {
                this.socStateList = UtilityService.clone(result);
                await this.handleSOCCountry(country);
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async filterStateList(iCountryId: number): Promise<State[]> {
        const filteredRecords: State[] = this.stateList.filter(st => st.countryId == iCountryId);
        return await UtilityService.clone(filteredRecords);
    }

    private async filterAddlDoc(): Promise<State[]> {
        const filteredRecords: State[] = this.stateList.filter(st => (st.code == this.contractSession.clientState) && st.isAddlDoc == true);
        return await UtilityService.clone(filteredRecords);
    }

    private async filterUserStateList(istateCode: string): Promise<State[]> {
        const filteredRecords: State[] = this.stateList.filter(st => st.code == istateCode);
        return await UtilityService.clone(filteredRecords);
    }

    private async filterSOCStateList(iCountryId: number): Promise<State[]> {
        const filteredRows: State[] = this.socStateList.filter(st => st.countryId == iCountryId);
        return await UtilityService.clone(filteredRows);
    }

    private async filterPOPUPStateList(iCountryId: number): Promise<State[]> {
        const filteredRows: State[] = this.popUPStateList.filter(st => st.countryId == iCountryId);
        return await UtilityService.clone(filteredRows);
    }

    private preparesocGroup(): FormGroup {
        return this.fb.group({
            firstname: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            lastname: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            address1: [{ value: '' }, [Validators.required]],
            address2: [{ value: '' }],
            address3: [{ value: '' }],
            country: [{ value: '-1' }, [CustomValidators.requiredDropdown(-1)]],
            state: [{ value: '-1' }, [CustomValidators.requiredDropdown(-1)]],
            city: [{ value: '' }, [Validators.required]],
            zipcode: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9-\s]{0,50})$/)]],
            homephone: [{ value: '' }, [Validators.pattern(/^\d{10}$/)]],
            workphone: [{ value: '' }, [Validators.pattern(/^\d{10}$/)]],
            //mobile: [{ value: '' }, [Validators.required, Validators.pattern(/^\d{10}$/)]],
            mobile: [{ value: '' }, [Validators.required]],
            email: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/)]],
            inventname: ['', Validators.required],
            chkinvent: [{ value: false }],
            chkcoInventConfirm: [{ value: false }],
            firstnamei2: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            lastnamei2: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            mobilei2: [{ value: '' }, [Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)]],
            emaili2: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/)]],
            initialSignature: [{ value: '' }],
            initialCoInvSignature: [{ value: '' }],
            initialAdsSignature: [{ value: '' }],
            initialAdsCoInvSignature: [{ value: '' }],
            otherState: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            otherCountry: [{ value: '' }],
        });
    }

    private async checkUserState() {
        this.socGroup = this.preparesocGroup();
        this.socGroup.reset();
        await this.fetchCountryList();
        await this.fetchStateList();
        this._route.queryParamMap.subscribe(params => {
            if (params.has('r')) {
                this.encryptedUser = params.get('r');

                if (params.has('i'))
                    this.inventionId = +params.get('i');

                this._route.paramMap.subscribe(async params => {
                    if (params.has('contact')) {
                        this.contactId = +params.get('contact');
                        if (params.has('invention')) {
                            if (!this.inventionId)
                                this.inventionId = +params.get('invention');
                            if (params.has('contractSessionId')) {
                                this.contractSessionId = +params.get('contractSessionId');
                                if (isNullOrUndefined(this.clpUserId)) {
                                    if (!isNullOrUndefined(this.encryptedUser)) {
                                        this._userService.getAuthenticateR(this.encryptedUser)
                                            .then(res => {
                                                if (res) {
                                                    if (res.isvalid) {
                                                        this.userResponse = UtilityService.clone(res);
                                                        this.clpUserId = this.userResponse.user.clpUserId;
                                                        this.currentUser = this.userResponse.user;
                                                        this.defaultCountryId = this.currentUser.clpUserCountryID;
                                                        this.filterStateforCountry();
                                                        if (isNullOrUndefined(this.contractSession))
                                                            this.handlePOPUPCountry(this.currentUser.clpUserCountryID);
                                                        else
                                                            this.handlePOPUPCountry(this.contractSession.CountryID);
                                                        console.log("Valid User");
                                                    } else {
                                                        this._router.navigate(['/unauthorized']);
                                                    }
                                                } else {
                                                    this._router.navigate(['/unauthorized']);
                                                }
                                            })
                                            .catch((err: HttpErrorResponse) => {
                                                console.log("Client side Error : " + err);
                                                this._utilityService.handleErrorResponse(err);
                                            });
                                    } else {
                                        this._router.navigate(['/unauthorized']);
                                    }
                                }
                                else {
                                    this.currentUser = this.userResponse.user;
                                    this.defaultCountryId = this.currentUser.clpUserCountryID;
                                    this.filterStateforCountry();
                                    this.handlePOPUPCountry(this.currentUser.clpUserCountryID);
                                }
                            }
                            else
                                console.log("no contractSession");
                        }
                        else
                            console.log("no invention");
                    }
                    else
                        console.log("no contact");
                });

            } else {
                console.log("no r");
                this._router.navigate(['/unauthorized']);
            }
        });
    }

    private async loadsocDocument() {
        if (isNullOrUndefined(this.contactId)) {
            this._route.paramMap.subscribe(async params => {
                if (params.has('contact')) {
                    this.contactId = +params.get('contact');
                }
            })
        }
        await this._contactService.getContactAsync(this.encryptedUser, this.contactId)
            .then(async (result: ContactResponse) => {
                if (result) {
                    if (result.statusCode == 0) {

                        this.contactResponse = UtilityService.clone(result);
                        if (this.contactResponse) {
                            this.contactDetails = UtilityService.clone(this.contactResponse.contactDetails);
                            var invName = this.contactDetails.inventionName;
                            if (!isNullOrUndefined(this.inventionName) && !isNullOrUndefined(invName)) {
                                if (invName.toLowerCase() == this.inventionName.toLowerCase()) {
                                    this.isBIPClient = this.contactDetails.isBIPClient;
                                    this.isSubClient = this.contactDetails.isSubClient;
                                    this.isPPSOClient = this.contactDetails.isPPSOClient;
                                    this.isPlusClient = this.contactDetails.isPlusClient;
                                }
                                else {
                                    this.isBIPClient = this.isSubClient = this.isPPSOClient = this.isPlusClient = false;
                                }
                            } else {
                                this.isBIPClient = this.isSubClient = this.isPPSOClient = this.isPlusClient = false;
                            }

                            if (this.currentUser.email)
                                this.ccId = this.currentUser.email;
                            this.person = this.contactDetails.firstname + ' ' + this.contactDetails.lastname;
                            this.email = this.contactDetails.email;
                            this.collectPaymentGroup.patchValue({
                                firstName: this.contactDetails.firstname,
                                lastName: this.contactDetails.lastname,
                            })
                            if ((this.contactDetails.country.toLowerCase() == "united kingdom") || (this.contactDetails.country.toLowerCase() == "uk")
                                || (this.contactDetails.country.toLowerCase() == "england") || (this.contactDetails.country.toLowerCase() == "great britain") || (this.contactDetails.country == "4"))
                                this.fetchSOCStateList(4);
                            else if ((this.contactDetails.country.toLowerCase() == "ireland") || (this.contactDetails.country.toLowerCase() == "ire") || (this.contactDetails.country == "6"))
                                this.fetchSOCStateList(6);
                            else if ((this.contactDetails.country.toLowerCase() == "aus") || (this.contactDetails.country.toLowerCase() == "australia") || (this.contactDetails.country == "3"))
                                this.fetchSOCStateList(3);
                            else if ((this.contactDetails.country.toLowerCase() == "can") || (this.contactDetails.country.toLowerCase() == "canada") || (this.contactDetails.country == "2")) {
                                this.fetchSOCStateList(2);
                                this.customerCountryID = 2;
                                this.handleChangeCountry(2);
                            }
                            else if ((this.contactDetails.country.toLowerCase() == "united states of america") || (this.contactDetails.country.toLowerCase() == "usa")
                                || (this.contactDetails.country.toLowerCase() == "us") || (this.contactDetails.country.toLowerCase() == "united states") || (this.contactDetails.country.toLowerCase() == "america")
                                || (this.contactDetails.country == "1") || ((this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country)))) {
                                this.fetchSOCStateList(1);
                                this.customerCountryID = 1;
                                this.handleChangeCountry(1);
                            }
                            else {
                                this.fetchSOCStateList(399);
                                this.customerCountryID = 399;
                                this.handleChangeCountry(399);
                            }
                            this._billingService.getContractNum_GetAsync(this.encryptedUser, this.contractSessionId)
                                .then(res => {
                                    if (res) {
                                        this.contractNumberResponse = UtilityService.clone(res);
                                        if (!isNullOrUndefined(this.contractNumberResponse)) {
                                            this.contractNum = this.contractNumberResponse.contractNumDetails;
                                        }

                                        this.loadContractSessionByInventionId(this.inventionId);
                                        if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
                                            this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                                                .then(res => {
                                                    if (res) {
                                                        this.contractSession = UtilityService.clone(res);
                                                        if (this.contractSession.isDeleted) {
                                                            $(':button').prop('disabled', true);
                                                            $('#backButton').prop('disabled', false);
                                                            $('#closeFileButton').prop('disabled', false);
                                                            $('#backContractList').prop('disabled', false);
                                                            $("#idLocationMsg").text("This Contract is no longer exist in the system!");
                                                        }
                                                        else {
                                                            this.loadUserState(this.contractSession.clientState);
                                                            this.loadAddlDoc();
                                                        }
                                                        this.productId = this.contractSession.productId;
                                                        this.getInventHelpSite();
                                                    }
                                                }).then(r => { this.changeProduct() })
                                                .catch((err: HttpErrorResponse) => {
                                                    this._utilityService.handleErrorResponse(err);
                                                });
                                        }
                                    }
                                })
                                .catch((err: HttpErrorResponse) => {
                                    this._utilityService.handleErrorResponse(err);
                                });
                        }
                        resizeCanvas();
                        this.loadConfigMaster("Product Configuration", "Promotions");
                        this.loadTextToNumber();
                        this.getROIRefreshFlags(this.inventionId, 0);
                        this.loadOffice();
                        this.loadPromotionOffers();
                        if (!isNullOrUndefined(this.contactDetails) && this.contactDetails.state.trim().length < 1 &&
                            ((this.contactDetails.country.toLowerCase() == "can") || (this.contactDetails.country.toLowerCase() == "canada") || (this.contactDetails.country == "2")
                                || (this.contactDetails.country.toLowerCase() == "united states of america") || (this.contactDetails.country.toLowerCase() == "usa")
                                || (this.contactDetails.country.toLowerCase() == "us") || (this.contactDetails.country.toLowerCase() == "united states") || (this.contactDetails.country.toLowerCase() == "america") || (this.contactDetails.country == "1"))) {
                            this.openSnackBar("Please update the correct State Code in your SalesOptima contact page.", "");
                            return;
                        }
                        else {
                            this.loadContractSession();
                        }
                        this.drawClear();
                        this.drawClearCoInv();
                        this.drawClearADS();
                        this.drawClearADSCoInv();
                        this.drawClearFinal();
                        this.drawClearFinalCoInv();
                        this.getclpUserCountry();
                        this.chkSOC = false;
                        this.chkADS = false;
                    }
                    else {
                        console.log("contact result status code: " + result.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getContractMultiPayment(payoption) {
        await this._billingService.getContractMultiPaymentAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    this.contractMultiPaymentResponse = UtilityService.clone(res);
                    var _paidAmount: number = 0;
                    var _downPaymentAmount: number = 0;
                    if (!isNullOrUndefined(this.contractMultiPaymentResponse)) {
                        this.contractMultiPayments = this.contractMultiPaymentResponse.contractMultiPayment;
                        //Get the card number here
                        this._billingService.getPaymentDetailsAsync(this.encryptedUser, this.contractSessionId)
                            .then(res => {
                                if (res) {
                                    this.contractBillingTxnResponse = UtilityService.clone(res);
                                    this.contractBillingTxns = this.contractBillingTxnResponse.ContractBillingTxn;
                                    if (!isNullOrUndefined(this.contractSession)) {
                                        for (var i = 0; i < this.contractMultiPayments.length; i++) {
                                            for (var j = 0; j < this.contractBillingTxns.length; j++) {
                                                if ((this.contractMultiPayments[i].id == this.contractBillingTxns[j].ContractMutiPaymentId) && (this.contractBillingTxns[j].Status == 1) && (this.contractBillingTxns[j].TxnType == 1)) {
                                                    this.contractMultiPayments[i].CCNumber = 'CC_' + this.contractBillingTxns[j].CCNumber.substr(this.contractBillingTxns[j].CCNumber.length - 4);
                                                    break;
                                                }
                                                else
                                                    this.contractMultiPayments[i].CCNumber = '';
                                            }
                                            if (this.contractMultiPayments[i].isPaid) {
                                                var downPayment: any = this.contractMultiPayments[i].downPaymentPart;
                                                if (downPayment && typeof downPayment == "number")
                                                    downPayment = downPayment.toString();
                                                downPayment = downPayment ? downPayment.toString().replace(this.currencySterling, "").replace(',', "") : 0;
                                                _paidAmount += Number(downPayment);
                                            }
                                            _downPaymentAmount += Number(this.contractMultiPayments[i].downPaymentPart.toString().replace(this.currencySterling, "").replace(',', ""));
                                            if (this.contractMultiPayments[i].payOption == payoption)
                                                this.partialFee = this.contractMultiPayments[i].downPaymentPart.toString().replace(this.currencySterling, "").replace(',', "");
                                        }
                                    }
                                    this.contractMultiPaymentResponse.contractMultiPayment = this.contractMultiPayments;
                                    this.dataSource = new MatTableDataSource(this.contractMultiPayments);
                                    for (var i = 0; i < this.contractMultiPayments.length; i++) {
                                        this.convertPartDownPaymentToCurrency(this.contractMultiPayments[i])
                                    }
                                    this.oneTimeFee = Number(_downPaymentAmount);
                                    this.remainingDue = Number(_paidAmount);
                                    this.editedRowId = -1;
                                    this.isDeleted = false;

                                    if (!this.verifyMultiPayments()) {
                                        if (!isNullOrUndefined(this.navigationResponse)) {
                                            if (!this.navigationResponse.navigation.isPayCollectForm && !this.isReceiptSent)
                                                this.sendReceiptEmail();
                                        }
                                        this.updateUserSteps("tdIsPayCollectForm");
                                    }
                                } else {
                                    this.dataSource = new MatTableDataSource(this.contractMultiPayments);
                                    for (var i = 0; i < this.contractMultiPayments.length; i++) {
                                        this.convertPartDownPaymentToCurrency(this.contractMultiPayments[i])
                                    }
                                }
                            })
                            .catch((err: HttpErrorResponse) => {
                                this._utilityService.handleErrorResponse(err);
                            });

                    }
                    else {
                        this.isDeleted = false;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    addPaymentType() {
        if (this.contractSession.isCancelled == false) {
            this.updateUserSteps("tdIsPayCollectAgain");
            let contractMultiPay = {} as ContractMultiPayment;
            contractMultiPay.payOption = -1;
            contractMultiPay.isPaid = false;
            contractMultiPay.downPaymentPart = '0';
            contractMultiPay.action = "I";
            contractMultiPay.contractSessionId = this.contractSessionId;
            contractMultiPay.id = this.contractMultiPayments[this.contractMultiPayments.length - 1].id + 1;
            contractMultiPay.CCNumber = "";
            contractMultiPay.chkAccNo = "";
            contractMultiPay.chkBankName = "";
            contractMultiPay.chkCity = "";
            contractMultiPay.chkNumber = "";
            contractMultiPay.bankAccountName = "";
            contractMultiPay.chkDate = "";
            contractMultiPay.chkRoutingNo = "";
            contractMultiPay.chkState = "";
            contractMultiPay.isChkAmount = false;
            contractMultiPay.paymentStatus = false;
            contractMultiPay.isShowSelect = false;

            this.contractMultiPayments.push(contractMultiPay);
            this.dataSource = new MatTableDataSource(this.contractMultiPayments);
            forkJoin(this.calculateDownPayment(1), this.calculateDownPayment(2), this.showPaymentInterface(contractMultiPay.id, contractMultiPay.payOption, contractMultiPay.downPaymentPart, contractMultiPay.isPaid = false)).subscribe(results => {
            });
        }
    }

    async deleteRow(id, grdType) {
        this.collectionError = '';
        if (this.contractSession.isCancelled == false) {
            var rowid = this.editedRowId;
            this.editedRowId = -1;
            if (this.isEditPay) {
                let index = this.contractMultiPaymentResponse.contractMultiPayment.findIndex(x => x.id == rowid)
                this.contractMultiPaymentResponse.contractMultiPayment[index].isPaid = true;
                this.contractMultiPaymentResponse.contractMultiPayment[index].downPaymentPart = this.downpaymentPre;
            }
            this.isEditPay = !this.isEditPay;
            this.isDeleted = true;
            this.contractMultiPayments.find(x => x.id == id).action = 'D';
            this.contractMultiPaymentResponse.contractMultiPayment = this.contractMultiPayments;
            this.contractMultiPaymentResponse.contractSessionId = this.contractSessionId;
            for (var i = 0; i < this.contractMultiPaymentResponse.contractMultiPayment.length; i++) {
                this.contractMultiPaymentResponse.contractMultiPayment[i].downPaymentPart = (this.contractMultiPaymentResponse.contractMultiPayment[i].downPaymentPart.toString().replace(this.currencySterling, "").replace(',', ""));
            }

            this.ContractMultiPaymentCRUD('D');
            if (grdType == 2) {
                this.updateDownPaymentOnDelete(id);
                this.showPaymentInterface(1, this.contractMultiPaymentResponse.contractMultiPayment[0].payOption, this.contractMultiPaymentResponse.contractMultiPayment[0].downPaymentPart, this.contractMultiPaymentResponse.contractMultiPayment[0].isPaid);
            }
            else {
                await this.updateDownPaymentOnDelete(id, grdType);
                this.showDivItem(this.stepper, 1, '#divPS');
            }
            this.loadDocument_DocTypeId(25);
            this.saveContrActionAcitonLog();
        }
    }

    async updateDownPaymentOnDelete(id: number, grdType?: number) {
        var contractMultiPayment = this.contractMultiPaymentResponse.contractMultiPayment;

        if (contractMultiPayment.filter(y => y.id != -1).length > 1) {
            const removeIndex = contractMultiPayment.findIndex(item => item.id === id);
            contractMultiPayment.splice(removeIndex, 1);

            let totalPayment: number = 0;
            let downPaymentPart: number = 0;
            for (var i = 0; i < contractMultiPayment.length; i++) {
                downPaymentPart += parseFloat(contractMultiPayment[i].downPaymentPart.toString().replace(this.currencySterling, "").replace(',', ""));
            }
            totalPayment = parseFloat(this.prodForm.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', ""));

            if (downPaymentPart == totalPayment)
                this.contractPaymentResponse.contractPayment.paymentOptionId = 1;
            else if (downPaymentPart > totalPayment) {
                this.openSnackBar("Down Payment can not be greater than Cash Price", "");
                this.downpaymentExceed = true;
                this.serviceButtonText = "Please Wait...";
                return;
            }
            else {
                this.contractPaymentResponse.contractPayment.paymentOptionId = 2;
                this.downpaymentExceed = false;
                this.serviceButtonText = "Save";
            }
            if ((downPaymentPart != this.oneTimeFee) || (downPaymentPart != this.oneTimeFeeInitial)) {
                this.contractPaymentResponse.contractPayment.downPayment = downPaymentPart;
                await this.calculatePaymentForDelete(downPaymentPart, grdType);
            }
        }
    }

    async calculatePaymentForDelete(downPaymentPart: number, grdType: number) {
        if (this.contractPaymentResponse.contractPayment.paymentOptionId == 2) {
            this.isCalcPayment = true;
            this.copyProdConfigValuesToDataObject('D');
            this.contractPaymentResponse.contractPayment.downPayment = downPaymentPart;
            if (this.contractPaymentResponse.contractPayment.cashPrice != 0) {
                await this._billingService.GetCalculatedInstalmentAsync(this.encryptedUser, this.contractPaymentResponse)
                    .then(res => {
                        if (res) {
                            if (res.statusCode == 0) {
                                this.contractPaymentResponse = UtilityService.clone(res);
                                if (this.contractPaymentResponse) {
                                    this.contractPayment = this.contractPaymentResponse.contractPayment;
                                    this.copyDataObjectToProdConfigValues();
                                    this.isCalcPayment = false;
                                    this.isCalc = true;
                                    this.isRetailInsDocument = true;
                                    this.isInfoInventDocument = true;
                                    this.isUniPayDocument = true;
                                    this.isPPADocument = true;
                                    this.saveContractPaymentAfterMultiCRUD(grdType);
                                }
                            } else {
                                console.log("Calculate Payment result status code: " + res.statusCode);
                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this._utilityService.handleErrorResponse(err);
                        this.isCalcPayment = false;
                    });
            }
        }

        var cashPrice = this.prodConfigGroup.controls.cashPrice.value;
        cashPrice = cashPrice ? cashPrice.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.convertNumberToCurrency(cashPrice, 'cashPrice');

        var downPayment = this.prodConfigGroup.controls.downPayment.value;
        if (downPayment && typeof downPayment == "number")
            downPayment = downPayment.toString();
        downPayment = downPayment ? downPayment.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.convertNumberToCurrency(downPayment, 'downPayment');

        var rolloverAmount = this.prodConfigGroup.controls.rolloverAmount.value;
        rolloverAmount = rolloverAmount ? rolloverAmount.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.convertNumberToCurrency(rolloverAmount, 'rolloverAmount');

        var altAmount = this.prodConfigGroup.controls.altAmount.value;
        altAmount = altAmount ? altAmount.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.convertNumberToCurrency(altAmount, 'altAmount');

    }

    changeAmountOnCollection(grdType) {
        this.CopyMultiPaymentToDataObject(grdType);
        let _downPartPayment: number = 0;
        this.remainingDue = 0;
        for (var i = 0; i < this.contractMultiPayments.length; i++) {
            var downPayment: any = this.contractMultiPayments[i].downPaymentPart;
            if (downPayment && typeof downPayment == "number")
                downPayment = downPayment.toString();
            downPayment = downPayment ? downPayment.toString().replace(this.currencySterling, "").replace(',', "") : 0;
            _downPartPayment += Number(downPayment);
            if (this.contractMultiPayments[i].isPaid)
                this.remainingDue += Number(downPayment);
        }
        if (this.oneTimeFee < _downPartPayment)
            this.oneTimeFee = Number(_downPartPayment);
        else
            this.oneTimeFee = Number(_downPartPayment);
    }

    async calculateDownPayment(grdType) {
        this.CopyMultiPaymentToDataObject(grdType)
        let _downPartPayment: number = 0;
        for (var i = 0; i < this.contractMultiPayments.length; i++) {
            var downPayment: any = this.contractMultiPayments[i].downPaymentPart;
            if (downPayment && typeof downPayment == "number")
                downPayment = downPayment.toString();
            this.contractMultiPayments[i].downPaymentPart = downPayment ? downPayment.toString().replace(this.currencySterling, "").replace(',', "") : 0;
            _downPartPayment += +this.contractMultiPayments[i].downPaymentPart;
            if (!isNullOrUndefined(this.contractMultiPayments[i]))
                this.convertPartDownPaymentToCurrency(this.contractMultiPayments[i]);
        }
        if (this.prodConfigGroup.controls.cashPrice.value) {
            if (this.prodConfigGroup.controls.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', "") <= 0)
                await this.getSetContractPaymentPrice();
            if (_downPartPayment > +this.prodConfigGroup.controls.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', "")) {
                this.openSnackBar("Down Payment can not be greater than Cash Price", "");
                this.isPaymentExceeds = true;
                this.expiry = true;
                this.downpaymentExceed = true;
                this.serviceButtonText = "Please Wait...";
                return;
            }
            else {
                this.prodConfigGroup.patchValue({
                    downPayment: _downPartPayment == 0 ? '0.00' : _downPartPayment
                });
                this.isPaymentExceeds = false;
                this.expiry = false;
                this.downpaymentExceed = false;
                this.serviceButtonText = "Save";
            }
            _downPartPayment == +this.prodConfigGroup.controls.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', "") ? this.payMode = "Full Payment" : this.payMode = "Down Payment";
            this.payMode == "Full Payment" ? this.payOption = 1 : this.payOption = 2;
            var installCheckboxElement = <HTMLInputElement>document.getElementById("paymentInstallment");
            var fullCheckboxElement = <HTMLInputElement>document.getElementById("paymentFull");
            if (_downPartPayment == +this.prodConfigGroup.controls.cashPrice.value.toString().replace(this.currencySterling, "").replace(',', "")) {
                if (!isNullOrUndefined(fullCheckboxElement))
                    fullCheckboxElement.click();
            }
            else {
                if (!isNullOrUndefined(installCheckboxElement))
                    installCheckboxElement.click();
            }
            this.calculatePayment();
        }
    }

    convertPartDownPaymentToCurrency(contractPaymentObj) {
        var downPaymentPart = contractPaymentObj.downPaymentPart;
        var cnvtDownPaymentPart = downPaymentPart.toString();
        cnvtDownPaymentPart = cnvtDownPaymentPart ? !isNullOrUndefined(this.contractSession) ? cnvtDownPaymentPart.toString().replace(this.currencySterling, "").replace(',', "") : cnvtDownPaymentPart.toString().replace(this.currencySterling, "").replace(',', "") : '';
        if (cnvtDownPaymentPart == '0') {
            return;
        }
        if (cnvtDownPaymentPart > '99999') {
            this.openSnackBar("The downpayment amount cannot be greater than 99,999.00.", "");
            return;
        }
        cnvtDownPaymentPart = Number(cnvtDownPaymentPart).toFixed(2);
        cnvtDownPaymentPart += '';
        var x = cnvtDownPaymentPart.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        var regxCashPrice = x1 + x2;
        var currencydownPayment: any = !isNullOrUndefined(this.contractSession) ? this.currencySterling + regxCashPrice : this.currencySterling + regxCashPrice;
        contractPaymentObj.downPaymentPart = currencydownPayment;
    }

    CopyMultiPaymentToDataObject(grdType) {
        for (var i = 0; i < this.contractMultiPayments.length; i++) {
            this.contractMultiPayments[i].contractSessionId = this.contractSessionId;
            this.contractMultiPayments[i].id = this.contractMultiPayments[i].id == 0 ? 1 : this.contractMultiPayments[i].id;
            if (grdType == 1) {
                if (!isNullOrUndefined($('#downPaymentPart_' + this.contractMultiPayments[i].id).val())) {
                    if (this.contractMultiPayments[i].downPaymentPart.toString().replace(this.currencySterling, "").replace(',', "") != $('#downPaymentPart_' + this.contractMultiPayments[i].id).val().toString().replace(this.currencySterling, "").replace(',', "")) {
                        this.contractMultiPayments[i].isPaid = false;
                        this.contractMultiPayments[i].downPaymentPart = !isNullOrUndefined($('#downPaymentPart_' + this.contractMultiPayments[i].id).val()) ? $('#downPaymentPart_' + this.contractMultiPayments[i].id).val() : 0;
                        if (!this.contractMultiPayments[i].isPaid)
                            this.contractMultiPayments[i].payOption = $('#payOption_' + this.contractMultiPayments[i].id).val();
                        this.updateUserSteps("tdIsPayCollectAgain");
                    }
                    else {
                        if (!this.contractMultiPayments[i].isPaid)
                            this.contractMultiPayments[i].payOption = $('#payOption_' + this.contractMultiPayments[i].id).val();
                    }
                }
            } else {
                this.contractMultiPayments[i].downPaymentPart = !isNullOrUndefined($('#downPaymentPartC_' + this.contractMultiPayments[i].id).val()) ? $('#downPaymentPartC_' + this.contractMultiPayments[i].id).val() : 0;
                if (!this.contractMultiPayments[i].isPaid)
                    this.contractMultiPayments[i].payOption = $('#payOptionC_' + this.contractMultiPayments[i].id).val();
            }
        }
        this.dataSource = new MatTableDataSource(this.contractMultiPayments);
    }

    saveContractMultiPayment() {
        this.CopyMultiPaymentToDataObject(1);
        this.contractMultiPaymentResponse.contractMultiPayment = this.contractMultiPayments;
        this.contractMultiPaymentResponse.contractSessionId = this.contractSessionId;
        for (var i = 0; i < this.contractMultiPaymentResponse.contractMultiPayment.length; i++) {
            if (!isNullOrUndefined(this.contractMultiPaymentResponse.contractMultiPayment[i].downPaymentPart))
                this.contractMultiPaymentResponse.contractMultiPayment[i].downPaymentPart = (this.contractMultiPaymentResponse.contractMultiPayment[i].downPaymentPart.toString().replace(this.currencySterling, "").replace(',', ""));
        }
        this.ContractMultiPaymentCRUD('');
    }

    async ContractMultiPaymentCRUD(action) {
        await this._billingService.ContractMultiPayment_CreateAsync(this.encryptedUser, this.contractMultiPaymentResponse)
            .then(res => {
                if (res) {
                    if (this.contractPayment.paymentOptionId == 1) {
                        this.oneTimeFee = Number(this.contractPayment.cashPrice);
                        this.oneTimeFeeInitial = Number(this.contractPayment.cashPrice);
                    }
                    else {
                        this.downpaymentExceed = true;
                        this.serviceButtonText = "Please Wait...";
                        this.oneTimeFee = Number(this.contractPayment.downPayment);
                        this.oneTimeFeeInitial = Number(this.contractPayment.downPayment);
                    }
                    if (action == 'D') {
                        this.oneTimeFee = Number(this.contractPayment.downPayment);
                        this.oneTimeFeeInitial = Number(this.contractPayment.downPayment);
                        this.isReceiptSent = true;
                        //this.sendReceiptEmail();
                    }
                    else
                        this.isReceiptSent = false;
                    this.getContractMultiPayment("");
                    this.isEditPay = false;
                    setTimeout(() => {
                        this.downpaymentExceed = false;
                        this.serviceButtonText = "Save";
                        this.calculateDownPayment(1);
                        this.calculateDownPayment(2);
                    }, 9000);
                } else {
                    this.isDeleted = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getConversionRate() {
        var conversionCode = this.contractSession.CurrencyCode == 'USD' ? "" : this.contractSession.CurrencyCode;
        if (conversionCode != '') {
            await this._currencyConversion.getConversionrate(this.encryptedUser, conversionCode)
                .then(res => {
                    if (res) {
                        this.conversionRate = UtilityService.clone(res);
                        this.currencyRate = this.conversionRate ? this.conversionRate : 1;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async showPaymentInterface(id, payOption, downPaymentPart, isPaid) {
        if (!isPaid)
            this.paymentUploader.resetFileUpload();
        this.cardErrorMsg = '';
        this.collectionError = '';
        await this.getConversionRate();
        var partialValue = downPaymentPart ? this.currencyRate ? (downPaymentPart.toString().replace(this.currencySterling, "").replace(',', "") * this.currencyRate) : downPaymentPart.toString().replace(this.currencySterling, "").replace(',', "") : "0";
        this.originalPrice = downPaymentPart ? downPaymentPart.toString().replace(this.currencySterling, "").replace(',', "") : 0;
        this.partialFee = parseFloat(partialValue.toString()).toFixed(2);
        this.currentMultiPayId = id;
        this.isPaymentError = false;
        this.isPaymentDone = false;
        this.isPaymentProcessing = false;
        this.isSubmitCharge = false;
        this.isAccountNumberBlank = false;
        this.isRoutingNumberBlank = false;
        this.isBankAccountNameBlank = false;

        if (!isNullOrUndefined(payOption)) {
            switch (payOption.toString()) {
                case "1":
                    this.sel_brand = "unknown";
                    this.prodConfigGroup.patchValue({
                        payCreditCard: true,
                        payCheck: false,
                        payMoneyOrder: false,
                        payCash: false,
                        payOther: false,
                        payCarryOver: false,
                        payMonterey: false
                    });
                    if (!isPaid) {
                        if (!isNullOrUndefined(this.contactDetails)) {
                            this.collectPaymentGroup.patchValue({
                                firstName: this.contactDetails.firstname,
                                lastName: this.contactDetails.lastname,
                                creditCard: '',
                                expirationDate: '',
                                cvc: '',
                                zip: '',
                                paymentType: false,
                                fileNo: false,
                            });
                        }
                        this.cardTxnReference = '';
                        this.cardTxnNotes = '';
                        this.collectPaymentGroup.markAsDirty();
                        this.collectPaymentGroup.markAsPristine();
                        this.collectPaymentGroup.markAsUntouched();
                    } else {
                        this._billingService.getPaymentDetailsAsync(this.encryptedUser, this.contractSessionId)
                            .then(res => {
                                if (res) {
                                    this.contractBillingTxnResponse = UtilityService.clone(res);
                                    this.contractBillingTxns = this.contractBillingTxnResponse.ContractBillingTxn.filter(x => x.ContractMutiPaymentId == id && x.Status == 1);
                                    if (this.contractBillingTxns.length > 0) {
                                        this.cardTxnReference = this.contractBillingTxns[0].MerchantTransactionID;
                                        this.cardTxnNotes = this.contractBillingTxns[0].FileNumber;
                                        this.contractBillingTxns[0].Status == 1 ? this.isPaymentError = false : this.isPaymentError = true;
                                        this.isPaymentDone = true;
                                        this.isPaymentProcessing = false;
                                        this.isSubmitCharge = true;
                                    }
                                }
                            })
                            .catch((err: HttpErrorResponse) => {
                                this._utilityService.handleErrorResponse(err);
                            });
                    }
                    break;

                case "2":
                    this.prodConfigGroup.patchValue({
                        payCreditCard: false,
                        payCheck: false,
                        payMoneyOrder: true,
                        payCash: false,
                        payOther: false,
                        payCarryOver: false,
                        payMonterey: false
                    });
                    if (!isPaid) {
                        this.collectPaymentGroup.patchValue({
                            paymentType: false
                        });
                    } else {
                        this.collectPaymentGroup.patchValue({
                            paymentType: true
                        });
                    }
                    this.fetchPaymentDocList(this.contractSessionId, id, 1);
                    break;

                case "3":
                    this.prodConfigGroup.patchValue({
                        payCreditCard: false,
                        payCheck: true,
                        payMoneyOrder: false,
                        payCash: false,
                        payOther: false,
                        payCarryOver: false,
                        payMonterey: false
                    });
                    if (!isPaid) {
                        this.collectPaymentGroup.patchValue({
                            firstName: this.contactDetails.firstname,
                            lastName: this.contactDetails.lastname,
                            chkBankName: '',
                            chkCity: '',
                            chkState: '',
                            chkRoutingNo: '',
                            chkAccNo: '',
                            chkNumber: '',
                            bankAccountName: '',
                            paymentType: false
                        });
                    } else {
                        this._billingService.getContractMultiPaymentAsync(this.encryptedUser, this.contractSessionId)
                            .then(res => {
                                if (res) {
                                    this.contractMultiPaymentResponse = UtilityService.clone(res);
                                    var contractMultiPaymentObj = this.contractMultiPaymentResponse.contractMultiPayment.find(x => x.id == id);
                                    if (contractMultiPaymentObj) {
                                        this.collectPaymentGroup.patchValue({
                                            firstName: this.contactDetails.firstname,
                                            lastName: this.contactDetails.lastname,
                                            chkBankName: contractMultiPaymentObj.chkBankName,
                                            chkCity: contractMultiPaymentObj.chkCity,
                                            chkState: contractMultiPaymentObj.chkState,
                                            chkRoutingNo: contractMultiPaymentObj.chkRoutingNo,
                                            chkAccNo: contractMultiPaymentObj.chkAccNo,
                                            chkNumber: contractMultiPaymentObj.chkNumber,
                                            bankAccountName: contractMultiPaymentObj.bankAccountName,
                                            paymentType: true,
                                        });
                                        $("#chkDate").val(contractMultiPaymentObj.chkDate);
                                        //this.expiry = false;
                                        //this.disabledAgreement = false;
                                    }
                                }
                            })
                            .catch((err: HttpErrorResponse) => {
                                this._utilityService.handleErrorResponse(err);
                            });
                    }
                    this.fetchPaymentDocList(this.contractSessionId, id, 2);
                    break;

                case "4":
                    this.prodConfigGroup.patchValue({
                        payCreditCard: false,
                        payCheck: false,
                        payMoneyOrder: false,
                        payCash: true,
                        payOther: false,
                        payCarryOver: false,
                        payMonterey: false
                    });
                    if (!isPaid) {
                        this.collectPaymentGroup.patchValue({
                            paymentType: false
                        });
                    } else {
                        this.collectPaymentGroup.patchValue({
                            paymentType: true
                        });
                    }
                    this.fetchPaymentDocList(this.contractSessionId, id, 4);
                    break;

                case "5":
                    this.prodConfigGroup.patchValue({
                        payCreditCard: false,
                        payCheck: false,
                        payMoneyOrder: false,
                        payCash: false,
                        payOther: true,
                        payCarryOver: false,
                        payMonterey: false
                    });
                    if (!isPaid) {
                        this.collectPaymentGroup.patchValue({
                            paymentType: false
                        });
                    } else {
                        this.collectPaymentGroup.patchValue({
                            paymentType: true
                        });
                    }
                    this.fetchPaymentDocList(this.contractSessionId, id, 3);
                    break;

                case "6":
                    this.prodConfigGroup.patchValue({
                        payCreditCard: false,
                        payCheck: false,
                        payMoneyOrder: false,
                        payCash: false,
                        payOther: false,
                        payCarryOver: true,
                        payMonterey: false
                    });
                    if (!isPaid) {
                        this.collectPaymentGroup.patchValue({
                            paymentType: false
                        });
                    } else {
                        this.collectPaymentGroup.patchValue({
                            paymentType: true
                        });
                    }
                    break;

                case "7":
                    this.prodConfigGroup.patchValue({
                        payCreditCard: false,
                        payCheck: false,
                        payMoneyOrder: false,
                        payCash: false,
                        payOther: false,
                        payCarryOver: false,
                        payMonterey: true
                    });
                    if (!isPaid) {
                        this.collectPaymentGroup.patchValue({
                            paymentType: false
                        });
                    } else {
                        this.collectPaymentGroup.patchValue({
                            paymentType: true
                        });
                    }
                    this.fetchPaymentDocList(this.contractSessionId, id, 7);
                    break;

                default:
                    this.prodConfigGroup.patchValue({
                        payCreditCard: false,
                        payCheck: false,
                        payMoneyOrder: false,
                        payCash: false,
                        payOther: false,
                        payCarryOver: false,
                        payMonterey: false
                    });
                    break;
            }
        }
        else {
            this.prodConfigGroup.patchValue({
                payCreditCard: true,
                payCheck: false,
                payMoneyOrder: false,
                payCash: false,
                payOther: false,
                payCarryOver: false,
                payMonterey: false
            });
            this.collectPaymentGroup.patchValue({
                firstName: this.contactDetails.firstname,
                lastName: this.contactDetails.lastname,
                creditCard: '',
                expirationDate: '',
                cvc: '',
                zip: '',
                paymentType: false,
                fileNo: false,
            });
            this.sel_brand = "unknown";
            this.collectPaymentGroup.markAsDirty();
            this.collectPaymentGroup.markAsPristine();
            this.collectPaymentGroup.markAsUntouched();
        }
        this.disabledAgreement = true;
    }

    recalcAllIframes(): void {
        document.querySelectorAll<HTMLIFrameElement>('iframe').forEach(iframe => {
            if (iframe.contentWindow?.document?.body) {
                this.setIframeHeight(iframe);
            }
        });
    }

    setIframeHeight(iframe: HTMLIFrameElement): void {
        try {
            const doc = iframe.contentWindow?.document;
            if (!doc || !doc.body) return;

            const body = doc.body;
            const html = doc.documentElement;

            body.style.margin = '0';
            body.style.padding = '0';
            body.style.overflow = 'hidden';
            html.style.overflow = 'hidden';

            body.querySelectorAll<HTMLElement>('*').forEach(el => {
                const computed = iframe.contentWindow!.getComputedStyle(el);
                const minH = computed.minHeight;
                // Strip min-height unless it's 0 or auto
                if (minH && minH !== '0px' && minH !== 'auto') {
                    el.style.minHeight = 'auto';
                }
            });

            body.querySelectorAll<HTMLElement>('p, br, td, li, span').forEach(el => {
                if (el.children.length > 0) return;
                const text = el.innerText?.trim() ?? '';
                const innerHTML = el.innerHTML?.trim() ?? '';
                const isBlank = text === '' && (
                    innerHTML === '' ||
                    innerHTML === '&nbsp;' ||
                    /^(<br\s*\/?>|\s|&nbsp;)*$/.test(innerHTML)
                );
                if (isBlank) {
                    el.style.margin = '0';
                    el.style.padding = '0';
                    el.style.lineHeight = '0';
                    el.style.fontSize = '0';
                    el.style.height = '0';
                    el.style.overflow = 'hidden';
                }
            });

            void body.offsetHeight;

            const getActualContentHeight = (): number => {
                const allElements = body.querySelectorAll<HTMLElement>('*');
                let maxBottom = 0;
                allElements.forEach(el => {
                    const rect = el.getBoundingClientRect();
                    const bottom = rect.bottom +
                        (iframe.contentWindow?.scrollY ?? 0);
                    if (bottom > maxBottom) maxBottom = bottom;
                });
                return maxBottom > 0 ? maxBottom : body.scrollHeight;
            };

            const contentHeight = getActualContentHeight();
            iframe.style.height = (contentHeight + 10) + 'px';
            iframe.style.minHeight = '';
            iframe.style.maxHeight = '';

            setTimeout(() => {
                try {
                    void body.offsetHeight;
                    const recalcHeight = getActualContentHeight();
                    if (Math.abs(recalcHeight - contentHeight) > 10) {
                        iframe.style.height = (recalcHeight + 10) + 'px';
                    }
                } catch { }
            }, 500);

        } catch {
            iframe.style.height = '800px';
        }
    }


    validateProduct(e) {
        var selectedType = +$("#contract option:selected").val();
        this.productId = +$("#contract option:selected").val();
        switch (Number(selectedType)) {
            case 3: case 10: this.noServiceDisabled = false; this.addendumBDisabled = false; this.addendumGDisabled = false; this.addendumPDisabled = false; this.patentDisabled = true; this.isCarryOver = true; break;
            case 7: case 8: case 9: case 12: case 13: case 14: this.noServiceDisabled = true; this.addendumBDisabled = false; this.addendumGDisabled = false; this.addendumPDisabled = false; this.patentDisabled = false; this.isCarryOver = true; break;
            case 4: case 5: this.noServiceDisabled = false; this.addendumBDisabled = true; this.addendumGDisabled = true; this.addendumPDisabled = true; this.patentDisabled = false; this.isCarryOver = false; break;
            default:
                this.noServiceDisabled = false; this.addendumBDisabled = false; this.addendumGDisabled = false; this.addendumPDisabled = false; this.patentDisabled = false; this.isCarryOver = false; break;
        }

        if (this.productDetails && this.contractSession && this.isSecondContract) {
            for (var i = 0; i < this.productDetails.length; i++) {
                if (this.isBIPClient) {
                    this.productDetails.find(p => p.productId == 1).isExists = true;
                    this.productDetails.find(p => p.productId == 2).isExists = true;
                }
                if (this.isSubClient) {
                    this.productDetails.find(p => p.productId == 3).isExists = true;
                    //this.productDetails.find(p => p.productId == 7).isExists = true;
                    this.productDetails.find(p => p.productId == 8).isExists = true;
                    this.productDetails.find(p => p.productId == 12).isExists = true;
                    this.productDetails.find(p => p.productId == 13).isExists = true;
                    this.productDetails.find(p => p.productId == 14).isExists = true;
                }
                if (this.isPPSOClient) {
                    this.productDetails.find(p => p.productId == 11).isExists = true;
                }
                if (this.isPlusClient) {
                    this.productDetails.find(p => p.productId == 9).isExists = true;
                    this.productDetails.find(p => p.productId == 10).isExists = true;
                }
            }
        }

        if (this.productDetails && this.contractSession && !isNullOrUndefined($("#contract option:selected").val())) {
            if ((this.contractSession.productId != + $("#contract option:selected").val()) && (+ $("#contract option:selected").val() != -1)) {
                for (var i = 0; i < this.productDetails.length; i++) {
                    if (this.productDetails[i].productId == + $("#contract option:selected").val() && this.productDetails[i].contractSessionId > 0 && this.productDetails[i].status != 2 && this.productDetails[i].productId != + $("#contract option:selected").val()) {
                        this.productDetails[i].isExists = true;
                        this._utilityService.showAlertMsg("Information!", "<b>" + this.productDetails[i].productDescription + "</b> is already been used for this invention.");
                    }
                }
            }
        }
        this.loadRepaymentTerms("ProductChange");
    }

    private async loadProductList() {
        await this._productService.getProductListAsync(this.encryptedUser, this.inventionId, this.contractSession.CountryID, !isNullOrUndefined(this.contractSession) && this.contractSession.productId >= 9 && this.contractSession.productId < 12 ? "Plus" : "Normal")
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.productListResponse = UtilityService.clone(res);
                        if (!isNullOrUndefined(this.productYCutOffDate))
                            this.productDetails = this.productListResponse.productDetails.filter(product => new Date(this.productYCutOffDate.configValue) <= new Date(this.contractActionlog.dtCreated) ? product.productId != 7 && product.productId != 4 : product);
                        else
                            this.productDetails = this.productListResponse.productDetails.filter(product => product.productId != 7 && product.productId != 4);
                        if (!isNullOrUndefined(this.productMCutOffDate))
                            this.productDetails = this.productDetails.filter(product => new Date(this.productMCutOffDate.configValue) <= new Date(this.contractActionlog.dtCreated) ? product.productId != 8 : product);
                        if (!isNullOrUndefined(this.product123CutOffDate))
                            this.productDetails = this.productDetails.filter(product => new Date(this.product123CutOffDate.configValue) <= new Date(this.contractActionlog.dtCreated) ? product.productId != 13 : product);
                        if (!isNullOrUndefined(this.documentVCutOffDate))
                            this.isProductV = new Date(this.documentVCutOffDate.configValue) >= new Date(this.contractActionlog.dtCreated) ? true : false;
                        if (this.isProductV)
                            this.lblAddendumP = "Addendum P, T & V: Prototype Model, Production Drawings & Virtual Invention Browsing Experience Agreement which must be signed by client and attached.";
                        else
                            this.lblAddendumP = "Addendum P, T: Prototype Model & Production Drawings Agreement which must be signed by client and attached.";

                        //else
                        //this.productDetails = this.productDetails.filter(product => product.productId != 8);
                        if (this.inventionId > 0 && this.productDetails) {
                            this.productName = this.productDetails.filter(i => i.productId == this.contractSession.productId)[0].productDescription;
                            this.productId = this.contractSession.productId;
                            this.prodConfigGroup.patchValue({
                                contract: this.productId
                            });
                            if (this.contractPayment && !this.productDetail) {
                                this.loadProduct();
                                this.loadDocument();
                            }
                            this.loadMandatoryDocs();
                        }
                        for (var i = 0; i < this.productDetails.length; i++) {
                            if (this.productDetails[i].contractSessionId > 0 && this.productDetails[i].status != 2 && this.productDetails[i].contractSessionId != this.contractSessionId)
                                this.productDetails[i].isExists = true;
                            if (this.isSecondContract) {
                                if (this.isBIPClient) {
                                    this.productDetails.find(p => p.productId == 1).isExists = true;
                                    this.productDetails.find(p => p.productId == 2).isExists = true;
                                }
                                if (this.isSubClient) {
                                    this.productDetails.find(p => p.productId == 3).isExists = true;
                                    //this.productDetails.find(p => p.productId == 7).isExists = true;
                                    this.productDetails.find(p => p.productId == 8).isExists = true;
                                    this.productDetails.find(p => p.productId == 12).isExists = true;
                                    this.productDetails.find(p => p.productId == 13).isExists = true;
                                    this.productDetails.find(p => p.productId == 14).isExists = true;
                                }
                                if (this.isPPSOClient) {
                                    this.productDetails.find(p => p.productId == 11).isExists = true;
                                }
                                if (this.isPlusClient) {
                                    this.productDetails.find(p => p.productId == 9).isExists = true;
                                    this.productDetails.find(p => p.productId == 10).isExists = true;
                                }
                            }
                        }
                    } else {
                        console.log("Product result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadOffice() {
        await this._officeService.getOfficeListAsync(this.encryptedUser, this.clpUserId)
            .then(res => {
                if (res) {

                    if (res.statusCode == 0) {
                        this.officeListResponse = UtilityService.clone(res);
                        this.officeList = this.officeListResponse.officeList;
                        if (this.officeList) {
                            this.prodConfigGroup.patchValue({
                                officeCode: this.officeList[0].number
                            });
                        }
                    } else {
                        console.log("Office List result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadRepaymentTerms(source?: string) {
        this.selectedProductID = + $("#contract option:selected").val() ? $("#contract option:selected").val() : this.contractSession.productId ? this.contractSession.productId : 1;
        await this._billingService.getRepaymentTermsAsync(this.encryptedUser, this.contractSession.CountryID, this.selectedProductID)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.repaymentTermsResponse = UtilityService.clone(res);
                        this.repaymentTerms = this.repaymentTermsResponse.RepaymentTerms;
                        if (source == "ProductChange")
                            this.calculatePayment();
                    } else {
                        console.log("Repayment Terms result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadContractSession() {
        if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
            await this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                .then(res => {
                    if (res) {
                        this.contractSession = UtilityService.clone(res);
                        if (this.contractSession.IsSecondContract) {
                            this.isSecondContract = true;
                            this.isMandDocSigned = true;
                        }
                        else {
                            this.isSecondContract = false;
                        }

                        this.sendToCorpModalTitle = !this.contractSession.isReSendToCorp ? "Comments" : "Confirmation!";
                        this.currencySterling = this.contractSession.CurrencySymbol;
                        this.convCurrencySterling = this.contractSession.CurrencyCode;
                        this.customerCountryID = this.contractSession.CountryID;
                        if (!isNullOrUndefined(this.contractActionlog) && this.contractActionlog.contractSessionId > 0) {
                            if (!isNullOrUndefined(this.canadaNDACutOffDate)) {
                                if (this.contractSession.CountryID === 2 && (new Date(this.canadaNDACutOffDate.configValue) <= new Date(this.contractActionlog.dtCreated)))
                                    this.isNewCanadianContract = true;
                                else
                                    this.isNewCanadianContract = false;
                            }
                        }
                        else {
                            this._contractActionLogService.getContractActionLog(this.encryptedUser, this.contractSessionId)
                                .then(res => {
                                    if (res) {
                                        this.contractActionlog = UtilityService.clone(res);
                                        if (!isNullOrUndefined(this.contractActionlog) && !isNullOrUndefined(this.canadaNDACutOffDate)) {
                                            if (this.contractSession.CountryID === 2 && (new Date(this.canadaNDACutOffDate.configValue) <= new Date(this.contractActionlog.dtCreated)))
                                                this.isNewCanadianContract = true;
                                            else
                                                this.isNewCanadianContract = false;
                                        }
                                    }
                                })
                                .catch((err: HttpErrorResponse) => {
                                    this._utilityService.handleErrorResponse(err);
                                });
                        }
                        this.checkListTabItem = this.contractSession.CountryID > 2 ? "d" : this.isNewCanadianContract === true ? "e" : "f";
                        this.getContractMultiPayment("");
                        this.USFeeConfirm = this.contractSession.USFeeConfirm;

                        this.loadProductList();
                        this.loadInventorInformation();
                        this.loadUniversalPayment();
                        this.loadNavigationWizard();
                        this.copyDataObjectToProdConfigCoInventorValues();
                        this.loadBillingPayment(() => { this.loadContractPayment(); });
                        this.loadFileNumber();
                        this.loadBIPConfirmation();
                        if ((this.contractSession.CountryID == 3) || (this.contractSession.CountryID == 4))
                            this.getConversionRate();
                        this.loadAddendumServices();
                        this.loadIMPServices();
                        this.loadRepaymentTerms();
                        this.fetchMediaDocList(this.inventionId);
                        if (this.contractSession.productId <= 9 || this.contractSession.productId == 12 || this.contractSession.productId == 13 || this.contractSession.productId == 10 || this.contractSession.productId == 14) {
                            this.loadInventionCheckList();
                            this.fetchCheckList(this.contractSessionId);
                            this.fetchConfigCheckList();
                        }
                        this.fetchPaymentDocList(this.contractSessionId, -1, 0);
                        this.fetchMediaImagesList(this.inventionId);
                        this.copyDataObjectToPopupFormValues();
                        this.copyDataObjectToInfoCollectValues();
                        this.copyDataObjectToFormValues();
                        if (this.contractSession.isCancelled == true)
                            $(':button').prop('disabled', true);
                        $('#backButton').prop('disabled', false);
                        $('#closeFileButton').prop('disabled', false);
                        $('#backContractList').prop('disabled', false);
                        this.productId = this.contractSession.productId;
                        this.applyZipValidators(this.contractSession.CountryID);
                    }
                }).then(r => { this.changeProduct() })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async loadFileNumber() {
        await this._documentService.getFileNumber(this.contractSessionId, this.encryptedUser)
            .then(res => {
                if (res) {
                    var fileNumber: string;
                    this.fileNumber = UtilityService.clone(res);
                    if (!isNullOrUndefined(this.fileNumber)) {
                        if (this.fileNumber.endsWith("PPSO"))
                            fileNumber = this.fileNumber.slice(0, - 4);
                        else if (this.fileNumber.endsWith("PS") || this.fileNumber.endsWith("PP") || this.fileNumber.endsWith("NP"))
                            fileNumber = this.fileNumber.slice(0, - 2);
                        else
                            fileNumber = this.fileNumber.slice(0, - 1);
                        this.inputFileNumber = fileNumber.slice(fileNumber.length - 4);
                    }
                    this.cardTxnNotes = this.fileNumber;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadBIPConfirmation() {
        await this._contractSessionService.getBIPConfirmationByCSIdAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    this.bipConfirmation = UtilityService.clone(res);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadSendToCorpCheckProcess() {
        this._contractSessionService.checkSendToCorp_GetAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    this.checkSendToCorpResponse = UtilityService.clone(res);
                    if (this.checkSendToCorpResponse.checkSendToCorp.isDocumentTypeIdsExist < 1) {
                        this.isGenerateContractsDone = false;
                        this.sendExportToPDF("Sendtocorp");
                    }
                    else
                        this.isGenerateContractsDone = true;
                    if (this.checkSendToCorpResponse.checkSendToCorp.isSendToCorpExist < 1) {
                        this.isUpdateContractSessionDone = false;
                        this.contractSession.sendToCorp = true;
                        this.CreateUpdate_ContractSession();
                    }
                    else
                        this.isUpdateContractSessionDone = true;
                    if (this.checkSendToCorpResponse.checkSendToCorp.isDTSendToCorpExist < 1) {
                        this.isContractActionLogDone = false;
                        this.updateContractLogObjectModel("sendToCorp", false);
                        this.saveContrActionAcitonLog();
                    }
                    else
                        this.isContractActionLogDone = true;
                    if (this.checkSendToCorpResponse.checkSendToCorp.isDocumentTypeIdsExist >= 1 && this.checkSendToCorpResponse.checkSendToCorp.isSendToCorpExist >= 1
                        && this.checkSendToCorpResponse.checkSendToCorp.isDTSendToCorpExist >= 1) {
                        $('#modalSendToCorpProcess').modal('hide');
                        this.openSnackBar("The document generation process has begun, and an email will be sent shortly.", "");
                        this.isHandleSendToCorp = true;
                        this.isContractActionLogDone = false;
                        this.isGenerateContractsDone = false;
                        this.isUpdateContractSessionDone = false;
                    }
                    else {
                        if (this.checkSendToCorpCounter == 3) {
                            this.isContractActionLogDone = false;
                            this.isGenerateContractsDone = false;
                            this.isUpdateContractSessionDone = false;
                        }
                        if (!this.isHandleSendToCorp) {
                            let email: EmailDetails = {
                                from: "",
                                message: "",
                                subject: "",
                                toList: "",
                            }
                            this.emailDetails = email;
                            this.emailDetails.from = "";
                            this.emailDetails.toList = "";
                            this.emailDetails.message = "Failure while triggering the document generation process for contractSessionId " + this.contractSessionId + ". Documents may be generated in a recursive attempt. Please open the contracts to get confirmation.";
                            this.emailDetails.subject = "InventHelp: SendToCorp process error has occurred for Invention- " + this.inventionName;
                            this.emailTemplateType = "GenerateContractsError";
                            if (this.emailDetails) {
                                this._emailService.sndEmailAsync(this.encryptedUser, this.emailDetails, this.contactId, this.emailTemplateType, this.contractSessionId)
                                    .then(res => {
                                        if (res) {
                                            if (res.statusCode == 0) {
                                                this.emailResponse = UtilityService.clone(res);
                                            } else {
                                                console.log("Email send result status code: " + res.statusCode);
                                            }
                                        }
                                    })
                                    .catch((err: HttpErrorResponse) => {
                                        this._utilityService.handleErrorResponse(err);
                                    });
                            }
                            this.isHandleSendToCorp = true;
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
        this.checkSendToCorpCounter++;
    }

    private async calculateBusinessDay() {
        if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
            await this.loadWaitDate(this.contractSessionId);
            var businessDays = new DatePipe("en-US");
            this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                .then(res => {
                    if (res) {
                        this.contractSession = UtilityService.clone(res);
                        if (this.contractSession.CountryID == 2)
                            this.isNoAutoPay = false;
                    }
                }).then(r => {
                    if (!isNullOrUndefined(this.contractSession) && !this.contractSession.isDeleted) {
                        var state = this.stateList.find(st => st.code.toLowerCase() == this.contractSession.conSessnClientState.toLowerCase());
                        this.waitAcceptDate = this.dtFirstWaitDate;
                        if (state && this.waitAcceptDate) {
                            this._documentService.calculateBusinessDay(state.waitDays, this.datePipe.transform(this.waitAcceptDate, 'yyyy-MM-dd'), this.encryptedUser)
                                .then(res => {
                                    if (res) {
                                        this.businessDays = UtilityService.clone(res);
                                        if (this.businessDays != null)
                                            this.paymentDate = businessDays.transform(this.businessDays, 'MMM dd yyyy')
                                    }
                                })
                                .catch((err: HttpErrorResponse) => {
                                    this._utilityService.handleErrorResponse(err);
                                });
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async getclpUserCountry() {
        if (this.clpUserId > 0 && this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
            await this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                .then(res => {
                    if (res) {
                        this.contractSession = UtilityService.clone(res);
                        this.clientLocation = this.contractSession.conSessnClientState ? true : this.contractSession.CountryID > 1 ? true : false;
                        if (this.contractSession.CountryID < 399)
                            var state = this.stateList.find(st => st.code.toLowerCase() == this.contractSession.conSessnClientState.toLowerCase());
                        else
                            var state = this.stateList.find(st => st.code.toLowerCase() == this.contractSession.clientState.toLowerCase());
                        let stateName: string = this.contractSession.CountryID == 3 ? "Australia" : this.contractSession.CountryID == 4 ? "United Kingdom"
                            : this.contractSession.CountryID == 6 ? "Ireland" : this.contractSession.CountryID == 2 ? "Canada"
                                : this.contractSession.CountryID == 399 ? this.contactDetails.country : state != null ? state.name : "";
                        this.locationPOPUP.patchValue({
                            clientstate: state ? state.code : this.contractSession.CountryID.toString() == this.contactDetails.country ? this.getState(this.contactDetails.state, this.contactDetails.country) : '-1'
                        });

                        if (this.clientLocation) {
                            this.stateMessage = "Client Location - " + stateName;
                            this._ClientsStateDataService.updateMessage(stateName);
                        }
                        if (this.contractSession.CountryID == 1 && !this.clientLocation)
                            this.stateMessage = "Please confirm Client State";

                        this._userService.getUserById(this.clpUserId, this.encryptedUser)
                            .then(res => {
                                if (res) {
                                    this.currentUser = UtilityService.clone(res);
                                    this.clpUserCountryID = this.currentUser.clpUserCountryID;
                                    this.handlePOPUPState(this.contractSession.CountryID);
                                    if (!this.contractSession.isCancelled)
                                        $('#modalCheckCountry').modal('show');
                                }
                                this.calculateBusinessDay();
                            })
                            .catch((err: HttpErrorResponse) => {
                                this._utilityService.handleErrorResponse(err);
                            });
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async loadPromotionOffers() {
        await this._billingService.getPromotionOffersAsync(this.encryptedUser)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.promotionOffersResponse = UtilityService.clone(res);
                        this.promotionOffers = this.promotionOffersResponse.promotionOffers;
                    } else {
                        console.log("Promotion result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadContractPayment() {
        await this._billingService.getContractPaymentAsync(this.encryptedUser, this.inventionId, this.productId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.contractPaymentResponse = UtilityService.clone(res);
                        this.initContractPayment = Object.assign({}, this.contractPaymentResponse.contractPayment);

                        this.contractPayment = this.contractPaymentResponse.contractPayment;
                        if (this.contractPayment.id > 0) {
                            this.productId = this.contractPayment.productId;
                            this.changeProduct();
                            this.loadProduct();
                            this.copyDataObjectToProdConfigValues("OnLoad");
                            this.loadDocument();
                        } else {
                            this.productId = + $("#contract option:selected").val();
                        }

                        if (this.contractPayment.paymentOptionId == 1) {
                            this.oneTimeFee = Number(this.contractPayment.cashPrice);
                            this.oneTimeFeeInitial = Number(this.contractPayment.downPayment);
                        }
                        else {
                            this.oneTimeFee = Number(this.contractPayment.downPayment);
                            this.oneTimeFeeInitial = Number(this.contractPayment.downPayment);
                        }
                        if (this.contractPayment.paymentOptionId == 2) {
                            this.isRetailInsDocument = true;
                            this.isInfoInventDocument = true;
                            this.isUniPayDocument = true;
                            this.isPPADocument = true;
                        }
                    } else {
                        console.log("Contract Payment result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadAddendumServices() {
        await this._addendumService.AddendumServices_GetAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.addendumServicesResponse = UtilityService.clone(res);
                        this.addendum = this.addendumServicesResponse.addendum;
                        if (!isNullOrUndefined(this.navigationResponse) && !this.navigationResponse.navigation.isSUBDoc /*&& !isNullOrUndefined(this.contractSession) && !this.contractSession.sendToCorp*/) {
                            this.isAddmBAccept = (this.productId > 8 && this.productId < 12) ? this.contractActionlog.dtAddendumBDoc ? true : false : this.addendumServicesResponse.addendum.isAddendumB && this.contractActionlog.dtAddendumBDoc ? true : false;
                            this.isAddmGAccept = this.addendumServicesResponse.addendum.isAddendumG && this.contractActionlog.dtAddendumGDoc ? true : false;
                            this.isAddmPAccept = this.addendumServicesResponse.addendum.isAddendumP && this.contractActionlog.dtAddendumPDoc ? true : false;
                            this.isAddmTAccept = this.addendumServicesResponse.addendum.isAddendumP && this.contractActionlog.dtAddendumTDoc ? true : false;
                            if (this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14)
                                this.isAddmVAccept = this.addendumServicesResponse.addendum.isAddendumP && this.contractActionlog.dtAddendumVDoc ? true : false;
                            this.isShowPatent = this.addendumServicesResponse.addendum.isPatentServices;
                            this.isPatentAccept = this.isShowPatent && this.contractActionlog.dtPatentDoc ? true : false;
                            this.isSUBAccept = this.contractActionlog.dtAddendumDoc ? true : false;
                            this.isSUBHeadAccept = this.isSUBAccept;
                            this.isIntroMarkAccept = this.contractActionlog.dtIntroMarkDoc ? true : false;
                        }
                        else {
                            this.isSUBAccept = true;
                            this.isSUBHeadAccept = true;
                            this.isAddmBAccept = true;
                            this.isAddmGAccept = true;
                            this.isAddmPAccept = true;
                            this.isAddmTAccept = true;
                            this.isAddmVAccept = true;
                            this.isPatentAccept = true;
                            this.isIntroMarkAccept = true;
                        }
                        if (this.addendum.id > 0)
                            this.copyDataObjectToInfoCollectValues();
                    } else {
                        console.log("Addendum services result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadIMPServices() {
        if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
            await this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                .then(res => {
                    if (res) {
                        if (this.contractSession.isIMPAuth == true)
                            this.copyDataObjectToInfoCollectValues();
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async loadContractSessionByInventionId(inventionId) {
        await this._contractSessionService.getContactSessionAsync(this.encryptedUser, inventionId)
            .then(res => {
                if (res) {
                    this.contractSessionListResponse = UtilityService.clone(res);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }


    private async loadInventorInformation() {
        await this._infoCollectService.InventorInvention_GetAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.inventorInformationResponse = UtilityService.clone(res);
                        this.inventorInformation = this.inventorInformationResponse.inventorInformation;

                        if (this.inventorInformation.id > 0)
                            this.copyDataObjectToInfoCollectValues();
                    } else {
                        console.log("InventorInvention result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadInvention(count?: number) {
        this._route.paramMap.subscribe(async params => {
            if (params.has('invention')) {
                this.inventionId = +params.get('invention');
            }
        });
        await this._inventionService.getInventionAsync(this.encryptedUser, this.inventionId)
            .then(async (result: InventionResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.inventionResponse = UtilityService.clone(result);
                        if (this.inventionResponse) {
                            this.inventionDetails = UtilityService.clone(this.inventionResponse.inventionDetails);
                            this.inventionName = this.inventionDetails.InventionName;
                            if (count < 1)
                                this.loadDocumentSignature("OnLoad");
                        }

                    } else {
                        console.log("invention result status code: " + result.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
        await this._inventionService.getBIPExistforInventionAsync(this.encryptedUser, this.inventionId)
            .then(async (result: boolean) => {
                if (result) {
                    this.isBIPExist = UtilityService.clone(result);
                }
                else {
                    this.isBIPExist = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadUniversalPayment() {
        await this._infoCollectService.UniversalPayment_GetAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.universalPaymentResponse = UtilityService.clone(res);
                        this.universalPayment = this.universalPaymentResponse.universalPayment;

                        if (this.universalPayment.id == 0)
                            this.universalPayment.chkCCard = true;
                        else if (this.universalPayment.id > 0)
                            this.copyDataObjectToInfoCollectValues();

                    } else {
                        console.log("Universal Payment result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadInventionCheckList() {
        await this._inventionCheckListService.InventionCheckList_GetAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.inventionCheckListResponse = UtilityService.clone(res);
                        this.inventionCheckList = this.inventionCheckListResponse.inventionCheckList;
                        console.log(' this.inventionCheckList', this.inventionCheckList);
                        this.copyDataObjectToInventionCheckListValue();
                    } else {
                        console.log("Invenion Check List result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadBillingPayment(callBack) {
        await this._billingService.getAmountAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.billingResponse = UtilityService.clone(res);
                        this.billingDetails = this.billingResponse.billingDetails;
                        this.cardTxnReference = this.billingDetails.cardTxnReference;
                        this.response_code = this.billingDetails.response_code ? this.billingDetails.response_code : '';
                        if (this.billingDetails.ContractSessionId > 0)
                            this.copyDataObjectToPayFormValues();
                        this.showCollectionMultiPayment();
                        callBack();
                    } else {
                        console.log("Billing result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadContractMultiPayment() {
        await this._billingService.getContractMultiPaymentAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.contractMultiPaymentResponse = UtilityService.clone(res);
                        this.contractMultiPayments = this.contractMultiPaymentResponse.contractMultiPayment;
                        this.copyDataObjectToPayFormValues();
                    } else {
                        console.log("Contract MultiPayment result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadDocumentSignature(source?: string) {
        await this._documentService.getDocumentSignatureAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.documentSignatureResponse = UtilityService.clone(res);
                        this.documentSignature = this.documentSignatureResponse.documentSignature;
                        if (this.documentSignature) {
                            this.signature1 = this.documentSignature.signature1;
                            this.signature2 = this.documentSignature.signature2;
                            this.i1SignatureADS = this.documentSignature.i1SignatureADS;
                            this.i1SignatureFinal = this.documentSignature.i1SignatureFinal;
                            if (source == "OnLoad" && !isNullOrUndefined(this.documentSignature) && !this.documentSignature.isSecondContract) {
                                if (!isNullOrUndefined(this.navigationResponse)) {
                                    if (!isNullOrUndefined(this.inventionDetails) && this.inventionDetails.isCoInventor) {
                                        if (this.documentSignature.signature1 == '' && this.documentSignature.initial1 == '')
                                            this.navigationResponse.navigation.isSOCDoc = false;
                                        else if (this.documentSignature.signature2 == '' && this.documentSignature.initial2 == '')
                                            this.navigationResponse.navigation.isSOCDoc = false;
                                        else {
                                            this.navigationResponse.navigation.isSOCDoc = true;
                                            this.checkNavBar('tdIsSOCDoc');
                                        }

                                        if (this.documentSignature.i1SignatureADS == '' && this.documentSignature.i1InitialADS == '')
                                            this.navigationResponse.navigation.isADSDoc = false;
                                        else if (this.documentSignature.i2SignatureADS == '' && this.documentSignature.i2InitialADS == '')
                                            this.navigationResponse.navigation.isADSDoc = false;
                                        else {
                                            this.navigationResponse.navigation.isADSDoc = true;
                                            this.checkNavBar('tdIsADSDoc');
                                        }

                                        if (this.documentSignature.i1SignatureFinal == '' && this.documentSignature.i1InitialFinal == '')
                                            this.navigationResponse.navigation.isFinalSign = false;
                                        else if (this.documentSignature.i2SignatureFinal == '' && this.documentSignature.i2InitialFinal == '')
                                            this.navigationResponse.navigation.isFinalSign = false;
                                        else {
                                            this.navigationResponse.navigation.isFinalSign = true;
                                            this.checkNavBar('tdIsFinalDocuments');
                                        }

                                    }
                                    else {
                                        if (this.documentSignature.signature1 == '' && this.documentSignature.initial1 == '')
                                            this.navigationResponse.navigation.isSOCDoc = false;
                                        else {
                                            this.navigationResponse.navigation.isSOCDoc = true;
                                            this.checkNavBar('tdIsSOCDoc');
                                        }
                                        if (this.documentSignature.i1SignatureADS == '' && this.documentSignature.i1InitialADS == '')
                                            this.navigationResponse.navigation.isADSDoc = false;
                                        else {
                                            this.navigationResponse.navigation.isADSDoc = true;
                                            this.checkNavBar('tdIsADSDoc');
                                        }
                                        if (this.documentSignature.i1SignatureFinal == '' && this.documentSignature.i1InitialFinal == '')
                                            this.navigationResponse.navigation.isFinalSign = false;
                                        else {
                                            this.navigationResponse.navigation.isFinalSign = true;
                                            this.checkNavBar('tdIsFinalDocuments');
                                        }
                                    }
                                    this.saveNavigationWizard();
                                }
                            }
                        }
                    } else {
                        console.log("Document Signature result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }
    private async loadSignature() {
        await this._documentService.getDocumentSignatureAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.documentSignatureResponse = UtilityService.clone(res);
                        this.documentSignature = this.documentSignatureResponse.documentSignature;
                        if (this.documentSignature) {
                            this.signature1 = this.documentSignature.signature1;
                            this.signature2 = this.documentSignature.signature2;
                            this.i1SignatureADS = this.documentSignature.i1SignatureADS;
                            this.i1SignatureFinal = this.documentSignature.i1SignatureFinal;
                        }
                    }
                }
            })
    }
    private async patchSignature() {
        this.socGroup.patchValue({
            initialSignature: ''
        });
    }

    private async loadDocumentType() {
        await this._documentService.getConfigDetailsAsync(this.encryptedUser)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.configDocumentsResponse = UtilityService.clone(res);
                        if (this.configDocumentsResponse) {
                            this.configDocuments = this.configDocumentsResponse.configDocuments;

                            if (this.contractSessionId > 0 && isNullOrUndefined(this.contractSession)) {
                                this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                                    .then(res => {
                                        if (res) {
                                            this.contractSession = UtilityService.clone(res);
                                            if (this.contractSession.conSessnClientState.toLowerCase() != '')
                                                var state = this.stateList.find(st => st.code.toLowerCase() == this.contractSession.conSessnClientState.toLowerCase());
                                            else
                                                var state = this.stateList.find(st => st.code.toLowerCase() == this.contractSession.clientState.toLowerCase());

                                            let stateid: number = state != null ? state.id : -1;
                                            var waitstateDoc = this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == true);
                                            if (state) {
                                                if (state.waitDays > 0 && waitstateDoc)
                                                    this.waitStateDocTypeId = waitstateDoc.id;
                                            }
                                            this.loadMandatoryDocument(this.waitStateDocTypeId);
                                        }
                                    }).then(r => { this.changeProduct() })
                                    .catch((err: HttpErrorResponse) => {
                                        this._utilityService.handleErrorResponse(err);
                                    });
                            }
                            else if (!isNullOrUndefined(this.contractSession)) {

                                if (this.contractSession.conSessnClientState.toLowerCase() != '')
                                    var state = this.stateList.find(st => st.code.toLowerCase() == this.contractSession.conSessnClientState.toLowerCase());
                                else
                                    var state = this.stateList.find(st => st.code.toLowerCase() == this.contractSession.clientState.toLowerCase());

                                let stateid: number = state != null ? state.id : -1;
                                var waitstateDoc = this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == true);
                                if (state) {
                                    if (state.waitDays > 0 && waitstateDoc)
                                        this.waitStateDocTypeId = waitstateDoc.id;
                                }
                                this.loadMandatoryDocument(this.waitStateDocTypeId);
                            }
                        }
                    } else {
                        console.log("Config Documents result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadNavigationSteps() {
        await this._navigationService.getNavigationStepsAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.navigationStepsResponse = UtilityService.clone(res);
                        if (this.navigationStepsResponse) {
                            this.navigationSteps = this.navigationStepsResponse.navigationSteps;
                        }
                    } else {
                        console.log("Navigation Steps result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadNavigationWizard(tdName: string = "") {
        let _isROIForm: boolean = false;
        let _isSUBForm: boolean = false;
        var dtSOC = new DatePipe("en-US");
        if (this.navigationResponse) {
            _isROIForm = this.navigationResponse.navigation.isROIForm;
            _isSUBForm = this.navigationResponse.navigation.isSUBForm;
        }
        await this._navigationService.getNavigationWizardAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.navigationResponse = UtilityService.clone(res);
                        if (this.navigationResponse) {
                            this.validateContractSteps();
                            this.calculateBusinessDay();
                            this.navigation = this.navigationResponse.navigation;

                            this.waitDate = new Date(Date.parse(this.navigation.WaitStateAccept));
                            var parseDate = new Date(Date.parse(this.navigation.WaitStateAccept));
                            if (isNullOrUndefined(this.contractActionlog.dtFirstSign))
                                this.isFinalSignWait = this.navigation.isFinalSign;
                            else
                                this.isFinalSignWait = true;
                            this.waitDate.setDate(parseDate.getDate() + this.waitDays);
                            if (this.navigation.WaitStateAccept != null)
                                this.dtSOC = "The Wait Disclosure Agreement signed on " + dtSOC.transform(this.waitAcceptDate, 'MMM dd yyyy') + ".";
                            this.dtAddWait = this.waitDate.toString().substring(4, 16);

                            if (this.waitDays > 0) {
                                if (this.businessDays && !isNullOrUndefined(this.contractSession) && this.contractSession.CountryID < 2) {
                                    let bizdate = new Date(this.businessDays);
                                    if (this.businessDays == "Invalid Date") { this.isWaitPrdForPayment = false }
                                    else {
                                        bizdate <= new Date() ? this.isWaitPrdForPayment = false : this.isWaitPrdForPayment = true;
                                    }
                                }
                                else
                                    this.isWaitPrdForPayment = this.isWaitStateExists ? this.isWaitStateExists : false
                            }

                            if (tdName == "ROI" && _isROIForm == false) {
                                this.navigationResponse.navigation.isROIForm == true ? this.updateCheckClass("tdIsROIForm") : this.updateBanClass("tdIsROIForm");
                                this.navigationResponse.navigation.isROIForm == true ? this.updateCheckClass("tdIsROIDoc") : this.updateBanClass("tdIsROIDoc");
                                this.navigationResponse.navigation.isROIForm == true ? this.isROISaved = true : this.isROISaved = false;
                            }
                            this.updateNavBar();
                            if (this.isFinalSignWait)
                                this.sentPayAlert = this.navigationResponse.navigation.IsPaymentReminder;
                            else
                                this.sentPayAlert = true;
                        }
                    } else {
                        console.log("Navigation Wizard result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.recursiveCallAPI++;
                if (this.recursiveCallAPI > 8)
                    this.navigateToContactList();
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadTextToNumber() {
        await this._wizardService.getTextToNumberAsync(this.encryptedUser, "DocToNumber")
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.simpleResponse = UtilityService.clone(result);
                        if (this.simpleResponse) {
                            this.doc_to_number = "Please text the manually entered ROI form to " + UtilityService.clone(this.simpleResponse.messageString) + " ";
                        }
                    } else {
                        console.log("result.statuscode: " + result.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });

        await this._wizardService.getTextToNumberAsync(this.encryptedUser, "ImageToNumber")
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.simpleResponse = UtilityService.clone(result);
                        if (this.simpleResponse) {

                            this.image_to_number = "Optionally, you may also send invention images to " + UtilityService.clone(this.simpleResponse.messageString) + " ";
                        }
                    } else {
                        console.log("result.statuscode: " + result.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private loadROIImagesList(inventionId): void {
        this._mediaImagesService.getMediaImageList(inventionId, this.lastAddedDOCImageId, this.encryptedUser)
            .subscribe(
                (result: MediaImagesResponse) => {
                    this.globalResponse = result.listImages;
                    this.mediaImagesResponse = result;
                    this.lastAddedImageId = this.mediaImagesResponse.lastAdded;
                },
                error => {
                    console.error(error);
                    this.mediaImagesList = null;
                },
                () => {
                    if (Array.isArray(this.globalResponse)) {

                        if (this.mediaImagesResponse.lastAdded && this.mediaImagesList)
                            this.mediaImagesList.concat(Object.assign([], this.globalResponse));
                        else
                            this.mediaImagesList = Object.assign([], this.globalResponse);
                        this.globalResponse = null;
                        if (this.mediaImagesList.length > 0)
                            this.isROISignDoc = true
                    }
                }
            );
    }

    private getROIRefreshFlags(inventionId: number, isfreshCall: number): void {
        if (!isNullOrUndefined(inventionId) && !isNullOrUndefined(isfreshCall)) {
            this._mediaImagesService.getROIRefreshFlag(inventionId, isfreshCall, this.encryptedUser).pipe(retry(3))
                .subscribe(
                    (result: ROIRefreshFlagResponse) => {
                        this.ROIFlagResponse = result;
                    },
                    error => {
                        console.error(error);
                    }
                );
        }
        else
            console.log("contract.component.getROIRefreshFlags:-" + "inventionId-" + inventionId + "isfreshCall-" + isfreshCall);
    }

    private fetchPaymentDocList(contractSessionId, contractMultiPaymentId, payType): void {
        this._mediaImagesService.getPaymentDocList(this.encryptedUser, contractSessionId, contractMultiPaymentId, payType)
            .subscribe(
                (result: PaymentDocMediaImagesResponse) => {
                    this.globalResponse = result.listImages;
                    this.paymentDocMediaImagesResponse = result;
                    this.paymentDoc = Object.assign([], this.globalResponse).filter(payment => payment.payType == 1);
                    this.paymentDocCheque = Object.assign([], this.globalResponse).filter(payment => payment.payType == 2);
                    this.paymentOther = Object.assign([], this.globalResponse).filter(payment => payment.payType == 3);
                    this.paymentCash = Object.assign([], this.globalResponse).filter(payment => payment.payType == 4);
                    this.paymentMonterey = Object.assign([], this.globalResponse).filter(payment => payment.payType == 7);
                    this.globalResponse = null;
                },
                error => {
                    console.error(error);
                    this.paymentDoc = null;
                    this.paymentDocCheque = null;
                    this.paymentOther = null;
                    this.paymentCash = null;
                    this.paymentMonterey = null;
                }
            );
    }


    private fetchMediaDocList(inventionId): void {
        this._mediaImagesService.getMediaDocList(inventionId, this.lastAddedDOCImageId, this.encryptedUser)
            .subscribe(
                (result: MediaDocImagesResponse) => {
                    this.globalResponse = result.listDocImages;
                    this.mediaDocImagesResponse = result;
                    if (!isNullOrUndefined(this.mediaDocImagesResponse.listDocImages)) {
                        this.lastAddedDOCImageId = this.mediaDocImagesResponse.lastAdded;
                        this.refreshFlag = true;
                    }

                },
                error => {
                    console.error(error);
                    this.mediaDocList = null;
                },
                () => {
                    if (Array.isArray(this.globalResponse)) {
                        if (this.mediaDocImagesResponse.lastAdded && this.mediaDocList) {
                            var maxid: number = -1;
                            if (this.mediaDocList[this.mediaDocList.length - 1])
                                maxid = this.mediaDocList[this.mediaDocList.length - 1].MediaId;
                            if ((maxid != this.mediaDocImagesResponse.lastAdded) && (this.mediaDocImagesResponse.lastAdded > maxid)) {
                                for (var i = 0; i < this.mediaDocImagesResponse.listDocImages.length; i++) {
                                    this.mediaDocList.push(this.mediaDocImagesResponse.listDocImages[i]);
                                }
                            }
                            else if (!this.mediaDocList) {
                                this.mediaDocList.push(this.mediaDocImagesResponse.listDocImages[i]);
                            }
                        }
                        else
                            this.mediaDocList = Object.assign([], this.globalResponse);

                        this.globalResponse = null;
                        this.isROIDocMedia = false;
                        if (this.mediaDocList.length > 0)
                            this.isROISignDoc = true
                    }
                    else {
                        this.isROIDocMedia = true;
                    }
                }
            );
        this.loadDocument_DocTypeId(2);
    }

    async fetchMediaDocListUpload(inventionId): Promise<void> {
        await this._mediaImagesService.getMediaDocList(inventionId, this.lastAddedDOCImageId, this.encryptedUser)
            .subscribe(
                (result: MediaDocImagesResponse) => {
                    this.globalResponse = result.listDocImages;
                    this.mediaDocImagesResponse = result;
                    if (!isNullOrUndefined(this.mediaDocImagesResponse.listDocImages)) {
                        this.isImageUpload = true;
                        this.roiDocMediaUploader.resetFileUpload();
                        this.lastAddedDOCImageId = this.mediaDocImagesResponse.lastAdded;
                        this.refreshFlag = true;
                        this.updateUserSteps("tdIsROIForm");
                        this.updateContractLogObjectModel("roiFormSubmit", false);
                        this.saveContrActionAcitonLog();
                    }

                },
                error => {
                    console.error(error);
                    this.mediaDocList = null;
                },
                () => {
                    if (Array.isArray(this.globalResponse)) {
                        if (this.mediaDocImagesResponse.lastAdded && this.mediaDocList) {
                            var maxid: number = -1;
                            if (this.mediaDocList[this.mediaDocList.length - 1])
                                maxid = this.mediaDocList[this.mediaDocList.length - 1].MediaId;
                            if ((maxid != this.mediaDocImagesResponse.lastAdded) && (this.mediaDocImagesResponse.lastAdded > maxid)) {
                                for (var i = 0; i < this.mediaDocImagesResponse.listDocImages.length; i++) {
                                    this.mediaDocList.push(this.mediaDocImagesResponse.listDocImages[i]);
                                }
                            }
                            else if (!this.mediaDocList) {
                                this.mediaDocList.push(this.mediaDocImagesResponse.listDocImages[i]);
                            }
                        }
                        else
                            this.mediaDocList = Object.assign([], this.globalResponse);

                        this.globalResponse = null;
                        this.isROIDocMedia = false;
                        if (this.mediaDocList.length > 0)
                            this.isROISignDoc = true
                    }
                    else {
                        this.isROIDocMedia = true;
                    }
                }
            );
        this.loadDocument_DocTypeId(2);
    }

    private fetchCurruptedhMediaImages(inventionId): void {
        this._mediaImagesService.getCurruptedMediaImageList(inventionId, this.encryptedUser)
            .subscribe(
                (result: MediaImagesResponse) => {
                    this.mediaImagesResponse = result;
                    if (!isNullOrUndefined(this.mediaImagesResponse.listImages)) {
                        this.isImageUpload = false;
                        this.openSnackBar("File/s (" + this.mediaImagesResponse.listImages[0].FileName + ") is/are corrupted. Please upload again!", "");
                    }
                    else
                        this.openSnackBar("Successfully Uploaded!", "");
                });
    }

    private fetchCheckList(contractSessionId): void {

        this._checkListService.getCheckList(contractSessionId, this.encryptedUser)
            .subscribe(
                (result: CheckListImagesResponse) => {
                    this.globalCheckListResponse = result.listImages;
                    this.checkListImagesResponse = result;

                    this.checkList = Object.assign([], this.globalCheckListResponse);

                    this.globalCheckListResponse = null;
                    this.isCheckListDocMedia = false;
                    if (this.checkList.length > 0)
                        this.isCheckListSignDoc = true
                    if (this.productId == 9 || this.productId == 10)
                        this.loadDocument_DocTypeId(141);
                    else
                        this.loadDocument_DocTypeId(-3);

                },
                error => {
                    console.error(error);
                    this.checkList = null;
                },
                () => {
                }
            );
    }

    private fetchConfigCheckList(): void {

        this._checkListService.getConfigCheckList(this.encryptedUser)
            .subscribe(
                (result: ConfigCheckListImagesResponse) => {
                    this.globalConfigCheckListResponse = result.listConfigImages;
                    this.configCheckListImagesResponse = result;

                    this.configCheckListArr = Object.assign([], this.globalConfigCheckListResponse);
                    this.globalConfigCheckListResponse = null;

                },
                error => {
                    console.error(error);
                    this.checkList = null;
                },
                () => {
                }
            );
    }


    openCheckListPDF(response) {
        const linkSource: string = 'data:application/pdf;base64,' + response.Media;
        const downloadLink = document.createElement("a");
        const fileName = response.FileName;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    getBaseImage(response) {
        const linkSource: string = 'data:application/pdf;base64,' + response;
        return linkSource;
    }

    private fetchMediaImagesList(inventionId): void {

        this._mediaImagesService.getMediaImageList(inventionId, this.lastAddedImageId, this.encryptedUser)

            .subscribe(
                (result: MediaImagesResponse) => {
                    this.globalResponse = result.listImages;
                    this.mediaImagesResponse = result;
                    this.lastAddedImageId = this.mediaImagesResponse.lastAdded;
                    this.refreshImageFlag = true;
                },
                error => {
                    console.error(error);
                    this.mediaImagesList = null;
                },
                () => {
                    if (Array.isArray(this.globalResponse)) {
                        if (this.mediaImagesResponse.lastAdded && this.mediaImagesList) {
                            var maxid: number = -1;
                            if (this.mediaImagesList[this.mediaImagesList.length - 1])
                                maxid = this.mediaImagesList[this.mediaImagesList.length - 1].MediaId;
                            if ((maxid != this.mediaImagesResponse.lastAdded) && (this.mediaImagesResponse.lastAdded > maxid)) {
                                for (var i = 0; i < this.mediaImagesResponse.listImages.length; i++) {
                                    this.mediaImagesList.push(this.mediaImagesResponse.listImages[i]);
                                }
                            }
                            else if (!this.mediaImagesList) {
                                this.mediaImagesList.push(this.mediaImagesResponse.listImages[i]);
                            }
                        }
                        else
                            this.mediaImagesList = Object.assign([], this.globalResponse);

                        this.globalResponse = null;
                        if (this.mediaImagesList.length > 0)
                            this.isROISignDoc = true
                    }
                    else {
                    }
                }
            );
    }

    refresh() {
        this.getROIRefreshFlags(this.inventionId, this.isRefreshCall);
        this.isRefreshCall = 1;
        let flag: boolean = this.ROIFlagResponse && this.ROIFlagResponse.roiRefreshFlag ? true : false;
        this.isRefreshDocConfig = flag ? this.ROIFlagResponse.roiRefreshFlag.isRefreshDoc : false;
        this.isRefreshImageConfig = flag ? this.ROIFlagResponse.roiRefreshFlag.isRefreshImage : false;

        if ((this.refreshFlag && this.isRefreshDocConfig) || (flag && this.ROIFlagResponse.roiRefreshFlag.inventionId == 0)) {
            this.refreshFlag = false
            this.fetchMediaDocList(this.inventionId);
        }
        if ((this.refreshImageFlag && this.isRefreshImageConfig) || (flag && this.ROIFlagResponse.roiRefreshFlag.inventionId == 0)) {
            this.refreshImageFlag = false
            this.fetchMediaImagesList(this.inventionId);

        }

        if (this.navigationResponse) {
            if (!this.navigationResponse.navigation.isROIForm) {
                this.isROISubmitted = false;
            }
            else {
                this.isROISubmitted = true;
            }
        }
    }


    refreshSignedROINavigation() {
        this.refreshROINav = setTimeout(() => {
            this.loadNavigationWizard("ROI");
            this.loadInvention(this.countLoadDocument);
            this.countLoadDocument++;
            this.refreshSignedROINavigation();
        }, 10000);
    }

    refreshGetGenerateContractDetails() {
        this.refreshGenContact = setTimeout(() => {
            this.GetGenerateContractDetails();
            this.refreshGetGenerateContractDetails();
        }, 10000);
    }

    refreshCheckSendToCorpProcess() {
        this.refreshSendToCorp = setTimeout(() => {
            if (this.isContractActionLogDone && this.isGenerateContractsDone && this.checkSendToCorpCounter < 4)
                this.loadSendToCorpCheckProcess();
            this.refreshCheckSendToCorpProcess();
        }, 1000);
    }

    ngOnDestroy() {
        clearTimeout(this.refreshROINav);
        clearTimeout(this.refreshROIFlag);
        clearTimeout(this.refreshGenContact);
        clearTimeout(this.refreshSendToCorp);
    }

    checkFileNumber() {
        setTimeout(() => {
            if (this._transferDataService.isNavAction) {
                this.isFileNoBlank = this._transferDataService.isFileNoBlank;
                if (this._transferDataService.isChangedFileNumber) {
                    this.sendToCorpMsg = "Send to Corp";
                    this.loadFileNumber();
                }
                this._transferDataService.isNavAction = false;
            }
            this.checkFileNumber();
        }, 1000);
    }

    public signataurePadOptions = {
        'minWidth': 1,
        'maxWidth': 2,
        penColor: 'black',
        backgroundColor: '#fff',
    };

    public signataurePadOptionsADS = {
        'minWidth': 1,
        'maxWidth': 2,
        penColor: 'black',
        backgroundColor: '#fff',
    };

    public coSignataurePadOptions = {
        'minWidth': 1,
        'maxWidth': 2,
        penColor: 'black',
        backgroundColor: '#fff',
    };

    public signataurePadOptionsFinal = {
        'minWidth': 1,
        'maxWidth': 2,
        penColor: 'black',
        backgroundColor: '#fff',
    };

    drawClear(): boolean {
        this.signaturePad.clear();
        this.base64Str = "";
        this.isExistSoc = false;
        this.titleMsg = '';
        this.signaturePad.on();
        this.initialDisabled = false;
        this.socGroup.patchValue({
            initialSignature: ''
        });
        return false;
    }

    drawClearCoInv(): boolean {
        this.signaturePadCoInv.clear();
        this.base64StrCoInv = "";
        this.isExistSocinv = false;
        this.titleMsgInv = '';
        this.signaturePadCoInv.on();
        this.initialCoInvDisabled = false;
        this.socGroup.patchValue({
            initialCoInvSignature: ''
        });
        return false;
    }

    drawClearFinal(): boolean {
        this.signaturePadFinal.clear();
        this.base64StrFinal = "";
        this.titleMsg = '';
        this.isExistFinal = false;
        this.signaturePadFinal.on();
        this.initialFinalDisabled = false;
        this.signDocsGroup.patchValue({
            initialFinalSignature: ''
        });
        return false;
    }

    drawClearFinalCoInv(): boolean {
        this.signaturePadFinalCoInv.clear();
        this.base64StrFinalCoInv = "";
        this.isExistFinalinv = false;
        this.titleMsgInv = '';
        this.signaturePadFinalCoInv.on();
        this.initialFinalCoInvDisabled = false;
        this.signDocsGroup.patchValue({
            initialFinalCoInvSignature: ''
        });
        return false;
    }

    drawClearADS(): boolean {
        this.signaturePadADS.clear();
        this.base64StrADS = "";
        this.titleMsg = '';
        this.isExistADS = false;
        this.signaturePadADS.on();
        this.initialAdsDisabled = false;
        this.socGroup.patchValue({
            initialAdsSignature: ''
        });
        return false;
    }

    drawClearADSCoInv(): boolean {
        this.signaturePadADSCoInv.clear();
        this.base64StrADSCoInv = "";
        this.titleMsgInv = '';
        this.isExistADSinv = false;
        this.signaturePadADSCoInv.on();
        this.initialAdsCoInvDisabled = false;
        this.socGroup.patchValue({
            initialAdsCoInvSignature: ''
        });
        return false;
    }

    drawComplete() {
        this.base64Str = this.isExistSoc ? this.documentSignature.signature1 : this.signaturePad.toDataURL('image/png', 0.9);
    }

    drawCompleteCoInv() {
        this.base64StrCoInv = this.isExistSocinv ? this.documentSignature.signature2 : this.signaturePadCoInv.toDataURL('image/png', 0.9);
    }

    drawCompleteADS() {
        this.base64StrADS = this.isExistADS ? this.documentSignature.i1SignatureADS : this.signaturePadADS.toDataURL('image/png', 0.9);
    }

    drawCompleteADSCoInv() {
        this.base64StrADSCoInv = this.isExistADSinv ? this.documentSignature.i2SignatureADS : this.signaturePadADSCoInv.toDataURL('image/png', 0.9);
    }

    drawCompleteFinal() {
        this.base64StrFinal = this.isExistFinal ? this.documentSignature.i1SignatureFinal : this.signaturePadFinal.toDataURL('image/png', 0.9);
    }

    base64toBlob(base64) {
        const byteString = atob(base64.split(',')[1]);
        const mimeString = base64.split(',')[0].split(':')[1].split(':')[0];
        const byteNumbers = new Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            byteNumbers[i] = byteString.charAt(i);
        }
        const ia = new Uint8Array(byteNumbers);
        return new Blob([ia], { type: mimeString });
    }

    get disableContinue(): boolean {
        if (this.isCoInventor) {
            if (this.navigationResponse) {
                if (this.isStateExists && (!isNullOrUndefined(this.contractSession) && this.contractSession.IsSecondContract))
                    return false;
                if (this.isCoInventor && (!this.initialDisabled && !this.initialCoInvDisabled) && (!this.navigationResponse.navigation.isSOCDoc)
                    && (this.socGroup.controls.initialSignature.value.length == 0 || this.socGroup.controls.initialCoInvSignature.value.length == 0))
                    return true;
                else if (this.isCoInventor && this.initialDisabled && this.signaturePadCoInv.isEmpty() && this.socGroup.controls.initialCoInvSignature.value.length == 0
                    && (!this.navigationResponse.navigation.isSOCDoc))
                    return true;
                else if (this.isCoInventor && this.initialCoInvDisabled && this.signaturePad.isEmpty() && this.socGroup.controls.initialSignature.value.length == 0
                    && (!this.navigationResponse.navigation.isSOCDoc))
                    return true;
                else if (this.isCoInventor && (this.initialDisabled && this.initialCoInvDisabled) && (!this.navigationResponse.navigation.isSOCDoc)
                    && (this.signaturePad.isEmpty() || this.signaturePadCoInv.isEmpty()))
                    return true;
                if (this.navigationResponse.navigation.isSOCDoc && !this.navigationResponse.navigation.isADSDoc) {
                    if (this.isCoInventor && (!this.initialAdsDisabled && !this.initialAdsCoInvDisabled) && (!this.navigationResponse.navigation.isADSDoc)
                        && (this.socGroup.controls.initialAdsSignature.value.length == 0 || this.socGroup.controls.initialAdsCoInvSignature.value.length == 0))
                        return true;
                    else if (this.isCoInventor && this.initialAdsDisabled && this.signaturePadADSCoInv.isEmpty() && this.socGroup.controls.initialAdsCoInvSignature.value.length == 0
                        && (!this.navigationResponse.navigation.isADSDoc))
                        return true;
                    else if (this.isCoInventor && this.initialAdsCoInvDisabled && this.signaturePadADS.isEmpty() && this.socGroup.controls.initialAdsSignature.value.length == 0
                        && (!this.navigationResponse.navigation.isADSDoc))
                        return true;
                    else if (this.isCoInventor && (this.initialAdsDisabled && this.initialAdsCoInvDisabled) && (!this.navigationResponse.navigation.isADSDoc)
                        && (this.signaturePadADS.isEmpty() || this.signaturePadADSCoInv.isEmpty()))
                        return true;
                }
                if (this.navigationResponse.navigation.isSOCDoc && this.navigationResponse.navigation.isADSDoc) {
                    if (this.isCoInventor && (!this.initialAdsDisabled && !this.initialAdsCoInvDisabled) && (this.navigationResponse.navigation.isADSDoc)
                        && (this.socGroup.controls.initialAdsSignature.value.length == 0 || this.socGroup.controls.initialAdsCoInvSignature.value.length == 0)
                        && (!isNullOrUndefined(this.contractSession) && this.contractSession.IsSecondContract))
                        return true;
                    else if (this.isCoInventor && this.initialAdsDisabled && this.signaturePadADSCoInv.isEmpty() && this.socGroup.controls.initialAdsCoInvSignature.value.length == 0
                        && (this.navigationResponse.navigation.isADSDoc))
                        return true;
                    else if (this.isCoInventor && this.initialAdsCoInvDisabled && this.signaturePadADS.isEmpty() && this.socGroup.controls.initialAdsSignature.value.length == 0
                        && (this.navigationResponse.navigation.isADSDoc))
                        return true;
                    else if (this.isCoInventor && (this.initialAdsDisabled && this.initialAdsCoInvDisabled) && (this.navigationResponse.navigation.isADSDoc)
                        && ((this.signaturePadADS.isEmpty() && this.documentSignature.signature1 === '') || this.signaturePadADSCoInv.isEmpty()))
                        return true;
                }
                else
                    return false;
            }
        }
        else {
            if (this.navigationResponse) {
                if (this.socGroup.controls.initialSignature.value) {
                    if (!this.navigationResponse.navigation.isSOCDoc && this.signaturePad.isEmpty() && (this.socGroup.controls.initialSignature.value.length == 0))
                        return true;
                    else if (this.navigationResponse.navigation.isSOCDoc && !this.navigationResponse.navigation.isADSDoc && this.signaturePadADS.isEmpty() && (this.socGroup.controls.initialAdsSignature.value.length == 0))
                        return true;
                    else
                        return false;
                }
            }
            else
                return true;
        }
    }

    get disableContinueFinal(): boolean {
        if (this.isCoInventor) {
            if (this.navigationResponse) {
                if (this.isCoInventor && (!this.initialFinalDisabled && !this.initialFinalCoInvDisabled)
                    && (this.signDocsGroup.controls.initialFinalSignature.value.length == 0 || this.signDocsGroup.controls.initialFinalCoInvSignature.value.length == 0))
                    return true;
                else if (this.isCoInventor && this.initialFinalDisabled && this.signaturePadFinalCoInv.isEmpty() && this.signDocsGroup.controls.initialFinalCoInvSignature.value.length == 0)
                    return true;
                else if (this.isCoInventor && this.initialFinalCoInvDisabled && this.signaturePadFinal.isEmpty() && this.signDocsGroup.controls.initialFinalSignature.value.length == 0)
                    return true;
                else if (this.isCoInventor && (this.initialFinalDisabled && this.initialFinalCoInvDisabled)
                    && (this.signaturePadFinal.isEmpty() || this.signaturePadFinalCoInv.isEmpty()))
                    return true;
                else if (this.productId == 3 || this.productId == 7 || this.productId == 8 || this.productId == 12 || this.productId == 13 || this.productId == 14)
                    return this.disableCheckList;
                else
                    return false;
            }
        }
        if (this.productId == 3 || this.productId == 7 || this.productId == 8 || this.productId == 12 || this.productId == 13 || this.productId == 14)
            return this.disableCheckList;
    }

    get disableCheckList(): boolean {
        this.checkListStatus = this.checkListValid();
        if (this.navigationResponse) {
            if (!isNullOrUndefined(this.navigationResponse) && !this.navigationResponse.navigation.isCheckListForm)
                return true;
        }
        else if (!this.checkListStatus)
            return true;
        else
            return false;
    }

    stopWaiting(): void {
        $('#modalWaitingCoInventor').modal('hide');
    }

    /*Card Payment*/
    //setCardElement() {
    //    this.stripeService.elements(this.elementsOptions)
    //        .subscribe(elements => {
    //            this.elements = elements;
    //            if (!this.card) {
    //                this.card = this.elements.create('card', {
    //                    style: {
    //                        base: {
    //                            iconColor: '#666EE8',
    //                            color: '#31325F',
    //                            lineHeight: '40px',
    //                            fontWeight: 400,
    //                            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    //                            fontSize: '17px',
    //                            '::placeholder': {
    //                                color: '#00008b'
    //                            }
    //                        }
    //                    }
    //                });
    //                //this.card.mount('#card-element');
    //            }
    //        });
    //}

    allowAlphabets(e) {
        if (e.ctrlKey || e.altKey) {
            e.preventDefault();
        } else {
            var key = e.keyCode;
            if (!((key == 8) || (key == 9) || (key == 32) || (key == 46) || (key >= 35 && key <= 40) || (key >= 65 && key <= 90))) {
                e.preventDefault();
            }
        }
    }

    allowNumeric(e) {
        if (e.ctrlKey || e.altKey) {
            e.preventDefault();
        } else {
            var key = e.keyCode;
            if (key != 8 && key != 0 && (key < 48 || key > 57)) {
                e.preventDefault();
            }
        }
    }

    showCurrency(e) {
        let cashPrice: string = this.prodConfigGroup.controls.cashPrice.value;
        if (e.ctrlKey || e.altKey) {
            e.preventDefault();
        }
        else {
            var key = e.keyCode;
            if (key == 46 && cashPrice.toString().indexOf('.') > 0) {
                e.preventDefault();
            }
            if (key != 8 && key != 0 && (key != 46 && key > 31) && (key < 48 || key > 57)) {
                e.preventDefault();
            }
        }
    }

    checkDecimal(e) {
        let downPayment: string = this.prodConfigGroup.controls.downPayment.value;
        if (e.ctrlKey || e.altKey) {
            e.preventDefault();
        }
        else {
            var key = e.keyCode;
            if (key == 46 && downPayment.toString().indexOf('.') > 0) {
                e.preventDefault();
            }
            if (key != 8 && key != 0 && (key != 46 && key > 31) && (key < 48 || key > 57)) {
                e.preventDefault();
            }
        }
    }

    private async setCCKeys(configKey: string) {
        await this._appconfigService.getAppConfigValue(this.encryptedUser, configKey)
            .then(async (result: ConfigDetails) => {
                if (result) {
                    this.configDetails = UtilityService.clone(result);
                    if (this.configDetails) {
                        this.configKeyValue = this.configDetails.configValue;
                        if (this.configKeyValue != "") {
                            if (this.site.startsWith("https://evolve_cs")) {
                                if (this.useType == 99) {
                                    this.stripePublicKey = "Evolve_CC_PK_TestKey";
                                    this.stripePrivateKey = "Evolve_CC_SK_TestKey";
                                }
                                else {
                                    this.stripePublicKey = "Evolve_CC_PK_LiveKey";
                                    this.stripePrivateKey = "Evolve_CC_SK_LiveKey";
                                }
                            } else {
                                this.stripePublicKey = "SalesOptima_CC_PK_TestKey";
                                this.stripePrivateKey = "SalesOptima_CC_SK_TestKey";
                            }
                        }
                        await this._appconfigService.getAppConfigValue(this.encryptedUser, this.stripePublicKey)
                            .then(async (result: ConfigDetails) => {
                                if (result) {
                                    this.configDetails = UtilityService.clone(result);
                                    if (this.configDetails) {
                                        this.stripePublicKeyValue = this.configDetails.configValue;
                                        //this.stripeService.setKey(this.stripePublicKeyValue);
                                        //this.setCardElement();
                                    } else {
                                        console.log("Config Details error " + this.stripePublicKey);
                                    }
                                }
                            })
                            .catch((err: HttpErrorResponse) => {
                                this._utilityService.handleErrorResponse(err);
                            });
                    } else {
                        console.log("Config Details error " + configKey);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private copyPayFormValuesToDataObject() {
        let bill: BillingDetails = {
            cardToken: "",
            cardApiPrivateKey: "",
            cardApiPublicKey: "",
            cardTxnNotes: "",
            cardTxnReference: "",
            cardTxnStatus: -1,
            inventionName: "",
            ContractSessionId: -1,
            inventionId: -1,
            contractId: -1,
            productId: -1,
            product: "",
            OfficeNumber: -1,
            I1CLPContactId: -1,
            I2CLPContactId: -1,
            CLPUserId: -1,
            WizardId: 0,
            LawfirmId: -1,
            cardAmount: -1,
            fileNumber: '',
            cardHolderName: '',
            txnType: -1,
            chkAmount: false,
            chkFileNumber: false,
            authcode: '',
            avsresponse: '',
            cvvresponse: '',
            firstName: '',
            lastName: '',
            orderid: '',
            response: '',
            responsetext: '',
            response_code: '',
            transactionid: '',
            type: '',
            zip: '',
            ccNumber: '',
            ccExp: '',
            cvv: '',
            custVaultId: '',
            cardType: '',
            contractMultiPaymentId: -1,
            isPaid: false
        }
        this.billingDetails = bill;

        this.billingDetails.firstName = this.collectPaymentGroup.controls.firstName.value;
        this.billingDetails.lastName = this.collectPaymentGroup.controls.lastName.value;
        this.billingDetails.zip = this.collectPaymentGroup.controls.zip.value;
        this.billingDetails.ccNumber = this.collectPaymentGroup.controls.creditCard.value;
        this.billingDetails.ccExp = this.collectPaymentGroup.controls.expirationDate.value;
        this.billingDetails.cvv = this.collectPaymentGroup.controls.cvc.value;
        this.billingDetails.cardToken = this.cardToken;
        this.billingDetails.cardApiPrivateKey = this.stripePrivateKey;
        this.billingDetails.inventionName = this.inventionName;
        this.billingDetails.ContractSessionId = this.contractSessionId;
        this.billingDetails.inventionId = this.contractSession.inventionId;
        this.billingDetails.contractId = this.contractSession.contractId;
        this.billingDetails.productId = this.contractSession.productId;
        if (this.productDetails)
            this.billingDetails.product = this.productDetails[0].productDescription;
        else
            this.billingDetails.product = "";

        if (this.contractPayment)
            this.billingDetails.OfficeNumber = this.contractPayment.officeId;
        else
            this.billingDetails.OfficeNumber = -1;

        this.billingDetails.I1CLPContactId = this.contractSession.I1CLPContactId;
        this.billingDetails.I2CLPContactId = this.contractSession.I2CLPContactId;
        this.billingDetails.CLPUserId = this.contractSession.CLPUserId;
        this.billingDetails.WizardId = this.contractSession.WizardId || 1;
        this.billingDetails.LawfirmId = this.contractSession.LawfirmId;
        this.billingDetails.cardAmount = parseFloat(this.partialFee ? this.partialFee.toString().replace(this.currencySterling, "").replace(',', "") : "0");
        this.billingDetails.fileNumber = this.fileNumber;
        this.billingDetails.cardHolderName = this.collectPaymentForm.firstName.value + ' ' + this.collectPaymentForm.lastName.value;
        if (this.prodForm.payCheck.value) {
            this.billingDetails.txnType = 3;
        }
        else if (this.prodForm.payCash.value) {
            this.billingDetails.txnType = 4;
        }
        else if (this.prodForm.payMoneyOrder.value) {
            this.billingDetails.txnType = 2;
        }
        else if (this.prodForm.payOther.value) {
            this.billingDetails.txnType = 5;
        }
        else if (this.prodForm.payCarryOver.value) {
            this.billingDetails.txnType = 6;
        }
        else if (this.prodForm.payMonterey.value) {
            this.billingDetails.txnType = 7;
        }

        if (this.paymentForm.paymentType.value)
            this.billingDetails.chkAmount = this.paymentForm.paymentType.value;
        if (this.paymentForm.fileNo.value)
            this.billingDetails.chkFileNumber = this.paymentForm.fileNo.value;
        this.billingDetails.cardType = this.sel_brand === 'unknown' ? this.cc_brand_type(this.collectPaymentGroup.controls.creditCard.value) : this.sel_brand ? this.sel_brand : '';
        this.billingDetails.contractMultiPaymentId = this.currentMultiPayId;

        let contractMultiPayment: ContractMultiPayment = {
            id: -1,
            contractSessionId: -1,
            payOption: -1,
            downPaymentPart: '-1',
            dtCreated: new Date(),
            isChkAmount: false,
            chkBankName: '',
            chkCity: '',
            chkState: '',
            chkRoutingNo: '',
            chkAccNo: '',
            action: '',
            paymentStatus: false,
            isPaid: false,
            isShowSelect: false,
            chkNumber: '',
            bankAccountName: '',
            chkDate: '',
            CCNumber: ''
        }
        this.contractMultiPayment = contractMultiPayment;
        this.contractMultiPayment.id = this.currentMultiPayId;
        this.contractMultiPayment.contractSessionId = this.contractSessionId;
        this.contractMultiPayment.payOption = this.prodForm.payCheck.value ? 3 : this.prodForm.payCash.value ? 4 : this.prodForm.payMoneyOrder.value ? 2 : this.prodForm.payOther.value ? 5 : this.prodForm.payCarryOver.value ? 6 : this.prodForm.payMonterey.value ? 7 : 1;
        this.contractMultiPayment.isChkAmount = this.paymentForm.paymentType.value;
        this.contractMultiPayment.chkBankName = this.collectPaymentGroup.controls.chkBankName.value;
        this.contractMultiPayment.chkCity = this.collectPaymentGroup.controls.chkCity.value;
        this.contractMultiPayment.chkState = this.collectPaymentGroup.controls.chkState.value;
        this.contractMultiPayment.chkRoutingNo = this.collectPaymentGroup.controls.chkRoutingNo.value;
        this.contractMultiPayment.chkAccNo = this.collectPaymentGroup.controls.chkAccNo.value;
        this.contractMultiPayment.isPaid = true;
        this.contractMultiPayment.chkNumber = this.collectPaymentGroup.controls.chkNumber.value;
        this.contractMultiPayment.bankAccountName = this.collectPaymentGroup.controls.bankAccountName.value;
        this.contractMultiPayment.chkDate = $("#chkDate").val();

        if (this.contractMultiPaymentResponse.contractMultiPayment.length > 0) {
            var that = this;
            this.contractMultiPaymentResponse.contractMultiPayment.forEach(function (multiPaymentObj) {
                if ((multiPaymentObj.id == that.currentMultiPayId) && (multiPaymentObj.payOption == 3)) {
                    multiPaymentObj.isChkAmount = that.paymentForm.paymentType.value;
                    multiPaymentObj.chkBankName = that.collectPaymentGroup.controls.chkBankName.value;
                    multiPaymentObj.chkCity = that.collectPaymentGroup.controls.chkCity.value;
                    multiPaymentObj.chkState = that.collectPaymentGroup.controls.chkState.value;
                    multiPaymentObj.chkRoutingNo = that.collectPaymentGroup.controls.chkRoutingNo.value;
                    multiPaymentObj.chkAccNo = that.collectPaymentGroup.controls.chkAccNo.value;
                    multiPaymentObj.chkNumber = that.collectPaymentGroup.controls.chkNumber.value;
                    multiPaymentObj.bankAccountName = that.collectPaymentGroup.controls.bankAccountName.value;
                    multiPaymentObj.chkDate = $("#chkDate").val();
                }
            })
        }

    }


    SSNeyeopen() {

        let i1SSN: string = $("#i1SSN").val();
        var chars = i1SSN.split('-');
        var str = "";
        for (var i = 0; i < chars.length; i++) {
            str = str + chars[i].toString();
        }

        let maskedString: string = this.getSSNMaskString(str);
        if (this.showSSnDiv) {
            this.prodConfigGroup.patchValue({
                i1SSNMask: maskedString
            });
        }
        this.showSSnDiv = !this.showSSnDiv;
        this._i1SSN = "";
    }

    saveCardPayment() {
        this.isCardPaymentStarted = true;
        var isPaid = false;
        var downPaymentPart: number = 0;
        this.cardErrorMsg = "";
        this.collectionError = "";
        if (isNullOrUndefined(this._transferDataService.fileNumber) || this._transferDataService.fileNumber === '' || this._transferDataService.fileNumber === '0') {
            this.cardErrorMsg = "Before making a payment, please save the correct File Number.";
            this.isCardPaymentStarted = false;
        }
        else if (!isNullOrUndefined(this.contractPayment) && this.contractPayment.cashPrice <= 0) {
            this.cardErrorMsg = "Please enter Total price of Services in Service section.";
            this.isCardPaymentStarted = false;
        }
        else if (Number(this.partialFee) <= 0) {
            this.cardErrorMsg = "Amount should be greater than Zero.";
            this.isCardPaymentStarted = false;
        }
        else {
            this.validateAllFormFields(this.collectPaymentGroup);
            if (this.collectPaymentGroup.valid) {
                this.collectPaymentGroup.markAsPristine();
                this.isSubmitCharge = true;
                this.isPaymentProcessing = true;
                this.copyPayFormValuesToDataObject();
                this.billingDetails.chkAmount = false;
                this.billingDetails.chkFileNumber = false;
                if (this._transferDataService.fileNumber)
                    this.billingDetails.fileNumber = this._transferDataService.fileNumber;
                else
                    this.billingDetails.fileNumber = "1";

                if (!isNullOrUndefined(this.contractMultiPaymentResponse.contractMultiPayment)) {
                    for (var i = 0; i < this.contractMultiPaymentResponse.contractMultiPayment.length; i++) {
                        var downPayment: any = this.contractMultiPaymentResponse.contractMultiPayment[i].downPaymentPart;
                        if (downPayment == 0) {
                            //this.openSnackBar("Down Payment can not be $0", "");
                            this.collectionError = 'Down Payment can not be ' + this.currencySterling + '0';
                            this.isCardPaymentStarted = false;
                            this.isSubmitCharge = false;
                            this.isPaymentProcessing = false;
                            return;
                        }
                        if (downPayment && typeof downPayment == "number")
                            downPayment = downPayment.toString();
                        downPayment = downPayment ? downPayment.toString().replace(this.currencySterling, "").replace(',', "") : 0;
                        downPaymentPart += Number(downPayment);
                    }
                    this.contractPaymentResponse.contractPayment.downPayment = downPaymentPart;
                    this.saveContractPaymentAfterMultiCRUD();

                    if (!isNullOrUndefined(downPaymentPart) && downPaymentPart > 0) {
                        if ((downPaymentPart != this.oneTimeFee) || (downPaymentPart != this.oneTimeFeeInitial)) {
                            if (!isNullOrUndefined(this.navigationResponse.navigation)) {
                                this.navigationResponse.navigation.isPayCollectForm = false;
                                this.navigationResponse.navigation.isRetailDoc = false;
                                this.uncheckNavBar('tdIsRetailDoc');
                                this.isRetailAccept = false;
                                this.isRetailHeadAccept = false;
                                this.saveNavigationWizard();
                            }
                        }
                    }
                }
                if (this.billingDetails.cardType === 'unknown' || this.billingDetails.cardType.trim() === '' || isNullOrUndefined(this.billingDetails.cardType))
                    this.billingDetails.cardType = this.cc_brand_type(this.collectPaymentGroup.controls.creditCard.value);
                this._billingService.payCardPaymentAsync(this.encryptedUser, this.billingDetails)
                    .then(res => {
                        if (res) {
                            this.billingResponse = UtilityService.clone(res);
                            if (this.billingResponse.statusCode == 411) {
                                this.openSnackBar("Card number format is not valid.", "");
                                this.isPaymentDone = false;
                                this.isPaymentProcessing = false;
                                this.isSubmitCharge = false;
                                this.isCardPaymentStarted = false;
                                return;
                            }
                            else {
                                if (this.billingResponse) {
                                    if (this.billingResponse.billingDetails.cardTxnStatus == 1) {
                                        isPaid = true;
                                        this.loadDocument();
                                        this.cardTxnReference = this.billingResponse.billingDetails.cardTxnReference;
                                        this.cardTxnNotes = this.billingResponse.billingDetails.cardTxnNotes;
                                        this.isPaymentError = false;
                                        this.isPaymentDone = true;
                                        this.isPaymentProcessing = false;
                                        this.isCardPaymentStarted = false;
                                        this.getContractMultiPayment("");
                                        this.updateContractLogObjectModel("payCollectionFormSubmit", false);
                                        this.updateContractMultiPayment(isPaid);
                                    }
                                    else {
                                        this.cardTxnReference = this.billingResponse.billingDetails.cardTxnReference;
                                        this.cardTxnNotes = this.billingResponse.billingDetails.cardTxnNotes;
                                        this.isPaymentError = true;
                                        this.isPaymentDone = false;
                                        this.isPaymentProcessing = false;
                                        this.isCardPaymentStarted = false;
                                        this.isSubmitCharge = false;
                                        this.updateContractMultiPayment(isPaid);
                                    }
                                }
                            }
                        }
                        else {
                            this.isCardPaymentStarted = false;
                            this.updateContractMultiPayment(isPaid);
                        }
                    }).catch((err: HttpErrorResponse) => {
                        this.isPaymentDone = false;
                        this.isPaymentProcessing = false;
                        this.isSubmitCharge = false;
                        this.isCardPaymentStarted = false;
                        this._utilityService.handleErrorResponse(err);
                    });
                this.collectPaymentGroup.controls.creditCard.setValidators([Validators.required, Validators.minLength(14)]);
            } else {
                this.isPaymentProcessing = false;
                this.isSubmitCharge = false;
                this.isCardPaymentStarted = false;
            }
            this.saveContrActionAcitonLog();
        }
    }

    onEditPay(id: number, payOption, element) {
        if (this.contractSession.isCancelled == false) {
            if (!this.isEditPay) {
                this.downpaymentPre = element.downPaymentPart;
                this.editedRowId = id;
                this.isEditPay = !this.isEditPay;
                element.isPaid = !element.isPaid;
                this.updateUserSteps("tdIsPayCollectAgain");
            }
        }
    }

    resetGrid(element, index) {
        if (this.contractSession.isCancelled == false) {
            //let index = this.editedRowId;
            this.editedRowId = -1;
            this.isEditPay = !this.isEditPay;
            element.isPaid = true;
            if (!isNullOrUndefined(this.contractMultiPayments))
                this.contractMultiPayments[index].downPaymentPart = (this.downpaymentPre);
            this.changeAmountOnCancel();
            if (this.contractMultiPayments.length > 1) {
                for (var i = 0; i < this.contractMultiPayments.length; i++) {
                    if (!this.contractMultiPayments[i].isPaid) {
                        this.updateUserSteps("tdIsPayCollectAgain");
                        this.dataSource = new MatTableDataSource(this.contractMultiPayments);
                        return;
                    }
                }
            }

            this.updateUserSteps("tdIsPayCollectForm");

            this.dataSource = new MatTableDataSource(this.contractMultiPayments);
            //this.getContractMultiPayment(element.payOption);
        }
    }

    changeAmountOnCancel() {
        //this.CopyMultiPaymentToDataObject(grdType);
        let _downPartPayment: number = 0;
        this.remainingDue = 0;
        for (var i = 0; i < this.contractMultiPayments.length; i++) {
            var downPayment: any = this.contractMultiPayments[i].downPaymentPart;
            if (downPayment && typeof downPayment == "number")
                downPayment = downPayment.toString();
            downPayment = downPayment ? downPayment.toString().replace(this.currencySterling, "").replace(',', "") : 0;
            _downPartPayment += Number(downPayment);
            if (this.contractMultiPayments[i].isPaid)
                this.remainingDue += Number(downPayment);
        }
        if (this.oneTimeFee < _downPartPayment)
            this.oneTimeFee = Number(_downPartPayment);
        else
            this.oneTimeFee = Number(_downPartPayment);
    }

    showFirstMultiPayment() {
        if (this.contractMultiPaymentResponse.contractMultiPayment.length > 0) {
            let contractMultiPayment = this.contractMultiPaymentResponse.contractMultiPayment[0];
            this.showPaymentInterface(contractMultiPayment.id, contractMultiPayment.payOption, contractMultiPayment.downPaymentPart, contractMultiPayment.isPaid);
        }
    }

    showCollectionMultiPayment() {
        if (this.contractMultiPayments && this.contractMultiPayments.length > 0) {
            this.payCheck = false; this.payCreditCard = false; this.payMoneyOrder = false; this.payCash = false; this.payOther = false; this.payCarryOver = false; this.payMonterey = false;
            var contractMultiPayment = this.contractMultiPayments[0];
            contractMultiPayment.payOption == 1 ? this.payCreditCard = true : contractMultiPayment.payOption == 2 ? this.payMoneyOrder = true
                : contractMultiPayment.payOption == 3 ? this.payCheck = true : contractMultiPayment.payOption == 4 ? this.payCash = true
                    : contractMultiPayment.payOption == 5 ? this.payOther = true : contractMultiPayment.payOption == 6 ? this.payCarryOver = true : contractMultiPayment.payOption == 7 ? this.payMonterey = true : '';
            this.showPaymentInterface(contractMultiPayment.id, contractMultiPayment.payOption, contractMultiPayment.downPaymentPart, contractMultiPayment.isPaid);
        }
    }
    get hideDocuments(): boolean {
        if (this.contractSession) {
            if (this.contractSession.CountryID > 2)
                return true;
        }
        else
            return false;
    }

    get carryOver(): boolean {
        if (!isNullOrUndefined(this.contractSession) && !isNullOrUndefined(this.contractPayment)) {
            if (this.contractSession.IsSecondContract &&
                (this.contractSession.productId == 3 || this.contractSession.productId == 7 || this.contractSession.productId == 8 || this.contractSession.productId == 9 || this.contractSession.productId == 10 || this.contractSession.productId == 12 || this.contractSession.productId == 13 || this.contractSession.productId == 14 || this.contractPayment.productId == 3 || this.contractPayment.productId == 7 || this.contractPayment.productId == 8 || this.contractPayment.productId == 9 || this.contractPayment.productId == 10 || this.contractPayment.productId == 12 || this.contractPayment.productId == 13 || this.contractSession.productId == 14)) {
                if (+$("#contract option:selected").val() == 3 || +$("#contract option:selected").val() == 7 || +$("#contract option:selected").val() == 8 || +$("#contract option:selected").val() == 9 || +$("#contract option:selected").val() == 10 || +$("#contract option:selected").val() == 12 || +$("#contract option:selected").val() == 13 || +$("#contract option:selected").val() == 14)
                    return true;
                else
                    return false;
            }
        }
        if (this.isCarryOver)
            return true;
        else
            return false;
    }

    refreshNavBar() {
        if (this.navigationResponse) {
            if (this.navigationResponse.navigation) {
                this.navigationResponse.navigation.isSOCForm == true ? this.updateCheckClass("tdIsSOCForm") : this.updateBanClass("tdIsSOCForm");
                this.navigationResponse.navigation.isSOCDoc == true ? this.updateCheckClass("tdIsSOCDoc") : this.updateBanClass("tdIsSOCDoc");
                this.navigationResponse.navigation.isADSDoc == true ? this.updateCheckClass("tdIsADSDoc") : this.updateBanClass("tdIsADSDoc");
                this.navigationResponse.navigation.isNDADoc == true ? this.updateCheckClass("tdIsNDADoc") : this.updateBanClass("tdIsNDADoc");
                this.navigationResponse.navigation.isWaitDoc == true ? this.updateCheckClass("tdIsWaitDoc") : this.updateBanClass("tdIsWaitDoc");
                this.navigationResponse.navigation.isStateDoc == true ? this.updateCheckClass("tdIsSDADoc") : this.updateBanClass("tdIsSDADoc");
                this.navigationResponse.navigation.isProdServicesForm == true ? this.updateCheckClass("tdIsProdServicesForm") : this.updateBanClass("tdIsProdServicesForm");
                this.navigationResponse.navigation.isROIForm == true ? this.updateCheckClass("tdIsROIForm") : this.updateBanClass("tdIsROIForm");
                this.navigationResponse.navigation.isROIDoc == true ? this.updateCheckClass("tdIsROIDoc") : this.updateBanClass("tdIsROIDoc");
                this.navigationResponse.navigation.isCheckListForm == true ? this.updateCheckClass("tdIsCheckListForm") : this.updateBanClass("tdIsCheckListForm");
                this.navigationResponse.navigation.isCheckListDoc == true ? this.updateCheckClass("tdIsCheckListDoc") : this.updateBanClass("tdIsCheckListDoc");
                this.navigationResponse.navigation.isSUBForm == true ? this.updateCheckClass("tdIsSUBForm") : this.updateBanClass("tdIsSUBForm");
                this.navigationResponse.navigation.isSUBDoc == true ? this.updateCheckClass("tdIsSUBDoc") : this.updateBanClass("tdIsSUBDoc");
                this.navigationResponse.navigation.isBIForm == true ? this.updateCheckClass("tdIsBIForm") : this.updateBanClass("tdIsBIForm");
                this.navigationResponse.navigation.isBIDoc == true ? this.updateCheckClass("tdIsBIDoc") : this.updateBanClass("tdIsBIDoc");
                this.navigationResponse.navigation.isBIPForm == true ? this.updateCheckClass("tdIsBIPForm") : this.updateBanClass("tdIsBIPForm");
                this.navigationResponse.navigation.isBIPDoc == true ? this.updateCheckClass("tdIsBIPDoc") : this.updateBanClass("tdIsBIPDoc");
                this.navigationResponse.navigation.isPPSODoc == true ? this.updateCheckClass("tdIsPPSODoc") : this.updateBanClass("tdIsPPSODoc");
                this.navigationResponse.navigation.isInformInventForm == true ? this.updateCheckClass("tdIsInformInventForm") : this.updateBanClass("tdIsInformInventForm");
                this.navigationResponse.navigation.isInformInventDoc == true ? this.updateCheckClass("tdIsInformInventDoc") : this.updateBanClass("tdIsInformInventDoc");
                this.navigationResponse.navigation.isRetailDoc == true ? this.updateCheckClass("tdIsRetailDoc") : this.updateBanClass("tdIsRetailDoc");
                this.navigationResponse.navigation.isPPADoc == true ? this.updateCheckClass("tdIsPPADoc") : this.updateBanClass("tdIsPPADoc");
                this.navigationResponse.navigation.isUniPayForm == true ? this.updateCheckClass("tdIsUniPayForm") : this.updateBanClass("tdIsUniPayForm");
                this.navigationResponse.navigation.isUniPayDoc == true ? this.updateCheckClass("tdIsUniPayDoc") : this.updateBanClass("tdIsUniPayDoc");
                this.navigationResponse.navigation.isIMPForm == true ? this.updateCheckClass("tdIsIMPForm") : this.updateBanClass("tdIsIMPForm");
                this.navigationResponse.navigation.isIMPDoc == true ? this.updateCheckClass("tdIsIMPDoc") : this.updateBanClass("tdIsIMPDoc");
                this.navigationResponse.navigation.isAddlDoc == true ? this.updateCheckClass("tdIsAddlDoc") : this.updateBanClass("tdIsAddlDoc");
                this.navigationResponse.navigation.isPayCollectForm == true ? this.updateCheckClass("tdIsPayCollectForm") : this.updateBanClass("tdIsPayCollectForm");
                this.navigationResponse.navigation.isFinalSign == true ? this.updateCheckClass("tdIsFinalDocuments") : this.updateBanClass("tdIsFinalDocuments");
            }
        }
    }

    socOnchange() {
        this.socGroup.patchValue({
            address1: this.socGroup.controls.address1.value.trim() || '',
            city: this.socGroup.controls.city.value.trim() || ''
        });
    }

    continueClick() {
        if (this.navigation.isProdServicesForm == false)
            this.showDivItem(this.stepper, 1, '#divPS');
        else if (this.navigation.isBIPForm == false && this.isShowBIP === true)
            this.showDivItem(this.stepper, 1, '#divBIP');
        else if (this.navigation.isSUBForm == false && this.isShowSub === true)
            this.showDivItem(this.stepper, 1, '#divSUB');
        else if (this.navigation.isIMPForm == false && this.isShowIMP === true)
            this.showDivItem(this.stepper, 1, '#divIMP');
        else if (this.navigation.isInformInventForm == false && this.payOption == 2 && !this.hideDocuments)
            this.showDivItem(this.stepper, 1, '#divIFI');
        else if (this.navigation.isUniPayForm == false && this.payOption == 2)
            this.showDivItem(this.stepper, 1, '#divUPC');
        else if (this.navigation.isCheckListForm == false && this.isShowCheckList == true)
            this.showDivItem(this.stepper, 1, '#divCheckList');
        else if (this.navigation.isBIPDoc == false && this.isShowBIP === true)
            this.showDivItem(this.stepper, 2, '#dvBIPDocument');
        else if (this.navigation.isPPSODoc == false && this.isShowPPSO === true)
            this.showDivItem(this.stepper, 2, '#dvPPSODocument');

        else if (this.navigation.isIMPDoc == false && this.isShowIMP === true)
            this.showDivItem(this.stepper, 2, '#dvIMPDocument');
        else if (this.navigation.isSUBDoc == false && this.isShowSub === true)
            this.showDivItem(this.stepper, 2, '#dvSUBDocument');
        else if (this.navigation.isAddlDoc == false && this.isAddlDocExists === true)
            this.showDivItem(this.stepper, 2, '#divAddlDoc');
        else if (this.navigation.isNDADoc == false && (this.contractSession.CountryID == 1 || this.contractSession.CountryID == 2 || this.contractSession.CountryID == 5 || this.contractSession.CountryID == 399) && !this.isSecondContract)
            this.showDivItem(this.stepper, 2, '#dvNDASignDoc');
        else if (this.navigation.isPPADoc == false && this.payOption == 2 && this.hideDocuments)
            this.showDivItem(this.stepper, 2, '#dvPPADocument');
        else if (this.navigation.isWaitDoc == false && this.isWaitStateExists === true)
            this.showDivItem(this.stepper, 2, '#dvWaitSignDoc');
        else if (this.navigation.isRetailDoc == false && this.payOption == 2 && !this.hideDocuments)
            this.showDivItem(this.stepper, 2, '#dvRetailInsDocument');
        else if (this.navigation.isInformInventDoc == false && this.payOption == 2 && !this.hideDocuments)
            this.showDivItem(this.stepper, 2, '#dvInfoInventDocument');
        else if (this.navigation.isUniPayDoc == false && this.payOption == 2)
            this.showDivItem(this.stepper, 2, '#dvUniPayDocument');
        else if (this.navigation.isCheckListDoc == false && this.isShowCheckList == true)
            this.showDivItem(this.stepper, 2, '#dvCheckListDocument');
        else {
            if (this.isSecondContract) {
                if (+$("#contract option:selected").val() == 1)
                    this.showDivItem(this.stepper, 2, '#dvBIPDocument');
                if (+$("#contract option:selected").val() == 2)
                    this.showDivItem(this.stepper, 2, '#dvBIPDocument');
                //if (+$("#contract option:selected").val() == 3)
                //    this.showDivItem(this.stepper, 2, '#dvSUBDocument');
                if ((+$("#contract option:selected").val() >= 3 && +$("#contract option:selected").val() <= 10 && +$("#contract option:selected").val() != 6) || +$("#contract option:selected").val() == 12 || +$("#contract option:selected").val() == 13 || +$("#contract option:selected").val() == 14)
                    this.showDivItem(this.stepper, 2, '#dvSUBDocument');
                //if ((+$("#contract option:selected").val() == 4) || (+$("#contract option:selected").val() == 5))
                //    this.showDivItem(this.stepper, 2, '#dvSUBDocument');
                if (+$("#contract option:selected").val() == 6 || (+$("#contract option:selected").val() == 11))
                    this.showDivItem(this.stepper, 2, '#dvPPSODocument');
                //if (+$("#contract option:selected").val() == 7 || +$("#contract option:selected").val() == 8)
                //    this.showDivItem(this.stepper, 2, '#dvSUBDocument');
            }
            else
                this.showDivItem(this.stepper, 2, '#divSOCDoc');
        }

    }

    refillNavigationWizard() {
        this._navigationService.getNavigationWizardAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.navigationResponse = UtilityService.clone(res);
                    } else {
                        console.log("Navigation Wizard result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }
    createNetSuiteTransactions() {
        this._billingService.createNetSuiteTransactionsAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res <= 0)
                    this.openSnackBar("Failure while triggering Netsuite cancelation process. Please try again or contact administrator.", "");
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    copyContactDetailsToDataObject(isCancelled?: boolean, contractNumber: string = "") {
        let clpContactDetails = {} as CLPContactSOInvention;
        clpContactDetails.contactId = this.contactId;
        if (contractNumber != "") {
            clpContactDetails.fileNumber = this._transferDataService.fileNumber;
            clpContactDetails.contractNumber = contractNumber;
        }
        else {
            clpContactDetails.productId = this.productId;
            clpContactDetails.inventionName = this.inventionName;
            clpContactDetails.isCancelled = isCancelled;
        }
        this.soContactDetails = clpContactDetails;
    }

    updateFileNumber() {
        if ((parseInt(this._transferDataService.fileNumber) == 0) || !this._transferDataService.fileNumber) {
            this._transferDataService.isFileNoBlank = true;
            this.openSnackBar("File Number can not be 0. Considering " + parseInt(this.inputFileNumber).toString(), "");
        }
        else
            this.contractNumberUpdate();
    }

    contractNumberUpdate() {
        this._billingService.contractNumberUpdateAsync(this.encryptedUser, this.contractSessionId, this._transferDataService.fileNumber, this.clpUserId, true)
            .then(contractNumber => {
                if (contractNumber) {
                    this.copyContactDetailsToDataObject(false, contractNumber);
                    this.openSnackBar("The file number has changed. Please click on the Send to Corp button to send the updated copy.", "");
                    this.updateContactInSalesOptima();
                }
                else
                    this.openSnackBar("Failure while updating File number. Please try again or contact administrator.", "");
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getDocumentTypeIds() {
        if (isNullOrUndefined(this.contractPayment) || this.contractPayment.contractSessionId == 0) {
            await this._billingService.getContractPaymentAsync(this.encryptedUser, this.inventionId, this.productId, this.contractSessionId)
                .then(res => {
                    if (res) {
                        if (res.statusCode == 0) {
                            this.contractPaymentResponse = UtilityService.clone(res);
                            this.contractPayment = this.contractPaymentResponse.contractPayment;
                            this.exportDocumentIds = this.getDocumentIds();
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else
            this.exportDocumentIds = this.getDocumentIds();
    }

    getDocumentIds(): string {
        let docIds: string = "";
        var state = this.stateList.find(st => st.code.toLowerCase() == this.contractSession.conSessnClientState.toLowerCase());
        let stateid: number = state != null ? state.id : -1;

        if (this.navigationResponse.navigation) {
            if (this.productDetail) {
                if (this.contractPayment) {
                    if (this.contractPayment.paymentOptionId == 1 || this.contractPayment.paymentOptionId == 0)
                        docIds += this.isWestern == false ? this.productDetails.filter(product => product.productId == this.contractSession.productId)[0].eIHFullPaymentDoc : this.productDetails.filter(product => product.productId == this.contractSession.productId)[0].eIWHFullPaymentDoc;
                    else if (this.contractPayment.paymentOptionId == 2)
                        docIds += this.isWestern == false ? this.productDetails.filter(product => product.productId == this.contractSession.productId)[0].eIHInstallPaymentDoc : this.productDetails.filter(product => product.productId == this.contractSession.productId)[0].eIWHInstallPaymentDoc;
                }
            }
            else {
                if (this.contractPayment) {
                    if (this.contractPayment.paymentOptionId == 1 || this.contractPayment.paymentOptionId == 0)
                        docIds += this.isWestern == false ? this.productDetails[0].eIHFullPaymentDoc : this.productDetails[0].eIWHFullPaymentDoc;
                    else if (this.contractPayment.paymentOptionId == 2)
                        docIds += this.isWestern == false ? this.productDetails[0].eIHInstallPaymentDoc : this.productDetails[0].eIWHInstallPaymentDoc;
                }
            }
            if (this.contractSession.USFeeConfirm == 2 || this.contractSession.CountryID == 2) {
                docIds = this.isWestern == true ? docIds.replace("32", "37") : docIds.replace("22", "37");
                docIds = docIds.replace(",3,", ",38,");
            }
            if (this.productId == 1 || this.productId == 2 || this.productId == 6 || this.productId == 11) {

                if (!this.navigationResponse.navigation.isNDADoc && this.contractSession.CountryID < 3 && !this.isNewCanadianContract) {
                    //If NDA is not signed then export Mandate doc only
                    docIds = this.productDetails[0].ihMandatoryDoc.replace("S", "0");
                }
                else {
                    if (!isNullOrUndefined(this.configDocuments)) {
                        var sateDocBeforeAfterNDA = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 4));
                        var sateDocBeforeAfterNDA_bip = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 5));
                    }
                    if (!isNullOrUndefined(state) && state.code == "KS" && !isNullOrUndefined(this.contractSession) && (this.contractSession.CountryID == 1) && sateDocBeforeAfterNDA_bip)
                        docIds = docIds.replace("AD", sateDocBeforeAfterNDA_bip.id.toString());
                    else if (sateDocBeforeAfterNDA && sateDocBeforeAfterNDA_bip && this.productId < 9)
                        docIds = docIds.replace("AD", sateDocBeforeAfterNDA.id.toString() + "," + sateDocBeforeAfterNDA_bip.id.toString());
                    else if (sateDocBeforeAfterNDA && sateDocBeforeAfterNDA_bip && this.productId >= 9)
                        docIds = docIds.replace("AD", sateDocBeforeAfterNDA.id.toString());
                    else
                        docIds = docIds.replace(",AD", "");
                }
            }
            else if ((this.productId == 3 || this.productId == 12 || this.productId == 13 || this.productId == 14) || (this.productId >= 7 && this.productId <= 10)/*this.productId == 7 || this.productId == 8*/)//export for Sub ,sub only, IMP
            {
                //submission Agreemet

                var submissionAgreementDoc = this.contractSession.CountryID > 2 ? (this.configDocuments.docsList.find(i => i.id == 131 && i.agreement == false && i.docType == -1))
                    : (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == -1));
                if (this.productId == 14) {
                    submissionAgreementDoc = submissionAgreementDoc != null ? submissionAgreementDoc :
                        (this.configDocuments.docsList.find(i => i.id == 142 && i.agreement == false && i.docType == -1));
                }
                else {
                    submissionAgreementDoc = submissionAgreementDoc != null ? submissionAgreementDoc :
                        (this.configDocuments.docsList.find(i => i.id == 66 && i.agreement == false && i.docType == -1));
                }

                if (submissionAgreementDoc)
                    docIds = docIds.replace("SA", submissionAgreementDoc.id.toString());
                else
                    docIds = docIds.replace(",SA", "");

                //Addendum Service
                var addendum = this.addendumServicesResponse.addendum.isNoService;
                if (this.addendumServicesResponse.addendum.isNoService) {
                    docIds = docIds.replace("82,", "").replace("83,", "").replace("84,", "").replace("85,", "").replace("86,", "").replace("87,", "").replace("88,", "").replace("89,", "").replace("137,", "").replace("138,", "").replace("139,", "").replace("140,", "").replace("143,", "").replace("144,", "").replace("145,", "").replace("146,", "").replace("147,", "").replace("148,", "");
                }
                else {
                    if (!this.addendumServicesResponse.addendum.isAddendumB)
                        docIds = this.isWestern ? docIds.replace("89,", "") : docIds.replace("88,", "");

                    if (!this.addendumServicesResponse.addendum.isAddendumG)
                        docIds = this.isWestern ? docIds.replace("87,", "").replace("146,", "") : docIds.replace("86,", "").replace("143,", "");

                    if (!this.addendumServicesResponse.addendum.isAddendumP)
                        docIds = this.isWestern ? docIds.replace("85,", "").replace("138,", "").replace("140,", "").replace("147,", "") : docIds.replace("84,", "").replace("137,", "").replace("139,", "").replace("144,", "");

                    if (!this.addendumServicesResponse.addendum.isPatentServices)
                        docIds = this.isWestern ? docIds.replace("83,", "").replace("148,", "") : docIds.replace("82,", "").replace("145,", "");

                    if (!this.isProductV)
                        docIds = this.isWestern ? docIds.replace("140,", "") : docIds.replace("139,", "");
                }

                //Additional Docs
                if (!isNullOrUndefined(this.configDocuments)) {
                    var sateDocBeforeNDA = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 1));
                    var sateDocBeforeAfterNDA = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 4));
                }
                if (!this.navigation.isNDADoc) {
                    docIds = docIds.replace(",AD", "");
                }
                else {
                    if (sateDocBeforeAfterNDA)
                        docIds = docIds.replace("AD", sateDocBeforeAfterNDA.id.toString());
                    else
                        docIds = docIds.replace(",AD", "");
                }
            }
            else if (this.productId == 4) {
                if (!this.addendumServicesResponse.addendum.isPatentServices)
                    docIds = this.isWestern ? docIds.replace(",125", "") : docIds.replace(",124", "");
                var addldoc = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 4));
                if (addldoc)
                    docIds = docIds.replace("AD", addldoc.id.toString());
                else
                    docIds = docIds.replace(",AD", "");
            }
            else if (this.productId == 5) {
                if (!this.addendumServicesResponse.addendum.isPatentServices)
                    docIds = this.isWestern ? docIds.replace(",136", "") : docIds.replace(",134", "");
                var addldoc = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 4));
                if (addldoc)
                    docIds = docIds.replace("AD", addldoc.id.toString());
                else
                    docIds = docIds.replace(",AD", "");
            }
            if (this.isSecondContract) {
                docIds = docIds.replace(",3,", ",").replace(",4", "").replace(",1,", ",").replace(",38,", ",");
                if ((this.contractPayment.paymentOptionId == 1 || this.contractPayment.paymentOptionId == 0) && (this.contractSession.CountryID > 2) && ((this.productId == 4) || (this.productId == 5)))
                    docIds = docIds.replace("124,1", "124").replace("134,1", "134").replace("125,1", "125").replace("136,1", "136");
            }
            if (!this.navigationResponse.navigation.isPayCollectForm)
                docIds = docIds.replace("35,", "");

            //Wait state
            var waitstateDoc = this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == true);
            if (!isNullOrUndefined(state) && state.waitDays > 0)
                docIds = docIds.replace("W", waitstateDoc.id.toString());
            else
                docIds = docIds.replace(",W", "");

            if (!this.isStateExists) {
                if (this.contractPayment) {
                    if ((this.isSecondContract && this.contractPayment.paymentOptionId == 1) || (this.contractPayment.paymentOptionId == 0))
                        docIds = docIds.replace(",0", "");
                    else
                        docIds = docIds.replace(",0,", ",").replace(",0", "");

                    console.log("SDA : " + docIds);
                }
            }

            if (docIds.length > 2 && (this.productId == 1 || this.productId == 2)) {
                if (!this.navigationResponse.navigation.isROIForm) {
                    if (((this.flgInstallment) || (this.isWaitStateExists))
                        || sateDocBeforeNDA || sateDocBeforeAfterNDA || (!isNullOrUndefined(state) && state.code == "KS"))
                        docIds = docIds.replace(",2,", ",");
                    else {
                        if (this.navigationResponse) {
                            if (this.navigationResponse.navigation.isNDADoc) {
                                docIds = docIds.substring(0, docIds.length - 2);
                            }
                        }
                        console.log("ROI2 : " + docIds);
                    }
                }
            }
            if (docIds.length > 2 && this.productId == 6 && this.isBIPExist) {
                docIds = docIds.substring(0, docIds.length - 2);
            }
            if (docIds.length > 2 && !isNullOrUndefined(this.navigationResponse) && !this.navigationResponse.navigation.isROIForm && ((this.productId == 6 && !this.isBIPExist) || this.productId == 11)) {
                docIds = docIds.substring(0, docIds.length - 2);
            }
            if (!isNullOrUndefined(this.contractSession) && (this.isNewCanadianContract)) {
                if (!isNullOrUndefined(this.navigationResponse)) {
                    //BIP
                    if (this.productId == 1 || this.productId == 2 || this.productId == 6) {
                        if (!this.navigationResponse.navigation.isBIPDoc) {
                            docIds = docIds.replace("37,", "");
                        }
                        if (!this.navigationResponse.navigation.isPPSODoc) {
                            docIds = docIds.replace("23,", "");
                        }
                        if (!isNullOrUndefined(this.contractPayment) && this.contractPayment.paymentOptionId == 1 || this.contractPayment.paymentOptionId == 0) {
                            if (!this.navigationResponse.navigation.isROIDoc) {
                                docIds = docIds.replace("1,2", "1");
                            }
                        }
                        else {
                            if (!this.navigationResponse.navigation.isUniPayDoc) {
                                docIds = docIds.replace(",26", "");
                            }
                            if (!this.navigationResponse.navigation.isRetailDoc) {
                                docIds = docIds.replace(",25", "");
                            }
                            if (!this.navigationResponse.navigation.isInformInventDoc) {
                                docIds = docIds.replace(",24", "");
                            }
                        }
                        if (this.isSecondContract && this.productId == 6) {
                            if (!this.navigationResponse.navigation.isPPSODoc && !this.navigationResponse.navigation.isRetailDoc && !this.navigationResponse.navigation.isInformInventDoc
                                && !this.navigationResponse.navigation.isUniPayDoc) {
                                docIds = "";
                            }
                        }
                    }//SUB
                    if (this.productId == 3 || this.productId == 7 || this.productId == 8 || this.productId == 12 || this.productId == 13 || this.productId == 14) {
                        if (!this.navigationResponse.navigation.isSUBDoc) {
                            docIds = docIds.replace("66,94", "").replace("142,", "");
                            if (!isNullOrUndefined(this.addendumServicesResponse)) {
                                if (this.addendumServicesResponse.addendum.isAddendumB) {
                                    docIds = docIds.replace("88,", "");
                                }
                                if (this.addendumServicesResponse.addendum.isAddendumG) {
                                    docIds = docIds.replace("86,", "").replace("143,", "");
                                }
                                if (this.addendumServicesResponse.addendum.isAddendumP) {
                                    docIds = docIds.replace("84,137,139", "").replace("144,", "");
                                }
                                if (this.addendumServicesResponse.addendum.isPatentServices) {
                                    docIds = docIds.replace("82,", "").replace("145,", "");
                                }
                            }
                        }
                        if (!this.navigationResponse.navigation.isCheckListDoc) {
                            docIds = docIds.replace("-3", "");
                        }
                        if (!isNullOrUndefined(this.contractPayment) && this.contractPayment.paymentOptionId == 2) {
                            if (!this.navigationResponse.navigation.isUniPayDoc) {
                                docIds = docIds.replace(",26", "");
                            }
                            if (!this.navigationResponse.navigation.isRetailDoc) {
                                docIds = docIds.replace(",25", "");
                            }
                            if (!this.navigationResponse.navigation.isInformInventDoc) {
                                docIds = docIds.replace(",24", "");
                            }
                        }
                        if (!this.navigationResponse.navigation.isSUBDoc && !this.navigationResponse.navigation.isCheckListDoc && !this.navigationResponse.navigation.isRetailDoc &&
                            !this.navigationResponse.navigation.isInformInventDoc && !this.navigationResponse.navigation.isUniPayDoc) {
                            docIds = "";
                        }
                    }//IMP
                    if (this.productId == 4) {
                        if (!this.navigationResponse.navigation.isIMPDoc) {
                            docIds = docIds.replace("36", "");
                        }
                        if (!this.navigationResponse.navigation.isSUBDoc) {
                            if (!isNullOrUndefined(this.addendumServicesResponse)) {
                                if (this.addendumServicesResponse.addendum.isPatentServices) {
                                    docIds = docIds.replace(",124", "");
                                }
                            }
                        }
                        if (!isNullOrUndefined(this.contractPayment) && this.contractPayment.paymentOptionId == 2) {
                            if (!this.navigationResponse.navigation.isUniPayDoc) {
                                docIds = docIds.replace(",26", "");
                            }
                            if (!this.navigationResponse.navigation.isRetailDoc) {
                                docIds = docIds.replace(",25", "");
                            }
                            if (!this.navigationResponse.navigation.isInformInventDoc) {
                                docIds = docIds.replace(",24", "");
                            }
                        }
                        if (!this.navigationResponse.navigation.isIMPDoc && !this.navigationResponse.navigation.isSUBDoc && !this.navigationResponse.navigation.isRetailDoc &&
                            !this.navigationResponse.navigation.isInformInventDoc && !this.navigationResponse.navigation.isUniPayDoc) {
                            docIds = "";
                        }
                    }//Web Service
                    if (this.productId == 5) {
                        if (!this.navigationResponse.navigation.isIMPDoc) {
                            docIds = docIds.replace("133", "");
                        }
                        if (!this.navigationResponse.navigation.isSUBDoc) {
                            if (!isNullOrUndefined(this.addendumServicesResponse)) {
                                if (this.addendumServicesResponse.addendum.isPatentServices) {
                                    docIds = docIds.replace(",134", "");
                                }
                            }
                        }
                        if (!isNullOrUndefined(this.contractPayment) && this.contractPayment.paymentOptionId == 2) {
                            if (!this.navigationResponse.navigation.isUniPayDoc) {
                                docIds = docIds.replace(",26", "");
                            }
                            if (!this.navigationResponse.navigation.isRetailDoc) {
                                docIds = docIds.replace(",25", "");
                            }
                            if (!this.navigationResponse.navigation.isInformInventDoc) {
                                docIds = docIds.replace(",24", "");
                            }
                        }
                        if (!this.navigationResponse.navigation.isIMPDoc && !this.navigationResponse.navigation.isSUBDoc && !this.navigationResponse.navigation.isRetailDoc &&
                            !this.navigationResponse.navigation.isInformInventDoc && !this.navigationResponse.navigation.isUniPayDoc) {
                            docIds = "";
                        }
                    }
                    docIds = docIds.replace(",4", "");
                    if (docIds == "38,1") {
                        if (!this.navigationResponse.navigation.isSOCDoc && !this.navigationResponse.navigation.isADSDoc) {
                            docIds = "";
                        }
                        else
                            docIds = "1,38";
                    }
                }
            }
            if (docIds[0] == ',')
                docIds = docIds.replace(",", "");
            if (docIds.slice(-1) == ',')
                docIds = docIds.substring(0, docIds.length - 1);
            docIds = docIds.replace(/,{2,}/g, ',');
        }
        return docIds;
    }

    applyZipValidators(countryId: number) {
        if (countryId == 3)
            this.collectPaymentGroup.controls.zip.clearValidators();
        else
            this.collectPaymentGroup.controls.zip.setValidators([Validators.required, Validators.minLength(5), Validators.pattern(/^[a-zA-Z0-9\s]{5,10}$/)]);
    }

}
var canvasheight = 0;
var canvaswidgth = 0;
function resizeCanvas() {
    var canvas = document.getElementsByTagName("canvas")[0];
    var canvas2 = document.getElementsByTagName("canvas")[1];
    var canvas3 = document.getElementsByTagName("canvas")[2];
    var canvas4 = document.getElementsByTagName("canvas")[3];
    var canvas5 = document.getElementsByTagName("canvas")[4];
    var canvas6 = document.getElementsByTagName("canvas")[5];

    if (canvas) {
        var card = document.getElementsByClassName("signature-pad-card");
        var outer = document.getElementsByClassName("outerSign");
        var outerCoInv = document.getElementsByClassName("outerSign");
        var outerADS = document.getElementsByClassName("outerSignADS");
        var outerADSCoInv = document.getElementsByClassName("outerSignADS");
        var outerFinal = document.getElementsByClassName("outerSignFinal");
        var outerFinalCoInv = document.getElementsByClassName("outerSignFinal");

        canvas.width = outer[0].clientWidth - 50;
        canvas.height = outer[0].clientHeight - 50;
        canvasheight = canvas.height;
        canvaswidgth = canvas.width;

        if (canvas2) {
            canvas2.width = outerCoInv[0].clientWidth - 50;
            canvas2.height = outerCoInv[0].clientHeight - 50;
            canvasheight = canvas2.height;
            canvaswidgth = canvas2.width;
        }

        if (canvas3) {
            canvas3.width = outerADS[0].clientWidth - 50;
            canvas3.height = outerADS[0].clientHeight - 50;
            canvasheight = canvas3.height;
            canvaswidgth = canvas3.width;
        }

        if (canvas4) {
            canvas4.width = outerADSCoInv[0].clientWidth - 50;
            canvas4.height = outerADSCoInv[0].clientHeight - 50;
            canvasheight = canvas4.height;
            canvaswidgth = canvas4.width;
        }

        if (canvas5) {
            canvas5.width = outerFinal[0].clientWidth - 50;
            canvas5.height = outerFinal[0].clientHeight - 50;
            canvasheight = canvas5.height;
            canvaswidgth = canvas5.width;
        }

        if (canvas6) {
            canvas6.width = outerFinalCoInv[0].clientWidth - 50;
            canvas6.height = outerFinalCoInv[0].clientHeight - 50;
            canvasheight = canvas6.height;
            canvaswidgth = canvas6.width;
        }
    }
}
